/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A floating point number that requires more precision than IEEE 754 binary 64 */
  BigFloat: { input: any; output: any; }
  /**
   * A signed eight-byte integer. The upper big integer values are greater than the
   * max value for a JavaScript number. Therefore all big integers will be output as
   * strings and not numbers.
   */
  BigInt: { input: any; output: any; }
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: { input: any; output: any; }
  /** The day, does not include a time. */
  Date: { input: any; output: any; }
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) standard. May or may not include a timezone.
   */
  Datetime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

export type AppCoinflipLeaderboardLuckyBet = {
  __typename?: 'AppCoinflipLeaderboardLuckyBet';
  bet?: Maybe<Scalars['BigFloat']['output']>;
  betNormalize?: Maybe<Scalars['BigInt']['output']>;
  betUsd?: Maybe<Scalars['BigInt']['output']>;
  created?: Maybe<Scalars['Datetime']['output']>;
  denom?: Maybe<Scalars['String']['output']>;
  gameRound?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['BigInt']['output']>;
  maxGameRound?: Maybe<Scalars['Int']['output']>;
  maxWin?: Maybe<Scalars['BigFloat']['output']>;
  mode?: Maybe<CoinflipGameMode>;
  payable?: Maybe<Scalars['BigFloat']['output']>;
  payoutNormalize?: Maybe<Scalars['BigInt']['output']>;
  payoutUsd?: Maybe<Scalars['BigInt']['output']>;
  player?: Maybe<Scalars['String']['output']>;
  processedGameRound?: Maybe<Scalars['Int']['output']>;
  rtp?: Maybe<Scalars['BigFloat']['output']>;
  status?: Maybe<MiniGameStatus>;
  symbol?: Maybe<Scalars['String']['output']>;
  txHash?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['Datetime']['output']>;
};

/**
 * A condition to be used against `AppCoinflipLeaderboardLuckyBet` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type AppCoinflipLeaderboardLuckyBetCondition = {
  /** Checks for equality with the object’s `bet` field. */
  bet?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `betNormalize` field. */
  betNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `betUsd` field. */
  betUsd?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `denom` field. */
  denom?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `gameRound` field. */
  gameRound?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `maxGameRound` field. */
  maxGameRound?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `maxWin` field. */
  maxWin?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `mode` field. */
  mode?: InputMaybe<CoinflipGameMode>;
  /** Checks for equality with the object’s `payable` field. */
  payable?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `payoutNormalize` field. */
  payoutNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `payoutUsd` field. */
  payoutUsd?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `player` field. */
  player?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `processedGameRound` field. */
  processedGameRound?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rtp` field. */
  rtp?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<MiniGameStatus>;
  /** Checks for equality with the object’s `symbol` field. */
  symbol?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `txHash` field. */
  txHash?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updated` field. */
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `AppCoinflipLeaderboardLuckyBet` object types. All fields are combined with a logical ‘and.’ */
export type AppCoinflipLeaderboardLuckyBetFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AppCoinflipLeaderboardLuckyBetFilter>>;
  /** Filter by the object’s `bet` field. */
  bet?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `betNormalize` field. */
  betNormalize?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `betUsd` field. */
  betUsd?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `denom` field. */
  denom?: InputMaybe<StringFilter>;
  /** Filter by the object’s `gameRound` field. */
  gameRound?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `maxGameRound` field. */
  maxGameRound?: InputMaybe<IntFilter>;
  /** Filter by the object’s `maxWin` field. */
  maxWin?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `mode` field. */
  mode?: InputMaybe<CoinflipGameModeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AppCoinflipLeaderboardLuckyBetFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AppCoinflipLeaderboardLuckyBetFilter>>;
  /** Filter by the object’s `payable` field. */
  payable?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `payoutNormalize` field. */
  payoutNormalize?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `payoutUsd` field. */
  payoutUsd?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `player` field. */
  player?: InputMaybe<StringFilter>;
  /** Filter by the object’s `processedGameRound` field. */
  processedGameRound?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rtp` field. */
  rtp?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<MiniGameStatusFilter>;
  /** Filter by the object’s `symbol` field. */
  symbol?: InputMaybe<StringFilter>;
  /** Filter by the object’s `txHash` field. */
  txHash?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updated` field. */
  updated?: InputMaybe<DatetimeFilter>;
};

/** A connection to a list of `AppCoinflipLeaderboardLuckyBet` values. */
export type AppCoinflipLeaderboardLuckyBetsConnection = {
  __typename?: 'AppCoinflipLeaderboardLuckyBetsConnection';
  /** A list of edges which contains the `AppCoinflipLeaderboardLuckyBet` and cursor to aid in pagination. */
  edges: Array<AppCoinflipLeaderboardLuckyBetsEdge>;
  /** A list of `AppCoinflipLeaderboardLuckyBet` objects. */
  nodes: Array<Maybe<AppCoinflipLeaderboardLuckyBet>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AppCoinflipLeaderboardLuckyBet` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `AppCoinflipLeaderboardLuckyBet` edge in the connection. */
export type AppCoinflipLeaderboardLuckyBetsEdge = {
  __typename?: 'AppCoinflipLeaderboardLuckyBetsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AppCoinflipLeaderboardLuckyBet` at the end of the edge. */
  node?: Maybe<AppCoinflipLeaderboardLuckyBet>;
};

/** Methods to use when ordering `AppCoinflipLeaderboardLuckyBet`. */
export enum AppCoinflipLeaderboardLuckyBetsOrderBy {
  BetAsc = 'BET_ASC',
  BetDesc = 'BET_DESC',
  BetNormalizeAsc = 'BET_NORMALIZE_ASC',
  BetNormalizeDesc = 'BET_NORMALIZE_DESC',
  BetUsdAsc = 'BET_USD_ASC',
  BetUsdDesc = 'BET_USD_DESC',
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  DenomAsc = 'DENOM_ASC',
  DenomDesc = 'DENOM_DESC',
  GameRoundAsc = 'GAME_ROUND_ASC',
  GameRoundDesc = 'GAME_ROUND_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MaxGameRoundAsc = 'MAX_GAME_ROUND_ASC',
  MaxGameRoundDesc = 'MAX_GAME_ROUND_DESC',
  MaxWinAsc = 'MAX_WIN_ASC',
  MaxWinDesc = 'MAX_WIN_DESC',
  ModeAsc = 'MODE_ASC',
  ModeDesc = 'MODE_DESC',
  Natural = 'NATURAL',
  PayableAsc = 'PAYABLE_ASC',
  PayableDesc = 'PAYABLE_DESC',
  PayoutNormalizeAsc = 'PAYOUT_NORMALIZE_ASC',
  PayoutNormalizeDesc = 'PAYOUT_NORMALIZE_DESC',
  PayoutUsdAsc = 'PAYOUT_USD_ASC',
  PayoutUsdDesc = 'PAYOUT_USD_DESC',
  PlayerAsc = 'PLAYER_ASC',
  PlayerDesc = 'PLAYER_DESC',
  ProcessedGameRoundAsc = 'PROCESSED_GAME_ROUND_ASC',
  ProcessedGameRoundDesc = 'PROCESSED_GAME_ROUND_DESC',
  RtpAsc = 'RTP_ASC',
  RtpDesc = 'RTP_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  SymbolAsc = 'SYMBOL_ASC',
  SymbolDesc = 'SYMBOL_DESC',
  TxHashAsc = 'TX_HASH_ASC',
  TxHashDesc = 'TX_HASH_DESC',
  UpdatedAsc = 'UPDATED_ASC',
  UpdatedDesc = 'UPDATED_DESC'
}

export type AuctionBasket = {
  __typename?: 'AuctionBasket';
  /** Reads and enables pagination through a set of `AuctionBasketBet`. */
  auctionBasketBets: AuctionBasketBetsConnection;
  basket: Scalars['JSON']['output'];
  bet: Scalars['BigInt']['output'];
  created: Scalars['Datetime']['output'];
  end: Scalars['Datetime']['output'];
  id: Scalars['BigInt']['output'];
  leader?: Maybe<Scalars['String']['output']>;
  status: AuctionBasketStatus;
  updated: Scalars['Datetime']['output'];
};


export type AuctionBasketAuctionBasketBetsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AuctionBasketBetCondition>;
  filter?: InputMaybe<AuctionBasketBetFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AuctionBasketBetsOrderBy>>;
};

export type AuctionBasketBet = {
  __typename?: 'AuctionBasketBet';
  /** Reads a single `AuctionBasket` that is related to this `AuctionBasketBet`. */
  auctionBasket?: Maybe<AuctionBasket>;
  auctionBasketId?: Maybe<Scalars['BigInt']['output']>;
  bet: Scalars['BigInt']['output'];
  created?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['BigInt']['output'];
  player: Scalars['String']['output'];
  txHash?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `AuctionBasketBet` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AuctionBasketBetCondition = {
  /** Checks for equality with the object’s `auctionBasketId` field. */
  auctionBasketId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `bet` field. */
  bet?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `player` field. */
  player?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `txHash` field. */
  txHash?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `AuctionBasketBet` object types. All fields are combined with a logical ‘and.’ */
export type AuctionBasketBetFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AuctionBasketBetFilter>>;
  /** Filter by the object’s `auctionBasketId` field. */
  auctionBasketId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `bet` field. */
  bet?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AuctionBasketBetFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AuctionBasketBetFilter>>;
  /** Filter by the object’s `player` field. */
  player?: InputMaybe<StringFilter>;
  /** Filter by the object’s `txHash` field. */
  txHash?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `AuctionBasketBet` */
export type AuctionBasketBetInput = {
  auctionBasketId?: InputMaybe<Scalars['BigInt']['input']>;
  bet: Scalars['BigInt']['input'];
  created?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  player: Scalars['String']['input'];
  txHash?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an update to a `AuctionBasketBet`. Fields that are set will be updated. */
export type AuctionBasketBetPatch = {
  auctionBasketId?: InputMaybe<Scalars['BigInt']['input']>;
  bet?: InputMaybe<Scalars['BigInt']['input']>;
  created?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  player?: InputMaybe<Scalars['String']['input']>;
  txHash?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `AuctionBasketBet` values. */
export type AuctionBasketBetsConnection = {
  __typename?: 'AuctionBasketBetsConnection';
  /** A list of edges which contains the `AuctionBasketBet` and cursor to aid in pagination. */
  edges: Array<AuctionBasketBetsEdge>;
  /** A list of `AuctionBasketBet` objects. */
  nodes: Array<Maybe<AuctionBasketBet>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AuctionBasketBet` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `AuctionBasketBet` edge in the connection. */
export type AuctionBasketBetsEdge = {
  __typename?: 'AuctionBasketBetsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AuctionBasketBet` at the end of the edge. */
  node?: Maybe<AuctionBasketBet>;
};

/** Methods to use when ordering `AuctionBasketBet`. */
export enum AuctionBasketBetsOrderBy {
  AuctionBasketIdAsc = 'AUCTION_BASKET_ID_ASC',
  AuctionBasketIdDesc = 'AUCTION_BASKET_ID_DESC',
  BetAsc = 'BET_ASC',
  BetDesc = 'BET_DESC',
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PlayerAsc = 'PLAYER_ASC',
  PlayerDesc = 'PLAYER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TxHashAsc = 'TX_HASH_ASC',
  TxHashDesc = 'TX_HASH_DESC'
}

/**
 * A condition to be used against `AuctionBasket` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AuctionBasketCondition = {
  /** Checks for equality with the object’s `basket` field. */
  basket?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `bet` field. */
  bet?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `leader` field. */
  leader?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<AuctionBasketStatus>;
  /** Checks for equality with the object’s `updated` field. */
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `AuctionBasket` object types. All fields are combined with a logical ‘and.’ */
export type AuctionBasketFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AuctionBasketFilter>>;
  /** Filter by the object’s `basket` field. */
  basket?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `bet` field. */
  bet?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `leader` field. */
  leader?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AuctionBasketFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AuctionBasketFilter>>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<AuctionBasketStatusFilter>;
  /** Filter by the object’s `updated` field. */
  updated?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `AuctionBasket` */
export type AuctionBasketInput = {
  basket: Scalars['JSON']['input'];
  bet: Scalars['BigInt']['input'];
  created: Scalars['Datetime']['input'];
  end: Scalars['Datetime']['input'];
  id: Scalars['BigInt']['input'];
  leader?: InputMaybe<Scalars['String']['input']>;
  status: AuctionBasketStatus;
  updated: Scalars['Datetime']['input'];
};

/** Represents an update to a `AuctionBasket`. Fields that are set will be updated. */
export type AuctionBasketPatch = {
  basket?: InputMaybe<Scalars['JSON']['input']>;
  bet?: InputMaybe<Scalars['BigInt']['input']>;
  created?: InputMaybe<Scalars['Datetime']['input']>;
  end?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  leader?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AuctionBasketStatus>;
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

export enum AuctionBasketStatus {
  Active = 'ACTIVE',
  Finished = 'FINISHED'
}

/** A filter to be used against AuctionBasketStatus fields. All fields are combined with a logical ‘and.’ */
export type AuctionBasketStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<AuctionBasketStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<AuctionBasketStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<AuctionBasketStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<AuctionBasketStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<AuctionBasketStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<AuctionBasketStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<AuctionBasketStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<AuctionBasketStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<AuctionBasketStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<AuctionBasketStatus>>;
};

/** A connection to a list of `AuctionBasket` values. */
export type AuctionBasketsConnection = {
  __typename?: 'AuctionBasketsConnection';
  /** A list of edges which contains the `AuctionBasket` and cursor to aid in pagination. */
  edges: Array<AuctionBasketsEdge>;
  /** A list of `AuctionBasket` objects. */
  nodes: Array<Maybe<AuctionBasket>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AuctionBasket` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `AuctionBasket` edge in the connection. */
export type AuctionBasketsEdge = {
  __typename?: 'AuctionBasketsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AuctionBasket` at the end of the edge. */
  node?: Maybe<AuctionBasket>;
};

/** Methods to use when ordering `AuctionBasket`. */
export enum AuctionBasketsOrderBy {
  BasketAsc = 'BASKET_ASC',
  BasketDesc = 'BASKET_DESC',
  BetAsc = 'BET_ASC',
  BetDesc = 'BET_DESC',
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LeaderAsc = 'LEADER_ASC',
  LeaderDesc = 'LEADER_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UpdatedAsc = 'UPDATED_ASC',
  UpdatedDesc = 'UPDATED_DESC'
}

export type BankrollBalance = {
  __typename?: 'BankrollBalance';
  balance: Scalars['BigFloat']['output'];
  contract: Scalars['String']['output'];
  denom: Scalars['String']['output'];
  updated: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `BankrollBalance` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BankrollBalanceCondition = {
  /** Checks for equality with the object’s `balance` field. */
  balance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `contract` field. */
  contract?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `denom` field. */
  denom?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updated` field. */
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `BankrollBalance` object types. All fields are combined with a logical ‘and.’ */
export type BankrollBalanceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BankrollBalanceFilter>>;
  /** Filter by the object’s `balance` field. */
  balance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `contract` field. */
  contract?: InputMaybe<StringFilter>;
  /** Filter by the object’s `denom` field. */
  denom?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BankrollBalanceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BankrollBalanceFilter>>;
  /** Filter by the object’s `updated` field. */
  updated?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `BankrollBalance` */
export type BankrollBalanceInput = {
  balance: Scalars['BigFloat']['input'];
  contract: Scalars['String']['input'];
  denom: Scalars['String']['input'];
  updated: Scalars['Datetime']['input'];
};

/** Represents an update to a `BankrollBalance`. Fields that are set will be updated. */
export type BankrollBalancePatch = {
  balance?: InputMaybe<Scalars['BigFloat']['input']>;
  contract?: InputMaybe<Scalars['String']['input']>;
  denom?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `BankrollBalance` values. */
export type BankrollBalancesConnection = {
  __typename?: 'BankrollBalancesConnection';
  /** A list of edges which contains the `BankrollBalance` and cursor to aid in pagination. */
  edges: Array<BankrollBalancesEdge>;
  /** A list of `BankrollBalance` objects. */
  nodes: Array<Maybe<BankrollBalance>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BankrollBalance` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BankrollBalance` edge in the connection. */
export type BankrollBalancesEdge = {
  __typename?: 'BankrollBalancesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BankrollBalance` at the end of the edge. */
  node?: Maybe<BankrollBalance>;
};

/** Methods to use when ordering `BankrollBalance`. */
export enum BankrollBalancesOrderBy {
  BalanceAsc = 'BALANCE_ASC',
  BalanceDesc = 'BALANCE_DESC',
  ContractAsc = 'CONTRACT_ASC',
  ContractDesc = 'CONTRACT_DESC',
  DenomAsc = 'DENOM_ASC',
  DenomDesc = 'DENOM_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAsc = 'UPDATED_ASC',
  UpdatedDesc = 'UPDATED_DESC'
}

export enum BetStatus {
  Draw = 'DRAW',
  Lose = 'LOSE',
  Pending = 'PENDING',
  Refund = 'REFUND',
  RunAway = 'RUN_AWAY',
  Win = 'WIN'
}

/** A filter to be used against BetStatus fields. All fields are combined with a logical ‘and.’ */
export type BetStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<BetStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<BetStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<BetStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<BetStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<BetStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<BetStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<BetStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<BetStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<BetStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<BetStatus>>;
};

/** A connection to a list of `BetsHistory` values. */
export type BetsHistoriesConnection = {
  __typename?: 'BetsHistoriesConnection';
  /** A list of edges which contains the `BetsHistory` and cursor to aid in pagination. */
  edges: Array<BetsHistoriesEdge>;
  /** A list of `BetsHistory` objects. */
  nodes: Array<Maybe<BetsHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BetsHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BetsHistory` edge in the connection. */
export type BetsHistoriesEdge = {
  __typename?: 'BetsHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BetsHistory` at the end of the edge. */
  node?: Maybe<BetsHistory>;
};

/** Methods to use when ordering `BetsHistory`. */
export enum BetsHistoriesOrderBy {
  BetAsc = 'BET_ASC',
  BetDesc = 'BET_DESC',
  BetIdAsc = 'BET_ID_ASC',
  BetIdDesc = 'BET_ID_DESC',
  BetNormalizeAsc = 'BET_NORMALIZE_ASC',
  BetNormalizeDesc = 'BET_NORMALIZE_DESC',
  BetUsdAsc = 'BET_USD_ASC',
  BetUsdDesc = 'BET_USD_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DenomAsc = 'DENOM_ASC',
  DenomDesc = 'DENOM_DESC',
  ExtraAsc = 'EXTRA_ASC',
  ExtraDesc = 'EXTRA_DESC',
  GameAsc = 'GAME_ASC',
  GameDesc = 'GAME_DESC',
  GameIdAsc = 'GAME_ID_ASC',
  GameIdDesc = 'GAME_ID_DESC',
  Natural = 'NATURAL',
  PayoutAsc = 'PAYOUT_ASC',
  PayoutDesc = 'PAYOUT_DESC',
  PayoutNormalizeAsc = 'PAYOUT_NORMALIZE_ASC',
  PayoutNormalizeDesc = 'PAYOUT_NORMALIZE_DESC',
  PayoutUsdAsc = 'PAYOUT_USD_ASC',
  PayoutUsdDesc = 'PAYOUT_USD_DESC',
  PlayerAsc = 'PLAYER_ASC',
  PlayerDesc = 'PLAYER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SymbolAsc = 'SYMBOL_ASC',
  SymbolDesc = 'SYMBOL_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type BetsHistory = {
  __typename?: 'BetsHistory';
  _id: Scalars['BigInt']['output'];
  bet: Scalars['BigFloat']['output'];
  betId: Scalars['BigInt']['output'];
  betNormalize: Scalars['BigInt']['output'];
  betUsd: Scalars['BigInt']['output'];
  createdAt: Scalars['Datetime']['output'];
  denom: Scalars['String']['output'];
  extra?: Maybe<Scalars['JSON']['output']>;
  game: Scalars['String']['output'];
  gameId: Scalars['BigInt']['output'];
  payout: Scalars['BigFloat']['output'];
  payoutNormalize: Scalars['BigInt']['output'];
  payoutUsd: Scalars['BigInt']['output'];
  player: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

/**
 * A condition to be used against `BetsHistory` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type BetsHistoryCondition = {
  /** Checks for equality with the object’s `_id` field. */
  _id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `bet` field. */
  bet?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `betId` field. */
  betId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `betNormalize` field. */
  betNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `betUsd` field. */
  betUsd?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `denom` field. */
  denom?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `extra` field. */
  extra?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `game` field. */
  game?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `gameId` field. */
  gameId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `payout` field. */
  payout?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `payoutNormalize` field. */
  payoutNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `payoutUsd` field. */
  payoutUsd?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `player` field. */
  player?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `symbol` field. */
  symbol?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `BetsHistory` object types. All fields are combined with a logical ‘and.’ */
export type BetsHistoryFilter = {
  /** Filter by the object’s `_id` field. */
  _id?: InputMaybe<BigIntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BetsHistoryFilter>>;
  /** Filter by the object’s `bet` field. */
  bet?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `betId` field. */
  betId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `betNormalize` field. */
  betNormalize?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `betUsd` field. */
  betUsd?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `denom` field. */
  denom?: InputMaybe<StringFilter>;
  /** Filter by the object’s `extra` field. */
  extra?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `game` field. */
  game?: InputMaybe<StringFilter>;
  /** Filter by the object’s `gameId` field. */
  gameId?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BetsHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BetsHistoryFilter>>;
  /** Filter by the object’s `payout` field. */
  payout?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `payoutNormalize` field. */
  payoutNormalize?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `payoutUsd` field. */
  payoutUsd?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `player` field. */
  player?: InputMaybe<StringFilter>;
  /** Filter by the object’s `symbol` field. */
  symbol?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `BetsHistory` */
export type BetsHistoryInput = {
  _id?: InputMaybe<Scalars['BigInt']['input']>;
  bet: Scalars['BigFloat']['input'];
  betId: Scalars['BigInt']['input'];
  betNormalize: Scalars['BigInt']['input'];
  betUsd: Scalars['BigInt']['input'];
  createdAt: Scalars['Datetime']['input'];
  denom: Scalars['String']['input'];
  extra?: InputMaybe<Scalars['JSON']['input']>;
  game: Scalars['String']['input'];
  gameId: Scalars['BigInt']['input'];
  payout: Scalars['BigFloat']['input'];
  payoutNormalize: Scalars['BigInt']['input'];
  payoutUsd: Scalars['BigInt']['input'];
  player: Scalars['String']['input'];
  symbol: Scalars['String']['input'];
};

/** Represents an update to a `BetsHistory`. Fields that are set will be updated. */
export type BetsHistoryPatch = {
  _id?: InputMaybe<Scalars['BigInt']['input']>;
  bet?: InputMaybe<Scalars['BigFloat']['input']>;
  betId?: InputMaybe<Scalars['BigInt']['input']>;
  betNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  betUsd?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  denom?: InputMaybe<Scalars['String']['input']>;
  extra?: InputMaybe<Scalars['JSON']['input']>;
  game?: InputMaybe<Scalars['String']['input']>;
  gameId?: InputMaybe<Scalars['BigInt']['input']>;
  payout?: InputMaybe<Scalars['BigFloat']['input']>;
  payoutNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  payoutUsd?: InputMaybe<Scalars['BigInt']['input']>;
  player?: InputMaybe<Scalars['String']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against BigFloat fields. All fields are combined with a logical ‘and.’ */
export type BigFloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
};

/** A filter to be used against BigInt fields. All fields are combined with a logical ‘and.’ */
export type BigIntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigInt']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigInt']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

/** A connection to a list of `BonusBetsHistory` values. */
export type BonusBetsHistoriesConnection = {
  __typename?: 'BonusBetsHistoriesConnection';
  /** A list of edges which contains the `BonusBetsHistory` and cursor to aid in pagination. */
  edges: Array<BonusBetsHistoriesEdge>;
  /** A list of `BonusBetsHistory` objects. */
  nodes: Array<Maybe<BonusBetsHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BonusBetsHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BonusBetsHistory` edge in the connection. */
export type BonusBetsHistoriesEdge = {
  __typename?: 'BonusBetsHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BonusBetsHistory` at the end of the edge. */
  node?: Maybe<BonusBetsHistory>;
};

/** Methods to use when ordering `BonusBetsHistory`. */
export enum BonusBetsHistoriesOrderBy {
  BetIdAsc = 'BET_ID_ASC',
  BetIdDesc = 'BET_ID_DESC',
  BonusAsc = 'BONUS_ASC',
  BonusDesc = 'BONUS_DESC',
  BonusNormalizeAsc = 'BONUS_NORMALIZE_ASC',
  BonusNormalizeDesc = 'BONUS_NORMALIZE_DESC',
  BonusUsdAsc = 'BONUS_USD_ASC',
  BonusUsdDesc = 'BONUS_USD_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DenomAsc = 'DENOM_ASC',
  DenomDesc = 'DENOM_DESC',
  GameAsc = 'GAME_ASC',
  GameDesc = 'GAME_DESC',
  GameIdAsc = 'GAME_ID_ASC',
  GameIdDesc = 'GAME_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type BonusBetsHistory = {
  __typename?: 'BonusBetsHistory';
  betId: Scalars['BigInt']['output'];
  bonus: Scalars['BigFloat']['output'];
  bonusNormalize: Scalars['BigInt']['output'];
  bonusUsd: Scalars['BigInt']['output'];
  createdAt: Scalars['Datetime']['output'];
  denom: Scalars['String']['output'];
  game: Scalars['String']['output'];
  gameId: Scalars['BigInt']['output'];
};

/**
 * A condition to be used against `BonusBetsHistory` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BonusBetsHistoryCondition = {
  /** Checks for equality with the object’s `betId` field. */
  betId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `bonus` field. */
  bonus?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `bonusNormalize` field. */
  bonusNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `bonusUsd` field. */
  bonusUsd?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `denom` field. */
  denom?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `game` field. */
  game?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `gameId` field. */
  gameId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `BonusBetsHistory` object types. All fields are combined with a logical ‘and.’ */
export type BonusBetsHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BonusBetsHistoryFilter>>;
  /** Filter by the object’s `betId` field. */
  betId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `bonus` field. */
  bonus?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `bonusNormalize` field. */
  bonusNormalize?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `bonusUsd` field. */
  bonusUsd?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `denom` field. */
  denom?: InputMaybe<StringFilter>;
  /** Filter by the object’s `game` field. */
  game?: InputMaybe<StringFilter>;
  /** Filter by the object’s `gameId` field. */
  gameId?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BonusBetsHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BonusBetsHistoryFilter>>;
};

/** An input for mutations affecting `BonusBetsHistory` */
export type BonusBetsHistoryInput = {
  betId: Scalars['BigInt']['input'];
  bonus: Scalars['BigFloat']['input'];
  bonusNormalize: Scalars['BigInt']['input'];
  bonusUsd: Scalars['BigInt']['input'];
  createdAt: Scalars['Datetime']['input'];
  denom: Scalars['String']['input'];
  game: Scalars['String']['input'];
  gameId: Scalars['BigInt']['input'];
};

/** Represents an update to a `BonusBetsHistory`. Fields that are set will be updated. */
export type BonusBetsHistoryPatch = {
  betId?: InputMaybe<Scalars['BigInt']['input']>;
  bonus?: InputMaybe<Scalars['BigFloat']['input']>;
  bonusNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  bonusUsd?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  denom?: InputMaybe<Scalars['String']['input']>;
  game?: InputMaybe<Scalars['String']['input']>;
  gameId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type BooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** A connection to a list of `ClaimHistory` values. */
export type ClaimHistoriesConnection = {
  __typename?: 'ClaimHistoriesConnection';
  /** A list of edges which contains the `ClaimHistory` and cursor to aid in pagination. */
  edges: Array<ClaimHistoriesEdge>;
  /** A list of `ClaimHistory` objects. */
  nodes: Array<Maybe<ClaimHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ClaimHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ClaimHistory` edge in the connection. */
export type ClaimHistoriesEdge = {
  __typename?: 'ClaimHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ClaimHistory` at the end of the edge. */
  node?: Maybe<ClaimHistory>;
};

/** Methods to use when ordering `ClaimHistory`. */
export enum ClaimHistoriesOrderBy {
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserAsc = 'USER_ASC',
  UserDesc = 'USER_DESC'
}

export type ClaimHistory = {
  __typename?: 'ClaimHistory';
  date: Scalars['BigInt']['output'];
  id: Scalars['String']['output'];
  user: Scalars['String']['output'];
};

/**
 * A condition to be used against `ClaimHistory` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ClaimHistoryCondition = {
  /** Checks for equality with the object’s `date` field. */
  date?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `user` field. */
  user?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `ClaimHistory` object types. All fields are combined with a logical ‘and.’ */
export type ClaimHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ClaimHistoryFilter>>;
  /** Filter by the object’s `date` field. */
  date?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ClaimHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ClaimHistoryFilter>>;
  /** Filter by the object’s `user` field. */
  user?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `ClaimHistory` */
export type ClaimHistoryInput = {
  date: Scalars['BigInt']['input'];
  id: Scalars['String']['input'];
  user: Scalars['String']['input'];
};

/** Represents an update to a `ClaimHistory`. Fields that are set will be updated. */
export type ClaimHistoryPatch = {
  date?: InputMaybe<Scalars['BigInt']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export enum CoinflipChoice {
  Heads = 'HEADS',
  Tails = 'TAILS'
}

/** A filter to be used against CoinflipChoice fields. All fields are combined with a logical ‘and.’ */
export type CoinflipChoiceFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<CoinflipChoice>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<CoinflipChoice>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<CoinflipChoice>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<CoinflipChoice>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<CoinflipChoice>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<CoinflipChoice>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<CoinflipChoice>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<CoinflipChoice>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<CoinflipChoice>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<CoinflipChoice>>;
};

export type CoinflipGame = {
  __typename?: 'CoinflipGame';
  bet: Scalars['BigFloat']['output'];
  betNormalize: Scalars['BigInt']['output'];
  betUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Reads and enables pagination through a set of `CoinflipGameRound`. */
  coinflipGameRoundsByGameId: CoinflipGameRoundsConnection;
  created: Scalars['Datetime']['output'];
  denom?: Maybe<Scalars['String']['output']>;
  gameRound: Scalars['Int']['output'];
  id: Scalars['BigInt']['output'];
  maxGameRound: Scalars['Int']['output'];
  maxWin: Scalars['BigFloat']['output'];
  mode?: Maybe<CoinflipGameMode>;
  payable: Scalars['BigFloat']['output'];
  payoutNormalize: Scalars['BigInt']['output'];
  payoutUsd?: Maybe<Scalars['BigInt']['output']>;
  player: Scalars['String']['output'];
  processedGameRound: Scalars['Int']['output'];
  rtp: Scalars['BigFloat']['output'];
  status: MiniGameStatus;
  symbol: Scalars['String']['output'];
  txHash: Scalars['String']['output'];
  updated: Scalars['Datetime']['output'];
};


export type CoinflipGameCoinflipGameRoundsByGameIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoinflipGameRoundCondition>;
  filter?: InputMaybe<CoinflipGameRoundFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoinflipGameRoundsOrderBy>>;
};

/**
 * A condition to be used against `CoinflipGame` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CoinflipGameCondition = {
  /** Checks for equality with the object’s `bet` field. */
  bet?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `betNormalize` field. */
  betNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `betUsd` field. */
  betUsd?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `denom` field. */
  denom?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `gameRound` field. */
  gameRound?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `maxGameRound` field. */
  maxGameRound?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `maxWin` field. */
  maxWin?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `mode` field. */
  mode?: InputMaybe<CoinflipGameMode>;
  /** Checks for equality with the object’s `payable` field. */
  payable?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `payoutNormalize` field. */
  payoutNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `payoutUsd` field. */
  payoutUsd?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `player` field. */
  player?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `processedGameRound` field. */
  processedGameRound?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rtp` field. */
  rtp?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<MiniGameStatus>;
  /** Checks for equality with the object’s `symbol` field. */
  symbol?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `txHash` field. */
  txHash?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updated` field. */
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `CoinflipGame` object types. All fields are combined with a logical ‘and.’ */
export type CoinflipGameFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CoinflipGameFilter>>;
  /** Filter by the object’s `bet` field. */
  bet?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `betNormalize` field. */
  betNormalize?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `betUsd` field. */
  betUsd?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `denom` field. */
  denom?: InputMaybe<StringFilter>;
  /** Filter by the object’s `gameRound` field. */
  gameRound?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `maxGameRound` field. */
  maxGameRound?: InputMaybe<IntFilter>;
  /** Filter by the object’s `maxWin` field. */
  maxWin?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `mode` field. */
  mode?: InputMaybe<CoinflipGameModeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CoinflipGameFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CoinflipGameFilter>>;
  /** Filter by the object’s `payable` field. */
  payable?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `payoutNormalize` field. */
  payoutNormalize?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `payoutUsd` field. */
  payoutUsd?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `player` field. */
  player?: InputMaybe<StringFilter>;
  /** Filter by the object’s `processedGameRound` field. */
  processedGameRound?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rtp` field. */
  rtp?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<MiniGameStatusFilter>;
  /** Filter by the object’s `symbol` field. */
  symbol?: InputMaybe<StringFilter>;
  /** Filter by the object’s `txHash` field. */
  txHash?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updated` field. */
  updated?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `CoinflipGame` */
export type CoinflipGameInput = {
  bet: Scalars['BigFloat']['input'];
  betNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  betUsd?: InputMaybe<Scalars['BigInt']['input']>;
  created: Scalars['Datetime']['input'];
  denom?: InputMaybe<Scalars['String']['input']>;
  gameRound: Scalars['Int']['input'];
  id: Scalars['BigInt']['input'];
  maxGameRound: Scalars['Int']['input'];
  maxWin: Scalars['BigFloat']['input'];
  mode?: InputMaybe<CoinflipGameMode>;
  payable: Scalars['BigFloat']['input'];
  payoutNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  payoutUsd?: InputMaybe<Scalars['BigInt']['input']>;
  player: Scalars['String']['input'];
  processedGameRound: Scalars['Int']['input'];
  rtp: Scalars['BigFloat']['input'];
  status: MiniGameStatus;
  symbol?: InputMaybe<Scalars['String']['input']>;
  txHash: Scalars['String']['input'];
  updated: Scalars['Datetime']['input'];
};

export enum CoinflipGameMode {
  Instant = 'INSTANT',
  Multiple = 'MULTIPLE'
}

/** A filter to be used against CoinflipGameMode fields. All fields are combined with a logical ‘and.’ */
export type CoinflipGameModeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<CoinflipGameMode>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<CoinflipGameMode>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<CoinflipGameMode>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<CoinflipGameMode>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<CoinflipGameMode>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<CoinflipGameMode>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<CoinflipGameMode>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<CoinflipGameMode>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<CoinflipGameMode>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<CoinflipGameMode>>;
};

/** Represents an update to a `CoinflipGame`. Fields that are set will be updated. */
export type CoinflipGamePatch = {
  bet?: InputMaybe<Scalars['BigFloat']['input']>;
  betNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  betUsd?: InputMaybe<Scalars['BigInt']['input']>;
  created?: InputMaybe<Scalars['Datetime']['input']>;
  denom?: InputMaybe<Scalars['String']['input']>;
  gameRound?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  maxGameRound?: InputMaybe<Scalars['Int']['input']>;
  maxWin?: InputMaybe<Scalars['BigFloat']['input']>;
  mode?: InputMaybe<CoinflipGameMode>;
  payable?: InputMaybe<Scalars['BigFloat']['input']>;
  payoutNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  payoutUsd?: InputMaybe<Scalars['BigInt']['input']>;
  player?: InputMaybe<Scalars['String']['input']>;
  processedGameRound?: InputMaybe<Scalars['Int']['input']>;
  rtp?: InputMaybe<Scalars['BigFloat']['input']>;
  status?: InputMaybe<MiniGameStatus>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  txHash?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

export type CoinflipGameRound = {
  __typename?: 'CoinflipGameRound';
  created: Scalars['Datetime']['output'];
  /** Reads a single `CoinflipGame` that is related to this `CoinflipGameRound`. */
  game?: Maybe<CoinflipGame>;
  gameId: Scalars['BigInt']['output'];
  id: Scalars['BigInt']['output'];
  outcome?: Maybe<CoinflipChoice>;
  randomRound: Scalars['BigInt']['output'];
  result: MiniGameStatus;
  step: Scalars['BigInt']['output'];
  txHash: Scalars['String']['output'];
  updated: Scalars['Datetime']['output'];
  userChoice: CoinflipChoice;
};

/**
 * A condition to be used against `CoinflipGameRound` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CoinflipGameRoundCondition = {
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `gameId` field. */
  gameId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `outcome` field. */
  outcome?: InputMaybe<CoinflipChoice>;
  /** Checks for equality with the object’s `randomRound` field. */
  randomRound?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `result` field. */
  result?: InputMaybe<MiniGameStatus>;
  /** Checks for equality with the object’s `step` field. */
  step?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `txHash` field. */
  txHash?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updated` field. */
  updated?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `userChoice` field. */
  userChoice?: InputMaybe<CoinflipChoice>;
};

/** A filter to be used against `CoinflipGameRound` object types. All fields are combined with a logical ‘and.’ */
export type CoinflipGameRoundFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CoinflipGameRoundFilter>>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `gameId` field. */
  gameId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CoinflipGameRoundFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CoinflipGameRoundFilter>>;
  /** Filter by the object’s `outcome` field. */
  outcome?: InputMaybe<CoinflipChoiceFilter>;
  /** Filter by the object’s `randomRound` field. */
  randomRound?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `result` field. */
  result?: InputMaybe<MiniGameStatusFilter>;
  /** Filter by the object’s `step` field. */
  step?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `txHash` field. */
  txHash?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updated` field. */
  updated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userChoice` field. */
  userChoice?: InputMaybe<CoinflipChoiceFilter>;
};

/** An input for mutations affecting `CoinflipGameRound` */
export type CoinflipGameRoundInput = {
  created: Scalars['Datetime']['input'];
  gameId: Scalars['BigInt']['input'];
  id: Scalars['BigInt']['input'];
  outcome?: InputMaybe<CoinflipChoice>;
  randomRound: Scalars['BigInt']['input'];
  result: MiniGameStatus;
  step: Scalars['BigInt']['input'];
  txHash: Scalars['String']['input'];
  updated: Scalars['Datetime']['input'];
  userChoice: CoinflipChoice;
};

/** Represents an update to a `CoinflipGameRound`. Fields that are set will be updated. */
export type CoinflipGameRoundPatch = {
  created?: InputMaybe<Scalars['Datetime']['input']>;
  gameId?: InputMaybe<Scalars['BigInt']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  outcome?: InputMaybe<CoinflipChoice>;
  randomRound?: InputMaybe<Scalars['BigInt']['input']>;
  result?: InputMaybe<MiniGameStatus>;
  step?: InputMaybe<Scalars['BigInt']['input']>;
  txHash?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['Datetime']['input']>;
  userChoice?: InputMaybe<CoinflipChoice>;
};

/** A connection to a list of `CoinflipGameRound` values. */
export type CoinflipGameRoundsConnection = {
  __typename?: 'CoinflipGameRoundsConnection';
  /** A list of edges which contains the `CoinflipGameRound` and cursor to aid in pagination. */
  edges: Array<CoinflipGameRoundsEdge>;
  /** A list of `CoinflipGameRound` objects. */
  nodes: Array<Maybe<CoinflipGameRound>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CoinflipGameRound` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CoinflipGameRound` edge in the connection. */
export type CoinflipGameRoundsEdge = {
  __typename?: 'CoinflipGameRoundsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CoinflipGameRound` at the end of the edge. */
  node?: Maybe<CoinflipGameRound>;
};

/** Methods to use when ordering `CoinflipGameRound`. */
export enum CoinflipGameRoundsOrderBy {
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  GameIdAsc = 'GAME_ID_ASC',
  GameIdDesc = 'GAME_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OutcomeAsc = 'OUTCOME_ASC',
  OutcomeDesc = 'OUTCOME_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RandomRoundAsc = 'RANDOM_ROUND_ASC',
  RandomRoundDesc = 'RANDOM_ROUND_DESC',
  ResultAsc = 'RESULT_ASC',
  ResultDesc = 'RESULT_DESC',
  StepAsc = 'STEP_ASC',
  StepDesc = 'STEP_DESC',
  TxHashAsc = 'TX_HASH_ASC',
  TxHashDesc = 'TX_HASH_DESC',
  UpdatedAsc = 'UPDATED_ASC',
  UpdatedDesc = 'UPDATED_DESC',
  UserChoiceAsc = 'USER_CHOICE_ASC',
  UserChoiceDesc = 'USER_CHOICE_DESC'
}

/** A connection to a list of `CoinflipGame` values. */
export type CoinflipGamesConnection = {
  __typename?: 'CoinflipGamesConnection';
  /** A list of edges which contains the `CoinflipGame` and cursor to aid in pagination. */
  edges: Array<CoinflipGamesEdge>;
  /** A list of `CoinflipGame` objects. */
  nodes: Array<Maybe<CoinflipGame>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CoinflipGame` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CoinflipGame` edge in the connection. */
export type CoinflipGamesEdge = {
  __typename?: 'CoinflipGamesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CoinflipGame` at the end of the edge. */
  node?: Maybe<CoinflipGame>;
};

/** Methods to use when ordering `CoinflipGame`. */
export enum CoinflipGamesOrderBy {
  BetAsc = 'BET_ASC',
  BetDesc = 'BET_DESC',
  BetNormalizeAsc = 'BET_NORMALIZE_ASC',
  BetNormalizeDesc = 'BET_NORMALIZE_DESC',
  BetUsdAsc = 'BET_USD_ASC',
  BetUsdDesc = 'BET_USD_DESC',
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  DenomAsc = 'DENOM_ASC',
  DenomDesc = 'DENOM_DESC',
  GameRoundAsc = 'GAME_ROUND_ASC',
  GameRoundDesc = 'GAME_ROUND_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MaxGameRoundAsc = 'MAX_GAME_ROUND_ASC',
  MaxGameRoundDesc = 'MAX_GAME_ROUND_DESC',
  MaxWinAsc = 'MAX_WIN_ASC',
  MaxWinDesc = 'MAX_WIN_DESC',
  ModeAsc = 'MODE_ASC',
  ModeDesc = 'MODE_DESC',
  Natural = 'NATURAL',
  PayableAsc = 'PAYABLE_ASC',
  PayableDesc = 'PAYABLE_DESC',
  PayoutNormalizeAsc = 'PAYOUT_NORMALIZE_ASC',
  PayoutNormalizeDesc = 'PAYOUT_NORMALIZE_DESC',
  PayoutUsdAsc = 'PAYOUT_USD_ASC',
  PayoutUsdDesc = 'PAYOUT_USD_DESC',
  PlayerAsc = 'PLAYER_ASC',
  PlayerDesc = 'PLAYER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProcessedGameRoundAsc = 'PROCESSED_GAME_ROUND_ASC',
  ProcessedGameRoundDesc = 'PROCESSED_GAME_ROUND_DESC',
  RtpAsc = 'RTP_ASC',
  RtpDesc = 'RTP_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  SymbolAsc = 'SYMBOL_ASC',
  SymbolDesc = 'SYMBOL_DESC',
  TxHashAsc = 'TX_HASH_ASC',
  TxHashDesc = 'TX_HASH_DESC',
  UpdatedAsc = 'UPDATED_ASC',
  UpdatedDesc = 'UPDATED_DESC'
}

export type ContractConfig = {
  __typename?: 'ContractConfig';
  config: Scalars['JSON']['output'];
  id: Scalars['String']['output'];
  updated: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `ContractConfig` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ContractConfigCondition = {
  /** Checks for equality with the object’s `config` field. */
  config?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updated` field. */
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `ContractConfig` object types. All fields are combined with a logical ‘and.’ */
export type ContractConfigFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ContractConfigFilter>>;
  /** Filter by the object’s `config` field. */
  config?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ContractConfigFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ContractConfigFilter>>;
  /** Filter by the object’s `updated` field. */
  updated?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ContractConfig` */
export type ContractConfigInput = {
  config: Scalars['JSON']['input'];
  id: Scalars['String']['input'];
  updated: Scalars['Datetime']['input'];
};

/** Represents an update to a `ContractConfig`. Fields that are set will be updated. */
export type ContractConfigPatch = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `ContractConfig` values. */
export type ContractConfigsConnection = {
  __typename?: 'ContractConfigsConnection';
  /** A list of edges which contains the `ContractConfig` and cursor to aid in pagination. */
  edges: Array<ContractConfigsEdge>;
  /** A list of `ContractConfig` objects. */
  nodes: Array<Maybe<ContractConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ContractConfig` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ContractConfig` edge in the connection. */
export type ContractConfigsEdge = {
  __typename?: 'ContractConfigsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ContractConfig` at the end of the edge. */
  node?: Maybe<ContractConfig>;
};

/** Methods to use when ordering `ContractConfig`. */
export enum ContractConfigsOrderBy {
  ConfigAsc = 'CONFIG_ASC',
  ConfigDesc = 'CONFIG_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAsc = 'UPDATED_ASC',
  UpdatedDesc = 'UPDATED_DESC'
}

/** All input for the create `AuctionBasketBet` mutation. */
export type CreateAuctionBasketBetInput = {
  /** The `AuctionBasketBet` to be created by this mutation. */
  auctionBasketBet: AuctionBasketBetInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `AuctionBasketBet` mutation. */
export type CreateAuctionBasketBetPayload = {
  __typename?: 'CreateAuctionBasketBetPayload';
  /** Reads a single `AuctionBasket` that is related to this `AuctionBasketBet`. */
  auctionBasket?: Maybe<AuctionBasket>;
  /** The `AuctionBasketBet` that was created by this mutation. */
  auctionBasketBet?: Maybe<AuctionBasketBet>;
  /** An edge for our `AuctionBasketBet`. May be used by Relay 1. */
  auctionBasketBetEdge?: Maybe<AuctionBasketBetsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `AuctionBasketBet` mutation. */
export type CreateAuctionBasketBetPayloadAuctionBasketBetEdgeArgs = {
  orderBy?: InputMaybe<Array<AuctionBasketBetsOrderBy>>;
};

/** All input for the create `AuctionBasket` mutation. */
export type CreateAuctionBasketInput = {
  /** The `AuctionBasket` to be created by this mutation. */
  auctionBasket: AuctionBasketInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `AuctionBasket` mutation. */
export type CreateAuctionBasketPayload = {
  __typename?: 'CreateAuctionBasketPayload';
  /** The `AuctionBasket` that was created by this mutation. */
  auctionBasket?: Maybe<AuctionBasket>;
  /** An edge for our `AuctionBasket`. May be used by Relay 1. */
  auctionBasketEdge?: Maybe<AuctionBasketsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `AuctionBasket` mutation. */
export type CreateAuctionBasketPayloadAuctionBasketEdgeArgs = {
  orderBy?: InputMaybe<Array<AuctionBasketsOrderBy>>;
};

/** All input for the create `BankrollBalance` mutation. */
export type CreateBankrollBalanceInput = {
  /** The `BankrollBalance` to be created by this mutation. */
  bankrollBalance: BankrollBalanceInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `BankrollBalance` mutation. */
export type CreateBankrollBalancePayload = {
  __typename?: 'CreateBankrollBalancePayload';
  /** The `BankrollBalance` that was created by this mutation. */
  bankrollBalance?: Maybe<BankrollBalance>;
  /** An edge for our `BankrollBalance`. May be used by Relay 1. */
  bankrollBalanceEdge?: Maybe<BankrollBalancesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `BankrollBalance` mutation. */
export type CreateBankrollBalancePayloadBankrollBalanceEdgeArgs = {
  orderBy?: InputMaybe<Array<BankrollBalancesOrderBy>>;
};

/** All input for the create `BetsHistory` mutation. */
export type CreateBetsHistoryInput = {
  /** The `BetsHistory` to be created by this mutation. */
  betsHistory: BetsHistoryInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `BetsHistory` mutation. */
export type CreateBetsHistoryPayload = {
  __typename?: 'CreateBetsHistoryPayload';
  /** The `BetsHistory` that was created by this mutation. */
  betsHistory?: Maybe<BetsHistory>;
  /** An edge for our `BetsHistory`. May be used by Relay 1. */
  betsHistoryEdge?: Maybe<BetsHistoriesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `BetsHistory` mutation. */
export type CreateBetsHistoryPayloadBetsHistoryEdgeArgs = {
  orderBy?: InputMaybe<Array<BetsHistoriesOrderBy>>;
};

/** All input for the create `BonusBetsHistory` mutation. */
export type CreateBonusBetsHistoryInput = {
  /** The `BonusBetsHistory` to be created by this mutation. */
  bonusBetsHistory: BonusBetsHistoryInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `BonusBetsHistory` mutation. */
export type CreateBonusBetsHistoryPayload = {
  __typename?: 'CreateBonusBetsHistoryPayload';
  /** The `BonusBetsHistory` that was created by this mutation. */
  bonusBetsHistory?: Maybe<BonusBetsHistory>;
  /** An edge for our `BonusBetsHistory`. May be used by Relay 1. */
  bonusBetsHistoryEdge?: Maybe<BonusBetsHistoriesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `BonusBetsHistory` mutation. */
export type CreateBonusBetsHistoryPayloadBonusBetsHistoryEdgeArgs = {
  orderBy?: InputMaybe<Array<BonusBetsHistoriesOrderBy>>;
};

/** All input for the create `ClaimHistory` mutation. */
export type CreateClaimHistoryInput = {
  /** The `ClaimHistory` to be created by this mutation. */
  claimHistory: ClaimHistoryInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `ClaimHistory` mutation. */
export type CreateClaimHistoryPayload = {
  __typename?: 'CreateClaimHistoryPayload';
  /** The `ClaimHistory` that was created by this mutation. */
  claimHistory?: Maybe<ClaimHistory>;
  /** An edge for our `ClaimHistory`. May be used by Relay 1. */
  claimHistoryEdge?: Maybe<ClaimHistoriesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ClaimHistory` mutation. */
export type CreateClaimHistoryPayloadClaimHistoryEdgeArgs = {
  orderBy?: InputMaybe<Array<ClaimHistoriesOrderBy>>;
};

/** All input for the create `CoinflipGame` mutation. */
export type CreateCoinflipGameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `CoinflipGame` to be created by this mutation. */
  coinflipGame: CoinflipGameInput;
};

/** The output of our create `CoinflipGame` mutation. */
export type CreateCoinflipGamePayload = {
  __typename?: 'CreateCoinflipGamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CoinflipGame` that was created by this mutation. */
  coinflipGame?: Maybe<CoinflipGame>;
  /** An edge for our `CoinflipGame`. May be used by Relay 1. */
  coinflipGameEdge?: Maybe<CoinflipGamesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CoinflipGame` mutation. */
export type CreateCoinflipGamePayloadCoinflipGameEdgeArgs = {
  orderBy?: InputMaybe<Array<CoinflipGamesOrderBy>>;
};

/** All input for the create `CoinflipGameRound` mutation. */
export type CreateCoinflipGameRoundInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `CoinflipGameRound` to be created by this mutation. */
  coinflipGameRound: CoinflipGameRoundInput;
};

/** The output of our create `CoinflipGameRound` mutation. */
export type CreateCoinflipGameRoundPayload = {
  __typename?: 'CreateCoinflipGameRoundPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CoinflipGameRound` that was created by this mutation. */
  coinflipGameRound?: Maybe<CoinflipGameRound>;
  /** An edge for our `CoinflipGameRound`. May be used by Relay 1. */
  coinflipGameRoundEdge?: Maybe<CoinflipGameRoundsEdge>;
  /** Reads a single `CoinflipGame` that is related to this `CoinflipGameRound`. */
  game?: Maybe<CoinflipGame>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CoinflipGameRound` mutation. */
export type CreateCoinflipGameRoundPayloadCoinflipGameRoundEdgeArgs = {
  orderBy?: InputMaybe<Array<CoinflipGameRoundsOrderBy>>;
};

/** All input for the create `ContractConfig` mutation. */
export type CreateContractConfigInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ContractConfig` to be created by this mutation. */
  contractConfig: ContractConfigInput;
};

/** The output of our create `ContractConfig` mutation. */
export type CreateContractConfigPayload = {
  __typename?: 'CreateContractConfigPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `ContractConfig` that was created by this mutation. */
  contractConfig?: Maybe<ContractConfig>;
  /** An edge for our `ContractConfig`. May be used by Relay 1. */
  contractConfigEdge?: Maybe<ContractConfigsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ContractConfig` mutation. */
export type CreateContractConfigPayloadContractConfigEdgeArgs = {
  orderBy?: InputMaybe<Array<ContractConfigsOrderBy>>;
};

/** All input for the create `DoubleBet` mutation. */
export type CreateDoubleBetInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `DoubleBet` to be created by this mutation. */
  doubleBet: DoubleBetInput;
};

/** The output of our create `DoubleBet` mutation. */
export type CreateDoubleBetPayload = {
  __typename?: 'CreateDoubleBetPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `DoubleBet` that was created by this mutation. */
  doubleBet?: Maybe<DoubleBet>;
  /** An edge for our `DoubleBet`. May be used by Relay 1. */
  doubleBetEdge?: Maybe<DoubleBetsEdge>;
  /** Reads a single `DoubleGame` that is related to this `DoubleBet`. */
  game?: Maybe<DoubleGame>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `DoubleBet` mutation. */
export type CreateDoubleBetPayloadDoubleBetEdgeArgs = {
  orderBy?: InputMaybe<Array<DoubleBetsOrderBy>>;
};

/** All input for the create `DoubleGame` mutation. */
export type CreateDoubleGameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `DoubleGame` to be created by this mutation. */
  doubleGame: DoubleGameInput;
};

/** The output of our create `DoubleGame` mutation. */
export type CreateDoubleGamePayload = {
  __typename?: 'CreateDoubleGamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `DoubleGame` that was created by this mutation. */
  doubleGame?: Maybe<DoubleGame>;
  /** An edge for our `DoubleGame`. May be used by Relay 1. */
  doubleGameEdge?: Maybe<DoubleGamesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `DoubleGame` mutation. */
export type CreateDoubleGamePayloadDoubleGameEdgeArgs = {
  orderBy?: InputMaybe<Array<DoubleGamesOrderBy>>;
};

/** All input for the create `DoubleJackpot` mutation. */
export type CreateDoubleJackpotInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `DoubleJackpot` to be created by this mutation. */
  doubleJackpot: DoubleJackpotInput;
};

/** The output of our create `DoubleJackpot` mutation. */
export type CreateDoubleJackpotPayload = {
  __typename?: 'CreateDoubleJackpotPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `DoubleJackpot` that was created by this mutation. */
  doubleJackpot?: Maybe<DoubleJackpot>;
  /** An edge for our `DoubleJackpot`. May be used by Relay 1. */
  doubleJackpotEdge?: Maybe<DoubleJackpotsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `DoubleJackpot` mutation. */
export type CreateDoubleJackpotPayloadDoubleJackpotEdgeArgs = {
  orderBy?: InputMaybe<Array<DoubleJackpotsOrderBy>>;
};

/** All input for the create `FeeDistributedHistory` mutation. */
export type CreateFeeDistributedHistoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `FeeDistributedHistory` to be created by this mutation. */
  feeDistributedHistory: FeeDistributedHistoryInput;
};

/** The output of our create `FeeDistributedHistory` mutation. */
export type CreateFeeDistributedHistoryPayload = {
  __typename?: 'CreateFeeDistributedHistoryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `FeeDistributedHistory` that was created by this mutation. */
  feeDistributedHistory?: Maybe<FeeDistributedHistory>;
  /** An edge for our `FeeDistributedHistory`. May be used by Relay 1. */
  feeDistributedHistoryEdge?: Maybe<FeeDistributedHistoriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `FeeDistributedHistory` mutation. */
export type CreateFeeDistributedHistoryPayloadFeeDistributedHistoryEdgeArgs = {
  orderBy?: InputMaybe<Array<FeeDistributedHistoriesOrderBy>>;
};

/** All input for the create `GatewayChainTransaction` mutation. */
export type CreateGatewayChainTransactionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `GatewayChainTransaction` to be created by this mutation. */
  gatewayChainTransaction: GatewayChainTransactionInput;
};

/** The output of our create `GatewayChainTransaction` mutation. */
export type CreateGatewayChainTransactionPayload = {
  __typename?: 'CreateGatewayChainTransactionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `GatewayChainTransaction` that was created by this mutation. */
  gatewayChainTransaction?: Maybe<GatewayChainTransaction>;
  /** An edge for our `GatewayChainTransaction`. May be used by Relay 1. */
  gatewayChainTransactionEdge?: Maybe<GatewayChainTransactionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `GatewayChainTransaction` mutation. */
export type CreateGatewayChainTransactionPayloadGatewayChainTransactionEdgeArgs = {
  orderBy?: InputMaybe<Array<GatewayChainTransactionsOrderBy>>;
};

/** All input for the create `JackpotBet` mutation. */
export type CreateJackpotBetInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `JackpotBet` to be created by this mutation. */
  jackpotBet: JackpotBetInput;
};

/** The output of our create `JackpotBet` mutation. */
export type CreateJackpotBetPayload = {
  __typename?: 'CreateJackpotBetPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `JackpotGame` that is related to this `JackpotBet`. */
  game?: Maybe<JackpotGame>;
  /** The `JackpotBet` that was created by this mutation. */
  jackpotBet?: Maybe<JackpotBet>;
  /** An edge for our `JackpotBet`. May be used by Relay 1. */
  jackpotBetEdge?: Maybe<JackpotBetsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `JackpotBet` mutation. */
export type CreateJackpotBetPayloadJackpotBetEdgeArgs = {
  orderBy?: InputMaybe<Array<JackpotBetsOrderBy>>;
};

/** All input for the create `JackpotGame` mutation. */
export type CreateJackpotGameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `JackpotGame` to be created by this mutation. */
  jackpotGame: JackpotGameInput;
};

/** The output of our create `JackpotGame` mutation. */
export type CreateJackpotGamePayload = {
  __typename?: 'CreateJackpotGamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `JackpotGame` that was created by this mutation. */
  jackpotGame?: Maybe<JackpotGame>;
  /** An edge for our `JackpotGame`. May be used by Relay 1. */
  jackpotGameEdge?: Maybe<JackpotGamesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `JackpotGame` mutation. */
export type CreateJackpotGamePayloadJackpotGameEdgeArgs = {
  orderBy?: InputMaybe<Array<JackpotGamesOrderBy>>;
};

/** All input for the create `LootboxGame` mutation. */
export type CreateLootboxGameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `LootboxGame` to be created by this mutation. */
  lootboxGame: LootboxGameInput;
};

/** The output of our create `LootboxGame` mutation. */
export type CreateLootboxGamePayload = {
  __typename?: 'CreateLootboxGamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `LootboxGame` that was created by this mutation. */
  lootboxGame?: Maybe<LootboxGame>;
  /** An edge for our `LootboxGame`. May be used by Relay 1. */
  lootboxGameEdge?: Maybe<LootboxGamesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `LootboxGame` mutation. */
export type CreateLootboxGamePayloadLootboxGameEdgeArgs = {
  orderBy?: InputMaybe<Array<LootboxGamesOrderBy>>;
};

/** All input for the create `Lootbox` mutation. */
export type CreateLootboxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Lootbox` to be created by this mutation. */
  lootbox: LootboxInput;
};

/** All input for the create `LootboxMarketOrder` mutation. */
export type CreateLootboxMarketOrderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `LootboxMarketOrder` to be created by this mutation. */
  lootboxMarketOrder: LootboxMarketOrderInput;
};

/** The output of our create `LootboxMarketOrder` mutation. */
export type CreateLootboxMarketOrderPayload = {
  __typename?: 'CreateLootboxMarketOrderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `LootboxMarketOrder` that was created by this mutation. */
  lootboxMarketOrder?: Maybe<LootboxMarketOrder>;
  /** An edge for our `LootboxMarketOrder`. May be used by Relay 1. */
  lootboxMarketOrderEdge?: Maybe<LootboxMarketOrdersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `LootboxMarketOrder` mutation. */
export type CreateLootboxMarketOrderPayloadLootboxMarketOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<LootboxMarketOrdersOrderBy>>;
};

/** All input for the create `LootboxMarketTrade` mutation. */
export type CreateLootboxMarketTradeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `LootboxMarketTrade` to be created by this mutation. */
  lootboxMarketTrade: LootboxMarketTradeInput;
};

/** The output of our create `LootboxMarketTrade` mutation. */
export type CreateLootboxMarketTradePayload = {
  __typename?: 'CreateLootboxMarketTradePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `LootboxMarketTrade` that was created by this mutation. */
  lootboxMarketTrade?: Maybe<LootboxMarketTrade>;
  /** An edge for our `LootboxMarketTrade`. May be used by Relay 1. */
  lootboxMarketTradeEdge?: Maybe<LootboxMarketTradesEdge>;
  /** Reads a single `LootboxMarketOrder` that is related to this `LootboxMarketTrade`. */
  order?: Maybe<LootboxMarketOrder>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `LootboxMarketTrade` mutation. */
export type CreateLootboxMarketTradePayloadLootboxMarketTradeEdgeArgs = {
  orderBy?: InputMaybe<Array<LootboxMarketTradesOrderBy>>;
};

/** The output of our create `Lootbox` mutation. */
export type CreateLootboxPayload = {
  __typename?: 'CreateLootboxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Lootbox` that was created by this mutation. */
  lootbox?: Maybe<Lootbox>;
  /** An edge for our `Lootbox`. May be used by Relay 1. */
  lootboxEdge?: Maybe<LootboxesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Lootbox` mutation. */
export type CreateLootboxPayloadLootboxEdgeArgs = {
  orderBy?: InputMaybe<Array<LootboxesOrderBy>>;
};

/** All input for the create `LootboxReward` mutation. */
export type CreateLootboxRewardInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `LootboxReward` to be created by this mutation. */
  lootboxReward: LootboxRewardInput;
};

/** The output of our create `LootboxReward` mutation. */
export type CreateLootboxRewardPayload = {
  __typename?: 'CreateLootboxRewardPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `LootboxReward` that was created by this mutation. */
  lootboxReward?: Maybe<LootboxReward>;
  /** An edge for our `LootboxReward`. May be used by Relay 1. */
  lootboxRewardEdge?: Maybe<LootboxRewardsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `LootboxReward` mutation. */
export type CreateLootboxRewardPayloadLootboxRewardEdgeArgs = {
  orderBy?: InputMaybe<Array<LootboxRewardsOrderBy>>;
};

/** All input for the create `LootboxSale` mutation. */
export type CreateLootboxSaleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `LootboxSale` to be created by this mutation. */
  lootboxSale: LootboxSaleInput;
};

/** The output of our create `LootboxSale` mutation. */
export type CreateLootboxSalePayload = {
  __typename?: 'CreateLootboxSalePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `LootboxSale` that was created by this mutation. */
  lootboxSale?: Maybe<LootboxSale>;
  /** An edge for our `LootboxSale`. May be used by Relay 1. */
  lootboxSaleEdge?: Maybe<LootboxSalesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `LootboxSale` mutation. */
export type CreateLootboxSalePayloadLootboxSaleEdgeArgs = {
  orderBy?: InputMaybe<Array<LootboxSalesOrderBy>>;
};

/** All input for the create `LootboxUnlimitedGame` mutation. */
export type CreateLootboxUnlimitedGameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `LootboxUnlimitedGame` to be created by this mutation. */
  lootboxUnlimitedGame: LootboxUnlimitedGameInput;
};

/** The output of our create `LootboxUnlimitedGame` mutation. */
export type CreateLootboxUnlimitedGamePayload = {
  __typename?: 'CreateLootboxUnlimitedGamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `LootboxUnlimitedGame` that was created by this mutation. */
  lootboxUnlimitedGame?: Maybe<LootboxUnlimitedGame>;
  /** An edge for our `LootboxUnlimitedGame`. May be used by Relay 1. */
  lootboxUnlimitedGameEdge?: Maybe<LootboxUnlimitedGamesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `LootboxUnlimitedGame` mutation. */
export type CreateLootboxUnlimitedGamePayloadLootboxUnlimitedGameEdgeArgs = {
  orderBy?: InputMaybe<Array<LootboxUnlimitedGamesOrderBy>>;
};

/** All input for the create `LootboxesUnlimited` mutation. */
export type CreateLootboxesUnlimitedInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `LootboxesUnlimited` to be created by this mutation. */
  lootboxesUnlimited: LootboxesUnlimitedInput;
};

/** The output of our create `LootboxesUnlimited` mutation. */
export type CreateLootboxesUnlimitedPayload = {
  __typename?: 'CreateLootboxesUnlimitedPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `LootboxesUnlimited` that was created by this mutation. */
  lootboxesUnlimited?: Maybe<LootboxesUnlimited>;
  /** An edge for our `LootboxesUnlimited`. May be used by Relay 1. */
  lootboxesUnlimitedEdge?: Maybe<LootboxesUnlimitedsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `LootboxesUnlimited` mutation. */
export type CreateLootboxesUnlimitedPayloadLootboxesUnlimitedEdgeArgs = {
  orderBy?: InputMaybe<Array<LootboxesUnlimitedsOrderBy>>;
};

/** All input for the create `MinesGame` mutation. */
export type CreateMinesGameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `MinesGame` to be created by this mutation. */
  minesGame: MinesGameInput;
};

/** The output of our create `MinesGame` mutation. */
export type CreateMinesGamePayload = {
  __typename?: 'CreateMinesGamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `MinesGame` that was created by this mutation. */
  minesGame?: Maybe<MinesGame>;
  /** An edge for our `MinesGame`. May be used by Relay 1. */
  minesGameEdge?: Maybe<MinesGamesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `MinesGame` mutation. */
export type CreateMinesGamePayloadMinesGameEdgeArgs = {
  orderBy?: InputMaybe<Array<MinesGamesOrderBy>>;
};

/** All input for the create `MinesGameRound` mutation. */
export type CreateMinesGameRoundInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `MinesGameRound` to be created by this mutation. */
  minesGameRound: MinesGameRoundInput;
};

/** The output of our create `MinesGameRound` mutation. */
export type CreateMinesGameRoundPayload = {
  __typename?: 'CreateMinesGameRoundPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `MinesGame` that is related to this `MinesGameRound`. */
  game?: Maybe<MinesGame>;
  /** The `MinesGameRound` that was created by this mutation. */
  minesGameRound?: Maybe<MinesGameRound>;
  /** An edge for our `MinesGameRound`. May be used by Relay 1. */
  minesGameRoundEdge?: Maybe<MinesGameRoundsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `MinesGameRound` mutation. */
export type CreateMinesGameRoundPayloadMinesGameRoundEdgeArgs = {
  orderBy?: InputMaybe<Array<MinesGameRoundsOrderBy>>;
};

/** All input for the create `Nft` mutation. */
export type CreateNftInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Nft` to be created by this mutation. */
  nft: NftInput;
};

/** The output of our create `Nft` mutation. */
export type CreateNftPayload = {
  __typename?: 'CreateNftPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Nft` that was created by this mutation. */
  nft?: Maybe<Nft>;
  /** An edge for our `Nft`. May be used by Relay 1. */
  nftEdge?: Maybe<NftsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Nft` mutation. */
export type CreateNftPayloadNftEdgeArgs = {
  orderBy?: InputMaybe<Array<NftsOrderBy>>;
};

/** All input for the create `NftsVote` mutation. */
export type CreateNftsVoteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `NftsVote` to be created by this mutation. */
  nftsVote: NftsVoteInput;
};

/** The output of our create `NftsVote` mutation. */
export type CreateNftsVotePayload = {
  __typename?: 'CreateNftsVotePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `NftsVote` that was created by this mutation. */
  nftsVote?: Maybe<NftsVote>;
  /** An edge for our `NftsVote`. May be used by Relay 1. */
  nftsVoteEdge?: Maybe<NftsVotesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `NftsVote` mutation. */
export type CreateNftsVotePayloadNftsVoteEdgeArgs = {
  orderBy?: InputMaybe<Array<NftsVotesOrderBy>>;
};

/** All input for the create `OpenCompetitionEntity` mutation. */
export type CreateOpenCompetitionEntityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `OpenCompetitionEntity` to be created by this mutation. */
  openCompetitionEntity: OpenCompetitionEntityInput;
};

/** The output of our create `OpenCompetitionEntity` mutation. */
export type CreateOpenCompetitionEntityPayload = {
  __typename?: 'CreateOpenCompetitionEntityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `OpenCompetitionEntity` that was created by this mutation. */
  openCompetitionEntity?: Maybe<OpenCompetitionEntity>;
  /** An edge for our `OpenCompetitionEntity`. May be used by Relay 1. */
  openCompetitionEntityEdge?: Maybe<OpenCompetitionEntitiesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `OpenCompetitionEntity` mutation. */
export type CreateOpenCompetitionEntityPayloadOpenCompetitionEntityEdgeArgs = {
  orderBy?: InputMaybe<Array<OpenCompetitionEntitiesOrderBy>>;
};

/** All input for the create `PlinkoGame` mutation. */
export type CreatePlinkoGameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `PlinkoGame` to be created by this mutation. */
  plinkoGame: PlinkoGameInput;
};

/** The output of our create `PlinkoGame` mutation. */
export type CreatePlinkoGamePayload = {
  __typename?: 'CreatePlinkoGamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `PlinkoGame` that was created by this mutation. */
  plinkoGame?: Maybe<PlinkoGame>;
  /** An edge for our `PlinkoGame`. May be used by Relay 1. */
  plinkoGameEdge?: Maybe<PlinkoGamesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `PlinkoGame` mutation. */
export type CreatePlinkoGamePayloadPlinkoGameEdgeArgs = {
  orderBy?: InputMaybe<Array<PlinkoGamesOrderBy>>;
};

/** All input for the create `PointTransaction` mutation. */
export type CreatePointTransactionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `PointTransaction` to be created by this mutation. */
  pointTransaction: PointTransactionInput;
};

/** The output of our create `PointTransaction` mutation. */
export type CreatePointTransactionPayload = {
  __typename?: 'CreatePointTransactionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `PointTransaction` that was created by this mutation. */
  pointTransaction?: Maybe<PointTransaction>;
  /** An edge for our `PointTransaction`. May be used by Relay 1. */
  pointTransactionEdge?: Maybe<PointTransactionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `PointTransaction` mutation. */
export type CreatePointTransactionPayloadPointTransactionEdgeArgs = {
  orderBy?: InputMaybe<Array<PointTransactionsOrderBy>>;
};

/** All input for the create `RngRound` mutation. */
export type CreateRngRoundInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `RngRound` to be created by this mutation. */
  rngRound: RngRoundInput;
};

/** The output of our create `RngRound` mutation. */
export type CreateRngRoundPayload = {
  __typename?: 'CreateRngRoundPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RngRound` that was created by this mutation. */
  rngRound?: Maybe<RngRound>;
  /** An edge for our `RngRound`. May be used by Relay 1. */
  rngRoundEdge?: Maybe<RngRoundsEdge>;
};


/** The output of our create `RngRound` mutation. */
export type CreateRngRoundPayloadRngRoundEdgeArgs = {
  orderBy?: InputMaybe<Array<RngRoundsOrderBy>>;
};

/** All input for the create `RoshamboGame` mutation. */
export type CreateRoshamboGameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `RoshamboGame` to be created by this mutation. */
  roshamboGame: RoshamboGameInput;
};

/** All input for the create `RoshamboGameLog` mutation. */
export type CreateRoshamboGameLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `RoshamboGameLog` to be created by this mutation. */
  roshamboGameLog: RoshamboGameLogInput;
};

/** The output of our create `RoshamboGameLog` mutation. */
export type CreateRoshamboGameLogPayload = {
  __typename?: 'CreateRoshamboGameLogPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RoshamboGameLog` that was created by this mutation. */
  roshamboGameLog?: Maybe<RoshamboGameLog>;
  /** An edge for our `RoshamboGameLog`. May be used by Relay 1. */
  roshamboGameLogEdge?: Maybe<RoshamboGameLogsEdge>;
};


/** The output of our create `RoshamboGameLog` mutation. */
export type CreateRoshamboGameLogPayloadRoshamboGameLogEdgeArgs = {
  orderBy?: InputMaybe<Array<RoshamboGameLogsOrderBy>>;
};

/** The output of our create `RoshamboGame` mutation. */
export type CreateRoshamboGamePayload = {
  __typename?: 'CreateRoshamboGamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RoshamboGame` that was created by this mutation. */
  roshamboGame?: Maybe<RoshamboGame>;
  /** An edge for our `RoshamboGame`. May be used by Relay 1. */
  roshamboGameEdge?: Maybe<RoshamboGamesEdge>;
};


/** The output of our create `RoshamboGame` mutation. */
export type CreateRoshamboGamePayloadRoshamboGameEdgeArgs = {
  orderBy?: InputMaybe<Array<RoshamboGamesOrderBy>>;
};

/** All input for the create `RunesGame` mutation. */
export type CreateRunesGameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `RunesGame` to be created by this mutation. */
  runesGame: RunesGameInput;
};

/** The output of our create `RunesGame` mutation. */
export type CreateRunesGamePayload = {
  __typename?: 'CreateRunesGamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RunesGame` that was created by this mutation. */
  runesGame?: Maybe<RunesGame>;
  /** An edge for our `RunesGame`. May be used by Relay 1. */
  runesGameEdge?: Maybe<RunesGamesEdge>;
};


/** The output of our create `RunesGame` mutation. */
export type CreateRunesGamePayloadRunesGameEdgeArgs = {
  orderBy?: InputMaybe<Array<RunesGamesOrderBy>>;
};

/** All input for the create `Statistic` mutation. */
export type CreateStatisticInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Statistic` to be created by this mutation. */
  statistic: StatisticInput;
};

/** The output of our create `Statistic` mutation. */
export type CreateStatisticPayload = {
  __typename?: 'CreateStatisticPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Statistic` that was created by this mutation. */
  statistic?: Maybe<Statistic>;
  /** An edge for our `Statistic`. May be used by Relay 1. */
  statisticEdge?: Maybe<StatisticsEdge>;
};


/** The output of our create `Statistic` mutation. */
export type CreateStatisticPayloadStatisticEdgeArgs = {
  orderBy?: InputMaybe<Array<StatisticsOrderBy>>;
};

/** All input for the create `StatisticsV2` mutation. */
export type CreateStatisticsV2Input = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `StatisticsV2` to be created by this mutation. */
  statisticsV2: StatisticsV2Input;
};

/** The output of our create `StatisticsV2` mutation. */
export type CreateStatisticsV2Payload = {
  __typename?: 'CreateStatisticsV2Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `StatisticsV2` that was created by this mutation. */
  statisticsV2?: Maybe<StatisticsV2>;
  /** An edge for our `StatisticsV2`. May be used by Relay 1. */
  statisticsV2Edge?: Maybe<StatisticsV2sEdge>;
};


/** The output of our create `StatisticsV2` mutation. */
export type CreateStatisticsV2PayloadStatisticsV2EdgeArgs = {
  orderBy?: InputMaybe<Array<StatisticsV2sOrderBy>>;
};

/** All input for the create `TokenBurnHistory` mutation. */
export type CreateTokenBurnHistoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `TokenBurnHistory` to be created by this mutation. */
  tokenBurnHistory: TokenBurnHistoryInput;
};

/** The output of our create `TokenBurnHistory` mutation. */
export type CreateTokenBurnHistoryPayload = {
  __typename?: 'CreateTokenBurnHistoryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TokenBurnHistory` that was created by this mutation. */
  tokenBurnHistory?: Maybe<TokenBurnHistory>;
  /** An edge for our `TokenBurnHistory`. May be used by Relay 1. */
  tokenBurnHistoryEdge?: Maybe<TokenBurnHistoriesEdge>;
};


/** The output of our create `TokenBurnHistory` mutation. */
export type CreateTokenBurnHistoryPayloadTokenBurnHistoryEdgeArgs = {
  orderBy?: InputMaybe<Array<TokenBurnHistoriesOrderBy>>;
};

/** All input for the create `TokenClaim` mutation. */
export type CreateTokenClaimInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `TokenClaim` to be created by this mutation. */
  tokenClaim: TokenClaimInput;
};

/** The output of our create `TokenClaim` mutation. */
export type CreateTokenClaimPayload = {
  __typename?: 'CreateTokenClaimPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TokenClaim` that was created by this mutation. */
  tokenClaim?: Maybe<TokenClaim>;
  /** An edge for our `TokenClaim`. May be used by Relay 1. */
  tokenClaimEdge?: Maybe<TokenClaimsEdge>;
};


/** The output of our create `TokenClaim` mutation. */
export type CreateTokenClaimPayloadTokenClaimEdgeArgs = {
  orderBy?: InputMaybe<Array<TokenClaimsOrderBy>>;
};

/** All input for the create `TokenPrice` mutation. */
export type CreateTokenPriceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `TokenPrice` to be created by this mutation. */
  tokenPrice: TokenPriceInput;
};

/** The output of our create `TokenPrice` mutation. */
export type CreateTokenPricePayload = {
  __typename?: 'CreateTokenPricePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TokenPrice` that was created by this mutation. */
  tokenPrice?: Maybe<TokenPrice>;
  /** An edge for our `TokenPrice`. May be used by Relay 1. */
  tokenPriceEdge?: Maybe<TokenPricesEdge>;
};


/** The output of our create `TokenPrice` mutation. */
export type CreateTokenPricePayloadTokenPriceEdgeArgs = {
  orderBy?: InputMaybe<Array<TokenPricesOrderBy>>;
};

/** All input for the create `TokenSalesInfo` mutation. */
export type CreateTokenSalesInfoInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `TokenSalesInfo` to be created by this mutation. */
  tokenSalesInfo: TokenSalesInfoInput;
};

/** The output of our create `TokenSalesInfo` mutation. */
export type CreateTokenSalesInfoPayload = {
  __typename?: 'CreateTokenSalesInfoPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TokenSalesInfo` that was created by this mutation. */
  tokenSalesInfo?: Maybe<TokenSalesInfo>;
  /** An edge for our `TokenSalesInfo`. May be used by Relay 1. */
  tokenSalesInfoEdge?: Maybe<TokenSalesInfosEdge>;
};


/** The output of our create `TokenSalesInfo` mutation. */
export type CreateTokenSalesInfoPayloadTokenSalesInfoEdgeArgs = {
  orderBy?: InputMaybe<Array<TokenSalesInfosOrderBy>>;
};

/** All input for the create `TokenSalesPriceInfo` mutation. */
export type CreateTokenSalesPriceInfoInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `TokenSalesPriceInfo` to be created by this mutation. */
  tokenSalesPriceInfo: TokenSalesPriceInfoInput;
};

/** The output of our create `TokenSalesPriceInfo` mutation. */
export type CreateTokenSalesPriceInfoPayload = {
  __typename?: 'CreateTokenSalesPriceInfoPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TokenSalesPriceInfo` that was created by this mutation. */
  tokenSalesPriceInfo?: Maybe<TokenSalesPriceInfo>;
  /** An edge for our `TokenSalesPriceInfo`. May be used by Relay 1. */
  tokenSalesPriceInfoEdge?: Maybe<TokenSalesPriceInfosEdge>;
};


/** The output of our create `TokenSalesPriceInfo` mutation. */
export type CreateTokenSalesPriceInfoPayloadTokenSalesPriceInfoEdgeArgs = {
  orderBy?: InputMaybe<Array<TokenSalesPriceInfosOrderBy>>;
};

/** All input for the create `UserBetHistory` mutation. */
export type CreateUserBetHistoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UserBetHistory` to be created by this mutation. */
  userBetHistory: UserBetHistoryInput;
};

/** The output of our create `UserBetHistory` mutation. */
export type CreateUserBetHistoryPayload = {
  __typename?: 'CreateUserBetHistoryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserBetHistory` that was created by this mutation. */
  userBetHistory?: Maybe<UserBetHistory>;
  /** An edge for our `UserBetHistory`. May be used by Relay 1. */
  userBetHistoryEdge?: Maybe<UserBetHistoriesEdge>;
};


/** The output of our create `UserBetHistory` mutation. */
export type CreateUserBetHistoryPayloadUserBetHistoryEdgeArgs = {
  orderBy?: InputMaybe<Array<UserBetHistoriesOrderBy>>;
};

/** All input for the create `UserCompetition` mutation. */
export type CreateUserCompetitionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UserCompetition` to be created by this mutation. */
  userCompetition: UserCompetitionInput;
};

/** The output of our create `UserCompetition` mutation. */
export type CreateUserCompetitionPayload = {
  __typename?: 'CreateUserCompetitionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserCompetition` that was created by this mutation. */
  userCompetition?: Maybe<UserCompetition>;
  /** An edge for our `UserCompetition`. May be used by Relay 1. */
  userCompetitionEdge?: Maybe<UserCompetitionsEdge>;
};


/** The output of our create `UserCompetition` mutation. */
export type CreateUserCompetitionPayloadUserCompetitionEdgeArgs = {
  orderBy?: InputMaybe<Array<UserCompetitionsOrderBy>>;
};

/** All input for the create `User` mutation. */
export type CreateUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `User` to be created by this mutation. */
  user: UserInput;
};

/** The output of our create `User` mutation. */
export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was created by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
  /** Reads a single `UserStatistic` that is related to this `User`. */
  userStatistic?: Maybe<UserStatistic>;
};


/** The output of our create `User` mutation. */
export type CreateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the create `UserStatistic` mutation. */
export type CreateUserStatisticInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UserStatistic` to be created by this mutation. */
  userStatistic: UserStatisticInput;
};

/** The output of our create `UserStatistic` mutation. */
export type CreateUserStatisticPayload = {
  __typename?: 'CreateUserStatisticPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserStatistic` that was created by this mutation. */
  userStatistic?: Maybe<UserStatistic>;
  /** An edge for our `UserStatistic`. May be used by Relay 1. */
  userStatisticEdge?: Maybe<UserStatisticsEdge>;
};


/** The output of our create `UserStatistic` mutation. */
export type CreateUserStatisticPayloadUserStatisticEdgeArgs = {
  orderBy?: InputMaybe<Array<UserStatisticsOrderBy>>;
};

/** All input for the create `UserStatisticsByDay` mutation. */
export type CreateUserStatisticsByDayInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UserStatisticsByDay` to be created by this mutation. */
  userStatisticsByDay: UserStatisticsByDayInput;
};

/** The output of our create `UserStatisticsByDay` mutation. */
export type CreateUserStatisticsByDayPayload = {
  __typename?: 'CreateUserStatisticsByDayPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UserStatistic` that is related to this `UserStatisticsByDay`. */
  userStatisticById?: Maybe<UserStatistic>;
  /** The `UserStatisticsByDay` that was created by this mutation. */
  userStatisticsByDay?: Maybe<UserStatisticsByDay>;
  /** An edge for our `UserStatisticsByDay`. May be used by Relay 1. */
  userStatisticsByDayEdge?: Maybe<UserStatisticsByDaysEdge>;
};


/** The output of our create `UserStatisticsByDay` mutation. */
export type CreateUserStatisticsByDayPayloadUserStatisticsByDayEdgeArgs = {
  orderBy?: InputMaybe<Array<UserStatisticsByDaysOrderBy>>;
};

/** All input for the create `UserStatisticsV2` mutation. */
export type CreateUserStatisticsV2Input = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UserStatisticsV2` to be created by this mutation. */
  userStatisticsV2: UserStatisticsV2Input;
};

/** The output of our create `UserStatisticsV2` mutation. */
export type CreateUserStatisticsV2Payload = {
  __typename?: 'CreateUserStatisticsV2Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserStatisticsV2` that was created by this mutation. */
  userStatisticsV2?: Maybe<UserStatisticsV2>;
  /** An edge for our `UserStatisticsV2`. May be used by Relay 1. */
  userStatisticsV2Edge?: Maybe<UserStatisticsV2sEdge>;
};


/** The output of our create `UserStatisticsV2` mutation. */
export type CreateUserStatisticsV2PayloadUserStatisticsV2EdgeArgs = {
  orderBy?: InputMaybe<Array<UserStatisticsV2sOrderBy>>;
};

/** All input for the create `UserTokenSale` mutation. */
export type CreateUserTokenSaleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UserTokenSale` to be created by this mutation. */
  userTokenSale: UserTokenSaleInput;
};

/** The output of our create `UserTokenSale` mutation. */
export type CreateUserTokenSalePayload = {
  __typename?: 'CreateUserTokenSalePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserTokenSale` that was created by this mutation. */
  userTokenSale?: Maybe<UserTokenSale>;
  /** An edge for our `UserTokenSale`. May be used by Relay 1. */
  userTokenSaleEdge?: Maybe<UserTokenSalesEdge>;
};


/** The output of our create `UserTokenSale` mutation. */
export type CreateUserTokenSalePayloadUserTokenSaleEdgeArgs = {
  orderBy?: InputMaybe<Array<UserTokenSalesOrderBy>>;
};

/** All input for the create `UserTokenSaleTransaction` mutation. */
export type CreateUserTokenSaleTransactionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UserTokenSaleTransaction` to be created by this mutation. */
  userTokenSaleTransaction: UserTokenSaleTransactionInput;
};

/** The output of our create `UserTokenSaleTransaction` mutation. */
export type CreateUserTokenSaleTransactionPayload = {
  __typename?: 'CreateUserTokenSaleTransactionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserTokenSaleTransaction` that was created by this mutation. */
  userTokenSaleTransaction?: Maybe<UserTokenSaleTransaction>;
  /** An edge for our `UserTokenSaleTransaction`. May be used by Relay 1. */
  userTokenSaleTransactionEdge?: Maybe<UserTokenSaleTransactionsEdge>;
};


/** The output of our create `UserTokenSaleTransaction` mutation. */
export type CreateUserTokenSaleTransactionPayloadUserTokenSaleTransactionEdgeArgs = {
  orderBy?: InputMaybe<Array<UserTokenSaleTransactionsOrderBy>>;
};

/** All input for the create `VersionInfo` mutation. */
export type CreateVersionInfoInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `VersionInfo` to be created by this mutation. */
  versionInfo: VersionInfoInput;
};

/** The output of our create `VersionInfo` mutation. */
export type CreateVersionInfoPayload = {
  __typename?: 'CreateVersionInfoPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VersionInfo` that was created by this mutation. */
  versionInfo?: Maybe<VersionInfo>;
  /** An edge for our `VersionInfo`. May be used by Relay 1. */
  versionInfoEdge?: Maybe<VersionInfosEdge>;
};


/** The output of our create `VersionInfo` mutation. */
export type CreateVersionInfoPayloadVersionInfoEdgeArgs = {
  orderBy?: InputMaybe<Array<VersionInfosOrderBy>>;
};

/** A filter to be used against Date fields. All fields are combined with a logical ‘and.’ */
export type DateFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Date']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Date']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Date']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Date']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Date']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Date']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Date']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Date']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Date']['input']>>;
};

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Datetime']['input']>>;
};

/** All input for the `deleteAuctionBasketBet` mutation. */
export type DeleteAuctionBasketBetInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `AuctionBasketBet` mutation. */
export type DeleteAuctionBasketBetPayload = {
  __typename?: 'DeleteAuctionBasketBetPayload';
  /** Reads a single `AuctionBasket` that is related to this `AuctionBasketBet`. */
  auctionBasket?: Maybe<AuctionBasket>;
  /** The `AuctionBasketBet` that was deleted by this mutation. */
  auctionBasketBet?: Maybe<AuctionBasketBet>;
  /** An edge for our `AuctionBasketBet`. May be used by Relay 1. */
  auctionBasketBetEdge?: Maybe<AuctionBasketBetsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedAuctionBasketBetNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `AuctionBasketBet` mutation. */
export type DeleteAuctionBasketBetPayloadAuctionBasketBetEdgeArgs = {
  orderBy?: InputMaybe<Array<AuctionBasketBetsOrderBy>>;
};

/** All input for the `deleteAuctionBasket` mutation. */
export type DeleteAuctionBasketInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `AuctionBasket` mutation. */
export type DeleteAuctionBasketPayload = {
  __typename?: 'DeleteAuctionBasketPayload';
  /** The `AuctionBasket` that was deleted by this mutation. */
  auctionBasket?: Maybe<AuctionBasket>;
  /** An edge for our `AuctionBasket`. May be used by Relay 1. */
  auctionBasketEdge?: Maybe<AuctionBasketsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedAuctionBasketNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `AuctionBasket` mutation. */
export type DeleteAuctionBasketPayloadAuctionBasketEdgeArgs = {
  orderBy?: InputMaybe<Array<AuctionBasketsOrderBy>>;
};

/** All input for the `deleteBankrollBalance` mutation. */
export type DeleteBankrollBalanceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contract: Scalars['String']['input'];
  denom: Scalars['String']['input'];
};

/** The output of our delete `BankrollBalance` mutation. */
export type DeleteBankrollBalancePayload = {
  __typename?: 'DeleteBankrollBalancePayload';
  /** The `BankrollBalance` that was deleted by this mutation. */
  bankrollBalance?: Maybe<BankrollBalance>;
  /** An edge for our `BankrollBalance`. May be used by Relay 1. */
  bankrollBalanceEdge?: Maybe<BankrollBalancesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedBankrollBalanceNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `BankrollBalance` mutation. */
export type DeleteBankrollBalancePayloadBankrollBalanceEdgeArgs = {
  orderBy?: InputMaybe<Array<BankrollBalancesOrderBy>>;
};

/** All input for the `deleteBetsHistoryById` mutation. */
export type DeleteBetsHistoryByIdInput = {
  _id: Scalars['BigInt']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the `deleteBetsHistory` mutation. */
export type DeleteBetsHistoryInput = {
  betId: Scalars['BigInt']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  game: Scalars['String']['input'];
  gameId: Scalars['BigInt']['input'];
};

/** The output of our delete `BetsHistory` mutation. */
export type DeleteBetsHistoryPayload = {
  __typename?: 'DeleteBetsHistoryPayload';
  /** The `BetsHistory` that was deleted by this mutation. */
  betsHistory?: Maybe<BetsHistory>;
  /** An edge for our `BetsHistory`. May be used by Relay 1. */
  betsHistoryEdge?: Maybe<BetsHistoriesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedBetsHistoryNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `BetsHistory` mutation. */
export type DeleteBetsHistoryPayloadBetsHistoryEdgeArgs = {
  orderBy?: InputMaybe<Array<BetsHistoriesOrderBy>>;
};

/** All input for the `deleteBonusBetsHistory` mutation. */
export type DeleteBonusBetsHistoryInput = {
  betId: Scalars['BigInt']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  game: Scalars['String']['input'];
  gameId: Scalars['BigInt']['input'];
};

/** The output of our delete `BonusBetsHistory` mutation. */
export type DeleteBonusBetsHistoryPayload = {
  __typename?: 'DeleteBonusBetsHistoryPayload';
  /** The `BonusBetsHistory` that was deleted by this mutation. */
  bonusBetsHistory?: Maybe<BonusBetsHistory>;
  /** An edge for our `BonusBetsHistory`. May be used by Relay 1. */
  bonusBetsHistoryEdge?: Maybe<BonusBetsHistoriesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedBonusBetsHistoryNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `BonusBetsHistory` mutation. */
export type DeleteBonusBetsHistoryPayloadBonusBetsHistoryEdgeArgs = {
  orderBy?: InputMaybe<Array<BonusBetsHistoriesOrderBy>>;
};

/** All input for the `deleteClaimHistory` mutation. */
export type DeleteClaimHistoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** The output of our delete `ClaimHistory` mutation. */
export type DeleteClaimHistoryPayload = {
  __typename?: 'DeleteClaimHistoryPayload';
  /** The `ClaimHistory` that was deleted by this mutation. */
  claimHistory?: Maybe<ClaimHistory>;
  /** An edge for our `ClaimHistory`. May be used by Relay 1. */
  claimHistoryEdge?: Maybe<ClaimHistoriesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedClaimHistoryNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ClaimHistory` mutation. */
export type DeleteClaimHistoryPayloadClaimHistoryEdgeArgs = {
  orderBy?: InputMaybe<Array<ClaimHistoriesOrderBy>>;
};

/** All input for the `deleteCoinflipGame` mutation. */
export type DeleteCoinflipGameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `CoinflipGame` mutation. */
export type DeleteCoinflipGamePayload = {
  __typename?: 'DeleteCoinflipGamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CoinflipGame` that was deleted by this mutation. */
  coinflipGame?: Maybe<CoinflipGame>;
  /** An edge for our `CoinflipGame`. May be used by Relay 1. */
  coinflipGameEdge?: Maybe<CoinflipGamesEdge>;
  deletedCoinflipGameNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CoinflipGame` mutation. */
export type DeleteCoinflipGamePayloadCoinflipGameEdgeArgs = {
  orderBy?: InputMaybe<Array<CoinflipGamesOrderBy>>;
};

/** All input for the `deleteCoinflipGameRound` mutation. */
export type DeleteCoinflipGameRoundInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `CoinflipGameRound` mutation. */
export type DeleteCoinflipGameRoundPayload = {
  __typename?: 'DeleteCoinflipGameRoundPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CoinflipGameRound` that was deleted by this mutation. */
  coinflipGameRound?: Maybe<CoinflipGameRound>;
  /** An edge for our `CoinflipGameRound`. May be used by Relay 1. */
  coinflipGameRoundEdge?: Maybe<CoinflipGameRoundsEdge>;
  deletedCoinflipGameRoundNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `CoinflipGame` that is related to this `CoinflipGameRound`. */
  game?: Maybe<CoinflipGame>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CoinflipGameRound` mutation. */
export type DeleteCoinflipGameRoundPayloadCoinflipGameRoundEdgeArgs = {
  orderBy?: InputMaybe<Array<CoinflipGameRoundsOrderBy>>;
};

/** All input for the `deleteContractConfig` mutation. */
export type DeleteContractConfigInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** The output of our delete `ContractConfig` mutation. */
export type DeleteContractConfigPayload = {
  __typename?: 'DeleteContractConfigPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `ContractConfig` that was deleted by this mutation. */
  contractConfig?: Maybe<ContractConfig>;
  /** An edge for our `ContractConfig`. May be used by Relay 1. */
  contractConfigEdge?: Maybe<ContractConfigsEdge>;
  deletedContractConfigNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ContractConfig` mutation. */
export type DeleteContractConfigPayloadContractConfigEdgeArgs = {
  orderBy?: InputMaybe<Array<ContractConfigsOrderBy>>;
};

/** All input for the `deleteDoubleBet` mutation. */
export type DeleteDoubleBetInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `DoubleBet` mutation. */
export type DeleteDoubleBetPayload = {
  __typename?: 'DeleteDoubleBetPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedDoubleBetNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `DoubleBet` that was deleted by this mutation. */
  doubleBet?: Maybe<DoubleBet>;
  /** An edge for our `DoubleBet`. May be used by Relay 1. */
  doubleBetEdge?: Maybe<DoubleBetsEdge>;
  /** Reads a single `DoubleGame` that is related to this `DoubleBet`. */
  game?: Maybe<DoubleGame>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `DoubleBet` mutation. */
export type DeleteDoubleBetPayloadDoubleBetEdgeArgs = {
  orderBy?: InputMaybe<Array<DoubleBetsOrderBy>>;
};

/** All input for the `deleteDoubleGame` mutation. */
export type DeleteDoubleGameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `DoubleGame` mutation. */
export type DeleteDoubleGamePayload = {
  __typename?: 'DeleteDoubleGamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedDoubleGameNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `DoubleGame` that was deleted by this mutation. */
  doubleGame?: Maybe<DoubleGame>;
  /** An edge for our `DoubleGame`. May be used by Relay 1. */
  doubleGameEdge?: Maybe<DoubleGamesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `DoubleGame` mutation. */
export type DeleteDoubleGamePayloadDoubleGameEdgeArgs = {
  orderBy?: InputMaybe<Array<DoubleGamesOrderBy>>;
};

/** All input for the `deleteFeeDistributedHistory` mutation. */
export type DeleteFeeDistributedHistoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** The output of our delete `FeeDistributedHistory` mutation. */
export type DeleteFeeDistributedHistoryPayload = {
  __typename?: 'DeleteFeeDistributedHistoryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedFeeDistributedHistoryNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `FeeDistributedHistory` that was deleted by this mutation. */
  feeDistributedHistory?: Maybe<FeeDistributedHistory>;
  /** An edge for our `FeeDistributedHistory`. May be used by Relay 1. */
  feeDistributedHistoryEdge?: Maybe<FeeDistributedHistoriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `FeeDistributedHistory` mutation. */
export type DeleteFeeDistributedHistoryPayloadFeeDistributedHistoryEdgeArgs = {
  orderBy?: InputMaybe<Array<FeeDistributedHistoriesOrderBy>>;
};

/** All input for the `deleteGatewayChainTransaction` mutation. */
export type DeleteGatewayChainTransactionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `GatewayChainTransaction` mutation. */
export type DeleteGatewayChainTransactionPayload = {
  __typename?: 'DeleteGatewayChainTransactionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedGatewayChainTransactionNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `GatewayChainTransaction` that was deleted by this mutation. */
  gatewayChainTransaction?: Maybe<GatewayChainTransaction>;
  /** An edge for our `GatewayChainTransaction`. May be used by Relay 1. */
  gatewayChainTransactionEdge?: Maybe<GatewayChainTransactionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `GatewayChainTransaction` mutation. */
export type DeleteGatewayChainTransactionPayloadGatewayChainTransactionEdgeArgs = {
  orderBy?: InputMaybe<Array<GatewayChainTransactionsOrderBy>>;
};

/** All input for the `deleteJackpotBet` mutation. */
export type DeleteJackpotBetInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `JackpotBet` mutation. */
export type DeleteJackpotBetPayload = {
  __typename?: 'DeleteJackpotBetPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedJackpotBetNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `JackpotGame` that is related to this `JackpotBet`. */
  game?: Maybe<JackpotGame>;
  /** The `JackpotBet` that was deleted by this mutation. */
  jackpotBet?: Maybe<JackpotBet>;
  /** An edge for our `JackpotBet`. May be used by Relay 1. */
  jackpotBetEdge?: Maybe<JackpotBetsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `JackpotBet` mutation. */
export type DeleteJackpotBetPayloadJackpotBetEdgeArgs = {
  orderBy?: InputMaybe<Array<JackpotBetsOrderBy>>;
};

/** All input for the `deleteJackpotGame` mutation. */
export type DeleteJackpotGameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `JackpotGame` mutation. */
export type DeleteJackpotGamePayload = {
  __typename?: 'DeleteJackpotGamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedJackpotGameNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `JackpotGame` that was deleted by this mutation. */
  jackpotGame?: Maybe<JackpotGame>;
  /** An edge for our `JackpotGame`. May be used by Relay 1. */
  jackpotGameEdge?: Maybe<JackpotGamesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `JackpotGame` mutation. */
export type DeleteJackpotGamePayloadJackpotGameEdgeArgs = {
  orderBy?: InputMaybe<Array<JackpotGamesOrderBy>>;
};

/** All input for the `deleteLootboxGame` mutation. */
export type DeleteLootboxGameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  lootbox: Scalars['String']['input'];
};

/** The output of our delete `LootboxGame` mutation. */
export type DeleteLootboxGamePayload = {
  __typename?: 'DeleteLootboxGamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedLootboxGameNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `LootboxGame` that was deleted by this mutation. */
  lootboxGame?: Maybe<LootboxGame>;
  /** An edge for our `LootboxGame`. May be used by Relay 1. */
  lootboxGameEdge?: Maybe<LootboxGamesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `LootboxGame` mutation. */
export type DeleteLootboxGamePayloadLootboxGameEdgeArgs = {
  orderBy?: InputMaybe<Array<LootboxGamesOrderBy>>;
};

/** All input for the `deleteLootbox` mutation. */
export type DeleteLootboxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** All input for the `deleteLootboxMarketOrder` mutation. */
export type DeleteLootboxMarketOrderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['BigInt']['input'];
};

/** The output of our delete `LootboxMarketOrder` mutation. */
export type DeleteLootboxMarketOrderPayload = {
  __typename?: 'DeleteLootboxMarketOrderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedLootboxMarketOrderNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `LootboxMarketOrder` that was deleted by this mutation. */
  lootboxMarketOrder?: Maybe<LootboxMarketOrder>;
  /** An edge for our `LootboxMarketOrder`. May be used by Relay 1. */
  lootboxMarketOrderEdge?: Maybe<LootboxMarketOrdersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `LootboxMarketOrder` mutation. */
export type DeleteLootboxMarketOrderPayloadLootboxMarketOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<LootboxMarketOrdersOrderBy>>;
};

/** All input for the `deleteLootboxMarketTrade` mutation. */
export type DeleteLootboxMarketTradeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  tradeId: Scalars['BigInt']['input'];
};

/** The output of our delete `LootboxMarketTrade` mutation. */
export type DeleteLootboxMarketTradePayload = {
  __typename?: 'DeleteLootboxMarketTradePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedLootboxMarketTradeNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `LootboxMarketTrade` that was deleted by this mutation. */
  lootboxMarketTrade?: Maybe<LootboxMarketTrade>;
  /** An edge for our `LootboxMarketTrade`. May be used by Relay 1. */
  lootboxMarketTradeEdge?: Maybe<LootboxMarketTradesEdge>;
  /** Reads a single `LootboxMarketOrder` that is related to this `LootboxMarketTrade`. */
  order?: Maybe<LootboxMarketOrder>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `LootboxMarketTrade` mutation. */
export type DeleteLootboxMarketTradePayloadLootboxMarketTradeEdgeArgs = {
  orderBy?: InputMaybe<Array<LootboxMarketTradesOrderBy>>;
};

/** The output of our delete `Lootbox` mutation. */
export type DeleteLootboxPayload = {
  __typename?: 'DeleteLootboxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedLootboxNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `Lootbox` that was deleted by this mutation. */
  lootbox?: Maybe<Lootbox>;
  /** An edge for our `Lootbox`. May be used by Relay 1. */
  lootboxEdge?: Maybe<LootboxesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Lootbox` mutation. */
export type DeleteLootboxPayloadLootboxEdgeArgs = {
  orderBy?: InputMaybe<Array<LootboxesOrderBy>>;
};

/** All input for the `deleteLootboxReward` mutation. */
export type DeleteLootboxRewardInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lootbox: Scalars['String']['input'];
};

/** The output of our delete `LootboxReward` mutation. */
export type DeleteLootboxRewardPayload = {
  __typename?: 'DeleteLootboxRewardPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedLootboxRewardNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `LootboxReward` that was deleted by this mutation. */
  lootboxReward?: Maybe<LootboxReward>;
  /** An edge for our `LootboxReward`. May be used by Relay 1. */
  lootboxRewardEdge?: Maybe<LootboxRewardsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `LootboxReward` mutation. */
export type DeleteLootboxRewardPayloadLootboxRewardEdgeArgs = {
  orderBy?: InputMaybe<Array<LootboxRewardsOrderBy>>;
};

/** All input for the `deleteLootboxSale` mutation. */
export type DeleteLootboxSaleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** The output of our delete `LootboxSale` mutation. */
export type DeleteLootboxSalePayload = {
  __typename?: 'DeleteLootboxSalePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedLootboxSaleNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `LootboxSale` that was deleted by this mutation. */
  lootboxSale?: Maybe<LootboxSale>;
  /** An edge for our `LootboxSale`. May be used by Relay 1. */
  lootboxSaleEdge?: Maybe<LootboxSalesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `LootboxSale` mutation. */
export type DeleteLootboxSalePayloadLootboxSaleEdgeArgs = {
  orderBy?: InputMaybe<Array<LootboxSalesOrderBy>>;
};

/** All input for the `deleteLootboxUnlimitedGame` mutation. */
export type DeleteLootboxUnlimitedGameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `LootboxUnlimitedGame` mutation. */
export type DeleteLootboxUnlimitedGamePayload = {
  __typename?: 'DeleteLootboxUnlimitedGamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedLootboxUnlimitedGameNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `LootboxUnlimitedGame` that was deleted by this mutation. */
  lootboxUnlimitedGame?: Maybe<LootboxUnlimitedGame>;
  /** An edge for our `LootboxUnlimitedGame`. May be used by Relay 1. */
  lootboxUnlimitedGameEdge?: Maybe<LootboxUnlimitedGamesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `LootboxUnlimitedGame` mutation. */
export type DeleteLootboxUnlimitedGamePayloadLootboxUnlimitedGameEdgeArgs = {
  orderBy?: InputMaybe<Array<LootboxUnlimitedGamesOrderBy>>;
};

/** All input for the `deleteLootboxesUnlimited` mutation. */
export type DeleteLootboxesUnlimitedInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** The output of our delete `LootboxesUnlimited` mutation. */
export type DeleteLootboxesUnlimitedPayload = {
  __typename?: 'DeleteLootboxesUnlimitedPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedLootboxesUnlimitedNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `LootboxesUnlimited` that was deleted by this mutation. */
  lootboxesUnlimited?: Maybe<LootboxesUnlimited>;
  /** An edge for our `LootboxesUnlimited`. May be used by Relay 1. */
  lootboxesUnlimitedEdge?: Maybe<LootboxesUnlimitedsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `LootboxesUnlimited` mutation. */
export type DeleteLootboxesUnlimitedPayloadLootboxesUnlimitedEdgeArgs = {
  orderBy?: InputMaybe<Array<LootboxesUnlimitedsOrderBy>>;
};

/** All input for the `deleteMinesGame` mutation. */
export type DeleteMinesGameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `MinesGame` mutation. */
export type DeleteMinesGamePayload = {
  __typename?: 'DeleteMinesGamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedMinesGameNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `MinesGame` that was deleted by this mutation. */
  minesGame?: Maybe<MinesGame>;
  /** An edge for our `MinesGame`. May be used by Relay 1. */
  minesGameEdge?: Maybe<MinesGamesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `MinesGame` mutation. */
export type DeleteMinesGamePayloadMinesGameEdgeArgs = {
  orderBy?: InputMaybe<Array<MinesGamesOrderBy>>;
};

/** All input for the `deleteMinesGameRound` mutation. */
export type DeleteMinesGameRoundInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `MinesGameRound` mutation. */
export type DeleteMinesGameRoundPayload = {
  __typename?: 'DeleteMinesGameRoundPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedMinesGameRoundNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `MinesGame` that is related to this `MinesGameRound`. */
  game?: Maybe<MinesGame>;
  /** The `MinesGameRound` that was deleted by this mutation. */
  minesGameRound?: Maybe<MinesGameRound>;
  /** An edge for our `MinesGameRound`. May be used by Relay 1. */
  minesGameRoundEdge?: Maybe<MinesGameRoundsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `MinesGameRound` mutation. */
export type DeleteMinesGameRoundPayloadMinesGameRoundEdgeArgs = {
  orderBy?: InputMaybe<Array<MinesGameRoundsOrderBy>>;
};

/** All input for the `deleteNft` mutation. */
export type DeleteNftInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `Nft` mutation. */
export type DeleteNftPayload = {
  __typename?: 'DeleteNftPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedNftNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `Nft` that was deleted by this mutation. */
  nft?: Maybe<Nft>;
  /** An edge for our `Nft`. May be used by Relay 1. */
  nftEdge?: Maybe<NftsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Nft` mutation. */
export type DeleteNftPayloadNftEdgeArgs = {
  orderBy?: InputMaybe<Array<NftsOrderBy>>;
};

/** All input for the `deleteNftsVote` mutation. */
export type DeleteNftsVoteInput = {
  address: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  proposalId: Scalars['String']['input'];
};

/** The output of our delete `NftsVote` mutation. */
export type DeleteNftsVotePayload = {
  __typename?: 'DeleteNftsVotePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedNftsVoteNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `NftsVote` that was deleted by this mutation. */
  nftsVote?: Maybe<NftsVote>;
  /** An edge for our `NftsVote`. May be used by Relay 1. */
  nftsVoteEdge?: Maybe<NftsVotesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `NftsVote` mutation. */
export type DeleteNftsVotePayloadNftsVoteEdgeArgs = {
  orderBy?: InputMaybe<Array<NftsVotesOrderBy>>;
};

/** All input for the `deleteOpenCompetitionEntity` mutation. */
export type DeleteOpenCompetitionEntityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  player: Scalars['String']['input'];
};

/** The output of our delete `OpenCompetitionEntity` mutation. */
export type DeleteOpenCompetitionEntityPayload = {
  __typename?: 'DeleteOpenCompetitionEntityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedOpenCompetitionEntityNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `OpenCompetitionEntity` that was deleted by this mutation. */
  openCompetitionEntity?: Maybe<OpenCompetitionEntity>;
  /** An edge for our `OpenCompetitionEntity`. May be used by Relay 1. */
  openCompetitionEntityEdge?: Maybe<OpenCompetitionEntitiesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `OpenCompetitionEntity` mutation. */
export type DeleteOpenCompetitionEntityPayloadOpenCompetitionEntityEdgeArgs = {
  orderBy?: InputMaybe<Array<OpenCompetitionEntitiesOrderBy>>;
};

/** All input for the `deletePlinkoGame` mutation. */
export type DeletePlinkoGameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `PlinkoGame` mutation. */
export type DeletePlinkoGamePayload = {
  __typename?: 'DeletePlinkoGamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedPlinkoGameNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `PlinkoGame` that was deleted by this mutation. */
  plinkoGame?: Maybe<PlinkoGame>;
  /** An edge for our `PlinkoGame`. May be used by Relay 1. */
  plinkoGameEdge?: Maybe<PlinkoGamesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `PlinkoGame` mutation. */
export type DeletePlinkoGamePayloadPlinkoGameEdgeArgs = {
  orderBy?: InputMaybe<Array<PlinkoGamesOrderBy>>;
};

/** All input for the `deletePointTransaction` mutation. */
export type DeletePointTransactionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `PointTransaction` mutation. */
export type DeletePointTransactionPayload = {
  __typename?: 'DeletePointTransactionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedPointTransactionNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `PointTransaction` that was deleted by this mutation. */
  pointTransaction?: Maybe<PointTransaction>;
  /** An edge for our `PointTransaction`. May be used by Relay 1. */
  pointTransactionEdge?: Maybe<PointTransactionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `PointTransaction` mutation. */
export type DeletePointTransactionPayloadPointTransactionEdgeArgs = {
  orderBy?: InputMaybe<Array<PointTransactionsOrderBy>>;
};

/** All input for the `deleteRngRound` mutation. */
export type DeleteRngRoundInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** The output of our delete `RngRound` mutation. */
export type DeleteRngRoundPayload = {
  __typename?: 'DeleteRngRoundPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedRngRoundNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RngRound` that was deleted by this mutation. */
  rngRound?: Maybe<RngRound>;
  /** An edge for our `RngRound`. May be used by Relay 1. */
  rngRoundEdge?: Maybe<RngRoundsEdge>;
};


/** The output of our delete `RngRound` mutation. */
export type DeleteRngRoundPayloadRngRoundEdgeArgs = {
  orderBy?: InputMaybe<Array<RngRoundsOrderBy>>;
};

/** All input for the `deleteRoshamboGame` mutation. */
export type DeleteRoshamboGameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** All input for the `deleteRoshamboGameLog` mutation. */
export type DeleteRoshamboGameLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['BigInt']['input'];
};

/** The output of our delete `RoshamboGameLog` mutation. */
export type DeleteRoshamboGameLogPayload = {
  __typename?: 'DeleteRoshamboGameLogPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedRoshamboGameLogNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RoshamboGameLog` that was deleted by this mutation. */
  roshamboGameLog?: Maybe<RoshamboGameLog>;
  /** An edge for our `RoshamboGameLog`. May be used by Relay 1. */
  roshamboGameLogEdge?: Maybe<RoshamboGameLogsEdge>;
};


/** The output of our delete `RoshamboGameLog` mutation. */
export type DeleteRoshamboGameLogPayloadRoshamboGameLogEdgeArgs = {
  orderBy?: InputMaybe<Array<RoshamboGameLogsOrderBy>>;
};

/** The output of our delete `RoshamboGame` mutation. */
export type DeleteRoshamboGamePayload = {
  __typename?: 'DeleteRoshamboGamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedRoshamboGameNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RoshamboGame` that was deleted by this mutation. */
  roshamboGame?: Maybe<RoshamboGame>;
  /** An edge for our `RoshamboGame`. May be used by Relay 1. */
  roshamboGameEdge?: Maybe<RoshamboGamesEdge>;
};


/** The output of our delete `RoshamboGame` mutation. */
export type DeleteRoshamboGamePayloadRoshamboGameEdgeArgs = {
  orderBy?: InputMaybe<Array<RoshamboGamesOrderBy>>;
};

/** All input for the `deleteRunesGame` mutation. */
export type DeleteRunesGameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `RunesGame` mutation. */
export type DeleteRunesGamePayload = {
  __typename?: 'DeleteRunesGamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedRunesGameNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RunesGame` that was deleted by this mutation. */
  runesGame?: Maybe<RunesGame>;
  /** An edge for our `RunesGame`. May be used by Relay 1. */
  runesGameEdge?: Maybe<RunesGamesEdge>;
};


/** The output of our delete `RunesGame` mutation. */
export type DeleteRunesGamePayloadRunesGameEdgeArgs = {
  orderBy?: InputMaybe<Array<RunesGamesOrderBy>>;
};

/** All input for the `deleteStatistic` mutation. */
export type DeleteStatisticInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** The output of our delete `Statistic` mutation. */
export type DeleteStatisticPayload = {
  __typename?: 'DeleteStatisticPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedStatisticNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Statistic` that was deleted by this mutation. */
  statistic?: Maybe<Statistic>;
  /** An edge for our `Statistic`. May be used by Relay 1. */
  statisticEdge?: Maybe<StatisticsEdge>;
};


/** The output of our delete `Statistic` mutation. */
export type DeleteStatisticPayloadStatisticEdgeArgs = {
  orderBy?: InputMaybe<Array<StatisticsOrderBy>>;
};

/** All input for the `deleteStatisticsV2` mutation. */
export type DeleteStatisticsV2Input = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** The output of our delete `StatisticsV2` mutation. */
export type DeleteStatisticsV2Payload = {
  __typename?: 'DeleteStatisticsV2Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedStatisticsV2NodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `StatisticsV2` that was deleted by this mutation. */
  statisticsV2?: Maybe<StatisticsV2>;
  /** An edge for our `StatisticsV2`. May be used by Relay 1. */
  statisticsV2Edge?: Maybe<StatisticsV2sEdge>;
};


/** The output of our delete `StatisticsV2` mutation. */
export type DeleteStatisticsV2PayloadStatisticsV2EdgeArgs = {
  orderBy?: InputMaybe<Array<StatisticsV2sOrderBy>>;
};

/** All input for the `deleteTokenBurnHistory` mutation. */
export type DeleteTokenBurnHistoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `TokenBurnHistory` mutation. */
export type DeleteTokenBurnHistoryPayload = {
  __typename?: 'DeleteTokenBurnHistoryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedTokenBurnHistoryNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TokenBurnHistory` that was deleted by this mutation. */
  tokenBurnHistory?: Maybe<TokenBurnHistory>;
  /** An edge for our `TokenBurnHistory`. May be used by Relay 1. */
  tokenBurnHistoryEdge?: Maybe<TokenBurnHistoriesEdge>;
};


/** The output of our delete `TokenBurnHistory` mutation. */
export type DeleteTokenBurnHistoryPayloadTokenBurnHistoryEdgeArgs = {
  orderBy?: InputMaybe<Array<TokenBurnHistoriesOrderBy>>;
};

/** All input for the `deleteTokenClaim` mutation. */
export type DeleteTokenClaimInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractAddress: Scalars['String']['input'];
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `TokenClaim` mutation. */
export type DeleteTokenClaimPayload = {
  __typename?: 'DeleteTokenClaimPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedTokenClaimNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TokenClaim` that was deleted by this mutation. */
  tokenClaim?: Maybe<TokenClaim>;
  /** An edge for our `TokenClaim`. May be used by Relay 1. */
  tokenClaimEdge?: Maybe<TokenClaimsEdge>;
};


/** The output of our delete `TokenClaim` mutation. */
export type DeleteTokenClaimPayloadTokenClaimEdgeArgs = {
  orderBy?: InputMaybe<Array<TokenClaimsOrderBy>>;
};

/** All input for the `deleteTokenPrice` mutation. */
export type DeleteTokenPriceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  symbol: Scalars['String']['input'];
};

/** The output of our delete `TokenPrice` mutation. */
export type DeleteTokenPricePayload = {
  __typename?: 'DeleteTokenPricePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedTokenPriceNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TokenPrice` that was deleted by this mutation. */
  tokenPrice?: Maybe<TokenPrice>;
  /** An edge for our `TokenPrice`. May be used by Relay 1. */
  tokenPriceEdge?: Maybe<TokenPricesEdge>;
};


/** The output of our delete `TokenPrice` mutation. */
export type DeleteTokenPricePayloadTokenPriceEdgeArgs = {
  orderBy?: InputMaybe<Array<TokenPricesOrderBy>>;
};

/** All input for the `deleteTokenSalesInfo` mutation. */
export type DeleteTokenSalesInfoInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `TokenSalesInfo` mutation. */
export type DeleteTokenSalesInfoPayload = {
  __typename?: 'DeleteTokenSalesInfoPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedTokenSalesInfoNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TokenSalesInfo` that was deleted by this mutation. */
  tokenSalesInfo?: Maybe<TokenSalesInfo>;
  /** An edge for our `TokenSalesInfo`. May be used by Relay 1. */
  tokenSalesInfoEdge?: Maybe<TokenSalesInfosEdge>;
};


/** The output of our delete `TokenSalesInfo` mutation. */
export type DeleteTokenSalesInfoPayloadTokenSalesInfoEdgeArgs = {
  orderBy?: InputMaybe<Array<TokenSalesInfosOrderBy>>;
};

/** All input for the `deleteTokenSalesPriceInfo` mutation. */
export type DeleteTokenSalesPriceInfoInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `TokenSalesPriceInfo` mutation. */
export type DeleteTokenSalesPriceInfoPayload = {
  __typename?: 'DeleteTokenSalesPriceInfoPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedTokenSalesPriceInfoNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TokenSalesPriceInfo` that was deleted by this mutation. */
  tokenSalesPriceInfo?: Maybe<TokenSalesPriceInfo>;
  /** An edge for our `TokenSalesPriceInfo`. May be used by Relay 1. */
  tokenSalesPriceInfoEdge?: Maybe<TokenSalesPriceInfosEdge>;
};


/** The output of our delete `TokenSalesPriceInfo` mutation. */
export type DeleteTokenSalesPriceInfoPayloadTokenSalesPriceInfoEdgeArgs = {
  orderBy?: InputMaybe<Array<TokenSalesPriceInfosOrderBy>>;
};

/** All input for the `deleteUserBetHistory` mutation. */
export type DeleteUserBetHistoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** The output of our delete `UserBetHistory` mutation. */
export type DeleteUserBetHistoryPayload = {
  __typename?: 'DeleteUserBetHistoryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUserBetHistoryNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserBetHistory` that was deleted by this mutation. */
  userBetHistory?: Maybe<UserBetHistory>;
  /** An edge for our `UserBetHistory`. May be used by Relay 1. */
  userBetHistoryEdge?: Maybe<UserBetHistoriesEdge>;
};


/** The output of our delete `UserBetHistory` mutation. */
export type DeleteUserBetHistoryPayloadUserBetHistoryEdgeArgs = {
  orderBy?: InputMaybe<Array<UserBetHistoriesOrderBy>>;
};

/** All input for the `deleteUserCompetition` mutation. */
export type DeleteUserCompetitionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  competition: Scalars['String']['input'];
  player: Scalars['String']['input'];
};

/** The output of our delete `UserCompetition` mutation. */
export type DeleteUserCompetitionPayload = {
  __typename?: 'DeleteUserCompetitionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUserCompetitionNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserCompetition` that was deleted by this mutation. */
  userCompetition?: Maybe<UserCompetition>;
  /** An edge for our `UserCompetition`. May be used by Relay 1. */
  userCompetitionEdge?: Maybe<UserCompetitionsEdge>;
};


/** The output of our delete `UserCompetition` mutation. */
export type DeleteUserCompetitionPayloadUserCompetitionEdgeArgs = {
  orderBy?: InputMaybe<Array<UserCompetitionsOrderBy>>;
};

/** All input for the `deleteUser` mutation. */
export type DeleteUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** The output of our delete `User` mutation. */
export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUserNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was deleted by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
  /** Reads a single `UserStatistic` that is related to this `User`. */
  userStatistic?: Maybe<UserStatistic>;
};


/** The output of our delete `User` mutation. */
export type DeleteUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `deleteUserStatistic` mutation. */
export type DeleteUserStatisticInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** The output of our delete `UserStatistic` mutation. */
export type DeleteUserStatisticPayload = {
  __typename?: 'DeleteUserStatisticPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUserStatisticNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserStatistic` that was deleted by this mutation. */
  userStatistic?: Maybe<UserStatistic>;
  /** An edge for our `UserStatistic`. May be used by Relay 1. */
  userStatisticEdge?: Maybe<UserStatisticsEdge>;
};


/** The output of our delete `UserStatistic` mutation. */
export type DeleteUserStatisticPayloadUserStatisticEdgeArgs = {
  orderBy?: InputMaybe<Array<UserStatisticsOrderBy>>;
};

/** All input for the `deleteUserStatisticsByDay` mutation. */
export type DeleteUserStatisticsByDayInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['Date']['input'];
  id: Scalars['String']['input'];
};

/** The output of our delete `UserStatisticsByDay` mutation. */
export type DeleteUserStatisticsByDayPayload = {
  __typename?: 'DeleteUserStatisticsByDayPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUserStatisticsByDayNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UserStatistic` that is related to this `UserStatisticsByDay`. */
  userStatisticById?: Maybe<UserStatistic>;
  /** The `UserStatisticsByDay` that was deleted by this mutation. */
  userStatisticsByDay?: Maybe<UserStatisticsByDay>;
  /** An edge for our `UserStatisticsByDay`. May be used by Relay 1. */
  userStatisticsByDayEdge?: Maybe<UserStatisticsByDaysEdge>;
};


/** The output of our delete `UserStatisticsByDay` mutation. */
export type DeleteUserStatisticsByDayPayloadUserStatisticsByDayEdgeArgs = {
  orderBy?: InputMaybe<Array<UserStatisticsByDaysOrderBy>>;
};

/** All input for the `deleteUserStatisticsV2` mutation. */
export type DeleteUserStatisticsV2Input = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  player: Scalars['String']['input'];
};

/** The output of our delete `UserStatisticsV2` mutation. */
export type DeleteUserStatisticsV2Payload = {
  __typename?: 'DeleteUserStatisticsV2Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUserStatisticsV2NodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserStatisticsV2` that was deleted by this mutation. */
  userStatisticsV2?: Maybe<UserStatisticsV2>;
  /** An edge for our `UserStatisticsV2`. May be used by Relay 1. */
  userStatisticsV2Edge?: Maybe<UserStatisticsV2sEdge>;
};


/** The output of our delete `UserStatisticsV2` mutation. */
export type DeleteUserStatisticsV2PayloadUserStatisticsV2EdgeArgs = {
  orderBy?: InputMaybe<Array<UserStatisticsV2sOrderBy>>;
};

/** All input for the `deleteUserTokenSale` mutation. */
export type DeleteUserTokenSaleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  player: Scalars['String']['input'];
};

/** The output of our delete `UserTokenSale` mutation. */
export type DeleteUserTokenSalePayload = {
  __typename?: 'DeleteUserTokenSalePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUserTokenSaleNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserTokenSale` that was deleted by this mutation. */
  userTokenSale?: Maybe<UserTokenSale>;
  /** An edge for our `UserTokenSale`. May be used by Relay 1. */
  userTokenSaleEdge?: Maybe<UserTokenSalesEdge>;
};


/** The output of our delete `UserTokenSale` mutation. */
export type DeleteUserTokenSalePayloadUserTokenSaleEdgeArgs = {
  orderBy?: InputMaybe<Array<UserTokenSalesOrderBy>>;
};

/** All input for the `deleteUserTokenSaleTransaction` mutation. */
export type DeleteUserTokenSaleTransactionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `UserTokenSaleTransaction` mutation. */
export type DeleteUserTokenSaleTransactionPayload = {
  __typename?: 'DeleteUserTokenSaleTransactionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUserTokenSaleTransactionNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserTokenSaleTransaction` that was deleted by this mutation. */
  userTokenSaleTransaction?: Maybe<UserTokenSaleTransaction>;
  /** An edge for our `UserTokenSaleTransaction`. May be used by Relay 1. */
  userTokenSaleTransactionEdge?: Maybe<UserTokenSaleTransactionsEdge>;
};


/** The output of our delete `UserTokenSaleTransaction` mutation. */
export type DeleteUserTokenSaleTransactionPayloadUserTokenSaleTransactionEdgeArgs = {
  orderBy?: InputMaybe<Array<UserTokenSaleTransactionsOrderBy>>;
};

export type DoubleBet = {
  __typename?: 'DoubleBet';
  address: Scalars['String']['output'];
  amount: Scalars['BigFloat']['output'];
  bet?: Maybe<Scalars['BigFloat']['output']>;
  betId?: Maybe<Scalars['BigInt']['output']>;
  betNormalize?: Maybe<Scalars['BigFloat']['output']>;
  betUsd?: Maybe<Scalars['BigFloat']['output']>;
  block: Scalars['BigInt']['output'];
  color: DoubleColor;
  created?: Maybe<Scalars['Datetime']['output']>;
  date: Scalars['BigInt']['output'];
  denom?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DoubleGame` that is related to this `DoubleBet`. */
  game?: Maybe<DoubleGame>;
  gameId: Scalars['BigInt']['output'];
  id: Scalars['BigInt']['output'];
  jackpotPayout?: Maybe<Scalars['BigFloat']['output']>;
  payout?: Maybe<Scalars['BigFloat']['output']>;
  payoutNormalize?: Maybe<Scalars['BigFloat']['output']>;
  payoutUsd?: Maybe<Scalars['BigFloat']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
  txHash: Scalars['String']['output'];
};

/**
 * A condition to be used against `DoubleBet` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type DoubleBetCondition = {
  /** Checks for equality with the object’s `address` field. */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `bet` field. */
  bet?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `betId` field. */
  betId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `betNormalize` field. */
  betNormalize?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `betUsd` field. */
  betUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `block` field. */
  block?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `color` field. */
  color?: InputMaybe<DoubleColor>;
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `date` field. */
  date?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `denom` field. */
  denom?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `gameId` field. */
  gameId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `jackpotPayout` field. */
  jackpotPayout?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `payout` field. */
  payout?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `payoutNormalize` field. */
  payoutNormalize?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `payoutUsd` field. */
  payoutUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `symbol` field. */
  symbol?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `txHash` field. */
  txHash?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `DoubleBet` object types. All fields are combined with a logical ‘and.’ */
export type DoubleBetFilter = {
  /** Filter by the object’s `address` field. */
  address?: InputMaybe<StringFilter>;
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DoubleBetFilter>>;
  /** Filter by the object’s `bet` field. */
  bet?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `betId` field. */
  betId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `betNormalize` field. */
  betNormalize?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `betUsd` field. */
  betUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `block` field. */
  block?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `color` field. */
  color?: InputMaybe<DoubleColorFilter>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `date` field. */
  date?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `denom` field. */
  denom?: InputMaybe<StringFilter>;
  /** Filter by the object’s `gameId` field. */
  gameId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `jackpotPayout` field. */
  jackpotPayout?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DoubleBetFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DoubleBetFilter>>;
  /** Filter by the object’s `payout` field. */
  payout?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `payoutNormalize` field. */
  payoutNormalize?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `payoutUsd` field. */
  payoutUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `symbol` field. */
  symbol?: InputMaybe<StringFilter>;
  /** Filter by the object’s `txHash` field. */
  txHash?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `DoubleBet` */
export type DoubleBetInput = {
  address: Scalars['String']['input'];
  amount: Scalars['BigFloat']['input'];
  bet?: InputMaybe<Scalars['BigFloat']['input']>;
  betId?: InputMaybe<Scalars['BigInt']['input']>;
  betNormalize?: InputMaybe<Scalars['BigFloat']['input']>;
  betUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  block: Scalars['BigInt']['input'];
  color: DoubleColor;
  created?: InputMaybe<Scalars['Datetime']['input']>;
  date: Scalars['BigInt']['input'];
  denom?: InputMaybe<Scalars['String']['input']>;
  gameId: Scalars['BigInt']['input'];
  id?: InputMaybe<Scalars['BigInt']['input']>;
  jackpotPayout?: InputMaybe<Scalars['BigFloat']['input']>;
  payout?: InputMaybe<Scalars['BigFloat']['input']>;
  payoutNormalize?: InputMaybe<Scalars['BigFloat']['input']>;
  payoutUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  txHash: Scalars['String']['input'];
};

/** Represents an update to a `DoubleBet`. Fields that are set will be updated. */
export type DoubleBetPatch = {
  address?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  bet?: InputMaybe<Scalars['BigFloat']['input']>;
  betId?: InputMaybe<Scalars['BigInt']['input']>;
  betNormalize?: InputMaybe<Scalars['BigFloat']['input']>;
  betUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  block?: InputMaybe<Scalars['BigInt']['input']>;
  color?: InputMaybe<DoubleColor>;
  created?: InputMaybe<Scalars['Datetime']['input']>;
  date?: InputMaybe<Scalars['BigInt']['input']>;
  denom?: InputMaybe<Scalars['String']['input']>;
  gameId?: InputMaybe<Scalars['BigInt']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  jackpotPayout?: InputMaybe<Scalars['BigFloat']['input']>;
  payout?: InputMaybe<Scalars['BigFloat']['input']>;
  payoutNormalize?: InputMaybe<Scalars['BigFloat']['input']>;
  payoutUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  txHash?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `DoubleBet` values. */
export type DoubleBetsConnection = {
  __typename?: 'DoubleBetsConnection';
  /** A list of edges which contains the `DoubleBet` and cursor to aid in pagination. */
  edges: Array<DoubleBetsEdge>;
  /** A list of `DoubleBet` objects. */
  nodes: Array<Maybe<DoubleBet>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DoubleBet` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DoubleBet` edge in the connection. */
export type DoubleBetsEdge = {
  __typename?: 'DoubleBetsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DoubleBet` at the end of the edge. */
  node?: Maybe<DoubleBet>;
};

/** Methods to use when ordering `DoubleBet`. */
export enum DoubleBetsOrderBy {
  AddressAsc = 'ADDRESS_ASC',
  AddressDesc = 'ADDRESS_DESC',
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  BetAsc = 'BET_ASC',
  BetDesc = 'BET_DESC',
  BetIdAsc = 'BET_ID_ASC',
  BetIdDesc = 'BET_ID_DESC',
  BetNormalizeAsc = 'BET_NORMALIZE_ASC',
  BetNormalizeDesc = 'BET_NORMALIZE_DESC',
  BetUsdAsc = 'BET_USD_ASC',
  BetUsdDesc = 'BET_USD_DESC',
  BlockAsc = 'BLOCK_ASC',
  BlockDesc = 'BLOCK_DESC',
  ColorAsc = 'COLOR_ASC',
  ColorDesc = 'COLOR_DESC',
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  DenomAsc = 'DENOM_ASC',
  DenomDesc = 'DENOM_DESC',
  GameIdAsc = 'GAME_ID_ASC',
  GameIdDesc = 'GAME_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  JackpotPayoutAsc = 'JACKPOT_PAYOUT_ASC',
  JackpotPayoutDesc = 'JACKPOT_PAYOUT_DESC',
  Natural = 'NATURAL',
  PayoutAsc = 'PAYOUT_ASC',
  PayoutDesc = 'PAYOUT_DESC',
  PayoutNormalizeAsc = 'PAYOUT_NORMALIZE_ASC',
  PayoutNormalizeDesc = 'PAYOUT_NORMALIZE_DESC',
  PayoutUsdAsc = 'PAYOUT_USD_ASC',
  PayoutUsdDesc = 'PAYOUT_USD_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SymbolAsc = 'SYMBOL_ASC',
  SymbolDesc = 'SYMBOL_DESC',
  TxHashAsc = 'TX_HASH_ASC',
  TxHashDesc = 'TX_HASH_DESC'
}

export enum DoubleColor {
  Black = 'BLACK',
  Green = 'GREEN',
  Red = 'RED'
}

/** A filter to be used against DoubleColor fields. All fields are combined with a logical ‘and.’ */
export type DoubleColorFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<DoubleColor>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<DoubleColor>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<DoubleColor>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<DoubleColor>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<DoubleColor>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<DoubleColor>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<DoubleColor>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<DoubleColor>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<DoubleColor>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<DoubleColor>>;
};

export type DoubleGame = {
  __typename?: 'DoubleGame';
  created?: Maybe<Scalars['Datetime']['output']>;
  /** Reads and enables pagination through a set of `DoubleBet`. */
  doubleBetsByGameId: DoubleBetsConnection;
  drawRound?: Maybe<Scalars['BigInt']['output']>;
  drawTimestamp?: Maybe<Scalars['BigInt']['output']>;
  drawTxHash?: Maybe<Scalars['String']['output']>;
  id: Scalars['BigInt']['output'];
  jackpot?: Maybe<Scalars['BigFloat']['output']>;
  pool: Scalars['BigFloat']['output'];
  randomness?: Maybe<Scalars['String']['output']>;
  startBlock?: Maybe<Scalars['BigInt']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  winColor?: Maybe<DoubleColor>;
  winNumber: Scalars['Int']['output'];
};


export type DoubleGameDoubleBetsByGameIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DoubleBetCondition>;
  filter?: InputMaybe<DoubleBetFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DoubleBetsOrderBy>>;
};

/**
 * A condition to be used against `DoubleGame` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type DoubleGameCondition = {
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `drawRound` field. */
  drawRound?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `drawTimestamp` field. */
  drawTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `drawTxHash` field. */
  drawTxHash?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `jackpot` field. */
  jackpot?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `pool` field. */
  pool?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `randomness` field. */
  randomness?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `startBlock` field. */
  startBlock?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `winColor` field. */
  winColor?: InputMaybe<DoubleColor>;
  /** Checks for equality with the object’s `winNumber` field. */
  winNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `DoubleGame` object types. All fields are combined with a logical ‘and.’ */
export type DoubleGameFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DoubleGameFilter>>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `drawRound` field. */
  drawRound?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `drawTimestamp` field. */
  drawTimestamp?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `drawTxHash` field. */
  drawTxHash?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `jackpot` field. */
  jackpot?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DoubleGameFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DoubleGameFilter>>;
  /** Filter by the object’s `pool` field. */
  pool?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `randomness` field. */
  randomness?: InputMaybe<StringFilter>;
  /** Filter by the object’s `startBlock` field. */
  startBlock?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<StringFilter>;
  /** Filter by the object’s `winColor` field. */
  winColor?: InputMaybe<DoubleColorFilter>;
  /** Filter by the object’s `winNumber` field. */
  winNumber?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `DoubleGame` */
export type DoubleGameInput = {
  created?: InputMaybe<Scalars['Datetime']['input']>;
  drawRound?: InputMaybe<Scalars['BigInt']['input']>;
  drawTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  drawTxHash?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  jackpot?: InputMaybe<Scalars['BigFloat']['input']>;
  pool: Scalars['BigFloat']['input'];
  randomness?: InputMaybe<Scalars['String']['input']>;
  startBlock?: InputMaybe<Scalars['BigInt']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  winColor?: InputMaybe<DoubleColor>;
  winNumber: Scalars['Int']['input'];
};

/** Represents an update to a `DoubleGame`. Fields that are set will be updated. */
export type DoubleGamePatch = {
  created?: InputMaybe<Scalars['Datetime']['input']>;
  drawRound?: InputMaybe<Scalars['BigInt']['input']>;
  drawTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  drawTxHash?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  jackpot?: InputMaybe<Scalars['BigFloat']['input']>;
  pool?: InputMaybe<Scalars['BigFloat']['input']>;
  randomness?: InputMaybe<Scalars['String']['input']>;
  startBlock?: InputMaybe<Scalars['BigInt']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  winColor?: InputMaybe<DoubleColor>;
  winNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `DoubleGame` values. */
export type DoubleGamesConnection = {
  __typename?: 'DoubleGamesConnection';
  /** A list of edges which contains the `DoubleGame` and cursor to aid in pagination. */
  edges: Array<DoubleGamesEdge>;
  /** A list of `DoubleGame` objects. */
  nodes: Array<Maybe<DoubleGame>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DoubleGame` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DoubleGame` edge in the connection. */
export type DoubleGamesEdge = {
  __typename?: 'DoubleGamesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DoubleGame` at the end of the edge. */
  node?: Maybe<DoubleGame>;
};

/** Methods to use when ordering `DoubleGame`. */
export enum DoubleGamesOrderBy {
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  DrawRoundAsc = 'DRAW_ROUND_ASC',
  DrawRoundDesc = 'DRAW_ROUND_DESC',
  DrawTimestampAsc = 'DRAW_TIMESTAMP_ASC',
  DrawTimestampDesc = 'DRAW_TIMESTAMP_DESC',
  DrawTxHashAsc = 'DRAW_TX_HASH_ASC',
  DrawTxHashDesc = 'DRAW_TX_HASH_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  JackpotAsc = 'JACKPOT_ASC',
  JackpotDesc = 'JACKPOT_DESC',
  Natural = 'NATURAL',
  PoolAsc = 'POOL_ASC',
  PoolDesc = 'POOL_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RandomnessAsc = 'RANDOMNESS_ASC',
  RandomnessDesc = 'RANDOMNESS_DESC',
  StartBlockAsc = 'START_BLOCK_ASC',
  StartBlockDesc = 'START_BLOCK_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  WinColorAsc = 'WIN_COLOR_ASC',
  WinColorDesc = 'WIN_COLOR_DESC',
  WinNumberAsc = 'WIN_NUMBER_ASC',
  WinNumberDesc = 'WIN_NUMBER_DESC'
}

export type DoubleJackpot = {
  __typename?: 'DoubleJackpot';
  drawTimeStamp?: Maybe<Scalars['BigInt']['output']>;
  id?: Maybe<Scalars['BigInt']['output']>;
  jackpot?: Maybe<Scalars['BigFloat']['output']>;
  pool?: Maybe<Scalars['BigFloat']['output']>;
  randomness?: Maybe<Scalars['String']['output']>;
  startBlock?: Maybe<Scalars['BigInt']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  winColor?: Maybe<DoubleColor>;
  winNumber?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `DoubleJackpot` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DoubleJackpotCondition = {
  /** Checks for equality with the object’s `drawTimeStamp` field. */
  drawTimeStamp?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `jackpot` field. */
  jackpot?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `pool` field. */
  pool?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `randomness` field. */
  randomness?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `startBlock` field. */
  startBlock?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `winColor` field. */
  winColor?: InputMaybe<DoubleColor>;
  /** Checks for equality with the object’s `winNumber` field. */
  winNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `DoubleJackpot` object types. All fields are combined with a logical ‘and.’ */
export type DoubleJackpotFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DoubleJackpotFilter>>;
  /** Filter by the object’s `drawTimeStamp` field. */
  drawTimeStamp?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `jackpot` field. */
  jackpot?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DoubleJackpotFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DoubleJackpotFilter>>;
  /** Filter by the object’s `pool` field. */
  pool?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `randomness` field. */
  randomness?: InputMaybe<StringFilter>;
  /** Filter by the object’s `startBlock` field. */
  startBlock?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<StringFilter>;
  /** Filter by the object’s `winColor` field. */
  winColor?: InputMaybe<DoubleColorFilter>;
  /** Filter by the object’s `winNumber` field. */
  winNumber?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `DoubleJackpot` */
export type DoubleJackpotInput = {
  drawTimeStamp?: InputMaybe<Scalars['BigInt']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  jackpot?: InputMaybe<Scalars['BigFloat']['input']>;
  pool?: InputMaybe<Scalars['BigFloat']['input']>;
  randomness?: InputMaybe<Scalars['String']['input']>;
  startBlock?: InputMaybe<Scalars['BigInt']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  winColor?: InputMaybe<DoubleColor>;
  winNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `DoubleJackpot` values. */
export type DoubleJackpotsConnection = {
  __typename?: 'DoubleJackpotsConnection';
  /** A list of edges which contains the `DoubleJackpot` and cursor to aid in pagination. */
  edges: Array<DoubleJackpotsEdge>;
  /** A list of `DoubleJackpot` objects. */
  nodes: Array<Maybe<DoubleJackpot>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DoubleJackpot` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DoubleJackpot` edge in the connection. */
export type DoubleJackpotsEdge = {
  __typename?: 'DoubleJackpotsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DoubleJackpot` at the end of the edge. */
  node?: Maybe<DoubleJackpot>;
};

/** Methods to use when ordering `DoubleJackpot`. */
export enum DoubleJackpotsOrderBy {
  DrawTimeStampAsc = 'DRAW_TIME_STAMP_ASC',
  DrawTimeStampDesc = 'DRAW_TIME_STAMP_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  JackpotAsc = 'JACKPOT_ASC',
  JackpotDesc = 'JACKPOT_DESC',
  Natural = 'NATURAL',
  PoolAsc = 'POOL_ASC',
  PoolDesc = 'POOL_DESC',
  RandomnessAsc = 'RANDOMNESS_ASC',
  RandomnessDesc = 'RANDOMNESS_DESC',
  StartBlockAsc = 'START_BLOCK_ASC',
  StartBlockDesc = 'START_BLOCK_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  WinColorAsc = 'WIN_COLOR_ASC',
  WinColorDesc = 'WIN_COLOR_DESC',
  WinNumberAsc = 'WIN_NUMBER_ASC',
  WinNumberDesc = 'WIN_NUMBER_DESC'
}

export type DoubleUserGame = {
  __typename?: 'DoubleUserGame';
  address?: Maybe<Scalars['String']['output']>;
  black?: Maybe<Scalars['BigFloat']['output']>;
  denom?: Maybe<Scalars['String']['output']>;
  gameId?: Maybe<Scalars['BigInt']['output']>;
  green?: Maybe<Scalars['BigFloat']['output']>;
  red?: Maybe<Scalars['BigFloat']['output']>;
  timestamp?: Maybe<Scalars['Datetime']['output']>;
  totalamount?: Maybe<Scalars['BigFloat']['output']>;
  totaljackpot?: Maybe<Scalars['BigFloat']['output']>;
  totalpayout?: Maybe<Scalars['BigFloat']['output']>;
  totalresult?: Maybe<Scalars['BigFloat']['output']>;
  wincolor?: Maybe<DoubleColor>;
};

/**
 * A condition to be used against `DoubleUserGame` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DoubleUserGameCondition = {
  /** Checks for equality with the object’s `address` field. */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `black` field. */
  black?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `denom` field. */
  denom?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `gameId` field. */
  gameId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `green` field. */
  green?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `red` field. */
  red?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `timestamp` field. */
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `totalamount` field. */
  totalamount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totaljackpot` field. */
  totaljackpot?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalpayout` field. */
  totalpayout?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalresult` field. */
  totalresult?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `wincolor` field. */
  wincolor?: InputMaybe<DoubleColor>;
};

/** A filter to be used against `DoubleUserGame` object types. All fields are combined with a logical ‘and.’ */
export type DoubleUserGameFilter = {
  /** Filter by the object’s `address` field. */
  address?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DoubleUserGameFilter>>;
  /** Filter by the object’s `black` field. */
  black?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `denom` field. */
  denom?: InputMaybe<StringFilter>;
  /** Filter by the object’s `gameId` field. */
  gameId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `green` field. */
  green?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DoubleUserGameFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DoubleUserGameFilter>>;
  /** Filter by the object’s `red` field. */
  red?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `timestamp` field. */
  timestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `totalamount` field. */
  totalamount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totaljackpot` field. */
  totaljackpot?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalpayout` field. */
  totalpayout?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalresult` field. */
  totalresult?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `wincolor` field. */
  wincolor?: InputMaybe<DoubleColorFilter>;
};

/** A connection to a list of `DoubleUserGame` values. */
export type DoubleUserGamesConnection = {
  __typename?: 'DoubleUserGamesConnection';
  /** A list of edges which contains the `DoubleUserGame` and cursor to aid in pagination. */
  edges: Array<DoubleUserGamesEdge>;
  /** A list of `DoubleUserGame` objects. */
  nodes: Array<Maybe<DoubleUserGame>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DoubleUserGame` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DoubleUserGame` edge in the connection. */
export type DoubleUserGamesEdge = {
  __typename?: 'DoubleUserGamesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DoubleUserGame` at the end of the edge. */
  node?: Maybe<DoubleUserGame>;
};

/** Methods to use when ordering `DoubleUserGame`. */
export enum DoubleUserGamesOrderBy {
  AddressAsc = 'ADDRESS_ASC',
  AddressDesc = 'ADDRESS_DESC',
  BlackAsc = 'BLACK_ASC',
  BlackDesc = 'BLACK_DESC',
  DenomAsc = 'DENOM_ASC',
  DenomDesc = 'DENOM_DESC',
  GameIdAsc = 'GAME_ID_ASC',
  GameIdDesc = 'GAME_ID_DESC',
  GreenAsc = 'GREEN_ASC',
  GreenDesc = 'GREEN_DESC',
  Natural = 'NATURAL',
  RedAsc = 'RED_ASC',
  RedDesc = 'RED_DESC',
  TimestampAsc = 'TIMESTAMP_ASC',
  TimestampDesc = 'TIMESTAMP_DESC',
  TotalamountAsc = 'TOTALAMOUNT_ASC',
  TotalamountDesc = 'TOTALAMOUNT_DESC',
  TotaljackpotAsc = 'TOTALJACKPOT_ASC',
  TotaljackpotDesc = 'TOTALJACKPOT_DESC',
  TotalpayoutAsc = 'TOTALPAYOUT_ASC',
  TotalpayoutDesc = 'TOTALPAYOUT_DESC',
  TotalresultAsc = 'TOTALRESULT_ASC',
  TotalresultDesc = 'TOTALRESULT_DESC',
  WincolorAsc = 'WINCOLOR_ASC',
  WincolorDesc = 'WINCOLOR_DESC'
}

/** A connection to a list of `FeeDistributedHistory` values. */
export type FeeDistributedHistoriesConnection = {
  __typename?: 'FeeDistributedHistoriesConnection';
  /** A list of edges which contains the `FeeDistributedHistory` and cursor to aid in pagination. */
  edges: Array<FeeDistributedHistoriesEdge>;
  /** A list of `FeeDistributedHistory` objects. */
  nodes: Array<Maybe<FeeDistributedHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FeeDistributedHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `FeeDistributedHistory` edge in the connection. */
export type FeeDistributedHistoriesEdge = {
  __typename?: 'FeeDistributedHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `FeeDistributedHistory` at the end of the edge. */
  node?: Maybe<FeeDistributedHistory>;
};

/** Methods to use when ordering `FeeDistributedHistory`. */
export enum FeeDistributedHistoriesOrderBy {
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  AmountUsdAsc = 'AMOUNT_USD_ASC',
  AmountUsdDesc = 'AMOUNT_USD_DESC',
  BetAsc = 'BET_ASC',
  BetDesc = 'BET_DESC',
  BetUsdAsc = 'BET_USD_ASC',
  BetUsdDesc = 'BET_USD_DESC',
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  DenomAsc = 'DENOM_ASC',
  DenomDesc = 'DENOM_DESC',
  GameAsc = 'GAME_ASC',
  GameDesc = 'GAME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PartnerAddressAsc = 'PARTNER_ADDRESS_ASC',
  PartnerAddressDesc = 'PARTNER_ADDRESS_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UserAsc = 'USER_ASC',
  UserDesc = 'USER_DESC'
}

export type FeeDistributedHistory = {
  __typename?: 'FeeDistributedHistory';
  amount: Scalars['BigFloat']['output'];
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  bet?: Maybe<Scalars['BigFloat']['output']>;
  betUsd?: Maybe<Scalars['BigFloat']['output']>;
  created: Scalars['Datetime']['output'];
  denom?: Maybe<Scalars['String']['output']>;
  game: Scalars['String']['output'];
  id: Scalars['String']['output'];
  partnerAddress: Scalars['String']['output'];
  type: Scalars['String']['output'];
  user: Scalars['String']['output'];
};

/**
 * A condition to be used against `FeeDistributedHistory` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type FeeDistributedHistoryCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `amountUsd` field. */
  amountUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `bet` field. */
  bet?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `betUsd` field. */
  betUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `denom` field. */
  denom?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `game` field. */
  game?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `partnerAddress` field. */
  partnerAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `user` field. */
  user?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `FeeDistributedHistory` object types. All fields are combined with a logical ‘and.’ */
export type FeeDistributedHistoryFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `amountUsd` field. */
  amountUsd?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FeeDistributedHistoryFilter>>;
  /** Filter by the object’s `bet` field. */
  bet?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `betUsd` field. */
  betUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `denom` field. */
  denom?: InputMaybe<StringFilter>;
  /** Filter by the object’s `game` field. */
  game?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FeeDistributedHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FeeDistributedHistoryFilter>>;
  /** Filter by the object’s `partnerAddress` field. */
  partnerAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
  /** Filter by the object’s `user` field. */
  user?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `FeeDistributedHistory` */
export type FeeDistributedHistoryInput = {
  amount: Scalars['BigFloat']['input'];
  amountUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  bet?: InputMaybe<Scalars['BigFloat']['input']>;
  betUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  created: Scalars['Datetime']['input'];
  denom?: InputMaybe<Scalars['String']['input']>;
  game: Scalars['String']['input'];
  id: Scalars['String']['input'];
  partnerAddress: Scalars['String']['input'];
  type: Scalars['String']['input'];
  user: Scalars['String']['input'];
};

/** Represents an update to a `FeeDistributedHistory`. Fields that are set will be updated. */
export type FeeDistributedHistoryPatch = {
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  amountUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  bet?: InputMaybe<Scalars['BigFloat']['input']>;
  betUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  created?: InputMaybe<Scalars['Datetime']['input']>;
  denom?: InputMaybe<Scalars['String']['input']>;
  game?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  partnerAddress?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export enum GameResult {
  Draw = 'DRAW',
  Player1 = 'PLAYER1',
  Player2 = 'PLAYER2',
  Refund = 'REFUND'
}

/** A filter to be used against GameResult fields. All fields are combined with a logical ‘and.’ */
export type GameResultFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<GameResult>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<GameResult>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<GameResult>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<GameResult>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<GameResult>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<GameResult>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<GameResult>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<GameResult>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<GameResult>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<GameResult>>;
};

export enum GameRisk {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

/** A filter to be used against GameRisk fields. All fields are combined with a logical ‘and.’ */
export type GameRiskFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<GameRisk>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<GameRisk>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<GameRisk>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<GameRisk>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<GameRisk>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<GameRisk>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<GameRisk>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<GameRisk>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<GameRisk>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<GameRisk>>;
};

export enum GameState {
  Canceled = 'CANCELED',
  End = 'END',
  Processing = 'PROCESSING'
}

/** A filter to be used against GameState fields. All fields are combined with a logical ‘and.’ */
export type GameStateFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<GameState>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<GameState>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<GameState>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<GameState>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<GameState>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<GameState>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<GameState>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<GameState>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<GameState>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<GameState>>;
};

export enum GameStatus {
  Finished = 'FINISHED',
  Pending = 'PENDING'
}

/** A filter to be used against GameStatus fields. All fields are combined with a logical ‘and.’ */
export type GameStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<GameStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<GameStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<GameStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<GameStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<GameStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<GameStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<GameStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<GameStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<GameStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<GameStatus>>;
};

export type GatewayChainTransaction = {
  __typename?: 'GatewayChainTransaction';
  createdAt: Scalars['Datetime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  executedAt?: Maybe<Scalars['Datetime']['output']>;
  executedBy?: Maybe<Scalars['String']['output']>;
  funds?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['BigInt']['output'];
  status: GatewayChainTransactionStatus;
  txHash?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `GatewayChainTransaction` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type GatewayChainTransactionCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `error` field. */
  error?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `executedAt` field. */
  executedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `executedBy` field. */
  executedBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `funds` field. */
  funds?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<GatewayChainTransactionStatus>;
  /** Checks for equality with the object’s `txHash` field. */
  txHash?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `GatewayChainTransaction` object types. All fields are combined with a logical ‘and.’ */
export type GatewayChainTransactionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GatewayChainTransactionFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `error` field. */
  error?: InputMaybe<StringFilter>;
  /** Filter by the object’s `executedAt` field. */
  executedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `executedBy` field. */
  executedBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `funds` field. */
  funds?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GatewayChainTransactionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GatewayChainTransactionFilter>>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<GatewayChainTransactionStatusFilter>;
  /** Filter by the object’s `txHash` field. */
  txHash?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `GatewayChainTransaction` */
export type GatewayChainTransactionInput = {
  createdAt: Scalars['Datetime']['input'];
  error?: InputMaybe<Scalars['String']['input']>;
  executedAt?: InputMaybe<Scalars['Datetime']['input']>;
  executedBy?: InputMaybe<Scalars['String']['input']>;
  funds?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  status: GatewayChainTransactionStatus;
  txHash?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an update to a `GatewayChainTransaction`. Fields that are set will be updated. */
export type GatewayChainTransactionPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  executedAt?: InputMaybe<Scalars['Datetime']['input']>;
  executedBy?: InputMaybe<Scalars['String']['input']>;
  funds?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  status?: InputMaybe<GatewayChainTransactionStatus>;
  txHash?: InputMaybe<Scalars['String']['input']>;
};

export enum GatewayChainTransactionStatus {
  Executed = 'EXECUTED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

/** A filter to be used against GatewayChainTransactionStatus fields. All fields are combined with a logical ‘and.’ */
export type GatewayChainTransactionStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<GatewayChainTransactionStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<GatewayChainTransactionStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<GatewayChainTransactionStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<GatewayChainTransactionStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<GatewayChainTransactionStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<GatewayChainTransactionStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<GatewayChainTransactionStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<GatewayChainTransactionStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<GatewayChainTransactionStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<GatewayChainTransactionStatus>>;
};

/** A connection to a list of `GatewayChainTransaction` values. */
export type GatewayChainTransactionsConnection = {
  __typename?: 'GatewayChainTransactionsConnection';
  /** A list of edges which contains the `GatewayChainTransaction` and cursor to aid in pagination. */
  edges: Array<GatewayChainTransactionsEdge>;
  /** A list of `GatewayChainTransaction` objects. */
  nodes: Array<Maybe<GatewayChainTransaction>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GatewayChainTransaction` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `GatewayChainTransaction` edge in the connection. */
export type GatewayChainTransactionsEdge = {
  __typename?: 'GatewayChainTransactionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `GatewayChainTransaction` at the end of the edge. */
  node?: Maybe<GatewayChainTransaction>;
};

/** Methods to use when ordering `GatewayChainTransaction`. */
export enum GatewayChainTransactionsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  ErrorAsc = 'ERROR_ASC',
  ErrorDesc = 'ERROR_DESC',
  ExecutedAtAsc = 'EXECUTED_AT_ASC',
  ExecutedAtDesc = 'EXECUTED_AT_DESC',
  ExecutedByAsc = 'EXECUTED_BY_ASC',
  ExecutedByDesc = 'EXECUTED_BY_DESC',
  FundsAsc = 'FUNDS_ASC',
  FundsDesc = 'FUNDS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TxHashAsc = 'TX_HASH_ASC',
  TxHashDesc = 'TX_HASH_DESC'
}

/** A `GetPartnerUsersStatsRecord` edge in the connection. */
export type GetPartnerUsersStatEdge = {
  __typename?: 'GetPartnerUsersStatEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `GetPartnerUsersStatsRecord` at the end of the edge. */
  node?: Maybe<GetPartnerUsersStatsRecord>;
};

/** A connection to a list of `GetPartnerUsersStatsRecord` values. */
export type GetPartnerUsersStatsConnection = {
  __typename?: 'GetPartnerUsersStatsConnection';
  /** A list of edges which contains the `GetPartnerUsersStatsRecord` and cursor to aid in pagination. */
  edges: Array<GetPartnerUsersStatEdge>;
  /** A list of `GetPartnerUsersStatsRecord` objects. */
  nodes: Array<Maybe<GetPartnerUsersStatsRecord>>;
  /** The count of *all* `GetPartnerUsersStatsRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** The return type of our `getPartnerUsersStats` query. */
export type GetPartnerUsersStatsRecord = {
  __typename?: 'GetPartnerUsersStatsRecord';
  betCount?: Maybe<Scalars['BigFloat']['output']>;
  byDenom?: Maybe<Scalars['JSON']['output']>;
  lastBetAt?: Maybe<Scalars['Datetime']['output']>;
  profileAvatar?: Maybe<Scalars['String']['output']>;
  profileUserName?: Maybe<Scalars['String']['output']>;
  registeredAt?: Maybe<Scalars['Datetime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** A filter to be used against `GetPartnerUsersStatsRecord` object types. All fields are combined with a logical ‘and.’ */
export type GetPartnerUsersStatsRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GetPartnerUsersStatsRecordFilter>>;
  /** Filter by the object’s `betCount` field. */
  betCount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `byDenom` field. */
  byDenom?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `lastBetAt` field. */
  lastBetAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GetPartnerUsersStatsRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GetPartnerUsersStatsRecordFilter>>;
  /** Filter by the object’s `profileAvatar` field. */
  profileAvatar?: InputMaybe<StringFilter>;
  /** Filter by the object’s `profileUserName` field. */
  profileUserName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `registeredAt` field. */
  registeredAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<StringFilter>;
};

export type InfoLast100WinBet = {
  __typename?: 'InfoLast100WinBet';
  bet?: Maybe<Scalars['BigFloat']['output']>;
  betUsd?: Maybe<Scalars['BigInt']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  denom?: Maybe<Scalars['String']['output']>;
  extraGameId?: Maybe<Scalars['String']['output']>;
  game?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  payout?: Maybe<Scalars['BigFloat']['output']>;
  payoutUsd?: Maybe<Scalars['BigInt']['output']>;
  player?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `InfoLast100WinBet` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type InfoLast100WinBetCondition = {
  /** Checks for equality with the object’s `bet` field. */
  bet?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `betUsd` field. */
  betUsd?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `denom` field. */
  denom?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `extraGameId` field. */
  extraGameId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `game` field. */
  game?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `payout` field. */
  payout?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `payoutUsd` field. */
  payoutUsd?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `player` field. */
  player?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `InfoLast100WinBet` object types. All fields are combined with a logical ‘and.’ */
export type InfoLast100WinBetFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<InfoLast100WinBetFilter>>;
  /** Filter by the object’s `bet` field. */
  bet?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `betUsd` field. */
  betUsd?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `denom` field. */
  denom?: InputMaybe<StringFilter>;
  /** Filter by the object’s `extraGameId` field. */
  extraGameId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `game` field. */
  game?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<InfoLast100WinBetFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<InfoLast100WinBetFilter>>;
  /** Filter by the object’s `payout` field. */
  payout?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `payoutUsd` field. */
  payoutUsd?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `player` field. */
  player?: InputMaybe<StringFilter>;
};

/** A connection to a list of `InfoLast100WinBet` values. */
export type InfoLast100WinBetsConnection = {
  __typename?: 'InfoLast100WinBetsConnection';
  /** A list of edges which contains the `InfoLast100WinBet` and cursor to aid in pagination. */
  edges: Array<InfoLast100WinBetsEdge>;
  /** A list of `InfoLast100WinBet` objects. */
  nodes: Array<Maybe<InfoLast100WinBet>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InfoLast100WinBet` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `InfoLast100WinBet` edge in the connection. */
export type InfoLast100WinBetsEdge = {
  __typename?: 'InfoLast100WinBetsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `InfoLast100WinBet` at the end of the edge. */
  node?: Maybe<InfoLast100WinBet>;
};

/** Methods to use when ordering `InfoLast100WinBet`. */
export enum InfoLast100WinBetsOrderBy {
  BetAsc = 'BET_ASC',
  BetDesc = 'BET_DESC',
  BetUsdAsc = 'BET_USD_ASC',
  BetUsdDesc = 'BET_USD_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DenomAsc = 'DENOM_ASC',
  DenomDesc = 'DENOM_DESC',
  ExtraGameIdAsc = 'EXTRA_GAME_ID_ASC',
  ExtraGameIdDesc = 'EXTRA_GAME_ID_DESC',
  GameAsc = 'GAME_ASC',
  GameDesc = 'GAME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PayoutAsc = 'PAYOUT_ASC',
  PayoutDesc = 'PAYOUT_DESC',
  PayoutUsdAsc = 'PAYOUT_USD_ASC',
  PayoutUsdDesc = 'PAYOUT_USD_DESC',
  PlayerAsc = 'PLAYER_ASC',
  PlayerDesc = 'PLAYER_DESC'
}

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type IntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** A filter to be used against Int List fields. All fields are combined with a logical ‘and.’ */
export type IntListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['Int']['input']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['Int']['input']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/** A filter to be used against JSON fields. All fields are combined with a logical ‘and.’ */
export type JsonFilter = {
  /** Contained by the specified JSON. */
  containedBy?: InputMaybe<Scalars['JSON']['input']>;
  /** Contains the specified JSON. */
  contains?: InputMaybe<Scalars['JSON']['input']>;
  /** Contains all of the specified keys. */
  containsAllKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains any of the specified keys. */
  containsAnyKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified key. */
  containsKey?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
};

export type JackpotBet = {
  __typename?: 'JackpotBet';
  address: Scalars['String']['output'];
  amount: Scalars['BigFloat']['output'];
  block: Scalars['BigInt']['output'];
  created?: Maybe<Scalars['Datetime']['output']>;
  date: Scalars['BigInt']['output'];
  /** Reads a single `JackpotGame` that is related to this `JackpotBet`. */
  game?: Maybe<JackpotGame>;
  gameId: Scalars['BigInt']['output'];
  id: Scalars['BigInt']['output'];
  txHash: Scalars['String']['output'];
};

/**
 * A condition to be used against `JackpotBet` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type JackpotBetCondition = {
  /** Checks for equality with the object’s `address` field. */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `block` field. */
  block?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `date` field. */
  date?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `gameId` field. */
  gameId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `txHash` field. */
  txHash?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `JackpotBet` object types. All fields are combined with a logical ‘and.’ */
export type JackpotBetFilter = {
  /** Filter by the object’s `address` field. */
  address?: InputMaybe<StringFilter>;
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<JackpotBetFilter>>;
  /** Filter by the object’s `block` field. */
  block?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `date` field. */
  date?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `gameId` field. */
  gameId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<JackpotBetFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<JackpotBetFilter>>;
  /** Filter by the object’s `txHash` field. */
  txHash?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `JackpotBet` */
export type JackpotBetInput = {
  address: Scalars['String']['input'];
  amount: Scalars['BigFloat']['input'];
  block: Scalars['BigInt']['input'];
  created?: InputMaybe<Scalars['Datetime']['input']>;
  date: Scalars['BigInt']['input'];
  gameId: Scalars['BigInt']['input'];
  id?: InputMaybe<Scalars['BigInt']['input']>;
  txHash: Scalars['String']['input'];
};

/** Represents an update to a `JackpotBet`. Fields that are set will be updated. */
export type JackpotBetPatch = {
  address?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  block?: InputMaybe<Scalars['BigInt']['input']>;
  created?: InputMaybe<Scalars['Datetime']['input']>;
  date?: InputMaybe<Scalars['BigInt']['input']>;
  gameId?: InputMaybe<Scalars['BigInt']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  txHash?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `JackpotBet` values. */
export type JackpotBetsConnection = {
  __typename?: 'JackpotBetsConnection';
  /** A list of edges which contains the `JackpotBet` and cursor to aid in pagination. */
  edges: Array<JackpotBetsEdge>;
  /** A list of `JackpotBet` objects. */
  nodes: Array<Maybe<JackpotBet>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `JackpotBet` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `JackpotBet` edge in the connection. */
export type JackpotBetsEdge = {
  __typename?: 'JackpotBetsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `JackpotBet` at the end of the edge. */
  node?: Maybe<JackpotBet>;
};

/** Methods to use when ordering `JackpotBet`. */
export enum JackpotBetsOrderBy {
  AddressAsc = 'ADDRESS_ASC',
  AddressDesc = 'ADDRESS_DESC',
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  BlockAsc = 'BLOCK_ASC',
  BlockDesc = 'BLOCK_DESC',
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  GameIdAsc = 'GAME_ID_ASC',
  GameIdDesc = 'GAME_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TxHashAsc = 'TX_HASH_ASC',
  TxHashDesc = 'TX_HASH_DESC'
}

export type JackpotGame = {
  __typename?: 'JackpotGame';
  created?: Maybe<Scalars['Datetime']['output']>;
  drawRound?: Maybe<Scalars['BigInt']['output']>;
  drawTimestamp?: Maybe<Scalars['BigInt']['output']>;
  drawTxHash?: Maybe<Scalars['String']['output']>;
  id: Scalars['BigInt']['output'];
  /** Reads and enables pagination through a set of `JackpotBet`. */
  jackpotBetsByGameId: JackpotBetsConnection;
  playerWinner?: Maybe<Scalars['String']['output']>;
  pool: Scalars['BigFloat']['output'];
  randomness?: Maybe<Scalars['String']['output']>;
  startBlock?: Maybe<Scalars['BigInt']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  winAmount?: Maybe<Scalars['BigFloat']['output']>;
};


export type JackpotGameJackpotBetsByGameIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<JackpotBetCondition>;
  filter?: InputMaybe<JackpotBetFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<JackpotBetsOrderBy>>;
};

/**
 * A condition to be used against `JackpotGame` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type JackpotGameCondition = {
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `drawRound` field. */
  drawRound?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `drawTimestamp` field. */
  drawTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `drawTxHash` field. */
  drawTxHash?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `playerWinner` field. */
  playerWinner?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `pool` field. */
  pool?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `randomness` field. */
  randomness?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `startBlock` field. */
  startBlock?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `winAmount` field. */
  winAmount?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** A filter to be used against `JackpotGame` object types. All fields are combined with a logical ‘and.’ */
export type JackpotGameFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<JackpotGameFilter>>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `drawRound` field. */
  drawRound?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `drawTimestamp` field. */
  drawTimestamp?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `drawTxHash` field. */
  drawTxHash?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<JackpotGameFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<JackpotGameFilter>>;
  /** Filter by the object’s `playerWinner` field. */
  playerWinner?: InputMaybe<StringFilter>;
  /** Filter by the object’s `pool` field. */
  pool?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `randomness` field. */
  randomness?: InputMaybe<StringFilter>;
  /** Filter by the object’s `startBlock` field. */
  startBlock?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<StringFilter>;
  /** Filter by the object’s `winAmount` field. */
  winAmount?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `JackpotGame` */
export type JackpotGameInput = {
  created?: InputMaybe<Scalars['Datetime']['input']>;
  drawRound?: InputMaybe<Scalars['BigInt']['input']>;
  drawTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  drawTxHash?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  playerWinner?: InputMaybe<Scalars['String']['input']>;
  pool: Scalars['BigFloat']['input'];
  randomness?: InputMaybe<Scalars['String']['input']>;
  startBlock?: InputMaybe<Scalars['BigInt']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  winAmount?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** Represents an update to a `JackpotGame`. Fields that are set will be updated. */
export type JackpotGamePatch = {
  created?: InputMaybe<Scalars['Datetime']['input']>;
  drawRound?: InputMaybe<Scalars['BigInt']['input']>;
  drawTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  drawTxHash?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  playerWinner?: InputMaybe<Scalars['String']['input']>;
  pool?: InputMaybe<Scalars['BigFloat']['input']>;
  randomness?: InputMaybe<Scalars['String']['input']>;
  startBlock?: InputMaybe<Scalars['BigInt']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  winAmount?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** A connection to a list of `JackpotGame` values. */
export type JackpotGamesConnection = {
  __typename?: 'JackpotGamesConnection';
  /** A list of edges which contains the `JackpotGame` and cursor to aid in pagination. */
  edges: Array<JackpotGamesEdge>;
  /** A list of `JackpotGame` objects. */
  nodes: Array<Maybe<JackpotGame>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `JackpotGame` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `JackpotGame` edge in the connection. */
export type JackpotGamesEdge = {
  __typename?: 'JackpotGamesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `JackpotGame` at the end of the edge. */
  node?: Maybe<JackpotGame>;
};

/** Methods to use when ordering `JackpotGame`. */
export enum JackpotGamesOrderBy {
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  DrawRoundAsc = 'DRAW_ROUND_ASC',
  DrawRoundDesc = 'DRAW_ROUND_DESC',
  DrawTimestampAsc = 'DRAW_TIMESTAMP_ASC',
  DrawTimestampDesc = 'DRAW_TIMESTAMP_DESC',
  DrawTxHashAsc = 'DRAW_TX_HASH_ASC',
  DrawTxHashDesc = 'DRAW_TX_HASH_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PlayerWinnerAsc = 'PLAYER_WINNER_ASC',
  PlayerWinnerDesc = 'PLAYER_WINNER_DESC',
  PoolAsc = 'POOL_ASC',
  PoolDesc = 'POOL_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RandomnessAsc = 'RANDOMNESS_ASC',
  RandomnessDesc = 'RANDOMNESS_DESC',
  StartBlockAsc = 'START_BLOCK_ASC',
  StartBlockDesc = 'START_BLOCK_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  WinAmountAsc = 'WIN_AMOUNT_ASC',
  WinAmountDesc = 'WIN_AMOUNT_DESC'
}

/** A connection to a list of `JackpotUserGames2Record` values. */
export type JackpotUserGames2Connection = {
  __typename?: 'JackpotUserGames2Connection';
  /** A list of edges which contains the `JackpotUserGames2Record` and cursor to aid in pagination. */
  edges: Array<JackpotUserGames2Edge>;
  /** A list of `JackpotUserGames2Record` objects. */
  nodes: Array<Maybe<JackpotUserGames2Record>>;
  /** The count of *all* `JackpotUserGames2Record` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `JackpotUserGames2Record` edge in the connection. */
export type JackpotUserGames2Edge = {
  __typename?: 'JackpotUserGames2Edge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `JackpotUserGames2Record` at the end of the edge. */
  node?: Maybe<JackpotUserGames2Record>;
};

/** The return type of our `jackpotUserGames2` query. */
export type JackpotUserGames2Record = {
  __typename?: 'JackpotUserGames2Record';
  gameId?: Maybe<Scalars['BigInt']['output']>;
  participants?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  playerWinner?: Maybe<Scalars['String']['output']>;
  pool?: Maybe<Scalars['BigFloat']['output']>;
  winAmount?: Maybe<Scalars['BigFloat']['output']>;
  winnerBet?: Maybe<Scalars['BigFloat']['output']>;
};

/** A filter to be used against `JackpotUserGames2Record` object types. All fields are combined with a logical ‘and.’ */
export type JackpotUserGames2RecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<JackpotUserGames2RecordFilter>>;
  /** Filter by the object’s `gameId` field. */
  gameId?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<JackpotUserGames2RecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<JackpotUserGames2RecordFilter>>;
  /** Filter by the object’s `participants` field. */
  participants?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `playerWinner` field. */
  playerWinner?: InputMaybe<StringFilter>;
  /** Filter by the object’s `pool` field. */
  pool?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `winAmount` field. */
  winAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `winnerBet` field. */
  winnerBet?: InputMaybe<BigFloatFilter>;
};

export type Lootbox = {
  __typename?: 'Lootbox';
  finishedGameCount: Scalars['BigInt']['output'];
  gameCount: Scalars['BigInt']['output'];
  id: Scalars['String']['output'];
  remainRewardsQuantity: Scalars['BigInt']['output'];
  updated: Scalars['Datetime']['output'];
};

/** A condition to be used against `Lootbox` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type LootboxCondition = {
  /** Checks for equality with the object’s `finishedGameCount` field. */
  finishedGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `gameCount` field. */
  gameCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `remainRewardsQuantity` field. */
  remainRewardsQuantity?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `updated` field. */
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `Lootbox` object types. All fields are combined with a logical ‘and.’ */
export type LootboxFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LootboxFilter>>;
  /** Filter by the object’s `finishedGameCount` field. */
  finishedGameCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `gameCount` field. */
  gameCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LootboxFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LootboxFilter>>;
  /** Filter by the object’s `remainRewardsQuantity` field. */
  remainRewardsQuantity?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `updated` field. */
  updated?: InputMaybe<DatetimeFilter>;
};

export type LootboxGame = {
  __typename?: 'LootboxGame';
  bank?: Maybe<Scalars['JSON']['output']>;
  created: Scalars['Datetime']['output'];
  cw721?: Maybe<Scalars['String']['output']>;
  drawnTxHash?: Maybe<Scalars['String']['output']>;
  height: Scalars['BigInt']['output'];
  id: Scalars['BigInt']['output'];
  lootbox: Scalars['String']['output'];
  pay?: Maybe<Scalars['JSON']['output']>;
  player: Scalars['String']['output'];
  randomness?: Maybe<Scalars['String']['output']>;
  randomnessIndex?: Maybe<Scalars['BigFloat']['output']>;
  rewardId?: Maybe<Scalars['String']['output']>;
  round: Scalars['BigInt']['output'];
  roundRandomness?: Maybe<Scalars['String']['output']>;
  status: LootboxGameStatus;
  txHash: Scalars['String']['output'];
  updated: Scalars['Datetime']['output'];
  wasm?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `LootboxGame` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type LootboxGameCondition = {
  /** Checks for equality with the object’s `bank` field. */
  bank?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `cw721` field. */
  cw721?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `drawnTxHash` field. */
  drawnTxHash?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `height` field. */
  height?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `lootbox` field. */
  lootbox?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `pay` field. */
  pay?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `player` field. */
  player?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `randomness` field. */
  randomness?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `randomnessIndex` field. */
  randomnessIndex?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `rewardId` field. */
  rewardId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `round` field. */
  round?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `roundRandomness` field. */
  roundRandomness?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<LootboxGameStatus>;
  /** Checks for equality with the object’s `txHash` field. */
  txHash?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updated` field. */
  updated?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `wasm` field. */
  wasm?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `LootboxGame` object types. All fields are combined with a logical ‘and.’ */
export type LootboxGameFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LootboxGameFilter>>;
  /** Filter by the object’s `bank` field. */
  bank?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `cw721` field. */
  cw721?: InputMaybe<StringFilter>;
  /** Filter by the object’s `drawnTxHash` field. */
  drawnTxHash?: InputMaybe<StringFilter>;
  /** Filter by the object’s `height` field. */
  height?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `lootbox` field. */
  lootbox?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LootboxGameFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LootboxGameFilter>>;
  /** Filter by the object’s `pay` field. */
  pay?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `player` field. */
  player?: InputMaybe<StringFilter>;
  /** Filter by the object’s `randomness` field. */
  randomness?: InputMaybe<StringFilter>;
  /** Filter by the object’s `randomnessIndex` field. */
  randomnessIndex?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `rewardId` field. */
  rewardId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `round` field. */
  round?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `roundRandomness` field. */
  roundRandomness?: InputMaybe<StringFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<LootboxGameStatusFilter>;
  /** Filter by the object’s `txHash` field. */
  txHash?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updated` field. */
  updated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `wasm` field. */
  wasm?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `LootboxGame` */
export type LootboxGameInput = {
  bank?: InputMaybe<Scalars['JSON']['input']>;
  created: Scalars['Datetime']['input'];
  cw721?: InputMaybe<Scalars['String']['input']>;
  drawnTxHash?: InputMaybe<Scalars['String']['input']>;
  height: Scalars['BigInt']['input'];
  id: Scalars['BigInt']['input'];
  lootbox: Scalars['String']['input'];
  pay?: InputMaybe<Scalars['JSON']['input']>;
  player: Scalars['String']['input'];
  randomness?: InputMaybe<Scalars['String']['input']>;
  randomnessIndex?: InputMaybe<Scalars['BigFloat']['input']>;
  rewardId?: InputMaybe<Scalars['String']['input']>;
  round: Scalars['BigInt']['input'];
  roundRandomness?: InputMaybe<Scalars['String']['input']>;
  status: LootboxGameStatus;
  txHash: Scalars['String']['input'];
  updated: Scalars['Datetime']['input'];
  wasm?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an update to a `LootboxGame`. Fields that are set will be updated. */
export type LootboxGamePatch = {
  bank?: InputMaybe<Scalars['JSON']['input']>;
  created?: InputMaybe<Scalars['Datetime']['input']>;
  cw721?: InputMaybe<Scalars['String']['input']>;
  drawnTxHash?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['BigInt']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  lootbox?: InputMaybe<Scalars['String']['input']>;
  pay?: InputMaybe<Scalars['JSON']['input']>;
  player?: InputMaybe<Scalars['String']['input']>;
  randomness?: InputMaybe<Scalars['String']['input']>;
  randomnessIndex?: InputMaybe<Scalars['BigFloat']['input']>;
  rewardId?: InputMaybe<Scalars['String']['input']>;
  round?: InputMaybe<Scalars['BigInt']['input']>;
  roundRandomness?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<LootboxGameStatus>;
  txHash?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['Datetime']['input']>;
  wasm?: InputMaybe<Scalars['String']['input']>;
};

export enum LootboxGameStatus {
  Drawn = 'DRAWN',
  Finished = 'FINISHED',
  Init = 'INIT'
}

/** A filter to be used against LootboxGameStatus fields. All fields are combined with a logical ‘and.’ */
export type LootboxGameStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<LootboxGameStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<LootboxGameStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<LootboxGameStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<LootboxGameStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<LootboxGameStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<LootboxGameStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<LootboxGameStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<LootboxGameStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<LootboxGameStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<LootboxGameStatus>>;
};

/** A connection to a list of `LootboxGame` values. */
export type LootboxGamesConnection = {
  __typename?: 'LootboxGamesConnection';
  /** A list of edges which contains the `LootboxGame` and cursor to aid in pagination. */
  edges: Array<LootboxGamesEdge>;
  /** A list of `LootboxGame` objects. */
  nodes: Array<Maybe<LootboxGame>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LootboxGame` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `LootboxGame` edge in the connection. */
export type LootboxGamesEdge = {
  __typename?: 'LootboxGamesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LootboxGame` at the end of the edge. */
  node?: Maybe<LootboxGame>;
};

/** Methods to use when ordering `LootboxGame`. */
export enum LootboxGamesOrderBy {
  BankAsc = 'BANK_ASC',
  BankDesc = 'BANK_DESC',
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  Cw721Asc = 'CW721_ASC',
  Cw721Desc = 'CW721_DESC',
  DrawnTxHashAsc = 'DRAWN_TX_HASH_ASC',
  DrawnTxHashDesc = 'DRAWN_TX_HASH_DESC',
  HeightAsc = 'HEIGHT_ASC',
  HeightDesc = 'HEIGHT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LootboxAsc = 'LOOTBOX_ASC',
  LootboxDesc = 'LOOTBOX_DESC',
  Natural = 'NATURAL',
  PayAsc = 'PAY_ASC',
  PayDesc = 'PAY_DESC',
  PlayerAsc = 'PLAYER_ASC',
  PlayerDesc = 'PLAYER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RandomnessAsc = 'RANDOMNESS_ASC',
  RandomnessDesc = 'RANDOMNESS_DESC',
  RandomnessIndexAsc = 'RANDOMNESS_INDEX_ASC',
  RandomnessIndexDesc = 'RANDOMNESS_INDEX_DESC',
  RewardIdAsc = 'REWARD_ID_ASC',
  RewardIdDesc = 'REWARD_ID_DESC',
  RoundAsc = 'ROUND_ASC',
  RoundDesc = 'ROUND_DESC',
  RoundRandomnessAsc = 'ROUND_RANDOMNESS_ASC',
  RoundRandomnessDesc = 'ROUND_RANDOMNESS_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TxHashAsc = 'TX_HASH_ASC',
  TxHashDesc = 'TX_HASH_DESC',
  UpdatedAsc = 'UPDATED_ASC',
  UpdatedDesc = 'UPDATED_DESC',
  WasmAsc = 'WASM_ASC',
  WasmDesc = 'WASM_DESC'
}

/** An input for mutations affecting `Lootbox` */
export type LootboxInput = {
  finishedGameCount: Scalars['BigInt']['input'];
  gameCount: Scalars['BigInt']['input'];
  id: Scalars['String']['input'];
  remainRewardsQuantity: Scalars['BigInt']['input'];
  updated: Scalars['Datetime']['input'];
};

export type LootboxMarketOrder = {
  __typename?: 'LootboxMarketOrder';
  created: Scalars['Datetime']['output'];
  lootbox: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `LootboxMarketTrade`. */
  lootboxMarketTradesByOrderId: LootboxMarketTradesConnection;
  orderId: Scalars['BigInt']['output'];
  player: Scalars['String']['output'];
  price: Scalars['BigFloat']['output'];
  quote: Scalars['String']['output'];
  status: LootboxMarketOrderStatus;
  tx: Scalars['String']['output'];
  type: LootboxMarketOrderType;
  updated: Scalars['Datetime']['output'];
};


export type LootboxMarketOrderLootboxMarketTradesByOrderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LootboxMarketTradeCondition>;
  filter?: InputMaybe<LootboxMarketTradeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LootboxMarketTradesOrderBy>>;
};

/**
 * A condition to be used against `LootboxMarketOrder` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LootboxMarketOrderCondition = {
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `lootbox` field. */
  lootbox?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `player` field. */
  player?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `price` field. */
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `quote` field. */
  quote?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<LootboxMarketOrderStatus>;
  /** Checks for equality with the object’s `tx` field. */
  tx?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<LootboxMarketOrderType>;
  /** Checks for equality with the object’s `updated` field. */
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `LootboxMarketOrder` object types. All fields are combined with a logical ‘and.’ */
export type LootboxMarketOrderFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LootboxMarketOrderFilter>>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `lootbox` field. */
  lootbox?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LootboxMarketOrderFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LootboxMarketOrderFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `player` field. */
  player?: InputMaybe<StringFilter>;
  /** Filter by the object’s `price` field. */
  price?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `quote` field. */
  quote?: InputMaybe<StringFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<LootboxMarketOrderStatusFilter>;
  /** Filter by the object’s `tx` field. */
  tx?: InputMaybe<StringFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<LootboxMarketOrderTypeFilter>;
  /** Filter by the object’s `updated` field. */
  updated?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `LootboxMarketOrder` */
export type LootboxMarketOrderInput = {
  created: Scalars['Datetime']['input'];
  lootbox: Scalars['String']['input'];
  orderId: Scalars['BigInt']['input'];
  player: Scalars['String']['input'];
  price: Scalars['BigFloat']['input'];
  quote: Scalars['String']['input'];
  status: LootboxMarketOrderStatus;
  tx: Scalars['String']['input'];
  type: LootboxMarketOrderType;
  updated: Scalars['Datetime']['input'];
};

/** Represents an update to a `LootboxMarketOrder`. Fields that are set will be updated. */
export type LootboxMarketOrderPatch = {
  created?: InputMaybe<Scalars['Datetime']['input']>;
  lootbox?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['BigInt']['input']>;
  player?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  quote?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<LootboxMarketOrderStatus>;
  tx?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<LootboxMarketOrderType>;
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

export enum LootboxMarketOrderStatus {
  Active = 'ACTIVE',
  Finished = 'FINISHED',
  Partial = 'PARTIAL',
  Rejected = 'REJECTED'
}

/** A filter to be used against LootboxMarketOrderStatus fields. All fields are combined with a logical ‘and.’ */
export type LootboxMarketOrderStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<LootboxMarketOrderStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<LootboxMarketOrderStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<LootboxMarketOrderStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<LootboxMarketOrderStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<LootboxMarketOrderStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<LootboxMarketOrderStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<LootboxMarketOrderStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<LootboxMarketOrderStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<LootboxMarketOrderStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<LootboxMarketOrderStatus>>;
};

export enum LootboxMarketOrderType {
  Buy = 'BUY',
  Sell = 'SELL'
}

/** A filter to be used against LootboxMarketOrderType fields. All fields are combined with a logical ‘and.’ */
export type LootboxMarketOrderTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<LootboxMarketOrderType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<LootboxMarketOrderType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<LootboxMarketOrderType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<LootboxMarketOrderType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<LootboxMarketOrderType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<LootboxMarketOrderType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<LootboxMarketOrderType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<LootboxMarketOrderType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<LootboxMarketOrderType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<LootboxMarketOrderType>>;
};

/** A connection to a list of `LootboxMarketOrder` values. */
export type LootboxMarketOrdersConnection = {
  __typename?: 'LootboxMarketOrdersConnection';
  /** A list of edges which contains the `LootboxMarketOrder` and cursor to aid in pagination. */
  edges: Array<LootboxMarketOrdersEdge>;
  /** A list of `LootboxMarketOrder` objects. */
  nodes: Array<Maybe<LootboxMarketOrder>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LootboxMarketOrder` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `LootboxMarketOrder` edge in the connection. */
export type LootboxMarketOrdersEdge = {
  __typename?: 'LootboxMarketOrdersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LootboxMarketOrder` at the end of the edge. */
  node?: Maybe<LootboxMarketOrder>;
};

/** Methods to use when ordering `LootboxMarketOrder`. */
export enum LootboxMarketOrdersOrderBy {
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  LootboxAsc = 'LOOTBOX_ASC',
  LootboxDesc = 'LOOTBOX_DESC',
  Natural = 'NATURAL',
  OrderIdAsc = 'ORDER_ID_ASC',
  OrderIdDesc = 'ORDER_ID_DESC',
  PlayerAsc = 'PLAYER_ASC',
  PlayerDesc = 'PLAYER_DESC',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  QuoteAsc = 'QUOTE_ASC',
  QuoteDesc = 'QUOTE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TxAsc = 'TX_ASC',
  TxDesc = 'TX_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UpdatedAsc = 'UPDATED_ASC',
  UpdatedDesc = 'UPDATED_DESC'
}

export type LootboxMarketTrade = {
  __typename?: 'LootboxMarketTrade';
  buyer: Scalars['String']['output'];
  created: Scalars['Datetime']['output'];
  fee: Scalars['BigFloat']['output'];
  lootbox: Scalars['String']['output'];
  /** Reads a single `LootboxMarketOrder` that is related to this `LootboxMarketTrade`. */
  order?: Maybe<LootboxMarketOrder>;
  orderId: Scalars['BigInt']['output'];
  price: Scalars['BigFloat']['output'];
  quote: Scalars['String']['output'];
  seller: Scalars['String']['output'];
  tradeId: Scalars['BigInt']['output'];
  tx: Scalars['String']['output'];
};

/**
 * A condition to be used against `LootboxMarketTrade` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LootboxMarketTradeCondition = {
  /** Checks for equality with the object’s `buyer` field. */
  buyer?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `fee` field. */
  fee?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `lootbox` field. */
  lootbox?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `price` field. */
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `quote` field. */
  quote?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `seller` field. */
  seller?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `tradeId` field. */
  tradeId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `tx` field. */
  tx?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `LootboxMarketTrade` object types. All fields are combined with a logical ‘and.’ */
export type LootboxMarketTradeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LootboxMarketTradeFilter>>;
  /** Filter by the object’s `buyer` field. */
  buyer?: InputMaybe<StringFilter>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fee` field. */
  fee?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `lootbox` field. */
  lootbox?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LootboxMarketTradeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LootboxMarketTradeFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `price` field. */
  price?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `quote` field. */
  quote?: InputMaybe<StringFilter>;
  /** Filter by the object’s `seller` field. */
  seller?: InputMaybe<StringFilter>;
  /** Filter by the object’s `tradeId` field. */
  tradeId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `tx` field. */
  tx?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `LootboxMarketTrade` */
export type LootboxMarketTradeInput = {
  buyer: Scalars['String']['input'];
  created: Scalars['Datetime']['input'];
  fee: Scalars['BigFloat']['input'];
  lootbox: Scalars['String']['input'];
  orderId: Scalars['BigInt']['input'];
  price: Scalars['BigFloat']['input'];
  quote: Scalars['String']['input'];
  seller: Scalars['String']['input'];
  tradeId: Scalars['BigInt']['input'];
  tx: Scalars['String']['input'];
};

/** Represents an update to a `LootboxMarketTrade`. Fields that are set will be updated. */
export type LootboxMarketTradePatch = {
  buyer?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['Datetime']['input']>;
  fee?: InputMaybe<Scalars['BigFloat']['input']>;
  lootbox?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['BigInt']['input']>;
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  quote?: InputMaybe<Scalars['String']['input']>;
  seller?: InputMaybe<Scalars['String']['input']>;
  tradeId?: InputMaybe<Scalars['BigInt']['input']>;
  tx?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `LootboxMarketTrade` values. */
export type LootboxMarketTradesConnection = {
  __typename?: 'LootboxMarketTradesConnection';
  /** A list of edges which contains the `LootboxMarketTrade` and cursor to aid in pagination. */
  edges: Array<LootboxMarketTradesEdge>;
  /** A list of `LootboxMarketTrade` objects. */
  nodes: Array<Maybe<LootboxMarketTrade>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LootboxMarketTrade` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `LootboxMarketTrade` edge in the connection. */
export type LootboxMarketTradesEdge = {
  __typename?: 'LootboxMarketTradesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LootboxMarketTrade` at the end of the edge. */
  node?: Maybe<LootboxMarketTrade>;
};

/** Methods to use when ordering `LootboxMarketTrade`. */
export enum LootboxMarketTradesOrderBy {
  BuyerAsc = 'BUYER_ASC',
  BuyerDesc = 'BUYER_DESC',
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  FeeAsc = 'FEE_ASC',
  FeeDesc = 'FEE_DESC',
  LootboxAsc = 'LOOTBOX_ASC',
  LootboxDesc = 'LOOTBOX_DESC',
  Natural = 'NATURAL',
  OrderIdAsc = 'ORDER_ID_ASC',
  OrderIdDesc = 'ORDER_ID_DESC',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  QuoteAsc = 'QUOTE_ASC',
  QuoteDesc = 'QUOTE_DESC',
  SellerAsc = 'SELLER_ASC',
  SellerDesc = 'SELLER_DESC',
  TradeIdAsc = 'TRADE_ID_ASC',
  TradeIdDesc = 'TRADE_ID_DESC',
  TxAsc = 'TX_ASC',
  TxDesc = 'TX_DESC'
}

/** A connection to a list of `LootboxOrderBookRecord` values. */
export type LootboxOrderBookConnection = {
  __typename?: 'LootboxOrderBookConnection';
  /** A list of edges which contains the `LootboxOrderBookRecord` and cursor to aid in pagination. */
  edges: Array<LootboxOrderBookEdge>;
  /** A list of `LootboxOrderBookRecord` objects. */
  nodes: Array<Maybe<LootboxOrderBookRecord>>;
  /** The count of *all* `LootboxOrderBookRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `LootboxOrderBookRecord` edge in the connection. */
export type LootboxOrderBookEdge = {
  __typename?: 'LootboxOrderBookEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LootboxOrderBookRecord` at the end of the edge. */
  node?: Maybe<LootboxOrderBookRecord>;
};

/** The return type of our `lootboxOrderBook` query. */
export type LootboxOrderBookRecord = {
  __typename?: 'LootboxOrderBookRecord';
  price?: Maybe<Scalars['BigInt']['output']>;
  quantity?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LootboxOrderBookRecord` object types. All fields are combined with a logical ‘and.’ */
export type LootboxOrderBookRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LootboxOrderBookRecordFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<LootboxOrderBookRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LootboxOrderBookRecordFilter>>;
  /** Filter by the object’s `price` field. */
  price?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `quantity` field. */
  quantity?: InputMaybe<BigIntFilter>;
};

/** Represents an update to a `Lootbox`. Fields that are set will be updated. */
export type LootboxPatch = {
  finishedGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  gameCount?: InputMaybe<Scalars['BigInt']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  remainRewardsQuantity?: InputMaybe<Scalars['BigInt']['input']>;
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

export type LootboxReward = {
  __typename?: 'LootboxReward';
  distributedCount: Scalars['BigInt']['output'];
  id: Scalars['String']['output'];
  lootbox: Scalars['String']['output'];
  paidOutCount: Scalars['BigInt']['output'];
  updated: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `LootboxReward` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LootboxRewardCondition = {
  /** Checks for equality with the object’s `distributedCount` field. */
  distributedCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `lootbox` field. */
  lootbox?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `paidOutCount` field. */
  paidOutCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `updated` field. */
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `LootboxReward` object types. All fields are combined with a logical ‘and.’ */
export type LootboxRewardFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LootboxRewardFilter>>;
  /** Filter by the object’s `distributedCount` field. */
  distributedCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lootbox` field. */
  lootbox?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LootboxRewardFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LootboxRewardFilter>>;
  /** Filter by the object’s `paidOutCount` field. */
  paidOutCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `updated` field. */
  updated?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `LootboxReward` */
export type LootboxRewardInput = {
  distributedCount: Scalars['BigInt']['input'];
  id: Scalars['String']['input'];
  lootbox: Scalars['String']['input'];
  paidOutCount: Scalars['BigInt']['input'];
  updated: Scalars['Datetime']['input'];
};

/** Represents an update to a `LootboxReward`. Fields that are set will be updated. */
export type LootboxRewardPatch = {
  distributedCount?: InputMaybe<Scalars['BigInt']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lootbox?: InputMaybe<Scalars['String']['input']>;
  paidOutCount?: InputMaybe<Scalars['BigInt']['input']>;
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `LootboxReward` values. */
export type LootboxRewardsConnection = {
  __typename?: 'LootboxRewardsConnection';
  /** A list of edges which contains the `LootboxReward` and cursor to aid in pagination. */
  edges: Array<LootboxRewardsEdge>;
  /** A list of `LootboxReward` objects. */
  nodes: Array<Maybe<LootboxReward>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LootboxReward` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `LootboxReward` edge in the connection. */
export type LootboxRewardsEdge = {
  __typename?: 'LootboxRewardsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LootboxReward` at the end of the edge. */
  node?: Maybe<LootboxReward>;
};

/** Methods to use when ordering `LootboxReward`. */
export enum LootboxRewardsOrderBy {
  DistributedCountAsc = 'DISTRIBUTED_COUNT_ASC',
  DistributedCountDesc = 'DISTRIBUTED_COUNT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LootboxAsc = 'LOOTBOX_ASC',
  LootboxDesc = 'LOOTBOX_DESC',
  Natural = 'NATURAL',
  PaidOutCountAsc = 'PAID_OUT_COUNT_ASC',
  PaidOutCountDesc = 'PAID_OUT_COUNT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAsc = 'UPDATED_ASC',
  UpdatedDesc = 'UPDATED_DESC'
}

export type LootboxSale = {
  __typename?: 'LootboxSale';
  balance: Scalars['BigInt']['output'];
  id: Scalars['String']['output'];
  salesCount: Scalars['BigInt']['output'];
  updated: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `LootboxSale` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type LootboxSaleCondition = {
  /** Checks for equality with the object’s `balance` field. */
  balance?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `salesCount` field. */
  salesCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `updated` field. */
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `LootboxSale` object types. All fields are combined with a logical ‘and.’ */
export type LootboxSaleFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LootboxSaleFilter>>;
  /** Filter by the object’s `balance` field. */
  balance?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LootboxSaleFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LootboxSaleFilter>>;
  /** Filter by the object’s `salesCount` field. */
  salesCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `updated` field. */
  updated?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `LootboxSale` */
export type LootboxSaleInput = {
  balance: Scalars['BigInt']['input'];
  id: Scalars['String']['input'];
  salesCount: Scalars['BigInt']['input'];
  updated: Scalars['Datetime']['input'];
};

/** Represents an update to a `LootboxSale`. Fields that are set will be updated. */
export type LootboxSalePatch = {
  balance?: InputMaybe<Scalars['BigInt']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  salesCount?: InputMaybe<Scalars['BigInt']['input']>;
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `LootboxSale` values. */
export type LootboxSalesConnection = {
  __typename?: 'LootboxSalesConnection';
  /** A list of edges which contains the `LootboxSale` and cursor to aid in pagination. */
  edges: Array<LootboxSalesEdge>;
  /** A list of `LootboxSale` objects. */
  nodes: Array<Maybe<LootboxSale>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LootboxSale` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `LootboxSale` edge in the connection. */
export type LootboxSalesEdge = {
  __typename?: 'LootboxSalesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LootboxSale` at the end of the edge. */
  node?: Maybe<LootboxSale>;
};

/** Methods to use when ordering `LootboxSale`. */
export enum LootboxSalesOrderBy {
  BalanceAsc = 'BALANCE_ASC',
  BalanceDesc = 'BALANCE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SalesCountAsc = 'SALES_COUNT_ASC',
  SalesCountDesc = 'SALES_COUNT_DESC',
  UpdatedAsc = 'UPDATED_ASC',
  UpdatedDesc = 'UPDATED_DESC'
}

export type LootboxUnlimitedGame = {
  __typename?: 'LootboxUnlimitedGame';
  bet: Scalars['BigFloat']['output'];
  betNormalize: Scalars['BigInt']['output'];
  betUsd: Scalars['BigInt']['output'];
  created: Scalars['Datetime']['output'];
  denom: Scalars['String']['output'];
  id: Scalars['BigInt']['output'];
  lootbox: Scalars['String']['output'];
  payout?: Maybe<Scalars['BigFloat']['output']>;
  payoutNormalize?: Maybe<Scalars['BigInt']['output']>;
  payoutUsd?: Maybe<Scalars['BigInt']['output']>;
  player: Scalars['String']['output'];
  quantity: Scalars['BigInt']['output'];
  randomRound: Scalars['BigInt']['output'];
  rewards: Array<Maybe<Scalars['String']['output']>>;
  status: LootboxUnlimitedGameStatus;
  symbol: Scalars['String']['output'];
  txHash: Scalars['String']['output'];
};

/**
 * A condition to be used against `LootboxUnlimitedGame` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type LootboxUnlimitedGameCondition = {
  /** Checks for equality with the object’s `bet` field. */
  bet?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `betNormalize` field. */
  betNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `betUsd` field. */
  betUsd?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `denom` field. */
  denom?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `lootbox` field. */
  lootbox?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `payout` field. */
  payout?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `payoutNormalize` field. */
  payoutNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `payoutUsd` field. */
  payoutUsd?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `player` field. */
  player?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `quantity` field. */
  quantity?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `randomRound` field. */
  randomRound?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `rewards` field. */
  rewards?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<LootboxUnlimitedGameStatus>;
  /** Checks for equality with the object’s `symbol` field. */
  symbol?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `txHash` field. */
  txHash?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `LootboxUnlimitedGame` object types. All fields are combined with a logical ‘and.’ */
export type LootboxUnlimitedGameFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LootboxUnlimitedGameFilter>>;
  /** Filter by the object’s `bet` field. */
  bet?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `betNormalize` field. */
  betNormalize?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `betUsd` field. */
  betUsd?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `denom` field. */
  denom?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `lootbox` field. */
  lootbox?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LootboxUnlimitedGameFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LootboxUnlimitedGameFilter>>;
  /** Filter by the object’s `payout` field. */
  payout?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `payoutNormalize` field. */
  payoutNormalize?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `payoutUsd` field. */
  payoutUsd?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `player` field. */
  player?: InputMaybe<StringFilter>;
  /** Filter by the object’s `quantity` field. */
  quantity?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `randomRound` field. */
  randomRound?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `rewards` field. */
  rewards?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<LootboxUnlimitedGameStatusFilter>;
  /** Filter by the object’s `symbol` field. */
  symbol?: InputMaybe<StringFilter>;
  /** Filter by the object’s `txHash` field. */
  txHash?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `LootboxUnlimitedGame` */
export type LootboxUnlimitedGameInput = {
  bet: Scalars['BigFloat']['input'];
  betNormalize: Scalars['BigInt']['input'];
  betUsd: Scalars['BigInt']['input'];
  created: Scalars['Datetime']['input'];
  denom: Scalars['String']['input'];
  id?: InputMaybe<Scalars['BigInt']['input']>;
  lootbox: Scalars['String']['input'];
  payout?: InputMaybe<Scalars['BigFloat']['input']>;
  payoutNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  payoutUsd?: InputMaybe<Scalars['BigInt']['input']>;
  player: Scalars['String']['input'];
  quantity: Scalars['BigInt']['input'];
  randomRound: Scalars['BigInt']['input'];
  rewards: Array<InputMaybe<Scalars['String']['input']>>;
  status: LootboxUnlimitedGameStatus;
  symbol: Scalars['String']['input'];
  txHash: Scalars['String']['input'];
};

/** Represents an update to a `LootboxUnlimitedGame`. Fields that are set will be updated. */
export type LootboxUnlimitedGamePatch = {
  bet?: InputMaybe<Scalars['BigFloat']['input']>;
  betNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  betUsd?: InputMaybe<Scalars['BigInt']['input']>;
  created?: InputMaybe<Scalars['Datetime']['input']>;
  denom?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  lootbox?: InputMaybe<Scalars['String']['input']>;
  payout?: InputMaybe<Scalars['BigFloat']['input']>;
  payoutNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  payoutUsd?: InputMaybe<Scalars['BigInt']['input']>;
  player?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['BigInt']['input']>;
  randomRound?: InputMaybe<Scalars['BigInt']['input']>;
  rewards?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<LootboxUnlimitedGameStatus>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  txHash?: InputMaybe<Scalars['String']['input']>;
};

export enum LootboxUnlimitedGameStatus {
  Drawn = 'DRAWN',
  Finished = 'FINISHED',
  Pending = 'PENDING'
}

/** A filter to be used against LootboxUnlimitedGameStatus fields. All fields are combined with a logical ‘and.’ */
export type LootboxUnlimitedGameStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<LootboxUnlimitedGameStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<LootboxUnlimitedGameStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<LootboxUnlimitedGameStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<LootboxUnlimitedGameStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<LootboxUnlimitedGameStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<LootboxUnlimitedGameStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<LootboxUnlimitedGameStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<LootboxUnlimitedGameStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<LootboxUnlimitedGameStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<LootboxUnlimitedGameStatus>>;
};

/** A connection to a list of `LootboxUnlimitedGame` values. */
export type LootboxUnlimitedGamesConnection = {
  __typename?: 'LootboxUnlimitedGamesConnection';
  /** A list of edges which contains the `LootboxUnlimitedGame` and cursor to aid in pagination. */
  edges: Array<LootboxUnlimitedGamesEdge>;
  /** A list of `LootboxUnlimitedGame` objects. */
  nodes: Array<Maybe<LootboxUnlimitedGame>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LootboxUnlimitedGame` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `LootboxUnlimitedGame` edge in the connection. */
export type LootboxUnlimitedGamesEdge = {
  __typename?: 'LootboxUnlimitedGamesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LootboxUnlimitedGame` at the end of the edge. */
  node?: Maybe<LootboxUnlimitedGame>;
};

/** Methods to use when ordering `LootboxUnlimitedGame`. */
export enum LootboxUnlimitedGamesOrderBy {
  BetAsc = 'BET_ASC',
  BetDesc = 'BET_DESC',
  BetNormalizeAsc = 'BET_NORMALIZE_ASC',
  BetNormalizeDesc = 'BET_NORMALIZE_DESC',
  BetUsdAsc = 'BET_USD_ASC',
  BetUsdDesc = 'BET_USD_DESC',
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  DenomAsc = 'DENOM_ASC',
  DenomDesc = 'DENOM_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LootboxAsc = 'LOOTBOX_ASC',
  LootboxDesc = 'LOOTBOX_DESC',
  Natural = 'NATURAL',
  PayoutAsc = 'PAYOUT_ASC',
  PayoutDesc = 'PAYOUT_DESC',
  PayoutNormalizeAsc = 'PAYOUT_NORMALIZE_ASC',
  PayoutNormalizeDesc = 'PAYOUT_NORMALIZE_DESC',
  PayoutUsdAsc = 'PAYOUT_USD_ASC',
  PayoutUsdDesc = 'PAYOUT_USD_DESC',
  PlayerAsc = 'PLAYER_ASC',
  PlayerDesc = 'PLAYER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  QuantityAsc = 'QUANTITY_ASC',
  QuantityDesc = 'QUANTITY_DESC',
  RandomRoundAsc = 'RANDOM_ROUND_ASC',
  RandomRoundDesc = 'RANDOM_ROUND_DESC',
  RewardsAsc = 'REWARDS_ASC',
  RewardsDesc = 'REWARDS_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  SymbolAsc = 'SYMBOL_ASC',
  SymbolDesc = 'SYMBOL_DESC',
  TxHashAsc = 'TX_HASH_ASC',
  TxHashDesc = 'TX_HASH_DESC'
}

export enum LootboxUnlimitedStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Paused = 'PAUSED'
}

/** A filter to be used against LootboxUnlimitedStatus fields. All fields are combined with a logical ‘and.’ */
export type LootboxUnlimitedStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<LootboxUnlimitedStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<LootboxUnlimitedStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<LootboxUnlimitedStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<LootboxUnlimitedStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<LootboxUnlimitedStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<LootboxUnlimitedStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<LootboxUnlimitedStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<LootboxUnlimitedStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<LootboxUnlimitedStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<LootboxUnlimitedStatus>>;
};

/** A connection to a list of `Lootbox` values. */
export type LootboxesConnection = {
  __typename?: 'LootboxesConnection';
  /** A list of edges which contains the `Lootbox` and cursor to aid in pagination. */
  edges: Array<LootboxesEdge>;
  /** A list of `Lootbox` objects. */
  nodes: Array<Maybe<Lootbox>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Lootbox` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Lootbox` edge in the connection. */
export type LootboxesEdge = {
  __typename?: 'LootboxesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Lootbox` at the end of the edge. */
  node?: Maybe<Lootbox>;
};

/** Methods to use when ordering `Lootbox`. */
export enum LootboxesOrderBy {
  FinishedGameCountAsc = 'FINISHED_GAME_COUNT_ASC',
  FinishedGameCountDesc = 'FINISHED_GAME_COUNT_DESC',
  GameCountAsc = 'GAME_COUNT_ASC',
  GameCountDesc = 'GAME_COUNT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RemainRewardsQuantityAsc = 'REMAIN_REWARDS_QUANTITY_ASC',
  RemainRewardsQuantityDesc = 'REMAIN_REWARDS_QUANTITY_DESC',
  UpdatedAsc = 'UPDATED_ASC',
  UpdatedDesc = 'UPDATED_DESC'
}

export type LootboxesUnlimited = {
  __typename?: 'LootboxesUnlimited';
  createdAt: Scalars['Datetime']['output'];
  fee?: Maybe<Scalars['BigFloat']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  prices: Scalars['JSON']['output'];
  rewards: Scalars['JSON']['output'];
  status: LootboxUnlimitedStatus;
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `LootboxesUnlimited` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LootboxesUnlimitedCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `fee` field. */
  fee?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `prices` field. */
  prices?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `rewards` field. */
  rewards?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<LootboxUnlimitedStatus>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `LootboxesUnlimited` object types. All fields are combined with a logical ‘and.’ */
export type LootboxesUnlimitedFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LootboxesUnlimitedFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fee` field. */
  fee?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LootboxesUnlimitedFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LootboxesUnlimitedFilter>>;
  /** Filter by the object’s `prices` field. */
  prices?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `rewards` field. */
  rewards?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<LootboxUnlimitedStatusFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `LootboxesUnlimited` */
export type LootboxesUnlimitedInput = {
  createdAt: Scalars['Datetime']['input'];
  fee?: InputMaybe<Scalars['BigFloat']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  prices: Scalars['JSON']['input'];
  rewards: Scalars['JSON']['input'];
  status: LootboxUnlimitedStatus;
  updatedAt: Scalars['Datetime']['input'];
};

/** Represents an update to a `LootboxesUnlimited`. Fields that are set will be updated. */
export type LootboxesUnlimitedPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  fee?: InputMaybe<Scalars['BigFloat']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  prices?: InputMaybe<Scalars['JSON']['input']>;
  rewards?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<LootboxUnlimitedStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `LootboxesUnlimited` values. */
export type LootboxesUnlimitedsConnection = {
  __typename?: 'LootboxesUnlimitedsConnection';
  /** A list of edges which contains the `LootboxesUnlimited` and cursor to aid in pagination. */
  edges: Array<LootboxesUnlimitedsEdge>;
  /** A list of `LootboxesUnlimited` objects. */
  nodes: Array<Maybe<LootboxesUnlimited>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LootboxesUnlimited` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `LootboxesUnlimited` edge in the connection. */
export type LootboxesUnlimitedsEdge = {
  __typename?: 'LootboxesUnlimitedsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LootboxesUnlimited` at the end of the edge. */
  node?: Maybe<LootboxesUnlimited>;
};

/** Methods to use when ordering `LootboxesUnlimited`. */
export enum LootboxesUnlimitedsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  FeeAsc = 'FEE_ASC',
  FeeDesc = 'FEE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PricesAsc = 'PRICES_ASC',
  PricesDesc = 'PRICES_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RewardsAsc = 'REWARDS_ASC',
  RewardsDesc = 'REWARDS_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type MinesGame = {
  __typename?: 'MinesGame';
  bet: Scalars['BigFloat']['output'];
  betNormalize?: Maybe<Scalars['BigInt']['output']>;
  betUsd?: Maybe<Scalars['BigInt']['output']>;
  created: Scalars['Datetime']['output'];
  denom?: Maybe<Scalars['String']['output']>;
  gemsOpened?: Maybe<Scalars['Int']['output']>;
  id: Scalars['BigInt']['output'];
  maxCells: Scalars['Int']['output'];
  maxWin: Scalars['BigFloat']['output'];
  mines: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `MinesGameRound`. */
  minesGameRoundsByGameId: MinesGameRoundsConnection;
  minesLast?: Maybe<Scalars['BigInt']['output']>;
  payable: Scalars['BigFloat']['output'];
  payoutNormalize?: Maybe<Scalars['BigInt']['output']>;
  payoutTxHash?: Maybe<Scalars['String']['output']>;
  payoutUsd?: Maybe<Scalars['BigInt']['output']>;
  player: Scalars['String']['output'];
  rtp: Scalars['BigFloat']['output'];
  status: MiniGameStatus;
  symbol?: Maybe<Scalars['String']['output']>;
  theoreticalGemsOpened: Scalars['Int']['output'];
  tryGemsOpened: Scalars['Int']['output'];
  txHash: Scalars['String']['output'];
  updated: Scalars['Datetime']['output'];
};


export type MinesGameMinesGameRoundsByGameIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MinesGameRoundCondition>;
  filter?: InputMaybe<MinesGameRoundFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MinesGameRoundsOrderBy>>;
};

/**
 * A condition to be used against `MinesGame` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type MinesGameCondition = {
  /** Checks for equality with the object’s `bet` field. */
  bet?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `betNormalize` field. */
  betNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `betUsd` field. */
  betUsd?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `denom` field. */
  denom?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `gemsOpened` field. */
  gemsOpened?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `maxCells` field. */
  maxCells?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `maxWin` field. */
  maxWin?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `mines` field. */
  mines?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `minesLast` field. */
  minesLast?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `payable` field. */
  payable?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `payoutNormalize` field. */
  payoutNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `payoutTxHash` field. */
  payoutTxHash?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `payoutUsd` field. */
  payoutUsd?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `player` field. */
  player?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rtp` field. */
  rtp?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<MiniGameStatus>;
  /** Checks for equality with the object’s `symbol` field. */
  symbol?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `theoreticalGemsOpened` field. */
  theoreticalGemsOpened?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `tryGemsOpened` field. */
  tryGemsOpened?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `txHash` field. */
  txHash?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updated` field. */
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `MinesGame` object types. All fields are combined with a logical ‘and.’ */
export type MinesGameFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MinesGameFilter>>;
  /** Filter by the object’s `bet` field. */
  bet?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `betNormalize` field. */
  betNormalize?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `betUsd` field. */
  betUsd?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `denom` field. */
  denom?: InputMaybe<StringFilter>;
  /** Filter by the object’s `gemsOpened` field. */
  gemsOpened?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `maxCells` field. */
  maxCells?: InputMaybe<IntFilter>;
  /** Filter by the object’s `maxWin` field. */
  maxWin?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `mines` field. */
  mines?: InputMaybe<IntFilter>;
  /** Filter by the object’s `minesLast` field. */
  minesLast?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MinesGameFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MinesGameFilter>>;
  /** Filter by the object’s `payable` field. */
  payable?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `payoutNormalize` field. */
  payoutNormalize?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `payoutTxHash` field. */
  payoutTxHash?: InputMaybe<StringFilter>;
  /** Filter by the object’s `payoutUsd` field. */
  payoutUsd?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `player` field. */
  player?: InputMaybe<StringFilter>;
  /** Filter by the object’s `rtp` field. */
  rtp?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<MiniGameStatusFilter>;
  /** Filter by the object’s `symbol` field. */
  symbol?: InputMaybe<StringFilter>;
  /** Filter by the object’s `theoreticalGemsOpened` field. */
  theoreticalGemsOpened?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tryGemsOpened` field. */
  tryGemsOpened?: InputMaybe<IntFilter>;
  /** Filter by the object’s `txHash` field. */
  txHash?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updated` field. */
  updated?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `MinesGame` */
export type MinesGameInput = {
  bet?: InputMaybe<Scalars['BigFloat']['input']>;
  betNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  betUsd?: InputMaybe<Scalars['BigInt']['input']>;
  created: Scalars['Datetime']['input'];
  denom?: InputMaybe<Scalars['String']['input']>;
  gemsOpened?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['BigInt']['input'];
  maxCells: Scalars['Int']['input'];
  maxWin: Scalars['BigFloat']['input'];
  mines: Scalars['Int']['input'];
  minesLast?: InputMaybe<Scalars['BigInt']['input']>;
  payable: Scalars['BigFloat']['input'];
  payoutNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  payoutTxHash?: InputMaybe<Scalars['String']['input']>;
  payoutUsd?: InputMaybe<Scalars['BigInt']['input']>;
  player: Scalars['String']['input'];
  rtp: Scalars['BigFloat']['input'];
  status: MiniGameStatus;
  symbol?: InputMaybe<Scalars['String']['input']>;
  theoreticalGemsOpened?: InputMaybe<Scalars['Int']['input']>;
  tryGemsOpened?: InputMaybe<Scalars['Int']['input']>;
  txHash: Scalars['String']['input'];
  updated: Scalars['Datetime']['input'];
};

/** Represents an update to a `MinesGame`. Fields that are set will be updated. */
export type MinesGamePatch = {
  bet?: InputMaybe<Scalars['BigFloat']['input']>;
  betNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  betUsd?: InputMaybe<Scalars['BigInt']['input']>;
  created?: InputMaybe<Scalars['Datetime']['input']>;
  denom?: InputMaybe<Scalars['String']['input']>;
  gemsOpened?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  maxCells?: InputMaybe<Scalars['Int']['input']>;
  maxWin?: InputMaybe<Scalars['BigFloat']['input']>;
  mines?: InputMaybe<Scalars['Int']['input']>;
  minesLast?: InputMaybe<Scalars['BigInt']['input']>;
  payable?: InputMaybe<Scalars['BigFloat']['input']>;
  payoutNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  payoutTxHash?: InputMaybe<Scalars['String']['input']>;
  payoutUsd?: InputMaybe<Scalars['BigInt']['input']>;
  player?: InputMaybe<Scalars['String']['input']>;
  rtp?: InputMaybe<Scalars['BigFloat']['input']>;
  status?: InputMaybe<MiniGameStatus>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  theoreticalGemsOpened?: InputMaybe<Scalars['Int']['input']>;
  tryGemsOpened?: InputMaybe<Scalars['Int']['input']>;
  txHash?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

export type MinesGameRound = {
  __typename?: 'MinesGameRound';
  created: Scalars['Datetime']['output'];
  /** Reads a single `MinesGame` that is related to this `MinesGameRound`. */
  game?: Maybe<MinesGame>;
  gameId: Scalars['BigInt']['output'];
  id: Scalars['BigInt']['output'];
  mines?: Maybe<Scalars['BigInt']['output']>;
  randomRound: Scalars['BigInt']['output'];
  result: MiniGameStatus;
  txHash: Scalars['String']['output'];
  updated: Scalars['Datetime']['output'];
  userChoice: Scalars['BigInt']['output'];
};

/**
 * A condition to be used against `MinesGameRound` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MinesGameRoundCondition = {
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `gameId` field. */
  gameId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `mines` field. */
  mines?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `randomRound` field. */
  randomRound?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `result` field. */
  result?: InputMaybe<MiniGameStatus>;
  /** Checks for equality with the object’s `txHash` field. */
  txHash?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updated` field. */
  updated?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `userChoice` field. */
  userChoice?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `MinesGameRound` object types. All fields are combined with a logical ‘and.’ */
export type MinesGameRoundFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MinesGameRoundFilter>>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `gameId` field. */
  gameId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `mines` field. */
  mines?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MinesGameRoundFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MinesGameRoundFilter>>;
  /** Filter by the object’s `randomRound` field. */
  randomRound?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `result` field. */
  result?: InputMaybe<MiniGameStatusFilter>;
  /** Filter by the object’s `txHash` field. */
  txHash?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updated` field. */
  updated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userChoice` field. */
  userChoice?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `MinesGameRound` */
export type MinesGameRoundInput = {
  created: Scalars['Datetime']['input'];
  gameId: Scalars['BigInt']['input'];
  id: Scalars['BigInt']['input'];
  mines?: InputMaybe<Scalars['BigInt']['input']>;
  randomRound: Scalars['BigInt']['input'];
  result: MiniGameStatus;
  txHash: Scalars['String']['input'];
  updated: Scalars['Datetime']['input'];
  userChoice: Scalars['BigInt']['input'];
};

/** Represents an update to a `MinesGameRound`. Fields that are set will be updated. */
export type MinesGameRoundPatch = {
  created?: InputMaybe<Scalars['Datetime']['input']>;
  gameId?: InputMaybe<Scalars['BigInt']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  mines?: InputMaybe<Scalars['BigInt']['input']>;
  randomRound?: InputMaybe<Scalars['BigInt']['input']>;
  result?: InputMaybe<MiniGameStatus>;
  txHash?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['Datetime']['input']>;
  userChoice?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A connection to a list of `MinesGameRound` values. */
export type MinesGameRoundsConnection = {
  __typename?: 'MinesGameRoundsConnection';
  /** A list of edges which contains the `MinesGameRound` and cursor to aid in pagination. */
  edges: Array<MinesGameRoundsEdge>;
  /** A list of `MinesGameRound` objects. */
  nodes: Array<Maybe<MinesGameRound>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MinesGameRound` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MinesGameRound` edge in the connection. */
export type MinesGameRoundsEdge = {
  __typename?: 'MinesGameRoundsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MinesGameRound` at the end of the edge. */
  node?: Maybe<MinesGameRound>;
};

/** Methods to use when ordering `MinesGameRound`. */
export enum MinesGameRoundsOrderBy {
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  GameIdAsc = 'GAME_ID_ASC',
  GameIdDesc = 'GAME_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MinesAsc = 'MINES_ASC',
  MinesDesc = 'MINES_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RandomRoundAsc = 'RANDOM_ROUND_ASC',
  RandomRoundDesc = 'RANDOM_ROUND_DESC',
  ResultAsc = 'RESULT_ASC',
  ResultDesc = 'RESULT_DESC',
  TxHashAsc = 'TX_HASH_ASC',
  TxHashDesc = 'TX_HASH_DESC',
  UpdatedAsc = 'UPDATED_ASC',
  UpdatedDesc = 'UPDATED_DESC',
  UserChoiceAsc = 'USER_CHOICE_ASC',
  UserChoiceDesc = 'USER_CHOICE_DESC'
}

/** A connection to a list of `MinesGame` values. */
export type MinesGamesConnection = {
  __typename?: 'MinesGamesConnection';
  /** A list of edges which contains the `MinesGame` and cursor to aid in pagination. */
  edges: Array<MinesGamesEdge>;
  /** A list of `MinesGame` objects. */
  nodes: Array<Maybe<MinesGame>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MinesGame` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MinesGame` edge in the connection. */
export type MinesGamesEdge = {
  __typename?: 'MinesGamesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MinesGame` at the end of the edge. */
  node?: Maybe<MinesGame>;
};

/** Methods to use when ordering `MinesGame`. */
export enum MinesGamesOrderBy {
  BetAsc = 'BET_ASC',
  BetDesc = 'BET_DESC',
  BetNormalizeAsc = 'BET_NORMALIZE_ASC',
  BetNormalizeDesc = 'BET_NORMALIZE_DESC',
  BetUsdAsc = 'BET_USD_ASC',
  BetUsdDesc = 'BET_USD_DESC',
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  DenomAsc = 'DENOM_ASC',
  DenomDesc = 'DENOM_DESC',
  GemsOpenedAsc = 'GEMS_OPENED_ASC',
  GemsOpenedDesc = 'GEMS_OPENED_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MaxCellsAsc = 'MAX_CELLS_ASC',
  MaxCellsDesc = 'MAX_CELLS_DESC',
  MaxWinAsc = 'MAX_WIN_ASC',
  MaxWinDesc = 'MAX_WIN_DESC',
  MinesAsc = 'MINES_ASC',
  MinesDesc = 'MINES_DESC',
  MinesLastAsc = 'MINES_LAST_ASC',
  MinesLastDesc = 'MINES_LAST_DESC',
  Natural = 'NATURAL',
  PayableAsc = 'PAYABLE_ASC',
  PayableDesc = 'PAYABLE_DESC',
  PayoutNormalizeAsc = 'PAYOUT_NORMALIZE_ASC',
  PayoutNormalizeDesc = 'PAYOUT_NORMALIZE_DESC',
  PayoutTxHashAsc = 'PAYOUT_TX_HASH_ASC',
  PayoutTxHashDesc = 'PAYOUT_TX_HASH_DESC',
  PayoutUsdAsc = 'PAYOUT_USD_ASC',
  PayoutUsdDesc = 'PAYOUT_USD_DESC',
  PlayerAsc = 'PLAYER_ASC',
  PlayerDesc = 'PLAYER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RtpAsc = 'RTP_ASC',
  RtpDesc = 'RTP_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  SymbolAsc = 'SYMBOL_ASC',
  SymbolDesc = 'SYMBOL_DESC',
  TheoreticalGemsOpenedAsc = 'THEORETICAL_GEMS_OPENED_ASC',
  TheoreticalGemsOpenedDesc = 'THEORETICAL_GEMS_OPENED_DESC',
  TryGemsOpenedAsc = 'TRY_GEMS_OPENED_ASC',
  TryGemsOpenedDesc = 'TRY_GEMS_OPENED_DESC',
  TxHashAsc = 'TX_HASH_ASC',
  TxHashDesc = 'TX_HASH_DESC',
  UpdatedAsc = 'UPDATED_ASC',
  UpdatedDesc = 'UPDATED_DESC'
}

export enum MiniGameStatus {
  Lose = 'LOSE',
  Pending = 'PENDING',
  Win = 'WIN'
}

/** A filter to be used against MiniGameStatus fields. All fields are combined with a logical ‘and.’ */
export type MiniGameStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<MiniGameStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<MiniGameStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<MiniGameStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<MiniGameStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<MiniGameStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<MiniGameStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<MiniGameStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<MiniGameStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<MiniGameStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<MiniGameStatus>>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation';
  /** Creates a single `AuctionBasket`. */
  createAuctionBasket?: Maybe<CreateAuctionBasketPayload>;
  /** Creates a single `AuctionBasketBet`. */
  createAuctionBasketBet?: Maybe<CreateAuctionBasketBetPayload>;
  /** Creates a single `BankrollBalance`. */
  createBankrollBalance?: Maybe<CreateBankrollBalancePayload>;
  /** Creates a single `BetsHistory`. */
  createBetsHistory?: Maybe<CreateBetsHistoryPayload>;
  /** Creates a single `BonusBetsHistory`. */
  createBonusBetsHistory?: Maybe<CreateBonusBetsHistoryPayload>;
  /** Creates a single `ClaimHistory`. */
  createClaimHistory?: Maybe<CreateClaimHistoryPayload>;
  /** Creates a single `CoinflipGame`. */
  createCoinflipGame?: Maybe<CreateCoinflipGamePayload>;
  /** Creates a single `CoinflipGameRound`. */
  createCoinflipGameRound?: Maybe<CreateCoinflipGameRoundPayload>;
  /** Creates a single `ContractConfig`. */
  createContractConfig?: Maybe<CreateContractConfigPayload>;
  /** Creates a single `DoubleBet`. */
  createDoubleBet?: Maybe<CreateDoubleBetPayload>;
  /** Creates a single `DoubleGame`. */
  createDoubleGame?: Maybe<CreateDoubleGamePayload>;
  /** Creates a single `DoubleJackpot`. */
  createDoubleJackpot?: Maybe<CreateDoubleJackpotPayload>;
  /** Creates a single `FeeDistributedHistory`. */
  createFeeDistributedHistory?: Maybe<CreateFeeDistributedHistoryPayload>;
  /** Creates a single `GatewayChainTransaction`. */
  createGatewayChainTransaction?: Maybe<CreateGatewayChainTransactionPayload>;
  /** Creates a single `JackpotBet`. */
  createJackpotBet?: Maybe<CreateJackpotBetPayload>;
  /** Creates a single `JackpotGame`. */
  createJackpotGame?: Maybe<CreateJackpotGamePayload>;
  /** Creates a single `Lootbox`. */
  createLootbox?: Maybe<CreateLootboxPayload>;
  /** Creates a single `LootboxGame`. */
  createLootboxGame?: Maybe<CreateLootboxGamePayload>;
  /** Creates a single `LootboxMarketOrder`. */
  createLootboxMarketOrder?: Maybe<CreateLootboxMarketOrderPayload>;
  /** Creates a single `LootboxMarketTrade`. */
  createLootboxMarketTrade?: Maybe<CreateLootboxMarketTradePayload>;
  /** Creates a single `LootboxReward`. */
  createLootboxReward?: Maybe<CreateLootboxRewardPayload>;
  /** Creates a single `LootboxSale`. */
  createLootboxSale?: Maybe<CreateLootboxSalePayload>;
  /** Creates a single `LootboxUnlimitedGame`. */
  createLootboxUnlimitedGame?: Maybe<CreateLootboxUnlimitedGamePayload>;
  /** Creates a single `LootboxesUnlimited`. */
  createLootboxesUnlimited?: Maybe<CreateLootboxesUnlimitedPayload>;
  /** Creates a single `MinesGame`. */
  createMinesGame?: Maybe<CreateMinesGamePayload>;
  /** Creates a single `MinesGameRound`. */
  createMinesGameRound?: Maybe<CreateMinesGameRoundPayload>;
  /** Creates a single `Nft`. */
  createNft?: Maybe<CreateNftPayload>;
  /** Creates a single `NftsVote`. */
  createNftsVote?: Maybe<CreateNftsVotePayload>;
  /** Creates a single `OpenCompetitionEntity`. */
  createOpenCompetitionEntity?: Maybe<CreateOpenCompetitionEntityPayload>;
  /** Creates a single `PlinkoGame`. */
  createPlinkoGame?: Maybe<CreatePlinkoGamePayload>;
  /** Creates a single `PointTransaction`. */
  createPointTransaction?: Maybe<CreatePointTransactionPayload>;
  /** Creates a single `RngRound`. */
  createRngRound?: Maybe<CreateRngRoundPayload>;
  /** Creates a single `RoshamboGame`. */
  createRoshamboGame?: Maybe<CreateRoshamboGamePayload>;
  /** Creates a single `RoshamboGameLog`. */
  createRoshamboGameLog?: Maybe<CreateRoshamboGameLogPayload>;
  /** Creates a single `RunesGame`. */
  createRunesGame?: Maybe<CreateRunesGamePayload>;
  /** Creates a single `Statistic`. */
  createStatistic?: Maybe<CreateStatisticPayload>;
  /** Creates a single `StatisticsV2`. */
  createStatisticsV2?: Maybe<CreateStatisticsV2Payload>;
  /** Creates a single `TokenBurnHistory`. */
  createTokenBurnHistory?: Maybe<CreateTokenBurnHistoryPayload>;
  /** Creates a single `TokenClaim`. */
  createTokenClaim?: Maybe<CreateTokenClaimPayload>;
  /** Creates a single `TokenPrice`. */
  createTokenPrice?: Maybe<CreateTokenPricePayload>;
  /** Creates a single `TokenSalesInfo`. */
  createTokenSalesInfo?: Maybe<CreateTokenSalesInfoPayload>;
  /** Creates a single `TokenSalesPriceInfo`. */
  createTokenSalesPriceInfo?: Maybe<CreateTokenSalesPriceInfoPayload>;
  /** Creates a single `User`. */
  createUser?: Maybe<CreateUserPayload>;
  /** Creates a single `UserBetHistory`. */
  createUserBetHistory?: Maybe<CreateUserBetHistoryPayload>;
  /** Creates a single `UserCompetition`. */
  createUserCompetition?: Maybe<CreateUserCompetitionPayload>;
  /** Creates a single `UserStatistic`. */
  createUserStatistic?: Maybe<CreateUserStatisticPayload>;
  /** Creates a single `UserStatisticsByDay`. */
  createUserStatisticsByDay?: Maybe<CreateUserStatisticsByDayPayload>;
  /** Creates a single `UserStatisticsV2`. */
  createUserStatisticsV2?: Maybe<CreateUserStatisticsV2Payload>;
  /** Creates a single `UserTokenSale`. */
  createUserTokenSale?: Maybe<CreateUserTokenSalePayload>;
  /** Creates a single `UserTokenSaleTransaction`. */
  createUserTokenSaleTransaction?: Maybe<CreateUserTokenSaleTransactionPayload>;
  /** Creates a single `VersionInfo`. */
  createVersionInfo?: Maybe<CreateVersionInfoPayload>;
  /** Deletes a single `AuctionBasket` using a unique key. */
  deleteAuctionBasket?: Maybe<DeleteAuctionBasketPayload>;
  /** Deletes a single `AuctionBasketBet` using a unique key. */
  deleteAuctionBasketBet?: Maybe<DeleteAuctionBasketBetPayload>;
  /** Deletes a single `BankrollBalance` using a unique key. */
  deleteBankrollBalance?: Maybe<DeleteBankrollBalancePayload>;
  /** Deletes a single `BetsHistory` using a unique key. */
  deleteBetsHistory?: Maybe<DeleteBetsHistoryPayload>;
  /** Deletes a single `BetsHistory` using a unique key. */
  deleteBetsHistoryById?: Maybe<DeleteBetsHistoryPayload>;
  /** Deletes a single `BonusBetsHistory` using a unique key. */
  deleteBonusBetsHistory?: Maybe<DeleteBonusBetsHistoryPayload>;
  /** Deletes a single `ClaimHistory` using a unique key. */
  deleteClaimHistory?: Maybe<DeleteClaimHistoryPayload>;
  /** Deletes a single `CoinflipGame` using a unique key. */
  deleteCoinflipGame?: Maybe<DeleteCoinflipGamePayload>;
  /** Deletes a single `CoinflipGameRound` using a unique key. */
  deleteCoinflipGameRound?: Maybe<DeleteCoinflipGameRoundPayload>;
  /** Deletes a single `ContractConfig` using a unique key. */
  deleteContractConfig?: Maybe<DeleteContractConfigPayload>;
  /** Deletes a single `DoubleBet` using a unique key. */
  deleteDoubleBet?: Maybe<DeleteDoubleBetPayload>;
  /** Deletes a single `DoubleGame` using a unique key. */
  deleteDoubleGame?: Maybe<DeleteDoubleGamePayload>;
  /** Deletes a single `FeeDistributedHistory` using a unique key. */
  deleteFeeDistributedHistory?: Maybe<DeleteFeeDistributedHistoryPayload>;
  /** Deletes a single `GatewayChainTransaction` using a unique key. */
  deleteGatewayChainTransaction?: Maybe<DeleteGatewayChainTransactionPayload>;
  /** Deletes a single `JackpotBet` using a unique key. */
  deleteJackpotBet?: Maybe<DeleteJackpotBetPayload>;
  /** Deletes a single `JackpotGame` using a unique key. */
  deleteJackpotGame?: Maybe<DeleteJackpotGamePayload>;
  /** Deletes a single `Lootbox` using a unique key. */
  deleteLootbox?: Maybe<DeleteLootboxPayload>;
  /** Deletes a single `LootboxGame` using a unique key. */
  deleteLootboxGame?: Maybe<DeleteLootboxGamePayload>;
  /** Deletes a single `LootboxMarketOrder` using a unique key. */
  deleteLootboxMarketOrder?: Maybe<DeleteLootboxMarketOrderPayload>;
  /** Deletes a single `LootboxMarketTrade` using a unique key. */
  deleteLootboxMarketTrade?: Maybe<DeleteLootboxMarketTradePayload>;
  /** Deletes a single `LootboxReward` using a unique key. */
  deleteLootboxReward?: Maybe<DeleteLootboxRewardPayload>;
  /** Deletes a single `LootboxSale` using a unique key. */
  deleteLootboxSale?: Maybe<DeleteLootboxSalePayload>;
  /** Deletes a single `LootboxUnlimitedGame` using a unique key. */
  deleteLootboxUnlimitedGame?: Maybe<DeleteLootboxUnlimitedGamePayload>;
  /** Deletes a single `LootboxesUnlimited` using a unique key. */
  deleteLootboxesUnlimited?: Maybe<DeleteLootboxesUnlimitedPayload>;
  /** Deletes a single `MinesGame` using a unique key. */
  deleteMinesGame?: Maybe<DeleteMinesGamePayload>;
  /** Deletes a single `MinesGameRound` using a unique key. */
  deleteMinesGameRound?: Maybe<DeleteMinesGameRoundPayload>;
  /** Deletes a single `Nft` using a unique key. */
  deleteNft?: Maybe<DeleteNftPayload>;
  /** Deletes a single `NftsVote` using a unique key. */
  deleteNftsVote?: Maybe<DeleteNftsVotePayload>;
  /** Deletes a single `OpenCompetitionEntity` using a unique key. */
  deleteOpenCompetitionEntity?: Maybe<DeleteOpenCompetitionEntityPayload>;
  /** Deletes a single `PlinkoGame` using a unique key. */
  deletePlinkoGame?: Maybe<DeletePlinkoGamePayload>;
  /** Deletes a single `PointTransaction` using a unique key. */
  deletePointTransaction?: Maybe<DeletePointTransactionPayload>;
  /** Deletes a single `RngRound` using a unique key. */
  deleteRngRound?: Maybe<DeleteRngRoundPayload>;
  /** Deletes a single `RoshamboGame` using a unique key. */
  deleteRoshamboGame?: Maybe<DeleteRoshamboGamePayload>;
  /** Deletes a single `RoshamboGameLog` using a unique key. */
  deleteRoshamboGameLog?: Maybe<DeleteRoshamboGameLogPayload>;
  /** Deletes a single `RunesGame` using a unique key. */
  deleteRunesGame?: Maybe<DeleteRunesGamePayload>;
  /** Deletes a single `Statistic` using a unique key. */
  deleteStatistic?: Maybe<DeleteStatisticPayload>;
  /** Deletes a single `StatisticsV2` using a unique key. */
  deleteStatisticsV2?: Maybe<DeleteStatisticsV2Payload>;
  /** Deletes a single `TokenBurnHistory` using a unique key. */
  deleteTokenBurnHistory?: Maybe<DeleteTokenBurnHistoryPayload>;
  /** Deletes a single `TokenClaim` using a unique key. */
  deleteTokenClaim?: Maybe<DeleteTokenClaimPayload>;
  /** Deletes a single `TokenPrice` using a unique key. */
  deleteTokenPrice?: Maybe<DeleteTokenPricePayload>;
  /** Deletes a single `TokenSalesInfo` using a unique key. */
  deleteTokenSalesInfo?: Maybe<DeleteTokenSalesInfoPayload>;
  /** Deletes a single `TokenSalesPriceInfo` using a unique key. */
  deleteTokenSalesPriceInfo?: Maybe<DeleteTokenSalesPriceInfoPayload>;
  /** Deletes a single `User` using a unique key. */
  deleteUser?: Maybe<DeleteUserPayload>;
  /** Deletes a single `UserBetHistory` using a unique key. */
  deleteUserBetHistory?: Maybe<DeleteUserBetHistoryPayload>;
  /** Deletes a single `UserCompetition` using a unique key. */
  deleteUserCompetition?: Maybe<DeleteUserCompetitionPayload>;
  /** Deletes a single `UserStatistic` using a unique key. */
  deleteUserStatistic?: Maybe<DeleteUserStatisticPayload>;
  /** Deletes a single `UserStatisticsByDay` using a unique key. */
  deleteUserStatisticsByDay?: Maybe<DeleteUserStatisticsByDayPayload>;
  /** Deletes a single `UserStatisticsV2` using a unique key. */
  deleteUserStatisticsV2?: Maybe<DeleteUserStatisticsV2Payload>;
  /** Deletes a single `UserTokenSale` using a unique key. */
  deleteUserTokenSale?: Maybe<DeleteUserTokenSalePayload>;
  /** Deletes a single `UserTokenSaleTransaction` using a unique key. */
  deleteUserTokenSaleTransaction?: Maybe<DeleteUserTokenSaleTransactionPayload>;
  /** Updates a single `AuctionBasket` using a unique key and a patch. */
  updateAuctionBasket?: Maybe<UpdateAuctionBasketPayload>;
  /** Updates a single `AuctionBasketBet` using a unique key and a patch. */
  updateAuctionBasketBet?: Maybe<UpdateAuctionBasketBetPayload>;
  /** Updates a single `BankrollBalance` using a unique key and a patch. */
  updateBankrollBalance?: Maybe<UpdateBankrollBalancePayload>;
  /** Updates a single `BetsHistory` using a unique key and a patch. */
  updateBetsHistory?: Maybe<UpdateBetsHistoryPayload>;
  /** Updates a single `BetsHistory` using a unique key and a patch. */
  updateBetsHistoryById?: Maybe<UpdateBetsHistoryPayload>;
  /** Updates a single `BonusBetsHistory` using a unique key and a patch. */
  updateBonusBetsHistory?: Maybe<UpdateBonusBetsHistoryPayload>;
  /** Updates a single `ClaimHistory` using a unique key and a patch. */
  updateClaimHistory?: Maybe<UpdateClaimHistoryPayload>;
  /** Updates a single `CoinflipGame` using a unique key and a patch. */
  updateCoinflipGame?: Maybe<UpdateCoinflipGamePayload>;
  /** Updates a single `CoinflipGameRound` using a unique key and a patch. */
  updateCoinflipGameRound?: Maybe<UpdateCoinflipGameRoundPayload>;
  /** Updates a single `ContractConfig` using a unique key and a patch. */
  updateContractConfig?: Maybe<UpdateContractConfigPayload>;
  /** Updates a single `DoubleBet` using a unique key and a patch. */
  updateDoubleBet?: Maybe<UpdateDoubleBetPayload>;
  /** Updates a single `DoubleGame` using a unique key and a patch. */
  updateDoubleGame?: Maybe<UpdateDoubleGamePayload>;
  /** Updates a single `FeeDistributedHistory` using a unique key and a patch. */
  updateFeeDistributedHistory?: Maybe<UpdateFeeDistributedHistoryPayload>;
  /** Updates a single `GatewayChainTransaction` using a unique key and a patch. */
  updateGatewayChainTransaction?: Maybe<UpdateGatewayChainTransactionPayload>;
  /** Updates a single `JackpotBet` using a unique key and a patch. */
  updateJackpotBet?: Maybe<UpdateJackpotBetPayload>;
  /** Updates a single `JackpotGame` using a unique key and a patch. */
  updateJackpotGame?: Maybe<UpdateJackpotGamePayload>;
  /** Updates a single `Lootbox` using a unique key and a patch. */
  updateLootbox?: Maybe<UpdateLootboxPayload>;
  /** Updates a single `LootboxGame` using a unique key and a patch. */
  updateLootboxGame?: Maybe<UpdateLootboxGamePayload>;
  /** Updates a single `LootboxMarketOrder` using a unique key and a patch. */
  updateLootboxMarketOrder?: Maybe<UpdateLootboxMarketOrderPayload>;
  /** Updates a single `LootboxMarketTrade` using a unique key and a patch. */
  updateLootboxMarketTrade?: Maybe<UpdateLootboxMarketTradePayload>;
  /** Updates a single `LootboxReward` using a unique key and a patch. */
  updateLootboxReward?: Maybe<UpdateLootboxRewardPayload>;
  /** Updates a single `LootboxSale` using a unique key and a patch. */
  updateLootboxSale?: Maybe<UpdateLootboxSalePayload>;
  /** Updates a single `LootboxUnlimitedGame` using a unique key and a patch. */
  updateLootboxUnlimitedGame?: Maybe<UpdateLootboxUnlimitedGamePayload>;
  /** Updates a single `LootboxesUnlimited` using a unique key and a patch. */
  updateLootboxesUnlimited?: Maybe<UpdateLootboxesUnlimitedPayload>;
  /** Updates a single `MinesGame` using a unique key and a patch. */
  updateMinesGame?: Maybe<UpdateMinesGamePayload>;
  /** Updates a single `MinesGameRound` using a unique key and a patch. */
  updateMinesGameRound?: Maybe<UpdateMinesGameRoundPayload>;
  /** Updates a single `Nft` using a unique key and a patch. */
  updateNft?: Maybe<UpdateNftPayload>;
  /** Updates a single `NftsVote` using a unique key and a patch. */
  updateNftsVote?: Maybe<UpdateNftsVotePayload>;
  /** Updates a single `OpenCompetitionEntity` using a unique key and a patch. */
  updateOpenCompetitionEntity?: Maybe<UpdateOpenCompetitionEntityPayload>;
  /** Updates a single `PlinkoGame` using a unique key and a patch. */
  updatePlinkoGame?: Maybe<UpdatePlinkoGamePayload>;
  /** Updates a single `PointTransaction` using a unique key and a patch. */
  updatePointTransaction?: Maybe<UpdatePointTransactionPayload>;
  /** Updates a single `RngRound` using a unique key and a patch. */
  updateRngRound?: Maybe<UpdateRngRoundPayload>;
  /** Updates a single `RoshamboGame` using a unique key and a patch. */
  updateRoshamboGame?: Maybe<UpdateRoshamboGamePayload>;
  /** Updates a single `RoshamboGameLog` using a unique key and a patch. */
  updateRoshamboGameLog?: Maybe<UpdateRoshamboGameLogPayload>;
  /** Updates a single `RunesGame` using a unique key and a patch. */
  updateRunesGame?: Maybe<UpdateRunesGamePayload>;
  /** Updates a single `Statistic` using a unique key and a patch. */
  updateStatistic?: Maybe<UpdateStatisticPayload>;
  /** Updates a single `StatisticsV2` using a unique key and a patch. */
  updateStatisticsV2?: Maybe<UpdateStatisticsV2Payload>;
  /** Updates a single `TokenBurnHistory` using a unique key and a patch. */
  updateTokenBurnHistory?: Maybe<UpdateTokenBurnHistoryPayload>;
  /** Updates a single `TokenClaim` using a unique key and a patch. */
  updateTokenClaim?: Maybe<UpdateTokenClaimPayload>;
  /** Updates a single `TokenPrice` using a unique key and a patch. */
  updateTokenPrice?: Maybe<UpdateTokenPricePayload>;
  /** Updates a single `TokenSalesInfo` using a unique key and a patch. */
  updateTokenSalesInfo?: Maybe<UpdateTokenSalesInfoPayload>;
  /** Updates a single `TokenSalesPriceInfo` using a unique key and a patch. */
  updateTokenSalesPriceInfo?: Maybe<UpdateTokenSalesPriceInfoPayload>;
  /** Updates a single `User` using a unique key and a patch. */
  updateUser?: Maybe<UpdateUserPayload>;
  /** Updates a single `UserBetHistory` using a unique key and a patch. */
  updateUserBetHistory?: Maybe<UpdateUserBetHistoryPayload>;
  /** Updates a single `UserCompetition` using a unique key and a patch. */
  updateUserCompetition?: Maybe<UpdateUserCompetitionPayload>;
  /** Updates a single `UserStatistic` using a unique key and a patch. */
  updateUserStatistic?: Maybe<UpdateUserStatisticPayload>;
  /** Updates a single `UserStatisticsByDay` using a unique key and a patch. */
  updateUserStatisticsByDay?: Maybe<UpdateUserStatisticsByDayPayload>;
  /** Updates a single `UserStatisticsV2` using a unique key and a patch. */
  updateUserStatisticsV2?: Maybe<UpdateUserStatisticsV2Payload>;
  /** Updates a single `UserTokenSale` using a unique key and a patch. */
  updateUserTokenSale?: Maybe<UpdateUserTokenSalePayload>;
  /** Updates a single `UserTokenSaleTransaction` using a unique key and a patch. */
  updateUserTokenSaleTransaction?: Maybe<UpdateUserTokenSaleTransactionPayload>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAuctionBasketArgs = {
  input: CreateAuctionBasketInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAuctionBasketBetArgs = {
  input: CreateAuctionBasketBetInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBankrollBalanceArgs = {
  input: CreateBankrollBalanceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBetsHistoryArgs = {
  input: CreateBetsHistoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBonusBetsHistoryArgs = {
  input: CreateBonusBetsHistoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateClaimHistoryArgs = {
  input: CreateClaimHistoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCoinflipGameArgs = {
  input: CreateCoinflipGameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCoinflipGameRoundArgs = {
  input: CreateCoinflipGameRoundInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateContractConfigArgs = {
  input: CreateContractConfigInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDoubleBetArgs = {
  input: CreateDoubleBetInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDoubleGameArgs = {
  input: CreateDoubleGameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDoubleJackpotArgs = {
  input: CreateDoubleJackpotInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFeeDistributedHistoryArgs = {
  input: CreateFeeDistributedHistoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateGatewayChainTransactionArgs = {
  input: CreateGatewayChainTransactionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateJackpotBetArgs = {
  input: CreateJackpotBetInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateJackpotGameArgs = {
  input: CreateJackpotGameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLootboxArgs = {
  input: CreateLootboxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLootboxGameArgs = {
  input: CreateLootboxGameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLootboxMarketOrderArgs = {
  input: CreateLootboxMarketOrderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLootboxMarketTradeArgs = {
  input: CreateLootboxMarketTradeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLootboxRewardArgs = {
  input: CreateLootboxRewardInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLootboxSaleArgs = {
  input: CreateLootboxSaleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLootboxUnlimitedGameArgs = {
  input: CreateLootboxUnlimitedGameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLootboxesUnlimitedArgs = {
  input: CreateLootboxesUnlimitedInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMinesGameArgs = {
  input: CreateMinesGameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMinesGameRoundArgs = {
  input: CreateMinesGameRoundInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateNftArgs = {
  input: CreateNftInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateNftsVoteArgs = {
  input: CreateNftsVoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOpenCompetitionEntityArgs = {
  input: CreateOpenCompetitionEntityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePlinkoGameArgs = {
  input: CreatePlinkoGameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePointTransactionArgs = {
  input: CreatePointTransactionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRngRoundArgs = {
  input: CreateRngRoundInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoshamboGameArgs = {
  input: CreateRoshamboGameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoshamboGameLogArgs = {
  input: CreateRoshamboGameLogInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRunesGameArgs = {
  input: CreateRunesGameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateStatisticArgs = {
  input: CreateStatisticInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateStatisticsV2Args = {
  input: CreateStatisticsV2Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTokenBurnHistoryArgs = {
  input: CreateTokenBurnHistoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTokenClaimArgs = {
  input: CreateTokenClaimInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTokenPriceArgs = {
  input: CreateTokenPriceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTokenSalesInfoArgs = {
  input: CreateTokenSalesInfoInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTokenSalesPriceInfoArgs = {
  input: CreateTokenSalesPriceInfoInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserBetHistoryArgs = {
  input: CreateUserBetHistoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserCompetitionArgs = {
  input: CreateUserCompetitionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserStatisticArgs = {
  input: CreateUserStatisticInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserStatisticsByDayArgs = {
  input: CreateUserStatisticsByDayInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserStatisticsV2Args = {
  input: CreateUserStatisticsV2Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserTokenSaleArgs = {
  input: CreateUserTokenSaleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserTokenSaleTransactionArgs = {
  input: CreateUserTokenSaleTransactionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVersionInfoArgs = {
  input: CreateVersionInfoInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAuctionBasketArgs = {
  input: DeleteAuctionBasketInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAuctionBasketBetArgs = {
  input: DeleteAuctionBasketBetInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBankrollBalanceArgs = {
  input: DeleteBankrollBalanceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBetsHistoryArgs = {
  input: DeleteBetsHistoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBetsHistoryByIdArgs = {
  input: DeleteBetsHistoryByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBonusBetsHistoryArgs = {
  input: DeleteBonusBetsHistoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteClaimHistoryArgs = {
  input: DeleteClaimHistoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCoinflipGameArgs = {
  input: DeleteCoinflipGameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCoinflipGameRoundArgs = {
  input: DeleteCoinflipGameRoundInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteContractConfigArgs = {
  input: DeleteContractConfigInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDoubleBetArgs = {
  input: DeleteDoubleBetInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDoubleGameArgs = {
  input: DeleteDoubleGameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFeeDistributedHistoryArgs = {
  input: DeleteFeeDistributedHistoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteGatewayChainTransactionArgs = {
  input: DeleteGatewayChainTransactionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteJackpotBetArgs = {
  input: DeleteJackpotBetInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteJackpotGameArgs = {
  input: DeleteJackpotGameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLootboxArgs = {
  input: DeleteLootboxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLootboxGameArgs = {
  input: DeleteLootboxGameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLootboxMarketOrderArgs = {
  input: DeleteLootboxMarketOrderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLootboxMarketTradeArgs = {
  input: DeleteLootboxMarketTradeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLootboxRewardArgs = {
  input: DeleteLootboxRewardInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLootboxSaleArgs = {
  input: DeleteLootboxSaleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLootboxUnlimitedGameArgs = {
  input: DeleteLootboxUnlimitedGameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLootboxesUnlimitedArgs = {
  input: DeleteLootboxesUnlimitedInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMinesGameArgs = {
  input: DeleteMinesGameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMinesGameRoundArgs = {
  input: DeleteMinesGameRoundInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteNftArgs = {
  input: DeleteNftInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteNftsVoteArgs = {
  input: DeleteNftsVoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOpenCompetitionEntityArgs = {
  input: DeleteOpenCompetitionEntityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePlinkoGameArgs = {
  input: DeletePlinkoGameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePointTransactionArgs = {
  input: DeletePointTransactionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRngRoundArgs = {
  input: DeleteRngRoundInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoshamboGameArgs = {
  input: DeleteRoshamboGameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoshamboGameLogArgs = {
  input: DeleteRoshamboGameLogInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRunesGameArgs = {
  input: DeleteRunesGameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteStatisticArgs = {
  input: DeleteStatisticInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteStatisticsV2Args = {
  input: DeleteStatisticsV2Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTokenBurnHistoryArgs = {
  input: DeleteTokenBurnHistoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTokenClaimArgs = {
  input: DeleteTokenClaimInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTokenPriceArgs = {
  input: DeleteTokenPriceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTokenSalesInfoArgs = {
  input: DeleteTokenSalesInfoInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTokenSalesPriceInfoArgs = {
  input: DeleteTokenSalesPriceInfoInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserBetHistoryArgs = {
  input: DeleteUserBetHistoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserCompetitionArgs = {
  input: DeleteUserCompetitionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserStatisticArgs = {
  input: DeleteUserStatisticInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserStatisticsByDayArgs = {
  input: DeleteUserStatisticsByDayInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserStatisticsV2Args = {
  input: DeleteUserStatisticsV2Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserTokenSaleArgs = {
  input: DeleteUserTokenSaleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserTokenSaleTransactionArgs = {
  input: DeleteUserTokenSaleTransactionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAuctionBasketArgs = {
  input: UpdateAuctionBasketInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAuctionBasketBetArgs = {
  input: UpdateAuctionBasketBetInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBankrollBalanceArgs = {
  input: UpdateBankrollBalanceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBetsHistoryArgs = {
  input: UpdateBetsHistoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBetsHistoryByIdArgs = {
  input: UpdateBetsHistoryByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBonusBetsHistoryArgs = {
  input: UpdateBonusBetsHistoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateClaimHistoryArgs = {
  input: UpdateClaimHistoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCoinflipGameArgs = {
  input: UpdateCoinflipGameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCoinflipGameRoundArgs = {
  input: UpdateCoinflipGameRoundInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateContractConfigArgs = {
  input: UpdateContractConfigInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDoubleBetArgs = {
  input: UpdateDoubleBetInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDoubleGameArgs = {
  input: UpdateDoubleGameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFeeDistributedHistoryArgs = {
  input: UpdateFeeDistributedHistoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGatewayChainTransactionArgs = {
  input: UpdateGatewayChainTransactionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateJackpotBetArgs = {
  input: UpdateJackpotBetInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateJackpotGameArgs = {
  input: UpdateJackpotGameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLootboxArgs = {
  input: UpdateLootboxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLootboxGameArgs = {
  input: UpdateLootboxGameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLootboxMarketOrderArgs = {
  input: UpdateLootboxMarketOrderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLootboxMarketTradeArgs = {
  input: UpdateLootboxMarketTradeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLootboxRewardArgs = {
  input: UpdateLootboxRewardInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLootboxSaleArgs = {
  input: UpdateLootboxSaleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLootboxUnlimitedGameArgs = {
  input: UpdateLootboxUnlimitedGameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLootboxesUnlimitedArgs = {
  input: UpdateLootboxesUnlimitedInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMinesGameArgs = {
  input: UpdateMinesGameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMinesGameRoundArgs = {
  input: UpdateMinesGameRoundInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateNftArgs = {
  input: UpdateNftInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateNftsVoteArgs = {
  input: UpdateNftsVoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOpenCompetitionEntityArgs = {
  input: UpdateOpenCompetitionEntityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePlinkoGameArgs = {
  input: UpdatePlinkoGameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePointTransactionArgs = {
  input: UpdatePointTransactionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRngRoundArgs = {
  input: UpdateRngRoundInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoshamboGameArgs = {
  input: UpdateRoshamboGameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoshamboGameLogArgs = {
  input: UpdateRoshamboGameLogInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRunesGameArgs = {
  input: UpdateRunesGameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateStatisticArgs = {
  input: UpdateStatisticInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateStatisticsV2Args = {
  input: UpdateStatisticsV2Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTokenBurnHistoryArgs = {
  input: UpdateTokenBurnHistoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTokenClaimArgs = {
  input: UpdateTokenClaimInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTokenPriceArgs = {
  input: UpdateTokenPriceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTokenSalesInfoArgs = {
  input: UpdateTokenSalesInfoInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTokenSalesPriceInfoArgs = {
  input: UpdateTokenSalesPriceInfoInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserBetHistoryArgs = {
  input: UpdateUserBetHistoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserCompetitionArgs = {
  input: UpdateUserCompetitionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserStatisticArgs = {
  input: UpdateUserStatisticInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserStatisticsByDayArgs = {
  input: UpdateUserStatisticsByDayInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserStatisticsV2Args = {
  input: UpdateUserStatisticsV2Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserTokenSaleArgs = {
  input: UpdateUserTokenSaleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserTokenSaleTransactionArgs = {
  input: UpdateUserTokenSaleTransactionInput;
};

export type Nft = {
  __typename?: 'Nft';
  id: Scalars['BigInt']['output'];
  mintTx: Scalars['String']['output'];
  minted: Scalars['BigInt']['output'];
  minter: Scalars['String']['output'];
  owner?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updated: Scalars['BigInt']['output'];
};

/** A condition to be used against `Nft` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type NftCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `mintTx` field. */
  mintTx?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `minted` field. */
  minted?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `minter` field. */
  minter?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `owner` field. */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `partner` field. */
  partner?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updated` field. */
  updated?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `Nft` object types. All fields are combined with a logical ‘and.’ */
export type NftFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<NftFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `mintTx` field. */
  mintTx?: InputMaybe<StringFilter>;
  /** Filter by the object’s `minted` field. */
  minted?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `minter` field. */
  minter?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<NftFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<NftFilter>>;
  /** Filter by the object’s `owner` field. */
  owner?: InputMaybe<StringFilter>;
  /** Filter by the object’s `partner` field. */
  partner?: InputMaybe<StringFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updated` field. */
  updated?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `Nft` */
export type NftInput = {
  id: Scalars['BigInt']['input'];
  mintTx: Scalars['String']['input'];
  minted: Scalars['BigInt']['input'];
  minter: Scalars['String']['input'];
  owner?: InputMaybe<Scalars['String']['input']>;
  partner?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  updated: Scalars['BigInt']['input'];
};

/** Represents an update to a `Nft`. Fields that are set will be updated. */
export type NftPatch = {
  id?: InputMaybe<Scalars['BigInt']['input']>;
  mintTx?: InputMaybe<Scalars['String']['input']>;
  minted?: InputMaybe<Scalars['BigInt']['input']>;
  minter?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  partner?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['BigInt']['input']>;
};

export type NftVoteResult = {
  __typename?: 'NftVoteResult';
  abstain?: Maybe<Scalars['BigFloat']['output']>;
  no?: Maybe<Scalars['BigFloat']['output']>;
  nonVote?: Maybe<Scalars['BigFloat']['output']>;
  proposalId: Scalars['String']['output'];
  yes?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `Nft` values. */
export type NftsConnection = {
  __typename?: 'NftsConnection';
  /** A list of edges which contains the `Nft` and cursor to aid in pagination. */
  edges: Array<NftsEdge>;
  /** A list of `Nft` objects. */
  nodes: Array<Maybe<Nft>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Nft` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Nft` edge in the connection. */
export type NftsEdge = {
  __typename?: 'NftsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Nft` at the end of the edge. */
  node?: Maybe<Nft>;
};

/** Methods to use when ordering `Nft`. */
export enum NftsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MintedAsc = 'MINTED_ASC',
  MintedDesc = 'MINTED_DESC',
  MinterAsc = 'MINTER_ASC',
  MinterDesc = 'MINTER_DESC',
  MintTxAsc = 'MINT_TX_ASC',
  MintTxDesc = 'MINT_TX_DESC',
  Natural = 'NATURAL',
  OwnerAsc = 'OWNER_ASC',
  OwnerDesc = 'OWNER_DESC',
  PartnerAsc = 'PARTNER_ASC',
  PartnerDesc = 'PARTNER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UpdatedAsc = 'UPDATED_ASC',
  UpdatedDesc = 'UPDATED_DESC'
}

export type NftsVote = {
  __typename?: 'NftsVote';
  address: Scalars['String']['output'];
  date?: Maybe<Scalars['BigInt']['output']>;
  power: Scalars['BigInt']['output'];
  proposalId: Scalars['String']['output'];
  tx?: Maybe<Scalars['String']['output']>;
  vote?: Maybe<Scalars['String']['output']>;
  voteComment?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `NftsVote` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type NftsVoteCondition = {
  /** Checks for equality with the object’s `address` field. */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `date` field. */
  date?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `power` field. */
  power?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `proposalId` field. */
  proposalId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `tx` field. */
  tx?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `vote` field. */
  vote?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `voteComment` field. */
  voteComment?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `NftsVote` object types. All fields are combined with a logical ‘and.’ */
export type NftsVoteFilter = {
  /** Filter by the object’s `address` field. */
  address?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<NftsVoteFilter>>;
  /** Filter by the object’s `date` field. */
  date?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<NftsVoteFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<NftsVoteFilter>>;
  /** Filter by the object’s `power` field. */
  power?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `proposalId` field. */
  proposalId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `tx` field. */
  tx?: InputMaybe<StringFilter>;
  /** Filter by the object’s `vote` field. */
  vote?: InputMaybe<StringFilter>;
  /** Filter by the object’s `voteComment` field. */
  voteComment?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `NftsVote` */
export type NftsVoteInput = {
  address: Scalars['String']['input'];
  date?: InputMaybe<Scalars['BigInt']['input']>;
  power: Scalars['BigInt']['input'];
  proposalId: Scalars['String']['input'];
  tx?: InputMaybe<Scalars['String']['input']>;
  vote?: InputMaybe<Scalars['String']['input']>;
  voteComment?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an update to a `NftsVote`. Fields that are set will be updated. */
export type NftsVotePatch = {
  address?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['BigInt']['input']>;
  power?: InputMaybe<Scalars['BigInt']['input']>;
  proposalId?: InputMaybe<Scalars['String']['input']>;
  tx?: InputMaybe<Scalars['String']['input']>;
  vote?: InputMaybe<Scalars['String']['input']>;
  voteComment?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `NftsVote` values. */
export type NftsVotesConnection = {
  __typename?: 'NftsVotesConnection';
  /** A list of edges which contains the `NftsVote` and cursor to aid in pagination. */
  edges: Array<NftsVotesEdge>;
  /** A list of `NftsVote` objects. */
  nodes: Array<Maybe<NftsVote>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `NftsVote` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `NftsVote` edge in the connection. */
export type NftsVotesEdge = {
  __typename?: 'NftsVotesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `NftsVote` at the end of the edge. */
  node?: Maybe<NftsVote>;
};

/** Methods to use when ordering `NftsVote`. */
export enum NftsVotesOrderBy {
  AddressAsc = 'ADDRESS_ASC',
  AddressDesc = 'ADDRESS_DESC',
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  Natural = 'NATURAL',
  PowerAsc = 'POWER_ASC',
  PowerDesc = 'POWER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProposalIdAsc = 'PROPOSAL_ID_ASC',
  ProposalIdDesc = 'PROPOSAL_ID_DESC',
  TxAsc = 'TX_ASC',
  TxDesc = 'TX_DESC',
  VoteAsc = 'VOTE_ASC',
  VoteCommentAsc = 'VOTE_COMMENT_ASC',
  VoteCommentDesc = 'VOTE_COMMENT_DESC',
  VoteDesc = 'VOTE_DESC'
}

/** A connection to a list of `OpenCompetitionEntity` values. */
export type OpenCompetitionEntitiesConnection = {
  __typename?: 'OpenCompetitionEntitiesConnection';
  /** A list of edges which contains the `OpenCompetitionEntity` and cursor to aid in pagination. */
  edges: Array<OpenCompetitionEntitiesEdge>;
  /** A list of `OpenCompetitionEntity` objects. */
  nodes: Array<Maybe<OpenCompetitionEntity>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OpenCompetitionEntity` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `OpenCompetitionEntity` edge in the connection. */
export type OpenCompetitionEntitiesEdge = {
  __typename?: 'OpenCompetitionEntitiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OpenCompetitionEntity` at the end of the edge. */
  node?: Maybe<OpenCompetitionEntity>;
};

/** Methods to use when ordering `OpenCompetitionEntity`. */
export enum OpenCompetitionEntitiesOrderBy {
  BoxOpenAsc = 'BOX_OPEN_ASC',
  BoxOpenDesc = 'BOX_OPEN_DESC',
  DoubleScoreAsc = 'DOUBLE_SCORE_ASC',
  DoubleScoreDesc = 'DOUBLE_SCORE_DESC',
  FeeBoxTxHashAsc = 'FEE_BOX_TX_HASH_ASC',
  FeeBoxTxHashDesc = 'FEE_BOX_TX_HASH_DESC',
  JackpotScoreAsc = 'JACKPOT_SCORE_ASC',
  JackpotScoreDesc = 'JACKPOT_SCORE_DESC',
  Natural = 'NATURAL',
  PlayerAsc = 'PLAYER_ASC',
  PlayerDesc = 'PLAYER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RefererScoreAsc = 'REFERER_SCORE_ASC',
  RefererScoreDesc = 'REFERER_SCORE_DESC',
  RoshamboScoreAsc = 'ROSHAMBO_SCORE_ASC',
  RoshamboScoreDesc = 'ROSHAMBO_SCORE_DESC',
  ScoreAsc = 'SCORE_ASC',
  ScoreDesc = 'SCORE_DESC'
}

export type OpenCompetitionEntity = {
  __typename?: 'OpenCompetitionEntity';
  boxOpen: Scalars['BigInt']['output'];
  doubleScore: Scalars['BigInt']['output'];
  feeBoxTxHash?: Maybe<Scalars['String']['output']>;
  jackpotScore?: Maybe<Scalars['BigInt']['output']>;
  player: Scalars['String']['output'];
  refererScore: Scalars['BigInt']['output'];
  roshamboScore?: Maybe<Scalars['BigInt']['output']>;
  score: Scalars['BigInt']['output'];
};

/**
 * A condition to be used against `OpenCompetitionEntity` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type OpenCompetitionEntityCondition = {
  /** Checks for equality with the object’s `boxOpen` field. */
  boxOpen?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `doubleScore` field. */
  doubleScore?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `feeBoxTxHash` field. */
  feeBoxTxHash?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `jackpotScore` field. */
  jackpotScore?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `player` field. */
  player?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `refererScore` field. */
  refererScore?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `roshamboScore` field. */
  roshamboScore?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `score` field. */
  score?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `OpenCompetitionEntity` object types. All fields are combined with a logical ‘and.’ */
export type OpenCompetitionEntityFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OpenCompetitionEntityFilter>>;
  /** Filter by the object’s `boxOpen` field. */
  boxOpen?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `doubleScore` field. */
  doubleScore?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `feeBoxTxHash` field. */
  feeBoxTxHash?: InputMaybe<StringFilter>;
  /** Filter by the object’s `jackpotScore` field. */
  jackpotScore?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OpenCompetitionEntityFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OpenCompetitionEntityFilter>>;
  /** Filter by the object’s `player` field. */
  player?: InputMaybe<StringFilter>;
  /** Filter by the object’s `refererScore` field. */
  refererScore?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `roshamboScore` field. */
  roshamboScore?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `score` field. */
  score?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `OpenCompetitionEntity` */
export type OpenCompetitionEntityInput = {
  boxOpen: Scalars['BigInt']['input'];
  doubleScore: Scalars['BigInt']['input'];
  feeBoxTxHash?: InputMaybe<Scalars['String']['input']>;
  jackpotScore?: InputMaybe<Scalars['BigInt']['input']>;
  player: Scalars['String']['input'];
  refererScore: Scalars['BigInt']['input'];
  roshamboScore?: InputMaybe<Scalars['BigInt']['input']>;
  score: Scalars['BigInt']['input'];
};

/** Represents an update to a `OpenCompetitionEntity`. Fields that are set will be updated. */
export type OpenCompetitionEntityPatch = {
  boxOpen?: InputMaybe<Scalars['BigInt']['input']>;
  doubleScore?: InputMaybe<Scalars['BigInt']['input']>;
  feeBoxTxHash?: InputMaybe<Scalars['String']['input']>;
  jackpotScore?: InputMaybe<Scalars['BigInt']['input']>;
  player?: InputMaybe<Scalars['String']['input']>;
  refererScore?: InputMaybe<Scalars['BigInt']['input']>;
  roshamboScore?: InputMaybe<Scalars['BigInt']['input']>;
  score?: InputMaybe<Scalars['BigInt']['input']>;
};

export type OpenCompetitionLeaderBoard = {
  __typename?: 'OpenCompetitionLeaderBoard';
  boxOpen?: Maybe<Scalars['BigInt']['output']>;
  fullScore?: Maybe<Scalars['BigFloat']['output']>;
  hasNft?: Maybe<Scalars['Int']['output']>;
  nfts?: Maybe<Scalars['BigInt']['output']>;
  player?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['BigInt']['output']>;
  refererScore?: Maybe<Scalars['BigInt']['output']>;
  score?: Maybe<Scalars['BigInt']['output']>;
  totalScore?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `OpenCompetitionLeaderBoard` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type OpenCompetitionLeaderBoardCondition = {
  /** Checks for equality with the object’s `boxOpen` field. */
  boxOpen?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `fullScore` field. */
  fullScore?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `hasNft` field. */
  hasNft?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `nfts` field. */
  nfts?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `player` field. */
  player?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rank` field. */
  rank?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `refererScore` field. */
  refererScore?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `score` field. */
  score?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `totalScore` field. */
  totalScore?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** A filter to be used against `OpenCompetitionLeaderBoard` object types. All fields are combined with a logical ‘and.’ */
export type OpenCompetitionLeaderBoardFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OpenCompetitionLeaderBoardFilter>>;
  /** Filter by the object’s `boxOpen` field. */
  boxOpen?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `fullScore` field. */
  fullScore?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `hasNft` field. */
  hasNft?: InputMaybe<IntFilter>;
  /** Filter by the object’s `nfts` field. */
  nfts?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OpenCompetitionLeaderBoardFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OpenCompetitionLeaderBoardFilter>>;
  /** Filter by the object’s `player` field. */
  player?: InputMaybe<StringFilter>;
  /** Filter by the object’s `rank` field. */
  rank?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `refererScore` field. */
  refererScore?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `score` field. */
  score?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `totalScore` field. */
  totalScore?: InputMaybe<BigFloatFilter>;
};

/** A connection to a list of `OpenCompetitionLeaderBoard` values. */
export type OpenCompetitionLeaderBoardsConnection = {
  __typename?: 'OpenCompetitionLeaderBoardsConnection';
  /** A list of edges which contains the `OpenCompetitionLeaderBoard` and cursor to aid in pagination. */
  edges: Array<OpenCompetitionLeaderBoardsEdge>;
  /** A list of `OpenCompetitionLeaderBoard` objects. */
  nodes: Array<Maybe<OpenCompetitionLeaderBoard>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OpenCompetitionLeaderBoard` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `OpenCompetitionLeaderBoard` edge in the connection. */
export type OpenCompetitionLeaderBoardsEdge = {
  __typename?: 'OpenCompetitionLeaderBoardsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OpenCompetitionLeaderBoard` at the end of the edge. */
  node?: Maybe<OpenCompetitionLeaderBoard>;
};

/** Methods to use when ordering `OpenCompetitionLeaderBoard`. */
export enum OpenCompetitionLeaderBoardsOrderBy {
  BoxOpenAsc = 'BOX_OPEN_ASC',
  BoxOpenDesc = 'BOX_OPEN_DESC',
  FullScoreAsc = 'FULL_SCORE_ASC',
  FullScoreDesc = 'FULL_SCORE_DESC',
  HasNftAsc = 'HAS_NFT_ASC',
  HasNftDesc = 'HAS_NFT_DESC',
  Natural = 'NATURAL',
  NftsAsc = 'NFTS_ASC',
  NftsDesc = 'NFTS_DESC',
  PlayerAsc = 'PLAYER_ASC',
  PlayerDesc = 'PLAYER_DESC',
  RankAsc = 'RANK_ASC',
  RankDesc = 'RANK_DESC',
  RefererScoreAsc = 'REFERER_SCORE_ASC',
  RefererScoreDesc = 'REFERER_SCORE_DESC',
  ScoreAsc = 'SCORE_ASC',
  ScoreDesc = 'SCORE_DESC',
  TotalScoreAsc = 'TOTAL_SCORE_ASC',
  TotalScoreDesc = 'TOTAL_SCORE_DESC'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

export type PlinkoGame = {
  __typename?: 'PlinkoGame';
  balls: Scalars['Int']['output'];
  bet: Scalars['BigFloat']['output'];
  betNormalize: Scalars['BigInt']['output'];
  betUsd: Scalars['BigInt']['output'];
  created: Scalars['Datetime']['output'];
  denom: Scalars['String']['output'];
  id: Scalars['BigInt']['output'];
  payout: Scalars['BigFloat']['output'];
  payoutNormalize: Scalars['BigInt']['output'];
  payoutUsd: Scalars['BigInt']['output'];
  player: Scalars['String']['output'];
  randomRound: Scalars['BigInt']['output'];
  result: Array<Maybe<Scalars['Int']['output']>>;
  risk: GameRisk;
  status: GameStatus;
  symbol: Scalars['String']['output'];
  txHash: Scalars['String']['output'];
  updated: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `PlinkoGame` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type PlinkoGameCondition = {
  /** Checks for equality with the object’s `balls` field. */
  balls?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `bet` field. */
  bet?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `betNormalize` field. */
  betNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `betUsd` field. */
  betUsd?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `denom` field. */
  denom?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `payout` field. */
  payout?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `payoutNormalize` field. */
  payoutNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `payoutUsd` field. */
  payoutUsd?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `player` field. */
  player?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `randomRound` field. */
  randomRound?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `result` field. */
  result?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Checks for equality with the object’s `risk` field. */
  risk?: InputMaybe<GameRisk>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<GameStatus>;
  /** Checks for equality with the object’s `symbol` field. */
  symbol?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `txHash` field. */
  txHash?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updated` field. */
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `PlinkoGame` object types. All fields are combined with a logical ‘and.’ */
export type PlinkoGameFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PlinkoGameFilter>>;
  /** Filter by the object’s `balls` field. */
  balls?: InputMaybe<IntFilter>;
  /** Filter by the object’s `bet` field. */
  bet?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `betNormalize` field. */
  betNormalize?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `betUsd` field. */
  betUsd?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `denom` field. */
  denom?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PlinkoGameFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PlinkoGameFilter>>;
  /** Filter by the object’s `payout` field. */
  payout?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `payoutNormalize` field. */
  payoutNormalize?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `payoutUsd` field. */
  payoutUsd?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `player` field. */
  player?: InputMaybe<StringFilter>;
  /** Filter by the object’s `randomRound` field. */
  randomRound?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `result` field. */
  result?: InputMaybe<IntListFilter>;
  /** Filter by the object’s `risk` field. */
  risk?: InputMaybe<GameRiskFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<GameStatusFilter>;
  /** Filter by the object’s `symbol` field. */
  symbol?: InputMaybe<StringFilter>;
  /** Filter by the object’s `txHash` field. */
  txHash?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updated` field. */
  updated?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `PlinkoGame` */
export type PlinkoGameInput = {
  balls: Scalars['Int']['input'];
  bet: Scalars['BigFloat']['input'];
  betNormalize: Scalars['BigInt']['input'];
  betUsd: Scalars['BigInt']['input'];
  created: Scalars['Datetime']['input'];
  denom: Scalars['String']['input'];
  id: Scalars['BigInt']['input'];
  payout: Scalars['BigFloat']['input'];
  payoutNormalize: Scalars['BigInt']['input'];
  payoutUsd: Scalars['BigInt']['input'];
  player: Scalars['String']['input'];
  randomRound: Scalars['BigInt']['input'];
  result: Array<InputMaybe<Scalars['Int']['input']>>;
  risk: GameRisk;
  status: GameStatus;
  symbol: Scalars['String']['input'];
  txHash: Scalars['String']['input'];
  updated: Scalars['Datetime']['input'];
};

/** Represents an update to a `PlinkoGame`. Fields that are set will be updated. */
export type PlinkoGamePatch = {
  balls?: InputMaybe<Scalars['Int']['input']>;
  bet?: InputMaybe<Scalars['BigFloat']['input']>;
  betNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  betUsd?: InputMaybe<Scalars['BigInt']['input']>;
  created?: InputMaybe<Scalars['Datetime']['input']>;
  denom?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  payout?: InputMaybe<Scalars['BigFloat']['input']>;
  payoutNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  payoutUsd?: InputMaybe<Scalars['BigInt']['input']>;
  player?: InputMaybe<Scalars['String']['input']>;
  randomRound?: InputMaybe<Scalars['BigInt']['input']>;
  result?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  risk?: InputMaybe<GameRisk>;
  status?: InputMaybe<GameStatus>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  txHash?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `PlinkoGame` values. */
export type PlinkoGamesConnection = {
  __typename?: 'PlinkoGamesConnection';
  /** A list of edges which contains the `PlinkoGame` and cursor to aid in pagination. */
  edges: Array<PlinkoGamesEdge>;
  /** A list of `PlinkoGame` objects. */
  nodes: Array<Maybe<PlinkoGame>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PlinkoGame` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `PlinkoGame` edge in the connection. */
export type PlinkoGamesEdge = {
  __typename?: 'PlinkoGamesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PlinkoGame` at the end of the edge. */
  node?: Maybe<PlinkoGame>;
};

/** Methods to use when ordering `PlinkoGame`. */
export enum PlinkoGamesOrderBy {
  BallsAsc = 'BALLS_ASC',
  BallsDesc = 'BALLS_DESC',
  BetAsc = 'BET_ASC',
  BetDesc = 'BET_DESC',
  BetNormalizeAsc = 'BET_NORMALIZE_ASC',
  BetNormalizeDesc = 'BET_NORMALIZE_DESC',
  BetUsdAsc = 'BET_USD_ASC',
  BetUsdDesc = 'BET_USD_DESC',
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  DenomAsc = 'DENOM_ASC',
  DenomDesc = 'DENOM_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PayoutAsc = 'PAYOUT_ASC',
  PayoutDesc = 'PAYOUT_DESC',
  PayoutNormalizeAsc = 'PAYOUT_NORMALIZE_ASC',
  PayoutNormalizeDesc = 'PAYOUT_NORMALIZE_DESC',
  PayoutUsdAsc = 'PAYOUT_USD_ASC',
  PayoutUsdDesc = 'PAYOUT_USD_DESC',
  PlayerAsc = 'PLAYER_ASC',
  PlayerDesc = 'PLAYER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RandomRoundAsc = 'RANDOM_ROUND_ASC',
  RandomRoundDesc = 'RANDOM_ROUND_DESC',
  ResultAsc = 'RESULT_ASC',
  ResultDesc = 'RESULT_DESC',
  RiskAsc = 'RISK_ASC',
  RiskDesc = 'RISK_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  SymbolAsc = 'SYMBOL_ASC',
  SymbolDesc = 'SYMBOL_DESC',
  TxHashAsc = 'TX_HASH_ASC',
  TxHashDesc = 'TX_HASH_DESC',
  UpdatedAsc = 'UPDATED_ASC',
  UpdatedDesc = 'UPDATED_DESC'
}

export type PointTransaction = {
  __typename?: 'PointTransaction';
  created: Scalars['Datetime']['output'];
  eventId: Scalars['BigInt']['output'];
  id: Scalars['BigInt']['output'];
  player: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['BigInt']['output'];
};

/**
 * A condition to be used against `PointTransaction` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PointTransactionCondition = {
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `player` field. */
  player?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `PointTransaction` object types. All fields are combined with a logical ‘and.’ */
export type PointTransactionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PointTransactionFilter>>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PointTransactionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PointTransactionFilter>>;
  /** Filter by the object’s `player` field. */
  player?: InputMaybe<StringFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `PointTransaction` */
export type PointTransactionInput = {
  created: Scalars['Datetime']['input'];
  eventId: Scalars['BigInt']['input'];
  id?: InputMaybe<Scalars['BigInt']['input']>;
  player: Scalars['String']['input'];
  type: Scalars['String']['input'];
  value: Scalars['BigInt']['input'];
};

/** Represents an update to a `PointTransaction`. Fields that are set will be updated. */
export type PointTransactionPatch = {
  created?: InputMaybe<Scalars['Datetime']['input']>;
  eventId?: InputMaybe<Scalars['BigInt']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  player?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A connection to a list of `PointTransaction` values. */
export type PointTransactionsConnection = {
  __typename?: 'PointTransactionsConnection';
  /** A list of edges which contains the `PointTransaction` and cursor to aid in pagination. */
  edges: Array<PointTransactionsEdge>;
  /** A list of `PointTransaction` objects. */
  nodes: Array<Maybe<PointTransaction>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PointTransaction` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `PointTransaction` edge in the connection. */
export type PointTransactionsEdge = {
  __typename?: 'PointTransactionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PointTransaction` at the end of the edge. */
  node?: Maybe<PointTransaction>;
};

/** Methods to use when ordering `PointTransaction`. */
export enum PointTransactionsOrderBy {
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  EventIdAsc = 'EVENT_ID_ASC',
  EventIdDesc = 'EVENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PlayerAsc = 'PLAYER_ASC',
  PlayerDesc = 'PLAYER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** The root query type which gives access points into the data universe. */
export type Query = {
  __typename?: 'Query';
  /** Reads and enables pagination through a set of `AppCoinflipLeaderboardLuckyBet`. */
  appCoinflipLeaderboardLuckyBets?: Maybe<AppCoinflipLeaderboardLuckyBetsConnection>;
  auctionBasket?: Maybe<AuctionBasket>;
  auctionBasketBet?: Maybe<AuctionBasketBet>;
  /** Reads and enables pagination through a set of `AuctionBasketBet`. */
  auctionBasketBets?: Maybe<AuctionBasketBetsConnection>;
  /** Reads and enables pagination through a set of `AuctionBasket`. */
  auctionBaskets?: Maybe<AuctionBasketsConnection>;
  bankrollBalance?: Maybe<BankrollBalance>;
  /** Reads and enables pagination through a set of `BankrollBalance`. */
  bankrollBalances?: Maybe<BankrollBalancesConnection>;
  /** Reads and enables pagination through a set of `BetsHistory`. */
  betsHistories?: Maybe<BetsHistoriesConnection>;
  betsHistory?: Maybe<BetsHistory>;
  betsHistoryById?: Maybe<BetsHistory>;
  /** Reads and enables pagination through a set of `BonusBetsHistory`. */
  bonusBetsHistories?: Maybe<BonusBetsHistoriesConnection>;
  bonusBetsHistory?: Maybe<BonusBetsHistory>;
  /** Reads and enables pagination through a set of `ClaimHistory`. */
  claimHistories?: Maybe<ClaimHistoriesConnection>;
  claimHistory?: Maybe<ClaimHistory>;
  coinflipGame?: Maybe<CoinflipGame>;
  coinflipGameRound?: Maybe<CoinflipGameRound>;
  /** Reads and enables pagination through a set of `CoinflipGameRound`. */
  coinflipGameRounds?: Maybe<CoinflipGameRoundsConnection>;
  /** Reads and enables pagination through a set of `CoinflipGame`. */
  coinflipGames?: Maybe<CoinflipGamesConnection>;
  contractConfig?: Maybe<ContractConfig>;
  /** Reads and enables pagination through a set of `ContractConfig`. */
  contractConfigs?: Maybe<ContractConfigsConnection>;
  doubleBet?: Maybe<DoubleBet>;
  /** Reads and enables pagination through a set of `DoubleBet`. */
  doubleBets?: Maybe<DoubleBetsConnection>;
  doubleGame?: Maybe<DoubleGame>;
  /** Reads and enables pagination through a set of `DoubleGame`. */
  doubleGames?: Maybe<DoubleGamesConnection>;
  /** Reads and enables pagination through a set of `DoubleJackpot`. */
  doubleJackpots?: Maybe<DoubleJackpotsConnection>;
  /** Reads and enables pagination through a set of `DoubleUserGame`. */
  doubleUserGames?: Maybe<DoubleUserGamesConnection>;
  /** Reads and enables pagination through a set of `FeeDistributedHistory`. */
  feeDistributedHistories?: Maybe<FeeDistributedHistoriesConnection>;
  feeDistributedHistory?: Maybe<FeeDistributedHistory>;
  gatewayChainTransaction?: Maybe<GatewayChainTransaction>;
  /** Reads and enables pagination through a set of `GatewayChainTransaction`. */
  gatewayChainTransactions?: Maybe<GatewayChainTransactionsConnection>;
  getPartnerUsersStats?: Maybe<GetPartnerUsersStatsConnection>;
  /** Reads and enables pagination through a set of `InfoLast100WinBet`. */
  infoLast100WinBets?: Maybe<InfoLast100WinBetsConnection>;
  jackpotBet?: Maybe<JackpotBet>;
  /** Reads and enables pagination through a set of `JackpotBet`. */
  jackpotBets?: Maybe<JackpotBetsConnection>;
  jackpotGame?: Maybe<JackpotGame>;
  /** Reads and enables pagination through a set of `JackpotGame`. */
  jackpotGames?: Maybe<JackpotGamesConnection>;
  /** Reads and enables pagination through a set of `JackpotGame`. */
  jackpotUserGames?: Maybe<JackpotGamesConnection>;
  jackpotUserGames2?: Maybe<JackpotUserGames2Connection>;
  lootbox?: Maybe<Lootbox>;
  lootboxGame?: Maybe<LootboxGame>;
  /** Reads and enables pagination through a set of `LootboxGame`. */
  lootboxGames?: Maybe<LootboxGamesConnection>;
  lootboxMarketOrder?: Maybe<LootboxMarketOrder>;
  /** Reads and enables pagination through a set of `LootboxMarketOrder`. */
  lootboxMarketOrders?: Maybe<LootboxMarketOrdersConnection>;
  lootboxMarketTrade?: Maybe<LootboxMarketTrade>;
  /** Reads and enables pagination through a set of `LootboxMarketTrade`. */
  lootboxMarketTrades?: Maybe<LootboxMarketTradesConnection>;
  lootboxOrderBook?: Maybe<LootboxOrderBookConnection>;
  lootboxReward?: Maybe<LootboxReward>;
  /** Reads and enables pagination through a set of `LootboxReward`. */
  lootboxRewards?: Maybe<LootboxRewardsConnection>;
  lootboxSale?: Maybe<LootboxSale>;
  /** Reads and enables pagination through a set of `LootboxSale`. */
  lootboxSales?: Maybe<LootboxSalesConnection>;
  lootboxUnlimitedGame?: Maybe<LootboxUnlimitedGame>;
  /** Reads and enables pagination through a set of `LootboxUnlimitedGame`. */
  lootboxUnlimitedGames?: Maybe<LootboxUnlimitedGamesConnection>;
  /** Reads and enables pagination through a set of `Lootbox`. */
  lootboxes?: Maybe<LootboxesConnection>;
  lootboxesUnlimited?: Maybe<LootboxesUnlimited>;
  /** Reads and enables pagination through a set of `LootboxesUnlimited`. */
  lootboxesUnlimiteds?: Maybe<LootboxesUnlimitedsConnection>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  minesGame?: Maybe<MinesGame>;
  minesGameRound?: Maybe<MinesGameRound>;
  /** Reads and enables pagination through a set of `MinesGameRound`. */
  minesGameRounds?: Maybe<MinesGameRoundsConnection>;
  /** Reads and enables pagination through a set of `MinesGame`. */
  minesGames?: Maybe<MinesGamesConnection>;
  nft?: Maybe<Nft>;
  nftVoteResult?: Maybe<NftVoteResult>;
  /** Reads and enables pagination through a set of `Nft`. */
  nfts?: Maybe<NftsConnection>;
  nftsVote?: Maybe<NftsVote>;
  /** Reads and enables pagination through a set of `NftsVote`. */
  nftsVotes?: Maybe<NftsVotesConnection>;
  /** Reads and enables pagination through a set of `OpenCompetitionEntity`. */
  openCompetitionEntities?: Maybe<OpenCompetitionEntitiesConnection>;
  openCompetitionEntity?: Maybe<OpenCompetitionEntity>;
  /** Reads and enables pagination through a set of `OpenCompetitionLeaderBoard`. */
  openCompetitionLeaderBoards?: Maybe<OpenCompetitionLeaderBoardsConnection>;
  plinkoGame?: Maybe<PlinkoGame>;
  /** Reads and enables pagination through a set of `PlinkoGame`. */
  plinkoGames?: Maybe<PlinkoGamesConnection>;
  pointTransaction?: Maybe<PointTransaction>;
  /** Reads and enables pagination through a set of `PointTransaction`. */
  pointTransactions?: Maybe<PointTransactionsConnection>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  rngRound?: Maybe<RngRound>;
  /** Reads and enables pagination through a set of `RngRound`. */
  rngRounds?: Maybe<RngRoundsConnection>;
  roshamboGame?: Maybe<RoshamboGame>;
  roshamboGameLog?: Maybe<RoshamboGameLog>;
  /** Reads and enables pagination through a set of `RoshamboGameLog`. */
  roshamboGameLogs?: Maybe<RoshamboGameLogsConnection>;
  /** Reads and enables pagination through a set of `RoshamboGame`. */
  roshamboGames?: Maybe<RoshamboGamesConnection>;
  runesGame?: Maybe<RunesGame>;
  /** Reads and enables pagination through a set of `RunesGame`. */
  runesGames?: Maybe<RunesGamesConnection>;
  statistic?: Maybe<Statistic>;
  /** Reads and enables pagination through a set of `Statistic`. */
  statistics?: Maybe<StatisticsConnection>;
  statisticsV2?: Maybe<StatisticsV2>;
  /** Reads and enables pagination through a set of `StatisticsV2`. */
  statisticsV2s?: Maybe<StatisticsV2sConnection>;
  /** Reads and enables pagination through a set of `TokenBurnHistory`. */
  tokenBurnHistories?: Maybe<TokenBurnHistoriesConnection>;
  tokenBurnHistory?: Maybe<TokenBurnHistory>;
  tokenClaim?: Maybe<TokenClaim>;
  /** Reads and enables pagination through a set of `TokenClaim`. */
  tokenClaims?: Maybe<TokenClaimsConnection>;
  tokenPrice?: Maybe<TokenPrice>;
  /** Reads and enables pagination through a set of `TokenPrice`. */
  tokenPrices?: Maybe<TokenPricesConnection>;
  tokenSalesInfo?: Maybe<TokenSalesInfo>;
  /** Reads and enables pagination through a set of `TokenSalesInfo`. */
  tokenSalesInfos?: Maybe<TokenSalesInfosConnection>;
  tokenSalesPriceInfo?: Maybe<TokenSalesPriceInfo>;
  /** Reads and enables pagination through a set of `TokenSalesPriceInfo`. */
  tokenSalesPriceInfos?: Maybe<TokenSalesPriceInfosConnection>;
  user?: Maybe<User>;
  /** Reads and enables pagination through a set of `UserBetHistory`. */
  userBetHistories?: Maybe<UserBetHistoriesConnection>;
  userBetHistory?: Maybe<UserBetHistory>;
  userCompetition?: Maybe<UserCompetition>;
  /** Reads and enables pagination through a set of `UserCompetition`. */
  userCompetitions?: Maybe<UserCompetitionsConnection>;
  userStatistic?: Maybe<UserStatistic>;
  /** Reads and enables pagination through a set of `UserStatistic`. */
  userStatistics?: Maybe<UserStatisticsConnection>;
  userStatisticsByDay?: Maybe<UserStatisticsByDay>;
  /** Reads and enables pagination through a set of `UserStatisticsByDay`. */
  userStatisticsByDays?: Maybe<UserStatisticsByDaysConnection>;
  userStatisticsV2?: Maybe<UserStatisticsV2>;
  /** Reads and enables pagination through a set of `UserStatisticsV2`. */
  userStatisticsV2s?: Maybe<UserStatisticsV2sConnection>;
  userTokenSale?: Maybe<UserTokenSale>;
  userTokenSaleTransaction?: Maybe<UserTokenSaleTransaction>;
  /** Reads and enables pagination through a set of `UserTokenSaleTransaction`. */
  userTokenSaleTransactions?: Maybe<UserTokenSaleTransactionsConnection>;
  /** Reads and enables pagination through a set of `UserTokenSale`. */
  userTokenSales?: Maybe<UserTokenSalesConnection>;
  /** Reads and enables pagination through a set of `User`. */
  users?: Maybe<UsersConnection>;
  /** Reads and enables pagination through a set of `VersionInfo`. */
  versionInfos?: Maybe<VersionInfosConnection>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAppCoinflipLeaderboardLuckyBetsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AppCoinflipLeaderboardLuckyBetCondition>;
  filter?: InputMaybe<AppCoinflipLeaderboardLuckyBetFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AppCoinflipLeaderboardLuckyBetsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAuctionBasketArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAuctionBasketBetArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAuctionBasketBetsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AuctionBasketBetCondition>;
  filter?: InputMaybe<AuctionBasketBetFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AuctionBasketBetsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAuctionBasketsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AuctionBasketCondition>;
  filter?: InputMaybe<AuctionBasketFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AuctionBasketsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBankrollBalanceArgs = {
  contract: Scalars['String']['input'];
  denom: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBankrollBalancesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BankrollBalanceCondition>;
  filter?: InputMaybe<BankrollBalanceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BankrollBalancesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBetsHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BetsHistoryCondition>;
  filter?: InputMaybe<BetsHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BetsHistoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBetsHistoryArgs = {
  betId: Scalars['BigInt']['input'];
  game: Scalars['String']['input'];
  gameId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBetsHistoryByIdArgs = {
  _id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBonusBetsHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BonusBetsHistoryCondition>;
  filter?: InputMaybe<BonusBetsHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BonusBetsHistoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBonusBetsHistoryArgs = {
  betId: Scalars['BigInt']['input'];
  game: Scalars['String']['input'];
  gameId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryClaimHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ClaimHistoryCondition>;
  filter?: InputMaybe<ClaimHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ClaimHistoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryClaimHistoryArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCoinflipGameArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCoinflipGameRoundArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCoinflipGameRoundsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoinflipGameRoundCondition>;
  filter?: InputMaybe<CoinflipGameRoundFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoinflipGameRoundsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCoinflipGamesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoinflipGameCondition>;
  filter?: InputMaybe<CoinflipGameFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoinflipGamesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryContractConfigArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContractConfigsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ContractConfigCondition>;
  filter?: InputMaybe<ContractConfigFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContractConfigsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDoubleBetArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDoubleBetsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DoubleBetCondition>;
  filter?: InputMaybe<DoubleBetFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DoubleBetsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDoubleGameArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDoubleGamesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DoubleGameCondition>;
  filter?: InputMaybe<DoubleGameFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DoubleGamesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDoubleJackpotsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DoubleJackpotCondition>;
  filter?: InputMaybe<DoubleJackpotFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DoubleJackpotsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDoubleUserGamesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DoubleUserGameCondition>;
  filter?: InputMaybe<DoubleUserGameFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DoubleUserGamesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFeeDistributedHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FeeDistributedHistoryCondition>;
  filter?: InputMaybe<FeeDistributedHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FeeDistributedHistoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFeeDistributedHistoryArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGatewayChainTransactionArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGatewayChainTransactionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GatewayChainTransactionCondition>;
  filter?: InputMaybe<GatewayChainTransactionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GatewayChainTransactionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetPartnerUsersStatsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<GetPartnerUsersStatsRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  pFrom?: InputMaybe<Scalars['Datetime']['input']>;
  pPartnerAddress?: InputMaybe<Scalars['String']['input']>;
  pTo?: InputMaybe<Scalars['Datetime']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryInfoLast100WinBetsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<InfoLast100WinBetCondition>;
  filter?: InputMaybe<InfoLast100WinBetFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InfoLast100WinBetsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryJackpotBetArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryJackpotBetsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<JackpotBetCondition>;
  filter?: InputMaybe<JackpotBetFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<JackpotBetsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryJackpotGameArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryJackpotGamesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<JackpotGameCondition>;
  filter?: InputMaybe<JackpotGameFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<JackpotGamesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryJackpotUserGamesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<JackpotGameFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  player?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryJackpotUserGames2Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<JackpotUserGames2RecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  player?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLootboxArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLootboxGameArgs = {
  id: Scalars['BigInt']['input'];
  lootbox: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLootboxGamesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LootboxGameCondition>;
  filter?: InputMaybe<LootboxGameFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LootboxGamesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLootboxMarketOrderArgs = {
  orderId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLootboxMarketOrdersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LootboxMarketOrderCondition>;
  filter?: InputMaybe<LootboxMarketOrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LootboxMarketOrdersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLootboxMarketTradeArgs = {
  tradeId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLootboxMarketTradesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LootboxMarketTradeCondition>;
  filter?: InputMaybe<LootboxMarketTradeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LootboxMarketTradesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLootboxOrderBookArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<LootboxOrderBookRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lootbox?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  quote?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<LootboxMarketOrderType>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLootboxRewardArgs = {
  id: Scalars['String']['input'];
  lootbox: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLootboxRewardsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LootboxRewardCondition>;
  filter?: InputMaybe<LootboxRewardFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LootboxRewardsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLootboxSaleArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLootboxSalesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LootboxSaleCondition>;
  filter?: InputMaybe<LootboxSaleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LootboxSalesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLootboxUnlimitedGameArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLootboxUnlimitedGamesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LootboxUnlimitedGameCondition>;
  filter?: InputMaybe<LootboxUnlimitedGameFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LootboxUnlimitedGamesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLootboxesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LootboxCondition>;
  filter?: InputMaybe<LootboxFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LootboxesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLootboxesUnlimitedArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLootboxesUnlimitedsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LootboxesUnlimitedCondition>;
  filter?: InputMaybe<LootboxesUnlimitedFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LootboxesUnlimitedsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMinesGameArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMinesGameRoundArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMinesGameRoundsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MinesGameRoundCondition>;
  filter?: InputMaybe<MinesGameRoundFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MinesGameRoundsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMinesGamesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MinesGameCondition>;
  filter?: InputMaybe<MinesGameFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MinesGamesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNftArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNftVoteResultArgs = {
  proposalId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNftsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NftCondition>;
  filter?: InputMaybe<NftFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NftsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNftsVoteArgs = {
  address: Scalars['String']['input'];
  proposalId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNftsVotesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NftsVoteCondition>;
  filter?: InputMaybe<NftsVoteFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NftsVotesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOpenCompetitionEntitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OpenCompetitionEntityCondition>;
  filter?: InputMaybe<OpenCompetitionEntityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OpenCompetitionEntitiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOpenCompetitionEntityArgs = {
  player: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOpenCompetitionLeaderBoardsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OpenCompetitionLeaderBoardCondition>;
  filter?: InputMaybe<OpenCompetitionLeaderBoardFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OpenCompetitionLeaderBoardsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPlinkoGameArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPlinkoGamesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PlinkoGameCondition>;
  filter?: InputMaybe<PlinkoGameFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PlinkoGamesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPointTransactionArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPointTransactionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PointTransactionCondition>;
  filter?: InputMaybe<PointTransactionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PointTransactionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRngRoundArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRngRoundsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RngRoundCondition>;
  filter?: InputMaybe<RngRoundFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RngRoundsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoshamboGameArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoshamboGameLogArgs = {
  eventId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoshamboGameLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RoshamboGameLogCondition>;
  filter?: InputMaybe<RoshamboGameLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RoshamboGameLogsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoshamboGamesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RoshamboGameCondition>;
  filter?: InputMaybe<RoshamboGameFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RoshamboGamesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRunesGameArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRunesGamesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RunesGameCondition>;
  filter?: InputMaybe<RunesGameFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RunesGamesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryStatisticArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<StatisticCondition>;
  filter?: InputMaybe<StatisticFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<StatisticsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryStatisticsV2Args = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryStatisticsV2sArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<StatisticsV2Condition>;
  filter?: InputMaybe<StatisticsV2Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<StatisticsV2sOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTokenBurnHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TokenBurnHistoryCondition>;
  filter?: InputMaybe<TokenBurnHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TokenBurnHistoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTokenBurnHistoryArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTokenClaimArgs = {
  contractAddress: Scalars['String']['input'];
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTokenClaimsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TokenClaimCondition>;
  filter?: InputMaybe<TokenClaimFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TokenClaimsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTokenPriceArgs = {
  symbol: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTokenPricesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TokenPriceCondition>;
  filter?: InputMaybe<TokenPriceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TokenPricesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTokenSalesInfoArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTokenSalesInfosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TokenSalesInfoCondition>;
  filter?: InputMaybe<TokenSalesInfoFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TokenSalesInfosOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTokenSalesPriceInfoArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTokenSalesPriceInfosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TokenSalesPriceInfoCondition>;
  filter?: InputMaybe<TokenSalesPriceInfoFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TokenSalesPriceInfosOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserBetHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserBetHistoryCondition>;
  filter?: InputMaybe<UserBetHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserBetHistoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserBetHistoryArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserCompetitionArgs = {
  competition: Scalars['String']['input'];
  player: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserCompetitionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCompetitionCondition>;
  filter?: InputMaybe<UserCompetitionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserCompetitionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserStatisticArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserStatisticCondition>;
  filter?: InputMaybe<UserStatisticFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserStatisticsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserStatisticsByDayArgs = {
  date: Scalars['Date']['input'];
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserStatisticsByDaysArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserStatisticsByDayCondition>;
  filter?: InputMaybe<UserStatisticsByDayFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserStatisticsByDaysOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserStatisticsV2Args = {
  player: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserStatisticsV2sArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserStatisticsV2Condition>;
  filter?: InputMaybe<UserStatisticsV2Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserStatisticsV2sOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserTokenSaleArgs = {
  player: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserTokenSaleTransactionArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserTokenSaleTransactionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserTokenSaleTransactionCondition>;
  filter?: InputMaybe<UserTokenSaleTransactionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserTokenSaleTransactionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserTokenSalesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserTokenSaleCondition>;
  filter?: InputMaybe<UserTokenSaleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserTokenSalesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryVersionInfosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VersionInfoCondition>;
  filter?: InputMaybe<VersionInfoFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VersionInfosOrderBy>>;
};

export type RngRound = {
  __typename?: 'RngRound';
  id: Scalars['Int']['output'];
};

/**
 * A condition to be used against `RngRound` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type RngRoundCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `RngRound` object types. All fields are combined with a logical ‘and.’ */
export type RngRoundFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RngRoundFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RngRoundFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RngRoundFilter>>;
};

/** An input for mutations affecting `RngRound` */
export type RngRoundInput = {
  id: Scalars['Int']['input'];
};

/** Represents an update to a `RngRound`. Fields that are set will be updated. */
export type RngRoundPatch = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `RngRound` values. */
export type RngRoundsConnection = {
  __typename?: 'RngRoundsConnection';
  /** A list of edges which contains the `RngRound` and cursor to aid in pagination. */
  edges: Array<RngRoundsEdge>;
  /** A list of `RngRound` objects. */
  nodes: Array<Maybe<RngRound>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RngRound` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `RngRound` edge in the connection. */
export type RngRoundsEdge = {
  __typename?: 'RngRoundsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `RngRound` at the end of the edge. */
  node?: Maybe<RngRound>;
};

/** Methods to use when ordering `RngRound`. */
export enum RngRoundsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type RoshamboGame = {
  __typename?: 'RoshamboGame';
  bet: Scalars['BigFloat']['output'];
  created: Scalars['Datetime']['output'];
  gameResult?: Maybe<GameResult>;
  id: Scalars['BigInt']['output'];
  modified: Scalars['Datetime']['output'];
  player1: Scalars['String']['output'];
  player1Choice?: Maybe<RoshamboGameChoice>;
  player2: Scalars['String']['output'];
  player2Choice?: Maybe<RoshamboGameChoice>;
  state: GameState;
};

export enum RoshamboGameChoice {
  Paper = 'PAPER',
  Rock = 'ROCK',
  Scissors = 'SCISSORS'
}

/** A filter to be used against RoshamboGameChoice fields. All fields are combined with a logical ‘and.’ */
export type RoshamboGameChoiceFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<RoshamboGameChoice>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<RoshamboGameChoice>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<RoshamboGameChoice>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<RoshamboGameChoice>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<RoshamboGameChoice>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<RoshamboGameChoice>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<RoshamboGameChoice>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<RoshamboGameChoice>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<RoshamboGameChoice>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<RoshamboGameChoice>>;
};

/**
 * A condition to be used against `RoshamboGame` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoshamboGameCondition = {
  /** Checks for equality with the object’s `bet` field. */
  bet?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `gameResult` field. */
  gameResult?: InputMaybe<GameResult>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `modified` field. */
  modified?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `player1` field. */
  player1?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `player1Choice` field. */
  player1Choice?: InputMaybe<RoshamboGameChoice>;
  /** Checks for equality with the object’s `player2` field. */
  player2?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `player2Choice` field. */
  player2Choice?: InputMaybe<RoshamboGameChoice>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<GameState>;
};

/** A filter to be used against `RoshamboGame` object types. All fields are combined with a logical ‘and.’ */
export type RoshamboGameFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoshamboGameFilter>>;
  /** Filter by the object’s `bet` field. */
  bet?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `gameResult` field. */
  gameResult?: InputMaybe<GameResultFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `modified` field. */
  modified?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoshamboGameFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoshamboGameFilter>>;
  /** Filter by the object’s `player1` field. */
  player1?: InputMaybe<StringFilter>;
  /** Filter by the object’s `player1Choice` field. */
  player1Choice?: InputMaybe<RoshamboGameChoiceFilter>;
  /** Filter by the object’s `player2` field. */
  player2?: InputMaybe<StringFilter>;
  /** Filter by the object’s `player2Choice` field. */
  player2Choice?: InputMaybe<RoshamboGameChoiceFilter>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<GameStateFilter>;
};

/** An input for mutations affecting `RoshamboGame` */
export type RoshamboGameInput = {
  bet: Scalars['BigFloat']['input'];
  created: Scalars['Datetime']['input'];
  gameResult?: InputMaybe<GameResult>;
  id: Scalars['BigInt']['input'];
  modified: Scalars['Datetime']['input'];
  player1: Scalars['String']['input'];
  player1Choice?: InputMaybe<RoshamboGameChoice>;
  player2: Scalars['String']['input'];
  player2Choice?: InputMaybe<RoshamboGameChoice>;
  state: GameState;
};

export type RoshamboGameLog = {
  __typename?: 'RoshamboGameLog';
  created: Scalars['Datetime']['output'];
  event: Scalars['String']['output'];
  eventId: Scalars['BigInt']['output'];
  gameId: Scalars['BigInt']['output'];
  txHash: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `RoshamboGameLog` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoshamboGameLogCondition = {
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `event` field. */
  event?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `gameId` field. */
  gameId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `txHash` field. */
  txHash?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `RoshamboGameLog` object types. All fields are combined with a logical ‘and.’ */
export type RoshamboGameLogFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoshamboGameLogFilter>>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `event` field. */
  event?: InputMaybe<StringFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `gameId` field. */
  gameId?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoshamboGameLogFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoshamboGameLogFilter>>;
  /** Filter by the object’s `txHash` field. */
  txHash?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `RoshamboGameLog` */
export type RoshamboGameLogInput = {
  created: Scalars['Datetime']['input'];
  event: Scalars['String']['input'];
  eventId: Scalars['BigInt']['input'];
  gameId: Scalars['BigInt']['input'];
  txHash: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an update to a `RoshamboGameLog`. Fields that are set will be updated. */
export type RoshamboGameLogPatch = {
  created?: InputMaybe<Scalars['Datetime']['input']>;
  event?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['BigInt']['input']>;
  gameId?: InputMaybe<Scalars['BigInt']['input']>;
  txHash?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `RoshamboGameLog` values. */
export type RoshamboGameLogsConnection = {
  __typename?: 'RoshamboGameLogsConnection';
  /** A list of edges which contains the `RoshamboGameLog` and cursor to aid in pagination. */
  edges: Array<RoshamboGameLogsEdge>;
  /** A list of `RoshamboGameLog` objects. */
  nodes: Array<Maybe<RoshamboGameLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoshamboGameLog` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `RoshamboGameLog` edge in the connection. */
export type RoshamboGameLogsEdge = {
  __typename?: 'RoshamboGameLogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `RoshamboGameLog` at the end of the edge. */
  node?: Maybe<RoshamboGameLog>;
};

/** Methods to use when ordering `RoshamboGameLog`. */
export enum RoshamboGameLogsOrderBy {
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  EventAsc = 'EVENT_ASC',
  EventDesc = 'EVENT_DESC',
  EventIdAsc = 'EVENT_ID_ASC',
  EventIdDesc = 'EVENT_ID_DESC',
  GameIdAsc = 'GAME_ID_ASC',
  GameIdDesc = 'GAME_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TxHashAsc = 'TX_HASH_ASC',
  TxHashDesc = 'TX_HASH_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** Represents an update to a `RoshamboGame`. Fields that are set will be updated. */
export type RoshamboGamePatch = {
  bet?: InputMaybe<Scalars['BigFloat']['input']>;
  created?: InputMaybe<Scalars['Datetime']['input']>;
  gameResult?: InputMaybe<GameResult>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  modified?: InputMaybe<Scalars['Datetime']['input']>;
  player1?: InputMaybe<Scalars['String']['input']>;
  player1Choice?: InputMaybe<RoshamboGameChoice>;
  player2?: InputMaybe<Scalars['String']['input']>;
  player2Choice?: InputMaybe<RoshamboGameChoice>;
  state?: InputMaybe<GameState>;
};

/** A connection to a list of `RoshamboGame` values. */
export type RoshamboGamesConnection = {
  __typename?: 'RoshamboGamesConnection';
  /** A list of edges which contains the `RoshamboGame` and cursor to aid in pagination. */
  edges: Array<RoshamboGamesEdge>;
  /** A list of `RoshamboGame` objects. */
  nodes: Array<Maybe<RoshamboGame>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoshamboGame` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `RoshamboGame` edge in the connection. */
export type RoshamboGamesEdge = {
  __typename?: 'RoshamboGamesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `RoshamboGame` at the end of the edge. */
  node?: Maybe<RoshamboGame>;
};

/** Methods to use when ordering `RoshamboGame`. */
export enum RoshamboGamesOrderBy {
  BetAsc = 'BET_ASC',
  BetDesc = 'BET_DESC',
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  GameResultAsc = 'GAME_RESULT_ASC',
  GameResultDesc = 'GAME_RESULT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  ModifiedAsc = 'MODIFIED_ASC',
  ModifiedDesc = 'MODIFIED_DESC',
  Natural = 'NATURAL',
  Player1Asc = 'PLAYER1_ASC',
  Player1ChoiceAsc = 'PLAYER1_CHOICE_ASC',
  Player1ChoiceDesc = 'PLAYER1_CHOICE_DESC',
  Player1Desc = 'PLAYER1_DESC',
  Player2Asc = 'PLAYER2_ASC',
  Player2ChoiceAsc = 'PLAYER2_CHOICE_ASC',
  Player2ChoiceDesc = 'PLAYER2_CHOICE_DESC',
  Player2Desc = 'PLAYER2_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC'
}

export type RunesGame = {
  __typename?: 'RunesGame';
  bet: Scalars['BigFloat']['output'];
  betNormalize: Scalars['BigInt']['output'];
  betUsd: Scalars['BigInt']['output'];
  created: Scalars['Datetime']['output'];
  denom: Scalars['String']['output'];
  id: Scalars['BigInt']['output'];
  payout: Scalars['BigFloat']['output'];
  payoutNormalize: Scalars['BigInt']['output'];
  payoutUsd: Scalars['BigInt']['output'];
  player: Scalars['String']['output'];
  randomRound: Scalars['BigInt']['output'];
  result?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  result2?: Maybe<Scalars['String']['output']>;
  risk: GameRisk;
  status: GameStatus;
  symbol: Scalars['String']['output'];
  txHash: Scalars['String']['output'];
  updated: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `RunesGame` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type RunesGameCondition = {
  /** Checks for equality with the object’s `bet` field. */
  bet?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `betNormalize` field. */
  betNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `betUsd` field. */
  betUsd?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `denom` field. */
  denom?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `payout` field. */
  payout?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `payoutNormalize` field. */
  payoutNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `payoutUsd` field. */
  payoutUsd?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `player` field. */
  player?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `randomRound` field. */
  randomRound?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `result` field. */
  result?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Checks for equality with the object’s `result2` field. */
  result2?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `risk` field. */
  risk?: InputMaybe<GameRisk>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<GameStatus>;
  /** Checks for equality with the object’s `symbol` field. */
  symbol?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `txHash` field. */
  txHash?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updated` field. */
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `RunesGame` object types. All fields are combined with a logical ‘and.’ */
export type RunesGameFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RunesGameFilter>>;
  /** Filter by the object’s `bet` field. */
  bet?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `betNormalize` field. */
  betNormalize?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `betUsd` field. */
  betUsd?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `denom` field. */
  denom?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RunesGameFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RunesGameFilter>>;
  /** Filter by the object’s `payout` field. */
  payout?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `payoutNormalize` field. */
  payoutNormalize?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `payoutUsd` field. */
  payoutUsd?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `player` field. */
  player?: InputMaybe<StringFilter>;
  /** Filter by the object’s `randomRound` field. */
  randomRound?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `result` field. */
  result?: InputMaybe<IntListFilter>;
  /** Filter by the object’s `result2` field. */
  result2?: InputMaybe<StringFilter>;
  /** Filter by the object’s `risk` field. */
  risk?: InputMaybe<GameRiskFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<GameStatusFilter>;
  /** Filter by the object’s `symbol` field. */
  symbol?: InputMaybe<StringFilter>;
  /** Filter by the object’s `txHash` field. */
  txHash?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updated` field. */
  updated?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `RunesGame` */
export type RunesGameInput = {
  bet: Scalars['BigFloat']['input'];
  betNormalize: Scalars['BigInt']['input'];
  betUsd: Scalars['BigInt']['input'];
  created: Scalars['Datetime']['input'];
  denom: Scalars['String']['input'];
  id: Scalars['BigInt']['input'];
  payout: Scalars['BigFloat']['input'];
  payoutNormalize: Scalars['BigInt']['input'];
  payoutUsd: Scalars['BigInt']['input'];
  player: Scalars['String']['input'];
  randomRound: Scalars['BigInt']['input'];
  result?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  result2?: InputMaybe<Scalars['String']['input']>;
  risk: GameRisk;
  status: GameStatus;
  symbol: Scalars['String']['input'];
  txHash: Scalars['String']['input'];
  updated: Scalars['Datetime']['input'];
};

/** Represents an update to a `RunesGame`. Fields that are set will be updated. */
export type RunesGamePatch = {
  bet?: InputMaybe<Scalars['BigFloat']['input']>;
  betNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  betUsd?: InputMaybe<Scalars['BigInt']['input']>;
  created?: InputMaybe<Scalars['Datetime']['input']>;
  denom?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  payout?: InputMaybe<Scalars['BigFloat']['input']>;
  payoutNormalize?: InputMaybe<Scalars['BigInt']['input']>;
  payoutUsd?: InputMaybe<Scalars['BigInt']['input']>;
  player?: InputMaybe<Scalars['String']['input']>;
  randomRound?: InputMaybe<Scalars['BigInt']['input']>;
  result?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  result2?: InputMaybe<Scalars['String']['input']>;
  risk?: InputMaybe<GameRisk>;
  status?: InputMaybe<GameStatus>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  txHash?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `RunesGame` values. */
export type RunesGamesConnection = {
  __typename?: 'RunesGamesConnection';
  /** A list of edges which contains the `RunesGame` and cursor to aid in pagination. */
  edges: Array<RunesGamesEdge>;
  /** A list of `RunesGame` objects. */
  nodes: Array<Maybe<RunesGame>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RunesGame` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `RunesGame` edge in the connection. */
export type RunesGamesEdge = {
  __typename?: 'RunesGamesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `RunesGame` at the end of the edge. */
  node?: Maybe<RunesGame>;
};

/** Methods to use when ordering `RunesGame`. */
export enum RunesGamesOrderBy {
  BetAsc = 'BET_ASC',
  BetDesc = 'BET_DESC',
  BetNormalizeAsc = 'BET_NORMALIZE_ASC',
  BetNormalizeDesc = 'BET_NORMALIZE_DESC',
  BetUsdAsc = 'BET_USD_ASC',
  BetUsdDesc = 'BET_USD_DESC',
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  DenomAsc = 'DENOM_ASC',
  DenomDesc = 'DENOM_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PayoutAsc = 'PAYOUT_ASC',
  PayoutDesc = 'PAYOUT_DESC',
  PayoutNormalizeAsc = 'PAYOUT_NORMALIZE_ASC',
  PayoutNormalizeDesc = 'PAYOUT_NORMALIZE_DESC',
  PayoutUsdAsc = 'PAYOUT_USD_ASC',
  PayoutUsdDesc = 'PAYOUT_USD_DESC',
  PlayerAsc = 'PLAYER_ASC',
  PlayerDesc = 'PLAYER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RandomRoundAsc = 'RANDOM_ROUND_ASC',
  RandomRoundDesc = 'RANDOM_ROUND_DESC',
  Result2Asc = 'RESULT2_ASC',
  Result2Desc = 'RESULT2_DESC',
  ResultAsc = 'RESULT_ASC',
  ResultDesc = 'RESULT_DESC',
  RiskAsc = 'RISK_ASC',
  RiskDesc = 'RISK_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  SymbolAsc = 'SYMBOL_ASC',
  SymbolDesc = 'SYMBOL_DESC',
  TxHashAsc = 'TX_HASH_ASC',
  TxHashDesc = 'TX_HASH_DESC',
  UpdatedAsc = 'UPDATED_ASC',
  UpdatedDesc = 'UPDATED_DESC'
}

export type Statistic = {
  __typename?: 'Statistic';
  auctionBurnToken?: Maybe<Scalars['BigInt']['output']>;
  claimsCount: Scalars['BigInt']['output'];
  coinflipBetAmount: Scalars['BigFloat']['output'];
  coinflipBetCount: Scalars['BigInt']['output'];
  coinflipGameCount: Scalars['BigInt']['output'];
  coinflipTopWinAmount: Scalars['BigFloat']['output'];
  coinflipWinAmount: Scalars['BigFloat']['output'];
  doubleBetAmount: Scalars['BigFloat']['output'];
  doubleBetCount: Scalars['BigInt']['output'];
  doubleGameCount: Scalars['BigInt']['output'];
  doubleTopWinAmount: Scalars['BigFloat']['output'];
  doubleWinAmount: Scalars['BigFloat']['output'];
  feeDistributedAmount: Scalars['BigFloat']['output'];
  id: Scalars['Int']['output'];
  jackpotBetAmount: Scalars['BigFloat']['output'];
  jackpotBetCount: Scalars['BigInt']['output'];
  jackpotGameCount: Scalars['BigInt']['output'];
  jackpotTopWinAmount: Scalars['BigFloat']['output'];
  jackpotWinAmount: Scalars['BigFloat']['output'];
  lootboxBetAmount?: Maybe<Scalars['BigFloat']['output']>;
  lootboxBetCount?: Maybe<Scalars['BigInt']['output']>;
  lootboxGameCount?: Maybe<Scalars['BigInt']['output']>;
  lootboxTopWinAmount?: Maybe<Scalars['BigFloat']['output']>;
  lootboxWinAmount?: Maybe<Scalars['BigFloat']['output']>;
  minesBetAmount: Scalars['BigFloat']['output'];
  minesBetCount: Scalars['BigInt']['output'];
  minesGameCount: Scalars['BigInt']['output'];
  minesTopWinAmount: Scalars['BigFloat']['output'];
  minesWinAmount: Scalars['BigFloat']['output'];
  roshamboBetAmount: Scalars['BigFloat']['output'];
  roshamboBetCount: Scalars['BigInt']['output'];
  roshamboGameCount: Scalars['BigInt']['output'];
  roshamboTopWinAmount: Scalars['BigFloat']['output'];
  roshamboWinAmount: Scalars['BigFloat']['output'];
  txsCount?: Maybe<Scalars['BigInt']['output']>;
  uniqueClaimsCount: Scalars['BigInt']['output'];
  usersCount: Scalars['BigInt']['output'];
  usersWithRefererCount: Scalars['BigInt']['output'];
};

/**
 * A condition to be used against `Statistic` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type StatisticCondition = {
  /** Checks for equality with the object’s `auctionBurnToken` field. */
  auctionBurnToken?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `claimsCount` field. */
  claimsCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `coinflipBetAmount` field. */
  coinflipBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `coinflipBetCount` field. */
  coinflipBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `coinflipGameCount` field. */
  coinflipGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `coinflipTopWinAmount` field. */
  coinflipTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `coinflipWinAmount` field. */
  coinflipWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `doubleBetAmount` field. */
  doubleBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `doubleBetCount` field. */
  doubleBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `doubleGameCount` field. */
  doubleGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `doubleTopWinAmount` field. */
  doubleTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `doubleWinAmount` field. */
  doubleWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `feeDistributedAmount` field. */
  feeDistributedAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `jackpotBetAmount` field. */
  jackpotBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `jackpotBetCount` field. */
  jackpotBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `jackpotGameCount` field. */
  jackpotGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `jackpotTopWinAmount` field. */
  jackpotTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `jackpotWinAmount` field. */
  jackpotWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `lootboxBetAmount` field. */
  lootboxBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `lootboxBetCount` field. */
  lootboxBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `lootboxGameCount` field. */
  lootboxGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `lootboxTopWinAmount` field. */
  lootboxTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `lootboxWinAmount` field. */
  lootboxWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `minesBetAmount` field. */
  minesBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `minesBetCount` field. */
  minesBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `minesGameCount` field. */
  minesGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `minesTopWinAmount` field. */
  minesTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `minesWinAmount` field. */
  minesWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `roshamboBetAmount` field. */
  roshamboBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `roshamboBetCount` field. */
  roshamboBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `roshamboGameCount` field. */
  roshamboGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `roshamboTopWinAmount` field. */
  roshamboTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `roshamboWinAmount` field. */
  roshamboWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `txsCount` field. */
  txsCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `uniqueClaimsCount` field. */
  uniqueClaimsCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `usersCount` field. */
  usersCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `usersWithRefererCount` field. */
  usersWithRefererCount?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `Statistic` object types. All fields are combined with a logical ‘and.’ */
export type StatisticFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<StatisticFilter>>;
  /** Filter by the object’s `auctionBurnToken` field. */
  auctionBurnToken?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `claimsCount` field. */
  claimsCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `coinflipBetAmount` field. */
  coinflipBetAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `coinflipBetCount` field. */
  coinflipBetCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `coinflipGameCount` field. */
  coinflipGameCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `coinflipTopWinAmount` field. */
  coinflipTopWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `coinflipWinAmount` field. */
  coinflipWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `doubleBetAmount` field. */
  doubleBetAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `doubleBetCount` field. */
  doubleBetCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `doubleGameCount` field. */
  doubleGameCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `doubleTopWinAmount` field. */
  doubleTopWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `doubleWinAmount` field. */
  doubleWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `feeDistributedAmount` field. */
  feeDistributedAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `jackpotBetAmount` field. */
  jackpotBetAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `jackpotBetCount` field. */
  jackpotBetCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `jackpotGameCount` field. */
  jackpotGameCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `jackpotTopWinAmount` field. */
  jackpotTopWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `jackpotWinAmount` field. */
  jackpotWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `lootboxBetAmount` field. */
  lootboxBetAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `lootboxBetCount` field. */
  lootboxBetCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `lootboxGameCount` field. */
  lootboxGameCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `lootboxTopWinAmount` field. */
  lootboxTopWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `lootboxWinAmount` field. */
  lootboxWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `minesBetAmount` field. */
  minesBetAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `minesBetCount` field. */
  minesBetCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `minesGameCount` field. */
  minesGameCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `minesTopWinAmount` field. */
  minesTopWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `minesWinAmount` field. */
  minesWinAmount?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<StatisticFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<StatisticFilter>>;
  /** Filter by the object’s `roshamboBetAmount` field. */
  roshamboBetAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `roshamboBetCount` field. */
  roshamboBetCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `roshamboGameCount` field. */
  roshamboGameCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `roshamboTopWinAmount` field. */
  roshamboTopWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `roshamboWinAmount` field. */
  roshamboWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `txsCount` field. */
  txsCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `uniqueClaimsCount` field. */
  uniqueClaimsCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `usersCount` field. */
  usersCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `usersWithRefererCount` field. */
  usersWithRefererCount?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `Statistic` */
export type StatisticInput = {
  auctionBurnToken?: InputMaybe<Scalars['BigInt']['input']>;
  claimsCount: Scalars['BigInt']['input'];
  coinflipBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  coinflipBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  coinflipGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  coinflipTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  coinflipWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  doubleBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  doubleBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  doubleGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  doubleTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  doubleWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  feeDistributedAmount: Scalars['BigFloat']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  jackpotBetAmount: Scalars['BigFloat']['input'];
  jackpotBetCount: Scalars['BigInt']['input'];
  jackpotGameCount: Scalars['BigInt']['input'];
  jackpotTopWinAmount: Scalars['BigFloat']['input'];
  jackpotWinAmount: Scalars['BigFloat']['input'];
  lootboxBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  lootboxBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  lootboxGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  lootboxTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  lootboxWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  minesBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  minesBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  minesGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  minesTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  minesWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  roshamboBetAmount: Scalars['BigFloat']['input'];
  roshamboBetCount: Scalars['BigInt']['input'];
  roshamboGameCount: Scalars['BigInt']['input'];
  roshamboTopWinAmount: Scalars['BigFloat']['input'];
  roshamboWinAmount: Scalars['BigFloat']['input'];
  txsCount?: InputMaybe<Scalars['BigInt']['input']>;
  uniqueClaimsCount: Scalars['BigInt']['input'];
  usersCount: Scalars['BigInt']['input'];
  usersWithRefererCount: Scalars['BigInt']['input'];
};

/** Represents an update to a `Statistic`. Fields that are set will be updated. */
export type StatisticPatch = {
  auctionBurnToken?: InputMaybe<Scalars['BigInt']['input']>;
  claimsCount?: InputMaybe<Scalars['BigInt']['input']>;
  coinflipBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  coinflipBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  coinflipGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  coinflipTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  coinflipWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  doubleBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  doubleBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  doubleGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  doubleTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  doubleWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  feeDistributedAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  jackpotBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  jackpotBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  jackpotGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  jackpotTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  jackpotWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  lootboxBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  lootboxBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  lootboxGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  lootboxTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  lootboxWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  minesBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  minesBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  minesGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  minesTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  minesWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  roshamboBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  roshamboBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  roshamboGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  roshamboTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  roshamboWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  txsCount?: InputMaybe<Scalars['BigInt']['input']>;
  uniqueClaimsCount?: InputMaybe<Scalars['BigInt']['input']>;
  usersCount?: InputMaybe<Scalars['BigInt']['input']>;
  usersWithRefererCount?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A connection to a list of `Statistic` values. */
export type StatisticsConnection = {
  __typename?: 'StatisticsConnection';
  /** A list of edges which contains the `Statistic` and cursor to aid in pagination. */
  edges: Array<StatisticsEdge>;
  /** A list of `Statistic` objects. */
  nodes: Array<Maybe<Statistic>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Statistic` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Statistic` edge in the connection. */
export type StatisticsEdge = {
  __typename?: 'StatisticsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Statistic` at the end of the edge. */
  node?: Maybe<Statistic>;
};

/** Methods to use when ordering `Statistic`. */
export enum StatisticsOrderBy {
  AuctionBurnTokenAsc = 'AUCTION_BURN_TOKEN_ASC',
  AuctionBurnTokenDesc = 'AUCTION_BURN_TOKEN_DESC',
  ClaimsCountAsc = 'CLAIMS_COUNT_ASC',
  ClaimsCountDesc = 'CLAIMS_COUNT_DESC',
  CoinflipBetAmountAsc = 'COINFLIP_BET_AMOUNT_ASC',
  CoinflipBetAmountDesc = 'COINFLIP_BET_AMOUNT_DESC',
  CoinflipBetCountAsc = 'COINFLIP_BET_COUNT_ASC',
  CoinflipBetCountDesc = 'COINFLIP_BET_COUNT_DESC',
  CoinflipGameCountAsc = 'COINFLIP_GAME_COUNT_ASC',
  CoinflipGameCountDesc = 'COINFLIP_GAME_COUNT_DESC',
  CoinflipTopWinAmountAsc = 'COINFLIP_TOP_WIN_AMOUNT_ASC',
  CoinflipTopWinAmountDesc = 'COINFLIP_TOP_WIN_AMOUNT_DESC',
  CoinflipWinAmountAsc = 'COINFLIP_WIN_AMOUNT_ASC',
  CoinflipWinAmountDesc = 'COINFLIP_WIN_AMOUNT_DESC',
  DoubleBetAmountAsc = 'DOUBLE_BET_AMOUNT_ASC',
  DoubleBetAmountDesc = 'DOUBLE_BET_AMOUNT_DESC',
  DoubleBetCountAsc = 'DOUBLE_BET_COUNT_ASC',
  DoubleBetCountDesc = 'DOUBLE_BET_COUNT_DESC',
  DoubleGameCountAsc = 'DOUBLE_GAME_COUNT_ASC',
  DoubleGameCountDesc = 'DOUBLE_GAME_COUNT_DESC',
  DoubleTopWinAmountAsc = 'DOUBLE_TOP_WIN_AMOUNT_ASC',
  DoubleTopWinAmountDesc = 'DOUBLE_TOP_WIN_AMOUNT_DESC',
  DoubleWinAmountAsc = 'DOUBLE_WIN_AMOUNT_ASC',
  DoubleWinAmountDesc = 'DOUBLE_WIN_AMOUNT_DESC',
  FeeDistributedAmountAsc = 'FEE_DISTRIBUTED_AMOUNT_ASC',
  FeeDistributedAmountDesc = 'FEE_DISTRIBUTED_AMOUNT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  JackpotBetAmountAsc = 'JACKPOT_BET_AMOUNT_ASC',
  JackpotBetAmountDesc = 'JACKPOT_BET_AMOUNT_DESC',
  JackpotBetCountAsc = 'JACKPOT_BET_COUNT_ASC',
  JackpotBetCountDesc = 'JACKPOT_BET_COUNT_DESC',
  JackpotGameCountAsc = 'JACKPOT_GAME_COUNT_ASC',
  JackpotGameCountDesc = 'JACKPOT_GAME_COUNT_DESC',
  JackpotTopWinAmountAsc = 'JACKPOT_TOP_WIN_AMOUNT_ASC',
  JackpotTopWinAmountDesc = 'JACKPOT_TOP_WIN_AMOUNT_DESC',
  JackpotWinAmountAsc = 'JACKPOT_WIN_AMOUNT_ASC',
  JackpotWinAmountDesc = 'JACKPOT_WIN_AMOUNT_DESC',
  LootboxBetAmountAsc = 'LOOTBOX_BET_AMOUNT_ASC',
  LootboxBetAmountDesc = 'LOOTBOX_BET_AMOUNT_DESC',
  LootboxBetCountAsc = 'LOOTBOX_BET_COUNT_ASC',
  LootboxBetCountDesc = 'LOOTBOX_BET_COUNT_DESC',
  LootboxGameCountAsc = 'LOOTBOX_GAME_COUNT_ASC',
  LootboxGameCountDesc = 'LOOTBOX_GAME_COUNT_DESC',
  LootboxTopWinAmountAsc = 'LOOTBOX_TOP_WIN_AMOUNT_ASC',
  LootboxTopWinAmountDesc = 'LOOTBOX_TOP_WIN_AMOUNT_DESC',
  LootboxWinAmountAsc = 'LOOTBOX_WIN_AMOUNT_ASC',
  LootboxWinAmountDesc = 'LOOTBOX_WIN_AMOUNT_DESC',
  MinesBetAmountAsc = 'MINES_BET_AMOUNT_ASC',
  MinesBetAmountDesc = 'MINES_BET_AMOUNT_DESC',
  MinesBetCountAsc = 'MINES_BET_COUNT_ASC',
  MinesBetCountDesc = 'MINES_BET_COUNT_DESC',
  MinesGameCountAsc = 'MINES_GAME_COUNT_ASC',
  MinesGameCountDesc = 'MINES_GAME_COUNT_DESC',
  MinesTopWinAmountAsc = 'MINES_TOP_WIN_AMOUNT_ASC',
  MinesTopWinAmountDesc = 'MINES_TOP_WIN_AMOUNT_DESC',
  MinesWinAmountAsc = 'MINES_WIN_AMOUNT_ASC',
  MinesWinAmountDesc = 'MINES_WIN_AMOUNT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoshamboBetAmountAsc = 'ROSHAMBO_BET_AMOUNT_ASC',
  RoshamboBetAmountDesc = 'ROSHAMBO_BET_AMOUNT_DESC',
  RoshamboBetCountAsc = 'ROSHAMBO_BET_COUNT_ASC',
  RoshamboBetCountDesc = 'ROSHAMBO_BET_COUNT_DESC',
  RoshamboGameCountAsc = 'ROSHAMBO_GAME_COUNT_ASC',
  RoshamboGameCountDesc = 'ROSHAMBO_GAME_COUNT_DESC',
  RoshamboTopWinAmountAsc = 'ROSHAMBO_TOP_WIN_AMOUNT_ASC',
  RoshamboTopWinAmountDesc = 'ROSHAMBO_TOP_WIN_AMOUNT_DESC',
  RoshamboWinAmountAsc = 'ROSHAMBO_WIN_AMOUNT_ASC',
  RoshamboWinAmountDesc = 'ROSHAMBO_WIN_AMOUNT_DESC',
  TxsCountAsc = 'TXS_COUNT_ASC',
  TxsCountDesc = 'TXS_COUNT_DESC',
  UniqueClaimsCountAsc = 'UNIQUE_CLAIMS_COUNT_ASC',
  UniqueClaimsCountDesc = 'UNIQUE_CLAIMS_COUNT_DESC',
  UsersCountAsc = 'USERS_COUNT_ASC',
  UsersCountDesc = 'USERS_COUNT_DESC',
  UsersWithRefererCountAsc = 'USERS_WITH_REFERER_COUNT_ASC',
  UsersWithRefererCountDesc = 'USERS_WITH_REFERER_COUNT_DESC'
}

export type StatisticsV2 = {
  __typename?: 'StatisticsV2';
  activeUsers: Scalars['BigInt']['output'];
  betAmount: Scalars['BigFloat']['output'];
  betCount: Scalars['BigInt']['output'];
  id: Scalars['Int']['output'];
  maxPayout: Scalars['BigFloat']['output'];
  payoutAmount: Scalars['BigFloat']['output'];
  payoutCount: Scalars['BigInt']['output'];
  winCount: Scalars['BigInt']['output'];
};

/**
 * A condition to be used against `StatisticsV2` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type StatisticsV2Condition = {
  /** Checks for equality with the object’s `activeUsers` field. */
  activeUsers?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `betAmount` field. */
  betAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `betCount` field. */
  betCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `maxPayout` field. */
  maxPayout?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `payoutAmount` field. */
  payoutAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `payoutCount` field. */
  payoutCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `winCount` field. */
  winCount?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `StatisticsV2` object types. All fields are combined with a logical ‘and.’ */
export type StatisticsV2Filter = {
  /** Filter by the object’s `activeUsers` field. */
  activeUsers?: InputMaybe<BigIntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<StatisticsV2Filter>>;
  /** Filter by the object’s `betAmount` field. */
  betAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `betCount` field. */
  betCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `maxPayout` field. */
  maxPayout?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<StatisticsV2Filter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<StatisticsV2Filter>>;
  /** Filter by the object’s `payoutAmount` field. */
  payoutAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `payoutCount` field. */
  payoutCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `winCount` field. */
  winCount?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `StatisticsV2` */
export type StatisticsV2Input = {
  activeUsers: Scalars['BigInt']['input'];
  betAmount: Scalars['BigFloat']['input'];
  betCount: Scalars['BigInt']['input'];
  id: Scalars['Int']['input'];
  maxPayout: Scalars['BigFloat']['input'];
  payoutAmount: Scalars['BigFloat']['input'];
  payoutCount: Scalars['BigInt']['input'];
  winCount: Scalars['BigInt']['input'];
};

/** Represents an update to a `StatisticsV2`. Fields that are set will be updated. */
export type StatisticsV2Patch = {
  activeUsers?: InputMaybe<Scalars['BigInt']['input']>;
  betAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  betCount?: InputMaybe<Scalars['BigInt']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  maxPayout?: InputMaybe<Scalars['BigFloat']['input']>;
  payoutAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  payoutCount?: InputMaybe<Scalars['BigInt']['input']>;
  winCount?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A connection to a list of `StatisticsV2` values. */
export type StatisticsV2sConnection = {
  __typename?: 'StatisticsV2sConnection';
  /** A list of edges which contains the `StatisticsV2` and cursor to aid in pagination. */
  edges: Array<StatisticsV2sEdge>;
  /** A list of `StatisticsV2` objects. */
  nodes: Array<Maybe<StatisticsV2>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `StatisticsV2` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `StatisticsV2` edge in the connection. */
export type StatisticsV2sEdge = {
  __typename?: 'StatisticsV2sEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `StatisticsV2` at the end of the edge. */
  node?: Maybe<StatisticsV2>;
};

/** Methods to use when ordering `StatisticsV2`. */
export enum StatisticsV2sOrderBy {
  ActiveUsersAsc = 'ACTIVE_USERS_ASC',
  ActiveUsersDesc = 'ACTIVE_USERS_DESC',
  BetAmountAsc = 'BET_AMOUNT_ASC',
  BetAmountDesc = 'BET_AMOUNT_DESC',
  BetCountAsc = 'BET_COUNT_ASC',
  BetCountDesc = 'BET_COUNT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MaxPayoutAsc = 'MAX_PAYOUT_ASC',
  MaxPayoutDesc = 'MAX_PAYOUT_DESC',
  Natural = 'NATURAL',
  PayoutAmountAsc = 'PAYOUT_AMOUNT_ASC',
  PayoutAmountDesc = 'PAYOUT_AMOUNT_DESC',
  PayoutCountAsc = 'PAYOUT_COUNT_ASC',
  PayoutCountDesc = 'PAYOUT_COUNT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  WinCountAsc = 'WIN_COUNT_ASC',
  WinCountDesc = 'WIN_COUNT_DESC'
}

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['String']['input']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['String']['input']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['String']['input']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against String List fields. All fields are combined with a logical ‘and.’ */
export type StringListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** A connection to a list of `TokenBurnHistory` values. */
export type TokenBurnHistoriesConnection = {
  __typename?: 'TokenBurnHistoriesConnection';
  /** A list of edges which contains the `TokenBurnHistory` and cursor to aid in pagination. */
  edges: Array<TokenBurnHistoriesEdge>;
  /** A list of `TokenBurnHistory` objects. */
  nodes: Array<Maybe<TokenBurnHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TokenBurnHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `TokenBurnHistory` edge in the connection. */
export type TokenBurnHistoriesEdge = {
  __typename?: 'TokenBurnHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `TokenBurnHistory` at the end of the edge. */
  node?: Maybe<TokenBurnHistory>;
};

/** Methods to use when ordering `TokenBurnHistory`. */
export enum TokenBurnHistoriesOrderBy {
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TxHashAsc = 'TX_HASH_ASC',
  TxHashDesc = 'TX_HASH_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC'
}

export type TokenBurnHistory = {
  __typename?: 'TokenBurnHistory';
  amount: Scalars['BigFloat']['output'];
  created: Scalars['Datetime']['output'];
  id: Scalars['BigInt']['output'];
  txHash: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/**
 * A condition to be used against `TokenBurnHistory` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TokenBurnHistoryCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `txHash` field. */
  txHash?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `TokenBurnHistory` object types. All fields are combined with a logical ‘and.’ */
export type TokenBurnHistoryFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TokenBurnHistoryFilter>>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TokenBurnHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TokenBurnHistoryFilter>>;
  /** Filter by the object’s `txHash` field. */
  txHash?: InputMaybe<StringFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `TokenBurnHistory` */
export type TokenBurnHistoryInput = {
  amount: Scalars['BigFloat']['input'];
  created: Scalars['Datetime']['input'];
  id: Scalars['BigInt']['input'];
  txHash: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

/** Represents an update to a `TokenBurnHistory`. Fields that are set will be updated. */
export type TokenBurnHistoryPatch = {
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  created?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  txHash?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TokenClaim = {
  __typename?: 'TokenClaim';
  amount: Scalars['JSON']['output'];
  contractAddress: Scalars['String']['output'];
  id: Scalars['BigInt']['output'];
  player: Scalars['String']['output'];
  status: TokenClaimStatus;
  txClaim?: Maybe<Scalars['String']['output']>;
  updated: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `TokenClaim` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type TokenClaimCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `contractAddress` field. */
  contractAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `player` field. */
  player?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<TokenClaimStatus>;
  /** Checks for equality with the object’s `txClaim` field. */
  txClaim?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updated` field. */
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `TokenClaim` object types. All fields are combined with a logical ‘and.’ */
export type TokenClaimFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<JsonFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TokenClaimFilter>>;
  /** Filter by the object’s `contractAddress` field. */
  contractAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TokenClaimFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TokenClaimFilter>>;
  /** Filter by the object’s `player` field. */
  player?: InputMaybe<StringFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<TokenClaimStatusFilter>;
  /** Filter by the object’s `txClaim` field. */
  txClaim?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updated` field. */
  updated?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `TokenClaim` */
export type TokenClaimInput = {
  amount: Scalars['JSON']['input'];
  contractAddress: Scalars['String']['input'];
  id: Scalars['BigInt']['input'];
  player: Scalars['String']['input'];
  status: TokenClaimStatus;
  txClaim?: InputMaybe<Scalars['String']['input']>;
  updated: Scalars['Datetime']['input'];
};

/** Represents an update to a `TokenClaim`. Fields that are set will be updated. */
export type TokenClaimPatch = {
  amount?: InputMaybe<Scalars['JSON']['input']>;
  contractAddress?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  player?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TokenClaimStatus>;
  txClaim?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

export enum TokenClaimStatus {
  Active = 'ACTIVE',
  Claimed = 'CLAIMED',
  Deleted = 'DELETED'
}

/** A filter to be used against TokenClaimStatus fields. All fields are combined with a logical ‘and.’ */
export type TokenClaimStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<TokenClaimStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<TokenClaimStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<TokenClaimStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<TokenClaimStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<TokenClaimStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<TokenClaimStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<TokenClaimStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<TokenClaimStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<TokenClaimStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<TokenClaimStatus>>;
};

/** A connection to a list of `TokenClaim` values. */
export type TokenClaimsConnection = {
  __typename?: 'TokenClaimsConnection';
  /** A list of edges which contains the `TokenClaim` and cursor to aid in pagination. */
  edges: Array<TokenClaimsEdge>;
  /** A list of `TokenClaim` objects. */
  nodes: Array<Maybe<TokenClaim>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TokenClaim` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `TokenClaim` edge in the connection. */
export type TokenClaimsEdge = {
  __typename?: 'TokenClaimsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `TokenClaim` at the end of the edge. */
  node?: Maybe<TokenClaim>;
};

/** Methods to use when ordering `TokenClaim`. */
export enum TokenClaimsOrderBy {
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  ContractAddressAsc = 'CONTRACT_ADDRESS_ASC',
  ContractAddressDesc = 'CONTRACT_ADDRESS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PlayerAsc = 'PLAYER_ASC',
  PlayerDesc = 'PLAYER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TxClaimAsc = 'TX_CLAIM_ASC',
  TxClaimDesc = 'TX_CLAIM_DESC',
  UpdatedAsc = 'UPDATED_ASC',
  UpdatedDesc = 'UPDATED_DESC'
}

export type TokenPrice = {
  __typename?: 'TokenPrice';
  denom: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  updated: Scalars['Datetime']['output'];
  value: Scalars['BigFloat']['output'];
};

/**
 * A condition to be used against `TokenPrice` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type TokenPriceCondition = {
  /** Checks for equality with the object’s `denom` field. */
  denom?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `symbol` field. */
  symbol?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updated` field. */
  updated?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** A filter to be used against `TokenPrice` object types. All fields are combined with a logical ‘and.’ */
export type TokenPriceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TokenPriceFilter>>;
  /** Filter by the object’s `denom` field. */
  denom?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TokenPriceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TokenPriceFilter>>;
  /** Filter by the object’s `symbol` field. */
  symbol?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updated` field. */
  updated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `TokenPrice` */
export type TokenPriceInput = {
  denom: Scalars['String']['input'];
  symbol: Scalars['String']['input'];
  updated: Scalars['Datetime']['input'];
  value: Scalars['BigFloat']['input'];
};

/** Represents an update to a `TokenPrice`. Fields that are set will be updated. */
export type TokenPricePatch = {
  denom?: InputMaybe<Scalars['String']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['Datetime']['input']>;
  value?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** A connection to a list of `TokenPrice` values. */
export type TokenPricesConnection = {
  __typename?: 'TokenPricesConnection';
  /** A list of edges which contains the `TokenPrice` and cursor to aid in pagination. */
  edges: Array<TokenPricesEdge>;
  /** A list of `TokenPrice` objects. */
  nodes: Array<Maybe<TokenPrice>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TokenPrice` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `TokenPrice` edge in the connection. */
export type TokenPricesEdge = {
  __typename?: 'TokenPricesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `TokenPrice` at the end of the edge. */
  node?: Maybe<TokenPrice>;
};

/** Methods to use when ordering `TokenPrice`. */
export enum TokenPricesOrderBy {
  DenomAsc = 'DENOM_ASC',
  DenomDesc = 'DENOM_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SymbolAsc = 'SYMBOL_ASC',
  SymbolDesc = 'SYMBOL_DESC',
  UpdatedAsc = 'UPDATED_ASC',
  UpdatedDesc = 'UPDATED_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type TokenSalesInfo = {
  __typename?: 'TokenSalesInfo';
  id: Scalars['BigInt']['output'];
  token: Scalars['BigInt']['output'];
};

/**
 * A condition to be used against `TokenSalesInfo` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TokenSalesInfoCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `token` field. */
  token?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `TokenSalesInfo` object types. All fields are combined with a logical ‘and.’ */
export type TokenSalesInfoFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TokenSalesInfoFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TokenSalesInfoFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TokenSalesInfoFilter>>;
  /** Filter by the object’s `token` field. */
  token?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `TokenSalesInfo` */
export type TokenSalesInfoInput = {
  id: Scalars['BigInt']['input'];
  token: Scalars['BigInt']['input'];
};

/** Represents an update to a `TokenSalesInfo`. Fields that are set will be updated. */
export type TokenSalesInfoPatch = {
  id?: InputMaybe<Scalars['BigInt']['input']>;
  token?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A connection to a list of `TokenSalesInfo` values. */
export type TokenSalesInfosConnection = {
  __typename?: 'TokenSalesInfosConnection';
  /** A list of edges which contains the `TokenSalesInfo` and cursor to aid in pagination. */
  edges: Array<TokenSalesInfosEdge>;
  /** A list of `TokenSalesInfo` objects. */
  nodes: Array<Maybe<TokenSalesInfo>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TokenSalesInfo` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `TokenSalesInfo` edge in the connection. */
export type TokenSalesInfosEdge = {
  __typename?: 'TokenSalesInfosEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `TokenSalesInfo` at the end of the edge. */
  node?: Maybe<TokenSalesInfo>;
};

/** Methods to use when ordering `TokenSalesInfo`. */
export enum TokenSalesInfosOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TokenAsc = 'TOKEN_ASC',
  TokenDesc = 'TOKEN_DESC'
}

export type TokenSalesPriceInfo = {
  __typename?: 'TokenSalesPriceInfo';
  created: Scalars['Datetime']['output'];
  denom: Scalars['String']['output'];
  id: Scalars['BigInt']['output'];
  isActive: Scalars['Boolean']['output'];
  price: Scalars['BigFloat']['output'];
  updated: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `TokenSalesPriceInfo` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type TokenSalesPriceInfoCondition = {
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `denom` field. */
  denom?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `isActive` field. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `price` field. */
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `updated` field. */
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `TokenSalesPriceInfo` object types. All fields are combined with a logical ‘and.’ */
export type TokenSalesPriceInfoFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TokenSalesPriceInfoFilter>>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `denom` field. */
  denom?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `isActive` field. */
  isActive?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TokenSalesPriceInfoFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TokenSalesPriceInfoFilter>>;
  /** Filter by the object’s `price` field. */
  price?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `updated` field. */
  updated?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `TokenSalesPriceInfo` */
export type TokenSalesPriceInfoInput = {
  created: Scalars['Datetime']['input'];
  denom: Scalars['String']['input'];
  id: Scalars['BigInt']['input'];
  isActive: Scalars['Boolean']['input'];
  price: Scalars['BigFloat']['input'];
  updated: Scalars['Datetime']['input'];
};

/** Represents an update to a `TokenSalesPriceInfo`. Fields that are set will be updated. */
export type TokenSalesPriceInfoPatch = {
  created?: InputMaybe<Scalars['Datetime']['input']>;
  denom?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `TokenSalesPriceInfo` values. */
export type TokenSalesPriceInfosConnection = {
  __typename?: 'TokenSalesPriceInfosConnection';
  /** A list of edges which contains the `TokenSalesPriceInfo` and cursor to aid in pagination. */
  edges: Array<TokenSalesPriceInfosEdge>;
  /** A list of `TokenSalesPriceInfo` objects. */
  nodes: Array<Maybe<TokenSalesPriceInfo>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TokenSalesPriceInfo` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `TokenSalesPriceInfo` edge in the connection. */
export type TokenSalesPriceInfosEdge = {
  __typename?: 'TokenSalesPriceInfosEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `TokenSalesPriceInfo` at the end of the edge. */
  node?: Maybe<TokenSalesPriceInfo>;
};

/** Methods to use when ordering `TokenSalesPriceInfo`. */
export enum TokenSalesPriceInfosOrderBy {
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  DenomAsc = 'DENOM_ASC',
  DenomDesc = 'DENOM_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsActiveAsc = 'IS_ACTIVE_ASC',
  IsActiveDesc = 'IS_ACTIVE_DESC',
  Natural = 'NATURAL',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAsc = 'UPDATED_ASC',
  UpdatedDesc = 'UPDATED_DESC'
}

/** All input for the `updateAuctionBasketBet` mutation. */
export type UpdateAuctionBasketBetInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `AuctionBasketBet` being updated. */
  patch: AuctionBasketBetPatch;
};

/** The output of our update `AuctionBasketBet` mutation. */
export type UpdateAuctionBasketBetPayload = {
  __typename?: 'UpdateAuctionBasketBetPayload';
  /** Reads a single `AuctionBasket` that is related to this `AuctionBasketBet`. */
  auctionBasket?: Maybe<AuctionBasket>;
  /** The `AuctionBasketBet` that was updated by this mutation. */
  auctionBasketBet?: Maybe<AuctionBasketBet>;
  /** An edge for our `AuctionBasketBet`. May be used by Relay 1. */
  auctionBasketBetEdge?: Maybe<AuctionBasketBetsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `AuctionBasketBet` mutation. */
export type UpdateAuctionBasketBetPayloadAuctionBasketBetEdgeArgs = {
  orderBy?: InputMaybe<Array<AuctionBasketBetsOrderBy>>;
};

/** All input for the `updateAuctionBasket` mutation. */
export type UpdateAuctionBasketInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `AuctionBasket` being updated. */
  patch: AuctionBasketPatch;
};

/** The output of our update `AuctionBasket` mutation. */
export type UpdateAuctionBasketPayload = {
  __typename?: 'UpdateAuctionBasketPayload';
  /** The `AuctionBasket` that was updated by this mutation. */
  auctionBasket?: Maybe<AuctionBasket>;
  /** An edge for our `AuctionBasket`. May be used by Relay 1. */
  auctionBasketEdge?: Maybe<AuctionBasketsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `AuctionBasket` mutation. */
export type UpdateAuctionBasketPayloadAuctionBasketEdgeArgs = {
  orderBy?: InputMaybe<Array<AuctionBasketsOrderBy>>;
};

/** All input for the `updateBankrollBalance` mutation. */
export type UpdateBankrollBalanceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contract: Scalars['String']['input'];
  denom: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `BankrollBalance` being updated. */
  patch: BankrollBalancePatch;
};

/** The output of our update `BankrollBalance` mutation. */
export type UpdateBankrollBalancePayload = {
  __typename?: 'UpdateBankrollBalancePayload';
  /** The `BankrollBalance` that was updated by this mutation. */
  bankrollBalance?: Maybe<BankrollBalance>;
  /** An edge for our `BankrollBalance`. May be used by Relay 1. */
  bankrollBalanceEdge?: Maybe<BankrollBalancesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `BankrollBalance` mutation. */
export type UpdateBankrollBalancePayloadBankrollBalanceEdgeArgs = {
  orderBy?: InputMaybe<Array<BankrollBalancesOrderBy>>;
};

/** All input for the `updateBetsHistoryById` mutation. */
export type UpdateBetsHistoryByIdInput = {
  _id: Scalars['BigInt']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `BetsHistory` being updated. */
  patch: BetsHistoryPatch;
};

/** All input for the `updateBetsHistory` mutation. */
export type UpdateBetsHistoryInput = {
  betId: Scalars['BigInt']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  game: Scalars['String']['input'];
  gameId: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `BetsHistory` being updated. */
  patch: BetsHistoryPatch;
};

/** The output of our update `BetsHistory` mutation. */
export type UpdateBetsHistoryPayload = {
  __typename?: 'UpdateBetsHistoryPayload';
  /** The `BetsHistory` that was updated by this mutation. */
  betsHistory?: Maybe<BetsHistory>;
  /** An edge for our `BetsHistory`. May be used by Relay 1. */
  betsHistoryEdge?: Maybe<BetsHistoriesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `BetsHistory` mutation. */
export type UpdateBetsHistoryPayloadBetsHistoryEdgeArgs = {
  orderBy?: InputMaybe<Array<BetsHistoriesOrderBy>>;
};

/** All input for the `updateBonusBetsHistory` mutation. */
export type UpdateBonusBetsHistoryInput = {
  betId: Scalars['BigInt']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  game: Scalars['String']['input'];
  gameId: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `BonusBetsHistory` being updated. */
  patch: BonusBetsHistoryPatch;
};

/** The output of our update `BonusBetsHistory` mutation. */
export type UpdateBonusBetsHistoryPayload = {
  __typename?: 'UpdateBonusBetsHistoryPayload';
  /** The `BonusBetsHistory` that was updated by this mutation. */
  bonusBetsHistory?: Maybe<BonusBetsHistory>;
  /** An edge for our `BonusBetsHistory`. May be used by Relay 1. */
  bonusBetsHistoryEdge?: Maybe<BonusBetsHistoriesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `BonusBetsHistory` mutation. */
export type UpdateBonusBetsHistoryPayloadBonusBetsHistoryEdgeArgs = {
  orderBy?: InputMaybe<Array<BonusBetsHistoriesOrderBy>>;
};

/** All input for the `updateClaimHistory` mutation. */
export type UpdateClaimHistoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `ClaimHistory` being updated. */
  patch: ClaimHistoryPatch;
};

/** The output of our update `ClaimHistory` mutation. */
export type UpdateClaimHistoryPayload = {
  __typename?: 'UpdateClaimHistoryPayload';
  /** The `ClaimHistory` that was updated by this mutation. */
  claimHistory?: Maybe<ClaimHistory>;
  /** An edge for our `ClaimHistory`. May be used by Relay 1. */
  claimHistoryEdge?: Maybe<ClaimHistoriesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ClaimHistory` mutation. */
export type UpdateClaimHistoryPayloadClaimHistoryEdgeArgs = {
  orderBy?: InputMaybe<Array<ClaimHistoriesOrderBy>>;
};

/** All input for the `updateCoinflipGame` mutation. */
export type UpdateCoinflipGameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `CoinflipGame` being updated. */
  patch: CoinflipGamePatch;
};

/** The output of our update `CoinflipGame` mutation. */
export type UpdateCoinflipGamePayload = {
  __typename?: 'UpdateCoinflipGamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CoinflipGame` that was updated by this mutation. */
  coinflipGame?: Maybe<CoinflipGame>;
  /** An edge for our `CoinflipGame`. May be used by Relay 1. */
  coinflipGameEdge?: Maybe<CoinflipGamesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CoinflipGame` mutation. */
export type UpdateCoinflipGamePayloadCoinflipGameEdgeArgs = {
  orderBy?: InputMaybe<Array<CoinflipGamesOrderBy>>;
};

/** All input for the `updateCoinflipGameRound` mutation. */
export type UpdateCoinflipGameRoundInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `CoinflipGameRound` being updated. */
  patch: CoinflipGameRoundPatch;
};

/** The output of our update `CoinflipGameRound` mutation. */
export type UpdateCoinflipGameRoundPayload = {
  __typename?: 'UpdateCoinflipGameRoundPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CoinflipGameRound` that was updated by this mutation. */
  coinflipGameRound?: Maybe<CoinflipGameRound>;
  /** An edge for our `CoinflipGameRound`. May be used by Relay 1. */
  coinflipGameRoundEdge?: Maybe<CoinflipGameRoundsEdge>;
  /** Reads a single `CoinflipGame` that is related to this `CoinflipGameRound`. */
  game?: Maybe<CoinflipGame>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CoinflipGameRound` mutation. */
export type UpdateCoinflipGameRoundPayloadCoinflipGameRoundEdgeArgs = {
  orderBy?: InputMaybe<Array<CoinflipGameRoundsOrderBy>>;
};

/** All input for the `updateContractConfig` mutation. */
export type UpdateContractConfigInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `ContractConfig` being updated. */
  patch: ContractConfigPatch;
};

/** The output of our update `ContractConfig` mutation. */
export type UpdateContractConfigPayload = {
  __typename?: 'UpdateContractConfigPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `ContractConfig` that was updated by this mutation. */
  contractConfig?: Maybe<ContractConfig>;
  /** An edge for our `ContractConfig`. May be used by Relay 1. */
  contractConfigEdge?: Maybe<ContractConfigsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ContractConfig` mutation. */
export type UpdateContractConfigPayloadContractConfigEdgeArgs = {
  orderBy?: InputMaybe<Array<ContractConfigsOrderBy>>;
};

/** All input for the `updateDoubleBet` mutation. */
export type UpdateDoubleBetInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DoubleBet` being updated. */
  patch: DoubleBetPatch;
};

/** The output of our update `DoubleBet` mutation. */
export type UpdateDoubleBetPayload = {
  __typename?: 'UpdateDoubleBetPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `DoubleBet` that was updated by this mutation. */
  doubleBet?: Maybe<DoubleBet>;
  /** An edge for our `DoubleBet`. May be used by Relay 1. */
  doubleBetEdge?: Maybe<DoubleBetsEdge>;
  /** Reads a single `DoubleGame` that is related to this `DoubleBet`. */
  game?: Maybe<DoubleGame>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `DoubleBet` mutation. */
export type UpdateDoubleBetPayloadDoubleBetEdgeArgs = {
  orderBy?: InputMaybe<Array<DoubleBetsOrderBy>>;
};

/** All input for the `updateDoubleGame` mutation. */
export type UpdateDoubleGameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DoubleGame` being updated. */
  patch: DoubleGamePatch;
};

/** The output of our update `DoubleGame` mutation. */
export type UpdateDoubleGamePayload = {
  __typename?: 'UpdateDoubleGamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `DoubleGame` that was updated by this mutation. */
  doubleGame?: Maybe<DoubleGame>;
  /** An edge for our `DoubleGame`. May be used by Relay 1. */
  doubleGameEdge?: Maybe<DoubleGamesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `DoubleGame` mutation. */
export type UpdateDoubleGamePayloadDoubleGameEdgeArgs = {
  orderBy?: InputMaybe<Array<DoubleGamesOrderBy>>;
};

/** All input for the `updateFeeDistributedHistory` mutation. */
export type UpdateFeeDistributedHistoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `FeeDistributedHistory` being updated. */
  patch: FeeDistributedHistoryPatch;
};

/** The output of our update `FeeDistributedHistory` mutation. */
export type UpdateFeeDistributedHistoryPayload = {
  __typename?: 'UpdateFeeDistributedHistoryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `FeeDistributedHistory` that was updated by this mutation. */
  feeDistributedHistory?: Maybe<FeeDistributedHistory>;
  /** An edge for our `FeeDistributedHistory`. May be used by Relay 1. */
  feeDistributedHistoryEdge?: Maybe<FeeDistributedHistoriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `FeeDistributedHistory` mutation. */
export type UpdateFeeDistributedHistoryPayloadFeeDistributedHistoryEdgeArgs = {
  orderBy?: InputMaybe<Array<FeeDistributedHistoriesOrderBy>>;
};

/** All input for the `updateGatewayChainTransaction` mutation. */
export type UpdateGatewayChainTransactionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `GatewayChainTransaction` being updated. */
  patch: GatewayChainTransactionPatch;
};

/** The output of our update `GatewayChainTransaction` mutation. */
export type UpdateGatewayChainTransactionPayload = {
  __typename?: 'UpdateGatewayChainTransactionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `GatewayChainTransaction` that was updated by this mutation. */
  gatewayChainTransaction?: Maybe<GatewayChainTransaction>;
  /** An edge for our `GatewayChainTransaction`. May be used by Relay 1. */
  gatewayChainTransactionEdge?: Maybe<GatewayChainTransactionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `GatewayChainTransaction` mutation. */
export type UpdateGatewayChainTransactionPayloadGatewayChainTransactionEdgeArgs = {
  orderBy?: InputMaybe<Array<GatewayChainTransactionsOrderBy>>;
};

/** All input for the `updateJackpotBet` mutation. */
export type UpdateJackpotBetInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `JackpotBet` being updated. */
  patch: JackpotBetPatch;
};

/** The output of our update `JackpotBet` mutation. */
export type UpdateJackpotBetPayload = {
  __typename?: 'UpdateJackpotBetPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `JackpotGame` that is related to this `JackpotBet`. */
  game?: Maybe<JackpotGame>;
  /** The `JackpotBet` that was updated by this mutation. */
  jackpotBet?: Maybe<JackpotBet>;
  /** An edge for our `JackpotBet`. May be used by Relay 1. */
  jackpotBetEdge?: Maybe<JackpotBetsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `JackpotBet` mutation. */
export type UpdateJackpotBetPayloadJackpotBetEdgeArgs = {
  orderBy?: InputMaybe<Array<JackpotBetsOrderBy>>;
};

/** All input for the `updateJackpotGame` mutation. */
export type UpdateJackpotGameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `JackpotGame` being updated. */
  patch: JackpotGamePatch;
};

/** The output of our update `JackpotGame` mutation. */
export type UpdateJackpotGamePayload = {
  __typename?: 'UpdateJackpotGamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `JackpotGame` that was updated by this mutation. */
  jackpotGame?: Maybe<JackpotGame>;
  /** An edge for our `JackpotGame`. May be used by Relay 1. */
  jackpotGameEdge?: Maybe<JackpotGamesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `JackpotGame` mutation. */
export type UpdateJackpotGamePayloadJackpotGameEdgeArgs = {
  orderBy?: InputMaybe<Array<JackpotGamesOrderBy>>;
};

/** All input for the `updateLootboxGame` mutation. */
export type UpdateLootboxGameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  lootbox: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `LootboxGame` being updated. */
  patch: LootboxGamePatch;
};

/** The output of our update `LootboxGame` mutation. */
export type UpdateLootboxGamePayload = {
  __typename?: 'UpdateLootboxGamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `LootboxGame` that was updated by this mutation. */
  lootboxGame?: Maybe<LootboxGame>;
  /** An edge for our `LootboxGame`. May be used by Relay 1. */
  lootboxGameEdge?: Maybe<LootboxGamesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `LootboxGame` mutation. */
export type UpdateLootboxGamePayloadLootboxGameEdgeArgs = {
  orderBy?: InputMaybe<Array<LootboxGamesOrderBy>>;
};

/** All input for the `updateLootbox` mutation. */
export type UpdateLootboxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `Lootbox` being updated. */
  patch: LootboxPatch;
};

/** All input for the `updateLootboxMarketOrder` mutation. */
export type UpdateLootboxMarketOrderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `LootboxMarketOrder` being updated. */
  patch: LootboxMarketOrderPatch;
};

/** The output of our update `LootboxMarketOrder` mutation. */
export type UpdateLootboxMarketOrderPayload = {
  __typename?: 'UpdateLootboxMarketOrderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `LootboxMarketOrder` that was updated by this mutation. */
  lootboxMarketOrder?: Maybe<LootboxMarketOrder>;
  /** An edge for our `LootboxMarketOrder`. May be used by Relay 1. */
  lootboxMarketOrderEdge?: Maybe<LootboxMarketOrdersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `LootboxMarketOrder` mutation. */
export type UpdateLootboxMarketOrderPayloadLootboxMarketOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<LootboxMarketOrdersOrderBy>>;
};

/** All input for the `updateLootboxMarketTrade` mutation. */
export type UpdateLootboxMarketTradeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `LootboxMarketTrade` being updated. */
  patch: LootboxMarketTradePatch;
  tradeId: Scalars['BigInt']['input'];
};

/** The output of our update `LootboxMarketTrade` mutation. */
export type UpdateLootboxMarketTradePayload = {
  __typename?: 'UpdateLootboxMarketTradePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `LootboxMarketTrade` that was updated by this mutation. */
  lootboxMarketTrade?: Maybe<LootboxMarketTrade>;
  /** An edge for our `LootboxMarketTrade`. May be used by Relay 1. */
  lootboxMarketTradeEdge?: Maybe<LootboxMarketTradesEdge>;
  /** Reads a single `LootboxMarketOrder` that is related to this `LootboxMarketTrade`. */
  order?: Maybe<LootboxMarketOrder>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `LootboxMarketTrade` mutation. */
export type UpdateLootboxMarketTradePayloadLootboxMarketTradeEdgeArgs = {
  orderBy?: InputMaybe<Array<LootboxMarketTradesOrderBy>>;
};

/** The output of our update `Lootbox` mutation. */
export type UpdateLootboxPayload = {
  __typename?: 'UpdateLootboxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Lootbox` that was updated by this mutation. */
  lootbox?: Maybe<Lootbox>;
  /** An edge for our `Lootbox`. May be used by Relay 1. */
  lootboxEdge?: Maybe<LootboxesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Lootbox` mutation. */
export type UpdateLootboxPayloadLootboxEdgeArgs = {
  orderBy?: InputMaybe<Array<LootboxesOrderBy>>;
};

/** All input for the `updateLootboxReward` mutation. */
export type UpdateLootboxRewardInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lootbox: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `LootboxReward` being updated. */
  patch: LootboxRewardPatch;
};

/** The output of our update `LootboxReward` mutation. */
export type UpdateLootboxRewardPayload = {
  __typename?: 'UpdateLootboxRewardPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `LootboxReward` that was updated by this mutation. */
  lootboxReward?: Maybe<LootboxReward>;
  /** An edge for our `LootboxReward`. May be used by Relay 1. */
  lootboxRewardEdge?: Maybe<LootboxRewardsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `LootboxReward` mutation. */
export type UpdateLootboxRewardPayloadLootboxRewardEdgeArgs = {
  orderBy?: InputMaybe<Array<LootboxRewardsOrderBy>>;
};

/** All input for the `updateLootboxSale` mutation. */
export type UpdateLootboxSaleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `LootboxSale` being updated. */
  patch: LootboxSalePatch;
};

/** The output of our update `LootboxSale` mutation. */
export type UpdateLootboxSalePayload = {
  __typename?: 'UpdateLootboxSalePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `LootboxSale` that was updated by this mutation. */
  lootboxSale?: Maybe<LootboxSale>;
  /** An edge for our `LootboxSale`. May be used by Relay 1. */
  lootboxSaleEdge?: Maybe<LootboxSalesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `LootboxSale` mutation. */
export type UpdateLootboxSalePayloadLootboxSaleEdgeArgs = {
  orderBy?: InputMaybe<Array<LootboxSalesOrderBy>>;
};

/** All input for the `updateLootboxUnlimitedGame` mutation. */
export type UpdateLootboxUnlimitedGameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `LootboxUnlimitedGame` being updated. */
  patch: LootboxUnlimitedGamePatch;
};

/** The output of our update `LootboxUnlimitedGame` mutation. */
export type UpdateLootboxUnlimitedGamePayload = {
  __typename?: 'UpdateLootboxUnlimitedGamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `LootboxUnlimitedGame` that was updated by this mutation. */
  lootboxUnlimitedGame?: Maybe<LootboxUnlimitedGame>;
  /** An edge for our `LootboxUnlimitedGame`. May be used by Relay 1. */
  lootboxUnlimitedGameEdge?: Maybe<LootboxUnlimitedGamesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `LootboxUnlimitedGame` mutation. */
export type UpdateLootboxUnlimitedGamePayloadLootboxUnlimitedGameEdgeArgs = {
  orderBy?: InputMaybe<Array<LootboxUnlimitedGamesOrderBy>>;
};

/** All input for the `updateLootboxesUnlimited` mutation. */
export type UpdateLootboxesUnlimitedInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `LootboxesUnlimited` being updated. */
  patch: LootboxesUnlimitedPatch;
};

/** The output of our update `LootboxesUnlimited` mutation. */
export type UpdateLootboxesUnlimitedPayload = {
  __typename?: 'UpdateLootboxesUnlimitedPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `LootboxesUnlimited` that was updated by this mutation. */
  lootboxesUnlimited?: Maybe<LootboxesUnlimited>;
  /** An edge for our `LootboxesUnlimited`. May be used by Relay 1. */
  lootboxesUnlimitedEdge?: Maybe<LootboxesUnlimitedsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `LootboxesUnlimited` mutation. */
export type UpdateLootboxesUnlimitedPayloadLootboxesUnlimitedEdgeArgs = {
  orderBy?: InputMaybe<Array<LootboxesUnlimitedsOrderBy>>;
};

/** All input for the `updateMinesGame` mutation. */
export type UpdateMinesGameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `MinesGame` being updated. */
  patch: MinesGamePatch;
};

/** The output of our update `MinesGame` mutation. */
export type UpdateMinesGamePayload = {
  __typename?: 'UpdateMinesGamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `MinesGame` that was updated by this mutation. */
  minesGame?: Maybe<MinesGame>;
  /** An edge for our `MinesGame`. May be used by Relay 1. */
  minesGameEdge?: Maybe<MinesGamesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `MinesGame` mutation. */
export type UpdateMinesGamePayloadMinesGameEdgeArgs = {
  orderBy?: InputMaybe<Array<MinesGamesOrderBy>>;
};

/** All input for the `updateMinesGameRound` mutation. */
export type UpdateMinesGameRoundInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `MinesGameRound` being updated. */
  patch: MinesGameRoundPatch;
};

/** The output of our update `MinesGameRound` mutation. */
export type UpdateMinesGameRoundPayload = {
  __typename?: 'UpdateMinesGameRoundPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `MinesGame` that is related to this `MinesGameRound`. */
  game?: Maybe<MinesGame>;
  /** The `MinesGameRound` that was updated by this mutation. */
  minesGameRound?: Maybe<MinesGameRound>;
  /** An edge for our `MinesGameRound`. May be used by Relay 1. */
  minesGameRoundEdge?: Maybe<MinesGameRoundsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `MinesGameRound` mutation. */
export type UpdateMinesGameRoundPayloadMinesGameRoundEdgeArgs = {
  orderBy?: InputMaybe<Array<MinesGameRoundsOrderBy>>;
};

/** All input for the `updateNft` mutation. */
export type UpdateNftInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `Nft` being updated. */
  patch: NftPatch;
};

/** The output of our update `Nft` mutation. */
export type UpdateNftPayload = {
  __typename?: 'UpdateNftPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Nft` that was updated by this mutation. */
  nft?: Maybe<Nft>;
  /** An edge for our `Nft`. May be used by Relay 1. */
  nftEdge?: Maybe<NftsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Nft` mutation. */
export type UpdateNftPayloadNftEdgeArgs = {
  orderBy?: InputMaybe<Array<NftsOrderBy>>;
};

/** All input for the `updateNftsVote` mutation. */
export type UpdateNftsVoteInput = {
  address: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `NftsVote` being updated. */
  patch: NftsVotePatch;
  proposalId: Scalars['String']['input'];
};

/** The output of our update `NftsVote` mutation. */
export type UpdateNftsVotePayload = {
  __typename?: 'UpdateNftsVotePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `NftsVote` that was updated by this mutation. */
  nftsVote?: Maybe<NftsVote>;
  /** An edge for our `NftsVote`. May be used by Relay 1. */
  nftsVoteEdge?: Maybe<NftsVotesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `NftsVote` mutation. */
export type UpdateNftsVotePayloadNftsVoteEdgeArgs = {
  orderBy?: InputMaybe<Array<NftsVotesOrderBy>>;
};

/** All input for the `updateOpenCompetitionEntity` mutation. */
export type UpdateOpenCompetitionEntityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `OpenCompetitionEntity` being updated. */
  patch: OpenCompetitionEntityPatch;
  player: Scalars['String']['input'];
};

/** The output of our update `OpenCompetitionEntity` mutation. */
export type UpdateOpenCompetitionEntityPayload = {
  __typename?: 'UpdateOpenCompetitionEntityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `OpenCompetitionEntity` that was updated by this mutation. */
  openCompetitionEntity?: Maybe<OpenCompetitionEntity>;
  /** An edge for our `OpenCompetitionEntity`. May be used by Relay 1. */
  openCompetitionEntityEdge?: Maybe<OpenCompetitionEntitiesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `OpenCompetitionEntity` mutation. */
export type UpdateOpenCompetitionEntityPayloadOpenCompetitionEntityEdgeArgs = {
  orderBy?: InputMaybe<Array<OpenCompetitionEntitiesOrderBy>>;
};

/** All input for the `updatePlinkoGame` mutation. */
export type UpdatePlinkoGameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `PlinkoGame` being updated. */
  patch: PlinkoGamePatch;
};

/** The output of our update `PlinkoGame` mutation. */
export type UpdatePlinkoGamePayload = {
  __typename?: 'UpdatePlinkoGamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `PlinkoGame` that was updated by this mutation. */
  plinkoGame?: Maybe<PlinkoGame>;
  /** An edge for our `PlinkoGame`. May be used by Relay 1. */
  plinkoGameEdge?: Maybe<PlinkoGamesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `PlinkoGame` mutation. */
export type UpdatePlinkoGamePayloadPlinkoGameEdgeArgs = {
  orderBy?: InputMaybe<Array<PlinkoGamesOrderBy>>;
};

/** All input for the `updatePointTransaction` mutation. */
export type UpdatePointTransactionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `PointTransaction` being updated. */
  patch: PointTransactionPatch;
};

/** The output of our update `PointTransaction` mutation. */
export type UpdatePointTransactionPayload = {
  __typename?: 'UpdatePointTransactionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `PointTransaction` that was updated by this mutation. */
  pointTransaction?: Maybe<PointTransaction>;
  /** An edge for our `PointTransaction`. May be used by Relay 1. */
  pointTransactionEdge?: Maybe<PointTransactionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `PointTransaction` mutation. */
export type UpdatePointTransactionPayloadPointTransactionEdgeArgs = {
  orderBy?: InputMaybe<Array<PointTransactionsOrderBy>>;
};

/** All input for the `updateRngRound` mutation. */
export type UpdateRngRoundInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `RngRound` being updated. */
  patch: RngRoundPatch;
};

/** The output of our update `RngRound` mutation. */
export type UpdateRngRoundPayload = {
  __typename?: 'UpdateRngRoundPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RngRound` that was updated by this mutation. */
  rngRound?: Maybe<RngRound>;
  /** An edge for our `RngRound`. May be used by Relay 1. */
  rngRoundEdge?: Maybe<RngRoundsEdge>;
};


/** The output of our update `RngRound` mutation. */
export type UpdateRngRoundPayloadRngRoundEdgeArgs = {
  orderBy?: InputMaybe<Array<RngRoundsOrderBy>>;
};

/** All input for the `updateRoshamboGame` mutation. */
export type UpdateRoshamboGameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `RoshamboGame` being updated. */
  patch: RoshamboGamePatch;
};

/** All input for the `updateRoshamboGameLog` mutation. */
export type UpdateRoshamboGameLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `RoshamboGameLog` being updated. */
  patch: RoshamboGameLogPatch;
};

/** The output of our update `RoshamboGameLog` mutation. */
export type UpdateRoshamboGameLogPayload = {
  __typename?: 'UpdateRoshamboGameLogPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RoshamboGameLog` that was updated by this mutation. */
  roshamboGameLog?: Maybe<RoshamboGameLog>;
  /** An edge for our `RoshamboGameLog`. May be used by Relay 1. */
  roshamboGameLogEdge?: Maybe<RoshamboGameLogsEdge>;
};


/** The output of our update `RoshamboGameLog` mutation. */
export type UpdateRoshamboGameLogPayloadRoshamboGameLogEdgeArgs = {
  orderBy?: InputMaybe<Array<RoshamboGameLogsOrderBy>>;
};

/** The output of our update `RoshamboGame` mutation. */
export type UpdateRoshamboGamePayload = {
  __typename?: 'UpdateRoshamboGamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RoshamboGame` that was updated by this mutation. */
  roshamboGame?: Maybe<RoshamboGame>;
  /** An edge for our `RoshamboGame`. May be used by Relay 1. */
  roshamboGameEdge?: Maybe<RoshamboGamesEdge>;
};


/** The output of our update `RoshamboGame` mutation. */
export type UpdateRoshamboGamePayloadRoshamboGameEdgeArgs = {
  orderBy?: InputMaybe<Array<RoshamboGamesOrderBy>>;
};

/** All input for the `updateRunesGame` mutation. */
export type UpdateRunesGameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `RunesGame` being updated. */
  patch: RunesGamePatch;
};

/** The output of our update `RunesGame` mutation. */
export type UpdateRunesGamePayload = {
  __typename?: 'UpdateRunesGamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RunesGame` that was updated by this mutation. */
  runesGame?: Maybe<RunesGame>;
  /** An edge for our `RunesGame`. May be used by Relay 1. */
  runesGameEdge?: Maybe<RunesGamesEdge>;
};


/** The output of our update `RunesGame` mutation. */
export type UpdateRunesGamePayloadRunesGameEdgeArgs = {
  orderBy?: InputMaybe<Array<RunesGamesOrderBy>>;
};

/** All input for the `updateStatistic` mutation. */
export type UpdateStatisticInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `Statistic` being updated. */
  patch: StatisticPatch;
};

/** The output of our update `Statistic` mutation. */
export type UpdateStatisticPayload = {
  __typename?: 'UpdateStatisticPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Statistic` that was updated by this mutation. */
  statistic?: Maybe<Statistic>;
  /** An edge for our `Statistic`. May be used by Relay 1. */
  statisticEdge?: Maybe<StatisticsEdge>;
};


/** The output of our update `Statistic` mutation. */
export type UpdateStatisticPayloadStatisticEdgeArgs = {
  orderBy?: InputMaybe<Array<StatisticsOrderBy>>;
};

/** All input for the `updateStatisticsV2` mutation. */
export type UpdateStatisticsV2Input = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `StatisticsV2` being updated. */
  patch: StatisticsV2Patch;
};

/** The output of our update `StatisticsV2` mutation. */
export type UpdateStatisticsV2Payload = {
  __typename?: 'UpdateStatisticsV2Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `StatisticsV2` that was updated by this mutation. */
  statisticsV2?: Maybe<StatisticsV2>;
  /** An edge for our `StatisticsV2`. May be used by Relay 1. */
  statisticsV2Edge?: Maybe<StatisticsV2sEdge>;
};


/** The output of our update `StatisticsV2` mutation. */
export type UpdateStatisticsV2PayloadStatisticsV2EdgeArgs = {
  orderBy?: InputMaybe<Array<StatisticsV2sOrderBy>>;
};

/** All input for the `updateTokenBurnHistory` mutation. */
export type UpdateTokenBurnHistoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `TokenBurnHistory` being updated. */
  patch: TokenBurnHistoryPatch;
};

/** The output of our update `TokenBurnHistory` mutation. */
export type UpdateTokenBurnHistoryPayload = {
  __typename?: 'UpdateTokenBurnHistoryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TokenBurnHistory` that was updated by this mutation. */
  tokenBurnHistory?: Maybe<TokenBurnHistory>;
  /** An edge for our `TokenBurnHistory`. May be used by Relay 1. */
  tokenBurnHistoryEdge?: Maybe<TokenBurnHistoriesEdge>;
};


/** The output of our update `TokenBurnHistory` mutation. */
export type UpdateTokenBurnHistoryPayloadTokenBurnHistoryEdgeArgs = {
  orderBy?: InputMaybe<Array<TokenBurnHistoriesOrderBy>>;
};

/** All input for the `updateTokenClaim` mutation. */
export type UpdateTokenClaimInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractAddress: Scalars['String']['input'];
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `TokenClaim` being updated. */
  patch: TokenClaimPatch;
};

/** The output of our update `TokenClaim` mutation. */
export type UpdateTokenClaimPayload = {
  __typename?: 'UpdateTokenClaimPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TokenClaim` that was updated by this mutation. */
  tokenClaim?: Maybe<TokenClaim>;
  /** An edge for our `TokenClaim`. May be used by Relay 1. */
  tokenClaimEdge?: Maybe<TokenClaimsEdge>;
};


/** The output of our update `TokenClaim` mutation. */
export type UpdateTokenClaimPayloadTokenClaimEdgeArgs = {
  orderBy?: InputMaybe<Array<TokenClaimsOrderBy>>;
};

/** All input for the `updateTokenPrice` mutation. */
export type UpdateTokenPriceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `TokenPrice` being updated. */
  patch: TokenPricePatch;
  symbol: Scalars['String']['input'];
};

/** The output of our update `TokenPrice` mutation. */
export type UpdateTokenPricePayload = {
  __typename?: 'UpdateTokenPricePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TokenPrice` that was updated by this mutation. */
  tokenPrice?: Maybe<TokenPrice>;
  /** An edge for our `TokenPrice`. May be used by Relay 1. */
  tokenPriceEdge?: Maybe<TokenPricesEdge>;
};


/** The output of our update `TokenPrice` mutation. */
export type UpdateTokenPricePayloadTokenPriceEdgeArgs = {
  orderBy?: InputMaybe<Array<TokenPricesOrderBy>>;
};

/** All input for the `updateTokenSalesInfo` mutation. */
export type UpdateTokenSalesInfoInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `TokenSalesInfo` being updated. */
  patch: TokenSalesInfoPatch;
};

/** The output of our update `TokenSalesInfo` mutation. */
export type UpdateTokenSalesInfoPayload = {
  __typename?: 'UpdateTokenSalesInfoPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TokenSalesInfo` that was updated by this mutation. */
  tokenSalesInfo?: Maybe<TokenSalesInfo>;
  /** An edge for our `TokenSalesInfo`. May be used by Relay 1. */
  tokenSalesInfoEdge?: Maybe<TokenSalesInfosEdge>;
};


/** The output of our update `TokenSalesInfo` mutation. */
export type UpdateTokenSalesInfoPayloadTokenSalesInfoEdgeArgs = {
  orderBy?: InputMaybe<Array<TokenSalesInfosOrderBy>>;
};

/** All input for the `updateTokenSalesPriceInfo` mutation. */
export type UpdateTokenSalesPriceInfoInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `TokenSalesPriceInfo` being updated. */
  patch: TokenSalesPriceInfoPatch;
};

/** The output of our update `TokenSalesPriceInfo` mutation. */
export type UpdateTokenSalesPriceInfoPayload = {
  __typename?: 'UpdateTokenSalesPriceInfoPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TokenSalesPriceInfo` that was updated by this mutation. */
  tokenSalesPriceInfo?: Maybe<TokenSalesPriceInfo>;
  /** An edge for our `TokenSalesPriceInfo`. May be used by Relay 1. */
  tokenSalesPriceInfoEdge?: Maybe<TokenSalesPriceInfosEdge>;
};


/** The output of our update `TokenSalesPriceInfo` mutation. */
export type UpdateTokenSalesPriceInfoPayloadTokenSalesPriceInfoEdgeArgs = {
  orderBy?: InputMaybe<Array<TokenSalesPriceInfosOrderBy>>;
};

/** All input for the `updateUserBetHistory` mutation. */
export type UpdateUserBetHistoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `UserBetHistory` being updated. */
  patch: UserBetHistoryPatch;
};

/** The output of our update `UserBetHistory` mutation. */
export type UpdateUserBetHistoryPayload = {
  __typename?: 'UpdateUserBetHistoryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserBetHistory` that was updated by this mutation. */
  userBetHistory?: Maybe<UserBetHistory>;
  /** An edge for our `UserBetHistory`. May be used by Relay 1. */
  userBetHistoryEdge?: Maybe<UserBetHistoriesEdge>;
};


/** The output of our update `UserBetHistory` mutation. */
export type UpdateUserBetHistoryPayloadUserBetHistoryEdgeArgs = {
  orderBy?: InputMaybe<Array<UserBetHistoriesOrderBy>>;
};

/** All input for the `updateUserCompetition` mutation. */
export type UpdateUserCompetitionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  competition: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `UserCompetition` being updated. */
  patch: UserCompetitionPatch;
  player: Scalars['String']['input'];
};

/** The output of our update `UserCompetition` mutation. */
export type UpdateUserCompetitionPayload = {
  __typename?: 'UpdateUserCompetitionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserCompetition` that was updated by this mutation. */
  userCompetition?: Maybe<UserCompetition>;
  /** An edge for our `UserCompetition`. May be used by Relay 1. */
  userCompetitionEdge?: Maybe<UserCompetitionsEdge>;
};


/** The output of our update `UserCompetition` mutation. */
export type UpdateUserCompetitionPayloadUserCompetitionEdgeArgs = {
  orderBy?: InputMaybe<Array<UserCompetitionsOrderBy>>;
};

/** All input for the `updateUser` mutation. */
export type UpdateUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `User` being updated. */
  patch: UserPatch;
};

/** The output of our update `User` mutation. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was updated by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
  /** Reads a single `UserStatistic` that is related to this `User`. */
  userStatistic?: Maybe<UserStatistic>;
};


/** The output of our update `User` mutation. */
export type UpdateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `updateUserStatistic` mutation. */
export type UpdateUserStatisticInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `UserStatistic` being updated. */
  patch: UserStatisticPatch;
};

/** The output of our update `UserStatistic` mutation. */
export type UpdateUserStatisticPayload = {
  __typename?: 'UpdateUserStatisticPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserStatistic` that was updated by this mutation. */
  userStatistic?: Maybe<UserStatistic>;
  /** An edge for our `UserStatistic`. May be used by Relay 1. */
  userStatisticEdge?: Maybe<UserStatisticsEdge>;
};


/** The output of our update `UserStatistic` mutation. */
export type UpdateUserStatisticPayloadUserStatisticEdgeArgs = {
  orderBy?: InputMaybe<Array<UserStatisticsOrderBy>>;
};

/** All input for the `updateUserStatisticsByDay` mutation. */
export type UpdateUserStatisticsByDayInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['Date']['input'];
  id: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `UserStatisticsByDay` being updated. */
  patch: UserStatisticsByDayPatch;
};

/** The output of our update `UserStatisticsByDay` mutation. */
export type UpdateUserStatisticsByDayPayload = {
  __typename?: 'UpdateUserStatisticsByDayPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UserStatistic` that is related to this `UserStatisticsByDay`. */
  userStatisticById?: Maybe<UserStatistic>;
  /** The `UserStatisticsByDay` that was updated by this mutation. */
  userStatisticsByDay?: Maybe<UserStatisticsByDay>;
  /** An edge for our `UserStatisticsByDay`. May be used by Relay 1. */
  userStatisticsByDayEdge?: Maybe<UserStatisticsByDaysEdge>;
};


/** The output of our update `UserStatisticsByDay` mutation. */
export type UpdateUserStatisticsByDayPayloadUserStatisticsByDayEdgeArgs = {
  orderBy?: InputMaybe<Array<UserStatisticsByDaysOrderBy>>;
};

/** All input for the `updateUserStatisticsV2` mutation. */
export type UpdateUserStatisticsV2Input = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `UserStatisticsV2` being updated. */
  patch: UserStatisticsV2Patch;
  player: Scalars['String']['input'];
};

/** The output of our update `UserStatisticsV2` mutation. */
export type UpdateUserStatisticsV2Payload = {
  __typename?: 'UpdateUserStatisticsV2Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserStatisticsV2` that was updated by this mutation. */
  userStatisticsV2?: Maybe<UserStatisticsV2>;
  /** An edge for our `UserStatisticsV2`. May be used by Relay 1. */
  userStatisticsV2Edge?: Maybe<UserStatisticsV2sEdge>;
};


/** The output of our update `UserStatisticsV2` mutation. */
export type UpdateUserStatisticsV2PayloadUserStatisticsV2EdgeArgs = {
  orderBy?: InputMaybe<Array<UserStatisticsV2sOrderBy>>;
};

/** All input for the `updateUserTokenSale` mutation. */
export type UpdateUserTokenSaleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `UserTokenSale` being updated. */
  patch: UserTokenSalePatch;
  player: Scalars['String']['input'];
};

/** The output of our update `UserTokenSale` mutation. */
export type UpdateUserTokenSalePayload = {
  __typename?: 'UpdateUserTokenSalePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserTokenSale` that was updated by this mutation. */
  userTokenSale?: Maybe<UserTokenSale>;
  /** An edge for our `UserTokenSale`. May be used by Relay 1. */
  userTokenSaleEdge?: Maybe<UserTokenSalesEdge>;
};


/** The output of our update `UserTokenSale` mutation. */
export type UpdateUserTokenSalePayloadUserTokenSaleEdgeArgs = {
  orderBy?: InputMaybe<Array<UserTokenSalesOrderBy>>;
};

/** All input for the `updateUserTokenSaleTransaction` mutation. */
export type UpdateUserTokenSaleTransactionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `UserTokenSaleTransaction` being updated. */
  patch: UserTokenSaleTransactionPatch;
};

/** The output of our update `UserTokenSaleTransaction` mutation. */
export type UpdateUserTokenSaleTransactionPayload = {
  __typename?: 'UpdateUserTokenSaleTransactionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserTokenSaleTransaction` that was updated by this mutation. */
  userTokenSaleTransaction?: Maybe<UserTokenSaleTransaction>;
  /** An edge for our `UserTokenSaleTransaction`. May be used by Relay 1. */
  userTokenSaleTransactionEdge?: Maybe<UserTokenSaleTransactionsEdge>;
};


/** The output of our update `UserTokenSaleTransaction` mutation. */
export type UpdateUserTokenSaleTransactionPayloadUserTokenSaleTransactionEdgeArgs = {
  orderBy?: InputMaybe<Array<UserTokenSaleTransactionsOrderBy>>;
};

export type User = {
  __typename?: 'User';
  balance: Scalars['BigInt']['output'];
  created: Scalars['Datetime']['output'];
  id: Scalars['String']['output'];
  lastBlockProcess: Scalars['BigInt']['output'];
  modified: Scalars['Datetime']['output'];
  profileAvatar?: Maybe<Scalars['String']['output']>;
  profileUserName?: Maybe<Scalars['String']['output']>;
  referrer: Scalars['String']['output'];
  /** Reads a single `UserStatistic` that is related to this `User`. */
  userStatistic?: Maybe<UserStatistic>;
};

/** A connection to a list of `UserBetHistory` values. */
export type UserBetHistoriesConnection = {
  __typename?: 'UserBetHistoriesConnection';
  /** A list of edges which contains the `UserBetHistory` and cursor to aid in pagination. */
  edges: Array<UserBetHistoriesEdge>;
  /** A list of `UserBetHistory` objects. */
  nodes: Array<Maybe<UserBetHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserBetHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UserBetHistory` edge in the connection. */
export type UserBetHistoriesEdge = {
  __typename?: 'UserBetHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserBetHistory` at the end of the edge. */
  node?: Maybe<UserBetHistory>;
};

/** Methods to use when ordering `UserBetHistory`. */
export enum UserBetHistoriesOrderBy {
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  GameAsc = 'GAME_ASC',
  GameDesc = 'GAME_DESC',
  GameIdAsc = 'GAME_ID_ASC',
  GameIdDesc = 'GAME_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UserAsc = 'USER_ASC',
  UserDesc = 'USER_DESC'
}

export type UserBetHistory = {
  __typename?: 'UserBetHistory';
  amount: Scalars['BigFloat']['output'];
  game: Scalars['String']['output'];
  gameId: Scalars['BigInt']['output'];
  id: Scalars['String']['output'];
  status?: Maybe<BetStatus>;
  user: Scalars['String']['output'];
};

/**
 * A condition to be used against `UserBetHistory` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserBetHistoryCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `game` field. */
  game?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `gameId` field. */
  gameId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<BetStatus>;
  /** Checks for equality with the object’s `user` field. */
  user?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `UserBetHistory` object types. All fields are combined with a logical ‘and.’ */
export type UserBetHistoryFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserBetHistoryFilter>>;
  /** Filter by the object’s `game` field. */
  game?: InputMaybe<StringFilter>;
  /** Filter by the object’s `gameId` field. */
  gameId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserBetHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserBetHistoryFilter>>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<BetStatusFilter>;
  /** Filter by the object’s `user` field. */
  user?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `UserBetHistory` */
export type UserBetHistoryInput = {
  amount: Scalars['BigFloat']['input'];
  game: Scalars['String']['input'];
  gameId: Scalars['BigInt']['input'];
  id: Scalars['String']['input'];
  status?: InputMaybe<BetStatus>;
  user: Scalars['String']['input'];
};

/** Represents an update to a `UserBetHistory`. Fields that are set will be updated. */
export type UserBetHistoryPatch = {
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  game?: InputMaybe<Scalars['String']['input']>;
  gameId?: InputMaybe<Scalars['BigInt']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BetStatus>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type UserCompetition = {
  __typename?: 'UserCompetition';
  competition: Scalars['String']['output'];
  info?: Maybe<Scalars['JSON']['output']>;
  player: Scalars['String']['output'];
  score: Scalars['BigInt']['output'];
};

/**
 * A condition to be used against `UserCompetition` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserCompetitionCondition = {
  /** Checks for equality with the object’s `competition` field. */
  competition?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `info` field. */
  info?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `player` field. */
  player?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `score` field. */
  score?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `UserCompetition` object types. All fields are combined with a logical ‘and.’ */
export type UserCompetitionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserCompetitionFilter>>;
  /** Filter by the object’s `competition` field. */
  competition?: InputMaybe<StringFilter>;
  /** Filter by the object’s `info` field. */
  info?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserCompetitionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserCompetitionFilter>>;
  /** Filter by the object’s `player` field. */
  player?: InputMaybe<StringFilter>;
  /** Filter by the object’s `score` field. */
  score?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `UserCompetition` */
export type UserCompetitionInput = {
  competition: Scalars['String']['input'];
  info?: InputMaybe<Scalars['JSON']['input']>;
  player: Scalars['String']['input'];
  score: Scalars['BigInt']['input'];
};

/** Represents an update to a `UserCompetition`. Fields that are set will be updated. */
export type UserCompetitionPatch = {
  competition?: InputMaybe<Scalars['String']['input']>;
  info?: InputMaybe<Scalars['JSON']['input']>;
  player?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A connection to a list of `UserCompetition` values. */
export type UserCompetitionsConnection = {
  __typename?: 'UserCompetitionsConnection';
  /** A list of edges which contains the `UserCompetition` and cursor to aid in pagination. */
  edges: Array<UserCompetitionsEdge>;
  /** A list of `UserCompetition` objects. */
  nodes: Array<Maybe<UserCompetition>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserCompetition` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UserCompetition` edge in the connection. */
export type UserCompetitionsEdge = {
  __typename?: 'UserCompetitionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserCompetition` at the end of the edge. */
  node?: Maybe<UserCompetition>;
};

/** Methods to use when ordering `UserCompetition`. */
export enum UserCompetitionsOrderBy {
  CompetitionAsc = 'COMPETITION_ASC',
  CompetitionDesc = 'COMPETITION_DESC',
  InfoAsc = 'INFO_ASC',
  InfoDesc = 'INFO_DESC',
  Natural = 'NATURAL',
  PlayerAsc = 'PLAYER_ASC',
  PlayerDesc = 'PLAYER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ScoreAsc = 'SCORE_ASC',
  ScoreDesc = 'SCORE_DESC'
}

/** A condition to be used against `User` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type UserCondition = {
  /** Checks for equality with the object’s `balance` field. */
  balance?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `lastBlockProcess` field. */
  lastBlockProcess?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `modified` field. */
  modified?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `profileAvatar` field. */
  profileAvatar?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `profileUserName` field. */
  profileUserName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `referrer` field. */
  referrer?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `User` object types. All fields are combined with a logical ‘and.’ */
export type UserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserFilter>>;
  /** Filter by the object’s `balance` field. */
  balance?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lastBlockProcess` field. */
  lastBlockProcess?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `modified` field. */
  modified?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserFilter>>;
  /** Filter by the object’s `profileAvatar` field. */
  profileAvatar?: InputMaybe<StringFilter>;
  /** Filter by the object’s `profileUserName` field. */
  profileUserName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `referrer` field. */
  referrer?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `User` */
export type UserInput = {
  balance?: InputMaybe<Scalars['BigInt']['input']>;
  created: Scalars['Datetime']['input'];
  id: Scalars['String']['input'];
  lastBlockProcess: Scalars['BigInt']['input'];
  modified: Scalars['Datetime']['input'];
  profileAvatar?: InputMaybe<Scalars['String']['input']>;
  profileUserName?: InputMaybe<Scalars['String']['input']>;
  referrer: Scalars['String']['input'];
};

/** Represents an update to a `User`. Fields that are set will be updated. */
export type UserPatch = {
  balance?: InputMaybe<Scalars['BigInt']['input']>;
  created?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastBlockProcess?: InputMaybe<Scalars['BigInt']['input']>;
  modified?: InputMaybe<Scalars['Datetime']['input']>;
  profileAvatar?: InputMaybe<Scalars['String']['input']>;
  profileUserName?: InputMaybe<Scalars['String']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
};

export type UserStatistic = {
  __typename?: 'UserStatistic';
  activeReferralsCount: Scalars['BigInt']['output'];
  claimsCount: Scalars['BigInt']['output'];
  coinflipBetAmount: Scalars['BigFloat']['output'];
  coinflipBetCount: Scalars['BigInt']['output'];
  coinflipGameCount: Scalars['BigInt']['output'];
  coinflipTopWinAmount: Scalars['BigFloat']['output'];
  coinflipWinAmount: Scalars['BigFloat']['output'];
  coinflipWinCount: Scalars['BigInt']['output'];
  doubleBetAmount: Scalars['BigFloat']['output'];
  doubleBetCount: Scalars['BigInt']['output'];
  doubleGameCount: Scalars['BigInt']['output'];
  doubleTopWinAmount: Scalars['BigFloat']['output'];
  doubleWinAmount: Scalars['BigFloat']['output'];
  doubleWinCount: Scalars['BigInt']['output'];
  id: Scalars['String']['output'];
  jackpotBetAmount: Scalars['BigFloat']['output'];
  jackpotBetCount: Scalars['BigInt']['output'];
  jackpotGameCount: Scalars['BigInt']['output'];
  jackpotTopWinAmount: Scalars['BigFloat']['output'];
  jackpotWinAmount: Scalars['BigFloat']['output'];
  jackpotWinCount: Scalars['BigInt']['output'];
  lootboxBetAmount: Scalars['BigFloat']['output'];
  lootboxBetCount: Scalars['BigInt']['output'];
  lootboxGameCount: Scalars['BigInt']['output'];
  lootboxTopWinAmount: Scalars['BigFloat']['output'];
  lootboxWinAmount: Scalars['BigFloat']['output'];
  minesBetAmount: Scalars['BigFloat']['output'];
  minesBetCount: Scalars['BigInt']['output'];
  minesGameCount: Scalars['BigInt']['output'];
  minesTopWinAmount: Scalars['BigFloat']['output'];
  minesWinAmount: Scalars['BigFloat']['output'];
  minesWinCount: Scalars['BigInt']['output'];
  referralTotalRewards: Scalars['BigFloat']['output'];
  referralsCount: Scalars['BigInt']['output'];
  roshamboBetAmount: Scalars['BigFloat']['output'];
  roshamboBetCount: Scalars['BigInt']['output'];
  roshamboGameCount: Scalars['BigInt']['output'];
  roshamboTopWinAmount: Scalars['BigFloat']['output'];
  roshamboWinAmount: Scalars['BigFloat']['output'];
  roshamboWinCount: Scalars['BigInt']['output'];
  totalBetAmount: Scalars['BigFloat']['output'];
  totalBetCount: Scalars['BigInt']['output'];
  totalGameCount: Scalars['BigInt']['output'];
  totalTopWinAmount: Scalars['BigFloat']['output'];
  totalWinAmount: Scalars['BigFloat']['output'];
  totalWinCount: Scalars['BigInt']['output'];
  /** Reads a single `User` that is related to this `UserStatistic`. */
  userStatistic?: Maybe<User>;
  /** Reads and enables pagination through a set of `UserStatisticsByDay`. */
  userStatisticsByDaysById: UserStatisticsByDaysConnection;
  /**
   * Reads and enables pagination through a set of `User`.
   * @deprecated Please use userStatistic instead
   */
  usersById: UsersConnection;
};


export type UserStatisticUserStatisticsByDaysByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserStatisticsByDayCondition>;
  filter?: InputMaybe<UserStatisticsByDayFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserStatisticsByDaysOrderBy>>;
};


export type UserStatisticUsersByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/**
 * A condition to be used against `UserStatistic` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserStatisticCondition = {
  /** Checks for equality with the object’s `activeReferralsCount` field. */
  activeReferralsCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `claimsCount` field. */
  claimsCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `coinflipBetAmount` field. */
  coinflipBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `coinflipBetCount` field. */
  coinflipBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `coinflipGameCount` field. */
  coinflipGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `coinflipTopWinAmount` field. */
  coinflipTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `coinflipWinAmount` field. */
  coinflipWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `coinflipWinCount` field. */
  coinflipWinCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `doubleBetAmount` field. */
  doubleBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `doubleBetCount` field. */
  doubleBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `doubleGameCount` field. */
  doubleGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `doubleTopWinAmount` field. */
  doubleTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `doubleWinAmount` field. */
  doubleWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `doubleWinCount` field. */
  doubleWinCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `jackpotBetAmount` field. */
  jackpotBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `jackpotBetCount` field. */
  jackpotBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `jackpotGameCount` field. */
  jackpotGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `jackpotTopWinAmount` field. */
  jackpotTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `jackpotWinAmount` field. */
  jackpotWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `jackpotWinCount` field. */
  jackpotWinCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `lootboxBetAmount` field. */
  lootboxBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `lootboxBetCount` field. */
  lootboxBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `lootboxGameCount` field. */
  lootboxGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `lootboxTopWinAmount` field. */
  lootboxTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `lootboxWinAmount` field. */
  lootboxWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `minesBetAmount` field. */
  minesBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `minesBetCount` field. */
  minesBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `minesGameCount` field. */
  minesGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `minesTopWinAmount` field. */
  minesTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `minesWinAmount` field. */
  minesWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `minesWinCount` field. */
  minesWinCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `referralTotalRewards` field. */
  referralTotalRewards?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `referralsCount` field. */
  referralsCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `roshamboBetAmount` field. */
  roshamboBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `roshamboBetCount` field. */
  roshamboBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `roshamboGameCount` field. */
  roshamboGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `roshamboTopWinAmount` field. */
  roshamboTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `roshamboWinAmount` field. */
  roshamboWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `roshamboWinCount` field. */
  roshamboWinCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `totalBetAmount` field. */
  totalBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalBetCount` field. */
  totalBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `totalGameCount` field. */
  totalGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `totalTopWinAmount` field. */
  totalTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalWinAmount` field. */
  totalWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalWinCount` field. */
  totalWinCount?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `UserStatistic` object types. All fields are combined with a logical ‘and.’ */
export type UserStatisticFilter = {
  /** Filter by the object’s `activeReferralsCount` field. */
  activeReferralsCount?: InputMaybe<BigIntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserStatisticFilter>>;
  /** Filter by the object’s `claimsCount` field. */
  claimsCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `coinflipBetAmount` field. */
  coinflipBetAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `coinflipBetCount` field. */
  coinflipBetCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `coinflipGameCount` field. */
  coinflipGameCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `coinflipTopWinAmount` field. */
  coinflipTopWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `coinflipWinAmount` field. */
  coinflipWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `coinflipWinCount` field. */
  coinflipWinCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `doubleBetAmount` field. */
  doubleBetAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `doubleBetCount` field. */
  doubleBetCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `doubleGameCount` field. */
  doubleGameCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `doubleTopWinAmount` field. */
  doubleTopWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `doubleWinAmount` field. */
  doubleWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `doubleWinCount` field. */
  doubleWinCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `jackpotBetAmount` field. */
  jackpotBetAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `jackpotBetCount` field. */
  jackpotBetCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `jackpotGameCount` field. */
  jackpotGameCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `jackpotTopWinAmount` field. */
  jackpotTopWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `jackpotWinAmount` field. */
  jackpotWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `jackpotWinCount` field. */
  jackpotWinCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `lootboxBetAmount` field. */
  lootboxBetAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `lootboxBetCount` field. */
  lootboxBetCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `lootboxGameCount` field. */
  lootboxGameCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `lootboxTopWinAmount` field. */
  lootboxTopWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `lootboxWinAmount` field. */
  lootboxWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `minesBetAmount` field. */
  minesBetAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `minesBetCount` field. */
  minesBetCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `minesGameCount` field. */
  minesGameCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `minesTopWinAmount` field. */
  minesTopWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `minesWinAmount` field. */
  minesWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `minesWinCount` field. */
  minesWinCount?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserStatisticFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserStatisticFilter>>;
  /** Filter by the object’s `referralTotalRewards` field. */
  referralTotalRewards?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `referralsCount` field. */
  referralsCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `roshamboBetAmount` field. */
  roshamboBetAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `roshamboBetCount` field. */
  roshamboBetCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `roshamboGameCount` field. */
  roshamboGameCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `roshamboTopWinAmount` field. */
  roshamboTopWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `roshamboWinAmount` field. */
  roshamboWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `roshamboWinCount` field. */
  roshamboWinCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `totalBetAmount` field. */
  totalBetAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalBetCount` field. */
  totalBetCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `totalGameCount` field. */
  totalGameCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `totalTopWinAmount` field. */
  totalTopWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalWinAmount` field. */
  totalWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalWinCount` field. */
  totalWinCount?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `UserStatistic` */
export type UserStatisticInput = {
  activeReferralsCount: Scalars['BigInt']['input'];
  claimsCount: Scalars['BigInt']['input'];
  coinflipBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  coinflipBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  coinflipGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  coinflipTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  coinflipWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  coinflipWinCount?: InputMaybe<Scalars['BigInt']['input']>;
  doubleBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  doubleBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  doubleGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  doubleTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  doubleWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  doubleWinCount?: InputMaybe<Scalars['BigInt']['input']>;
  id: Scalars['String']['input'];
  jackpotBetAmount: Scalars['BigFloat']['input'];
  jackpotBetCount: Scalars['BigInt']['input'];
  jackpotGameCount: Scalars['BigInt']['input'];
  jackpotTopWinAmount: Scalars['BigFloat']['input'];
  jackpotWinAmount: Scalars['BigFloat']['input'];
  jackpotWinCount: Scalars['BigInt']['input'];
  lootboxBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  lootboxBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  lootboxGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  lootboxTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  lootboxWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  minesBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  minesBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  minesGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  minesTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  minesWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  minesWinCount?: InputMaybe<Scalars['BigInt']['input']>;
  referralTotalRewards: Scalars['BigFloat']['input'];
  referralsCount: Scalars['BigInt']['input'];
  roshamboBetAmount: Scalars['BigFloat']['input'];
  roshamboBetCount: Scalars['BigInt']['input'];
  roshamboGameCount: Scalars['BigInt']['input'];
  roshamboTopWinAmount: Scalars['BigFloat']['input'];
  roshamboWinAmount: Scalars['BigFloat']['input'];
  roshamboWinCount: Scalars['BigInt']['input'];
  totalBetAmount: Scalars['BigFloat']['input'];
  totalBetCount: Scalars['BigInt']['input'];
  totalGameCount: Scalars['BigInt']['input'];
  totalTopWinAmount: Scalars['BigFloat']['input'];
  totalWinAmount: Scalars['BigFloat']['input'];
  totalWinCount: Scalars['BigInt']['input'];
};

/** Represents an update to a `UserStatistic`. Fields that are set will be updated. */
export type UserStatisticPatch = {
  activeReferralsCount?: InputMaybe<Scalars['BigInt']['input']>;
  claimsCount?: InputMaybe<Scalars['BigInt']['input']>;
  coinflipBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  coinflipBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  coinflipGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  coinflipTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  coinflipWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  coinflipWinCount?: InputMaybe<Scalars['BigInt']['input']>;
  doubleBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  doubleBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  doubleGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  doubleTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  doubleWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  doubleWinCount?: InputMaybe<Scalars['BigInt']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  jackpotBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  jackpotBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  jackpotGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  jackpotTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  jackpotWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  jackpotWinCount?: InputMaybe<Scalars['BigInt']['input']>;
  lootboxBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  lootboxBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  lootboxGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  lootboxTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  lootboxWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  minesBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  minesBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  minesGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  minesTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  minesWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  minesWinCount?: InputMaybe<Scalars['BigInt']['input']>;
  referralTotalRewards?: InputMaybe<Scalars['BigFloat']['input']>;
  referralsCount?: InputMaybe<Scalars['BigInt']['input']>;
  roshamboBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  roshamboBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  roshamboGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  roshamboTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  roshamboWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  roshamboWinCount?: InputMaybe<Scalars['BigInt']['input']>;
  totalBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  totalBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  totalGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  totalTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  totalWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  totalWinCount?: InputMaybe<Scalars['BigInt']['input']>;
};

export type UserStatisticsByDay = {
  __typename?: 'UserStatisticsByDay';
  activeReferralsCount: Scalars['BigInt']['output'];
  claimsCount: Scalars['BigInt']['output'];
  coinflipBetAmount: Scalars['BigFloat']['output'];
  coinflipBetCount: Scalars['BigInt']['output'];
  coinflipGameCount: Scalars['BigInt']['output'];
  coinflipTopWinAmount: Scalars['BigFloat']['output'];
  coinflipWinAmount: Scalars['BigFloat']['output'];
  coinflipWinCount: Scalars['BigInt']['output'];
  date: Scalars['Date']['output'];
  doubleBetAmount: Scalars['BigFloat']['output'];
  doubleBetCount: Scalars['BigInt']['output'];
  doubleGameCount: Scalars['BigInt']['output'];
  doubleTopWinAmount: Scalars['BigFloat']['output'];
  doubleWinAmount: Scalars['BigFloat']['output'];
  doubleWinCount: Scalars['BigInt']['output'];
  id: Scalars['String']['output'];
  jackpotBetAmount: Scalars['BigFloat']['output'];
  jackpotBetCount: Scalars['BigInt']['output'];
  jackpotGameCount: Scalars['BigInt']['output'];
  jackpotTopWinAmount: Scalars['BigFloat']['output'];
  jackpotWinAmount: Scalars['BigFloat']['output'];
  jackpotWinCount: Scalars['BigInt']['output'];
  lootboxBetAmount: Scalars['BigFloat']['output'];
  lootboxBetCount: Scalars['BigInt']['output'];
  lootboxGameCount: Scalars['BigInt']['output'];
  lootboxTopWinAmount: Scalars['BigFloat']['output'];
  lootboxWinAmount: Scalars['BigFloat']['output'];
  minesBetAmount: Scalars['BigFloat']['output'];
  minesBetCount: Scalars['BigInt']['output'];
  minesGameCount: Scalars['BigInt']['output'];
  minesTopWinAmount: Scalars['BigFloat']['output'];
  minesWinAmount: Scalars['BigFloat']['output'];
  minesWinCount: Scalars['BigInt']['output'];
  referralTotalRewards: Scalars['BigFloat']['output'];
  referralsCount: Scalars['BigInt']['output'];
  roshamboBetAmount: Scalars['BigFloat']['output'];
  roshamboBetCount: Scalars['BigInt']['output'];
  roshamboGameCount: Scalars['BigInt']['output'];
  roshamboTopWinAmount: Scalars['BigFloat']['output'];
  roshamboWinAmount: Scalars['BigFloat']['output'];
  roshamboWinCount: Scalars['BigInt']['output'];
  totalBetAmount: Scalars['BigFloat']['output'];
  totalBetCount: Scalars['BigInt']['output'];
  totalGameCount: Scalars['BigInt']['output'];
  totalTopWinAmount: Scalars['BigFloat']['output'];
  totalWinAmount: Scalars['BigFloat']['output'];
  totalWinCount: Scalars['BigInt']['output'];
  /** Reads a single `UserStatistic` that is related to this `UserStatisticsByDay`. */
  userStatisticById?: Maybe<UserStatistic>;
};

/**
 * A condition to be used against `UserStatisticsByDay` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type UserStatisticsByDayCondition = {
  /** Checks for equality with the object’s `activeReferralsCount` field. */
  activeReferralsCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `claimsCount` field. */
  claimsCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `coinflipBetAmount` field. */
  coinflipBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `coinflipBetCount` field. */
  coinflipBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `coinflipGameCount` field. */
  coinflipGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `coinflipTopWinAmount` field. */
  coinflipTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `coinflipWinAmount` field. */
  coinflipWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `coinflipWinCount` field. */
  coinflipWinCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `date` field. */
  date?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `doubleBetAmount` field. */
  doubleBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `doubleBetCount` field. */
  doubleBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `doubleGameCount` field. */
  doubleGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `doubleTopWinAmount` field. */
  doubleTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `doubleWinAmount` field. */
  doubleWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `doubleWinCount` field. */
  doubleWinCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `jackpotBetAmount` field. */
  jackpotBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `jackpotBetCount` field. */
  jackpotBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `jackpotGameCount` field. */
  jackpotGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `jackpotTopWinAmount` field. */
  jackpotTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `jackpotWinAmount` field. */
  jackpotWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `jackpotWinCount` field. */
  jackpotWinCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `lootboxBetAmount` field. */
  lootboxBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `lootboxBetCount` field. */
  lootboxBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `lootboxGameCount` field. */
  lootboxGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `lootboxTopWinAmount` field. */
  lootboxTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `lootboxWinAmount` field. */
  lootboxWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `minesBetAmount` field. */
  minesBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `minesBetCount` field. */
  minesBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `minesGameCount` field. */
  minesGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `minesTopWinAmount` field. */
  minesTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `minesWinAmount` field. */
  minesWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `minesWinCount` field. */
  minesWinCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `referralTotalRewards` field. */
  referralTotalRewards?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `referralsCount` field. */
  referralsCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `roshamboBetAmount` field. */
  roshamboBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `roshamboBetCount` field. */
  roshamboBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `roshamboGameCount` field. */
  roshamboGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `roshamboTopWinAmount` field. */
  roshamboTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `roshamboWinAmount` field. */
  roshamboWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `roshamboWinCount` field. */
  roshamboWinCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `totalBetAmount` field. */
  totalBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalBetCount` field. */
  totalBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `totalGameCount` field. */
  totalGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `totalTopWinAmount` field. */
  totalTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalWinAmount` field. */
  totalWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalWinCount` field. */
  totalWinCount?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `UserStatisticsByDay` object types. All fields are combined with a logical ‘and.’ */
export type UserStatisticsByDayFilter = {
  /** Filter by the object’s `activeReferralsCount` field. */
  activeReferralsCount?: InputMaybe<BigIntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserStatisticsByDayFilter>>;
  /** Filter by the object’s `claimsCount` field. */
  claimsCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `coinflipBetAmount` field. */
  coinflipBetAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `coinflipBetCount` field. */
  coinflipBetCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `coinflipGameCount` field. */
  coinflipGameCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `coinflipTopWinAmount` field. */
  coinflipTopWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `coinflipWinAmount` field. */
  coinflipWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `coinflipWinCount` field. */
  coinflipWinCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `date` field. */
  date?: InputMaybe<DateFilter>;
  /** Filter by the object’s `doubleBetAmount` field. */
  doubleBetAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `doubleBetCount` field. */
  doubleBetCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `doubleGameCount` field. */
  doubleGameCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `doubleTopWinAmount` field. */
  doubleTopWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `doubleWinAmount` field. */
  doubleWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `doubleWinCount` field. */
  doubleWinCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `jackpotBetAmount` field. */
  jackpotBetAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `jackpotBetCount` field. */
  jackpotBetCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `jackpotGameCount` field. */
  jackpotGameCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `jackpotTopWinAmount` field. */
  jackpotTopWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `jackpotWinAmount` field. */
  jackpotWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `jackpotWinCount` field. */
  jackpotWinCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `lootboxBetAmount` field. */
  lootboxBetAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `lootboxBetCount` field. */
  lootboxBetCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `lootboxGameCount` field. */
  lootboxGameCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `lootboxTopWinAmount` field. */
  lootboxTopWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `lootboxWinAmount` field. */
  lootboxWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `minesBetAmount` field. */
  minesBetAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `minesBetCount` field. */
  minesBetCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `minesGameCount` field. */
  minesGameCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `minesTopWinAmount` field. */
  minesTopWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `minesWinAmount` field. */
  minesWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `minesWinCount` field. */
  minesWinCount?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserStatisticsByDayFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserStatisticsByDayFilter>>;
  /** Filter by the object’s `referralTotalRewards` field. */
  referralTotalRewards?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `referralsCount` field. */
  referralsCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `roshamboBetAmount` field. */
  roshamboBetAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `roshamboBetCount` field. */
  roshamboBetCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `roshamboGameCount` field. */
  roshamboGameCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `roshamboTopWinAmount` field. */
  roshamboTopWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `roshamboWinAmount` field. */
  roshamboWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `roshamboWinCount` field. */
  roshamboWinCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `totalBetAmount` field. */
  totalBetAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalBetCount` field. */
  totalBetCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `totalGameCount` field. */
  totalGameCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `totalTopWinAmount` field. */
  totalTopWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalWinAmount` field. */
  totalWinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalWinCount` field. */
  totalWinCount?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `UserStatisticsByDay` */
export type UserStatisticsByDayInput = {
  activeReferralsCount: Scalars['BigInt']['input'];
  claimsCount: Scalars['BigInt']['input'];
  coinflipBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  coinflipBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  coinflipGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  coinflipTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  coinflipWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  coinflipWinCount?: InputMaybe<Scalars['BigInt']['input']>;
  date: Scalars['Date']['input'];
  doubleBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  doubleBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  doubleGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  doubleTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  doubleWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  doubleWinCount?: InputMaybe<Scalars['BigInt']['input']>;
  id: Scalars['String']['input'];
  jackpotBetAmount: Scalars['BigFloat']['input'];
  jackpotBetCount: Scalars['BigInt']['input'];
  jackpotGameCount: Scalars['BigInt']['input'];
  jackpotTopWinAmount: Scalars['BigFloat']['input'];
  jackpotWinAmount: Scalars['BigFloat']['input'];
  jackpotWinCount: Scalars['BigInt']['input'];
  lootboxBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  lootboxBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  lootboxGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  lootboxTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  lootboxWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  minesBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  minesBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  minesGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  minesTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  minesWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  minesWinCount?: InputMaybe<Scalars['BigInt']['input']>;
  referralTotalRewards: Scalars['BigFloat']['input'];
  referralsCount: Scalars['BigInt']['input'];
  roshamboBetAmount: Scalars['BigFloat']['input'];
  roshamboBetCount: Scalars['BigInt']['input'];
  roshamboGameCount: Scalars['BigInt']['input'];
  roshamboTopWinAmount: Scalars['BigFloat']['input'];
  roshamboWinAmount: Scalars['BigFloat']['input'];
  roshamboWinCount: Scalars['BigInt']['input'];
  totalBetAmount: Scalars['BigFloat']['input'];
  totalBetCount: Scalars['BigInt']['input'];
  totalGameCount: Scalars['BigInt']['input'];
  totalTopWinAmount: Scalars['BigFloat']['input'];
  totalWinAmount: Scalars['BigFloat']['input'];
  totalWinCount: Scalars['BigInt']['input'];
};

/** Represents an update to a `UserStatisticsByDay`. Fields that are set will be updated. */
export type UserStatisticsByDayPatch = {
  activeReferralsCount?: InputMaybe<Scalars['BigInt']['input']>;
  claimsCount?: InputMaybe<Scalars['BigInt']['input']>;
  coinflipBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  coinflipBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  coinflipGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  coinflipTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  coinflipWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  coinflipWinCount?: InputMaybe<Scalars['BigInt']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  doubleBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  doubleBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  doubleGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  doubleTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  doubleWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  doubleWinCount?: InputMaybe<Scalars['BigInt']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  jackpotBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  jackpotBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  jackpotGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  jackpotTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  jackpotWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  jackpotWinCount?: InputMaybe<Scalars['BigInt']['input']>;
  lootboxBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  lootboxBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  lootboxGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  lootboxTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  lootboxWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  minesBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  minesBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  minesGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  minesTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  minesWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  minesWinCount?: InputMaybe<Scalars['BigInt']['input']>;
  referralTotalRewards?: InputMaybe<Scalars['BigFloat']['input']>;
  referralsCount?: InputMaybe<Scalars['BigInt']['input']>;
  roshamboBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  roshamboBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  roshamboGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  roshamboTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  roshamboWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  roshamboWinCount?: InputMaybe<Scalars['BigInt']['input']>;
  totalBetAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  totalBetCount?: InputMaybe<Scalars['BigInt']['input']>;
  totalGameCount?: InputMaybe<Scalars['BigInt']['input']>;
  totalTopWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  totalWinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  totalWinCount?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A connection to a list of `UserStatisticsByDay` values. */
export type UserStatisticsByDaysConnection = {
  __typename?: 'UserStatisticsByDaysConnection';
  /** A list of edges which contains the `UserStatisticsByDay` and cursor to aid in pagination. */
  edges: Array<UserStatisticsByDaysEdge>;
  /** A list of `UserStatisticsByDay` objects. */
  nodes: Array<Maybe<UserStatisticsByDay>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserStatisticsByDay` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UserStatisticsByDay` edge in the connection. */
export type UserStatisticsByDaysEdge = {
  __typename?: 'UserStatisticsByDaysEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserStatisticsByDay` at the end of the edge. */
  node?: Maybe<UserStatisticsByDay>;
};

/** Methods to use when ordering `UserStatisticsByDay`. */
export enum UserStatisticsByDaysOrderBy {
  ActiveReferralsCountAsc = 'ACTIVE_REFERRALS_COUNT_ASC',
  ActiveReferralsCountDesc = 'ACTIVE_REFERRALS_COUNT_DESC',
  ClaimsCountAsc = 'CLAIMS_COUNT_ASC',
  ClaimsCountDesc = 'CLAIMS_COUNT_DESC',
  CoinflipBetAmountAsc = 'COINFLIP_BET_AMOUNT_ASC',
  CoinflipBetAmountDesc = 'COINFLIP_BET_AMOUNT_DESC',
  CoinflipBetCountAsc = 'COINFLIP_BET_COUNT_ASC',
  CoinflipBetCountDesc = 'COINFLIP_BET_COUNT_DESC',
  CoinflipGameCountAsc = 'COINFLIP_GAME_COUNT_ASC',
  CoinflipGameCountDesc = 'COINFLIP_GAME_COUNT_DESC',
  CoinflipTopWinAmountAsc = 'COINFLIP_TOP_WIN_AMOUNT_ASC',
  CoinflipTopWinAmountDesc = 'COINFLIP_TOP_WIN_AMOUNT_DESC',
  CoinflipWinAmountAsc = 'COINFLIP_WIN_AMOUNT_ASC',
  CoinflipWinAmountDesc = 'COINFLIP_WIN_AMOUNT_DESC',
  CoinflipWinCountAsc = 'COINFLIP_WIN_COUNT_ASC',
  CoinflipWinCountDesc = 'COINFLIP_WIN_COUNT_DESC',
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  DoubleBetAmountAsc = 'DOUBLE_BET_AMOUNT_ASC',
  DoubleBetAmountDesc = 'DOUBLE_BET_AMOUNT_DESC',
  DoubleBetCountAsc = 'DOUBLE_BET_COUNT_ASC',
  DoubleBetCountDesc = 'DOUBLE_BET_COUNT_DESC',
  DoubleGameCountAsc = 'DOUBLE_GAME_COUNT_ASC',
  DoubleGameCountDesc = 'DOUBLE_GAME_COUNT_DESC',
  DoubleTopWinAmountAsc = 'DOUBLE_TOP_WIN_AMOUNT_ASC',
  DoubleTopWinAmountDesc = 'DOUBLE_TOP_WIN_AMOUNT_DESC',
  DoubleWinAmountAsc = 'DOUBLE_WIN_AMOUNT_ASC',
  DoubleWinAmountDesc = 'DOUBLE_WIN_AMOUNT_DESC',
  DoubleWinCountAsc = 'DOUBLE_WIN_COUNT_ASC',
  DoubleWinCountDesc = 'DOUBLE_WIN_COUNT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  JackpotBetAmountAsc = 'JACKPOT_BET_AMOUNT_ASC',
  JackpotBetAmountDesc = 'JACKPOT_BET_AMOUNT_DESC',
  JackpotBetCountAsc = 'JACKPOT_BET_COUNT_ASC',
  JackpotBetCountDesc = 'JACKPOT_BET_COUNT_DESC',
  JackpotGameCountAsc = 'JACKPOT_GAME_COUNT_ASC',
  JackpotGameCountDesc = 'JACKPOT_GAME_COUNT_DESC',
  JackpotTopWinAmountAsc = 'JACKPOT_TOP_WIN_AMOUNT_ASC',
  JackpotTopWinAmountDesc = 'JACKPOT_TOP_WIN_AMOUNT_DESC',
  JackpotWinAmountAsc = 'JACKPOT_WIN_AMOUNT_ASC',
  JackpotWinAmountDesc = 'JACKPOT_WIN_AMOUNT_DESC',
  JackpotWinCountAsc = 'JACKPOT_WIN_COUNT_ASC',
  JackpotWinCountDesc = 'JACKPOT_WIN_COUNT_DESC',
  LootboxBetAmountAsc = 'LOOTBOX_BET_AMOUNT_ASC',
  LootboxBetAmountDesc = 'LOOTBOX_BET_AMOUNT_DESC',
  LootboxBetCountAsc = 'LOOTBOX_BET_COUNT_ASC',
  LootboxBetCountDesc = 'LOOTBOX_BET_COUNT_DESC',
  LootboxGameCountAsc = 'LOOTBOX_GAME_COUNT_ASC',
  LootboxGameCountDesc = 'LOOTBOX_GAME_COUNT_DESC',
  LootboxTopWinAmountAsc = 'LOOTBOX_TOP_WIN_AMOUNT_ASC',
  LootboxTopWinAmountDesc = 'LOOTBOX_TOP_WIN_AMOUNT_DESC',
  LootboxWinAmountAsc = 'LOOTBOX_WIN_AMOUNT_ASC',
  LootboxWinAmountDesc = 'LOOTBOX_WIN_AMOUNT_DESC',
  MinesBetAmountAsc = 'MINES_BET_AMOUNT_ASC',
  MinesBetAmountDesc = 'MINES_BET_AMOUNT_DESC',
  MinesBetCountAsc = 'MINES_BET_COUNT_ASC',
  MinesBetCountDesc = 'MINES_BET_COUNT_DESC',
  MinesGameCountAsc = 'MINES_GAME_COUNT_ASC',
  MinesGameCountDesc = 'MINES_GAME_COUNT_DESC',
  MinesTopWinAmountAsc = 'MINES_TOP_WIN_AMOUNT_ASC',
  MinesTopWinAmountDesc = 'MINES_TOP_WIN_AMOUNT_DESC',
  MinesWinAmountAsc = 'MINES_WIN_AMOUNT_ASC',
  MinesWinAmountDesc = 'MINES_WIN_AMOUNT_DESC',
  MinesWinCountAsc = 'MINES_WIN_COUNT_ASC',
  MinesWinCountDesc = 'MINES_WIN_COUNT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReferralsCountAsc = 'REFERRALS_COUNT_ASC',
  ReferralsCountDesc = 'REFERRALS_COUNT_DESC',
  ReferralTotalRewardsAsc = 'REFERRAL_TOTAL_REWARDS_ASC',
  ReferralTotalRewardsDesc = 'REFERRAL_TOTAL_REWARDS_DESC',
  RoshamboBetAmountAsc = 'ROSHAMBO_BET_AMOUNT_ASC',
  RoshamboBetAmountDesc = 'ROSHAMBO_BET_AMOUNT_DESC',
  RoshamboBetCountAsc = 'ROSHAMBO_BET_COUNT_ASC',
  RoshamboBetCountDesc = 'ROSHAMBO_BET_COUNT_DESC',
  RoshamboGameCountAsc = 'ROSHAMBO_GAME_COUNT_ASC',
  RoshamboGameCountDesc = 'ROSHAMBO_GAME_COUNT_DESC',
  RoshamboTopWinAmountAsc = 'ROSHAMBO_TOP_WIN_AMOUNT_ASC',
  RoshamboTopWinAmountDesc = 'ROSHAMBO_TOP_WIN_AMOUNT_DESC',
  RoshamboWinAmountAsc = 'ROSHAMBO_WIN_AMOUNT_ASC',
  RoshamboWinAmountDesc = 'ROSHAMBO_WIN_AMOUNT_DESC',
  RoshamboWinCountAsc = 'ROSHAMBO_WIN_COUNT_ASC',
  RoshamboWinCountDesc = 'ROSHAMBO_WIN_COUNT_DESC',
  TotalBetAmountAsc = 'TOTAL_BET_AMOUNT_ASC',
  TotalBetAmountDesc = 'TOTAL_BET_AMOUNT_DESC',
  TotalBetCountAsc = 'TOTAL_BET_COUNT_ASC',
  TotalBetCountDesc = 'TOTAL_BET_COUNT_DESC',
  TotalGameCountAsc = 'TOTAL_GAME_COUNT_ASC',
  TotalGameCountDesc = 'TOTAL_GAME_COUNT_DESC',
  TotalTopWinAmountAsc = 'TOTAL_TOP_WIN_AMOUNT_ASC',
  TotalTopWinAmountDesc = 'TOTAL_TOP_WIN_AMOUNT_DESC',
  TotalWinAmountAsc = 'TOTAL_WIN_AMOUNT_ASC',
  TotalWinAmountDesc = 'TOTAL_WIN_AMOUNT_DESC',
  TotalWinCountAsc = 'TOTAL_WIN_COUNT_ASC',
  TotalWinCountDesc = 'TOTAL_WIN_COUNT_DESC'
}

/** A connection to a list of `UserStatistic` values. */
export type UserStatisticsConnection = {
  __typename?: 'UserStatisticsConnection';
  /** A list of edges which contains the `UserStatistic` and cursor to aid in pagination. */
  edges: Array<UserStatisticsEdge>;
  /** A list of `UserStatistic` objects. */
  nodes: Array<Maybe<UserStatistic>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserStatistic` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UserStatistic` edge in the connection. */
export type UserStatisticsEdge = {
  __typename?: 'UserStatisticsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserStatistic` at the end of the edge. */
  node?: Maybe<UserStatistic>;
};

/** Methods to use when ordering `UserStatistic`. */
export enum UserStatisticsOrderBy {
  ActiveReferralsCountAsc = 'ACTIVE_REFERRALS_COUNT_ASC',
  ActiveReferralsCountDesc = 'ACTIVE_REFERRALS_COUNT_DESC',
  ClaimsCountAsc = 'CLAIMS_COUNT_ASC',
  ClaimsCountDesc = 'CLAIMS_COUNT_DESC',
  CoinflipBetAmountAsc = 'COINFLIP_BET_AMOUNT_ASC',
  CoinflipBetAmountDesc = 'COINFLIP_BET_AMOUNT_DESC',
  CoinflipBetCountAsc = 'COINFLIP_BET_COUNT_ASC',
  CoinflipBetCountDesc = 'COINFLIP_BET_COUNT_DESC',
  CoinflipGameCountAsc = 'COINFLIP_GAME_COUNT_ASC',
  CoinflipGameCountDesc = 'COINFLIP_GAME_COUNT_DESC',
  CoinflipTopWinAmountAsc = 'COINFLIP_TOP_WIN_AMOUNT_ASC',
  CoinflipTopWinAmountDesc = 'COINFLIP_TOP_WIN_AMOUNT_DESC',
  CoinflipWinAmountAsc = 'COINFLIP_WIN_AMOUNT_ASC',
  CoinflipWinAmountDesc = 'COINFLIP_WIN_AMOUNT_DESC',
  CoinflipWinCountAsc = 'COINFLIP_WIN_COUNT_ASC',
  CoinflipWinCountDesc = 'COINFLIP_WIN_COUNT_DESC',
  DoubleBetAmountAsc = 'DOUBLE_BET_AMOUNT_ASC',
  DoubleBetAmountDesc = 'DOUBLE_BET_AMOUNT_DESC',
  DoubleBetCountAsc = 'DOUBLE_BET_COUNT_ASC',
  DoubleBetCountDesc = 'DOUBLE_BET_COUNT_DESC',
  DoubleGameCountAsc = 'DOUBLE_GAME_COUNT_ASC',
  DoubleGameCountDesc = 'DOUBLE_GAME_COUNT_DESC',
  DoubleTopWinAmountAsc = 'DOUBLE_TOP_WIN_AMOUNT_ASC',
  DoubleTopWinAmountDesc = 'DOUBLE_TOP_WIN_AMOUNT_DESC',
  DoubleWinAmountAsc = 'DOUBLE_WIN_AMOUNT_ASC',
  DoubleWinAmountDesc = 'DOUBLE_WIN_AMOUNT_DESC',
  DoubleWinCountAsc = 'DOUBLE_WIN_COUNT_ASC',
  DoubleWinCountDesc = 'DOUBLE_WIN_COUNT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  JackpotBetAmountAsc = 'JACKPOT_BET_AMOUNT_ASC',
  JackpotBetAmountDesc = 'JACKPOT_BET_AMOUNT_DESC',
  JackpotBetCountAsc = 'JACKPOT_BET_COUNT_ASC',
  JackpotBetCountDesc = 'JACKPOT_BET_COUNT_DESC',
  JackpotGameCountAsc = 'JACKPOT_GAME_COUNT_ASC',
  JackpotGameCountDesc = 'JACKPOT_GAME_COUNT_DESC',
  JackpotTopWinAmountAsc = 'JACKPOT_TOP_WIN_AMOUNT_ASC',
  JackpotTopWinAmountDesc = 'JACKPOT_TOP_WIN_AMOUNT_DESC',
  JackpotWinAmountAsc = 'JACKPOT_WIN_AMOUNT_ASC',
  JackpotWinAmountDesc = 'JACKPOT_WIN_AMOUNT_DESC',
  JackpotWinCountAsc = 'JACKPOT_WIN_COUNT_ASC',
  JackpotWinCountDesc = 'JACKPOT_WIN_COUNT_DESC',
  LootboxBetAmountAsc = 'LOOTBOX_BET_AMOUNT_ASC',
  LootboxBetAmountDesc = 'LOOTBOX_BET_AMOUNT_DESC',
  LootboxBetCountAsc = 'LOOTBOX_BET_COUNT_ASC',
  LootboxBetCountDesc = 'LOOTBOX_BET_COUNT_DESC',
  LootboxGameCountAsc = 'LOOTBOX_GAME_COUNT_ASC',
  LootboxGameCountDesc = 'LOOTBOX_GAME_COUNT_DESC',
  LootboxTopWinAmountAsc = 'LOOTBOX_TOP_WIN_AMOUNT_ASC',
  LootboxTopWinAmountDesc = 'LOOTBOX_TOP_WIN_AMOUNT_DESC',
  LootboxWinAmountAsc = 'LOOTBOX_WIN_AMOUNT_ASC',
  LootboxWinAmountDesc = 'LOOTBOX_WIN_AMOUNT_DESC',
  MinesBetAmountAsc = 'MINES_BET_AMOUNT_ASC',
  MinesBetAmountDesc = 'MINES_BET_AMOUNT_DESC',
  MinesBetCountAsc = 'MINES_BET_COUNT_ASC',
  MinesBetCountDesc = 'MINES_BET_COUNT_DESC',
  MinesGameCountAsc = 'MINES_GAME_COUNT_ASC',
  MinesGameCountDesc = 'MINES_GAME_COUNT_DESC',
  MinesTopWinAmountAsc = 'MINES_TOP_WIN_AMOUNT_ASC',
  MinesTopWinAmountDesc = 'MINES_TOP_WIN_AMOUNT_DESC',
  MinesWinAmountAsc = 'MINES_WIN_AMOUNT_ASC',
  MinesWinAmountDesc = 'MINES_WIN_AMOUNT_DESC',
  MinesWinCountAsc = 'MINES_WIN_COUNT_ASC',
  MinesWinCountDesc = 'MINES_WIN_COUNT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReferralsCountAsc = 'REFERRALS_COUNT_ASC',
  ReferralsCountDesc = 'REFERRALS_COUNT_DESC',
  ReferralTotalRewardsAsc = 'REFERRAL_TOTAL_REWARDS_ASC',
  ReferralTotalRewardsDesc = 'REFERRAL_TOTAL_REWARDS_DESC',
  RoshamboBetAmountAsc = 'ROSHAMBO_BET_AMOUNT_ASC',
  RoshamboBetAmountDesc = 'ROSHAMBO_BET_AMOUNT_DESC',
  RoshamboBetCountAsc = 'ROSHAMBO_BET_COUNT_ASC',
  RoshamboBetCountDesc = 'ROSHAMBO_BET_COUNT_DESC',
  RoshamboGameCountAsc = 'ROSHAMBO_GAME_COUNT_ASC',
  RoshamboGameCountDesc = 'ROSHAMBO_GAME_COUNT_DESC',
  RoshamboTopWinAmountAsc = 'ROSHAMBO_TOP_WIN_AMOUNT_ASC',
  RoshamboTopWinAmountDesc = 'ROSHAMBO_TOP_WIN_AMOUNT_DESC',
  RoshamboWinAmountAsc = 'ROSHAMBO_WIN_AMOUNT_ASC',
  RoshamboWinAmountDesc = 'ROSHAMBO_WIN_AMOUNT_DESC',
  RoshamboWinCountAsc = 'ROSHAMBO_WIN_COUNT_ASC',
  RoshamboWinCountDesc = 'ROSHAMBO_WIN_COUNT_DESC',
  TotalBetAmountAsc = 'TOTAL_BET_AMOUNT_ASC',
  TotalBetAmountDesc = 'TOTAL_BET_AMOUNT_DESC',
  TotalBetCountAsc = 'TOTAL_BET_COUNT_ASC',
  TotalBetCountDesc = 'TOTAL_BET_COUNT_DESC',
  TotalGameCountAsc = 'TOTAL_GAME_COUNT_ASC',
  TotalGameCountDesc = 'TOTAL_GAME_COUNT_DESC',
  TotalTopWinAmountAsc = 'TOTAL_TOP_WIN_AMOUNT_ASC',
  TotalTopWinAmountDesc = 'TOTAL_TOP_WIN_AMOUNT_DESC',
  TotalWinAmountAsc = 'TOTAL_WIN_AMOUNT_ASC',
  TotalWinAmountDesc = 'TOTAL_WIN_AMOUNT_DESC',
  TotalWinCountAsc = 'TOTAL_WIN_COUNT_ASC',
  TotalWinCountDesc = 'TOTAL_WIN_COUNT_DESC'
}

export type UserStatisticsV2 = {
  __typename?: 'UserStatisticsV2';
  activeReferralsCount: Scalars['BigInt']['output'];
  betAmount: Scalars['BigFloat']['output'];
  betCount: Scalars['BigInt']['output'];
  maxPayout: Scalars['BigFloat']['output'];
  payoutAmount: Scalars['BigFloat']['output'];
  payoutCount: Scalars['BigInt']['output'];
  player: Scalars['String']['output'];
  winCount: Scalars['BigInt']['output'];
};

/**
 * A condition to be used against `UserStatisticsV2` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserStatisticsV2Condition = {
  /** Checks for equality with the object’s `activeReferralsCount` field. */
  activeReferralsCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `betAmount` field. */
  betAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `betCount` field. */
  betCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `maxPayout` field. */
  maxPayout?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `payoutAmount` field. */
  payoutAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `payoutCount` field. */
  payoutCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `player` field. */
  player?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `winCount` field. */
  winCount?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `UserStatisticsV2` object types. All fields are combined with a logical ‘and.’ */
export type UserStatisticsV2Filter = {
  /** Filter by the object’s `activeReferralsCount` field. */
  activeReferralsCount?: InputMaybe<BigIntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserStatisticsV2Filter>>;
  /** Filter by the object’s `betAmount` field. */
  betAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `betCount` field. */
  betCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `maxPayout` field. */
  maxPayout?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserStatisticsV2Filter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserStatisticsV2Filter>>;
  /** Filter by the object’s `payoutAmount` field. */
  payoutAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `payoutCount` field. */
  payoutCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `player` field. */
  player?: InputMaybe<StringFilter>;
  /** Filter by the object’s `winCount` field. */
  winCount?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `UserStatisticsV2` */
export type UserStatisticsV2Input = {
  activeReferralsCount: Scalars['BigInt']['input'];
  betAmount: Scalars['BigFloat']['input'];
  betCount: Scalars['BigInt']['input'];
  maxPayout: Scalars['BigFloat']['input'];
  payoutAmount: Scalars['BigFloat']['input'];
  payoutCount: Scalars['BigInt']['input'];
  player: Scalars['String']['input'];
  winCount: Scalars['BigInt']['input'];
};

/** Represents an update to a `UserStatisticsV2`. Fields that are set will be updated. */
export type UserStatisticsV2Patch = {
  activeReferralsCount?: InputMaybe<Scalars['BigInt']['input']>;
  betAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  betCount?: InputMaybe<Scalars['BigInt']['input']>;
  maxPayout?: InputMaybe<Scalars['BigFloat']['input']>;
  payoutAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  payoutCount?: InputMaybe<Scalars['BigInt']['input']>;
  player?: InputMaybe<Scalars['String']['input']>;
  winCount?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A connection to a list of `UserStatisticsV2` values. */
export type UserStatisticsV2sConnection = {
  __typename?: 'UserStatisticsV2sConnection';
  /** A list of edges which contains the `UserStatisticsV2` and cursor to aid in pagination. */
  edges: Array<UserStatisticsV2sEdge>;
  /** A list of `UserStatisticsV2` objects. */
  nodes: Array<Maybe<UserStatisticsV2>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserStatisticsV2` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UserStatisticsV2` edge in the connection. */
export type UserStatisticsV2sEdge = {
  __typename?: 'UserStatisticsV2sEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserStatisticsV2` at the end of the edge. */
  node?: Maybe<UserStatisticsV2>;
};

/** Methods to use when ordering `UserStatisticsV2`. */
export enum UserStatisticsV2sOrderBy {
  ActiveReferralsCountAsc = 'ACTIVE_REFERRALS_COUNT_ASC',
  ActiveReferralsCountDesc = 'ACTIVE_REFERRALS_COUNT_DESC',
  BetAmountAsc = 'BET_AMOUNT_ASC',
  BetAmountDesc = 'BET_AMOUNT_DESC',
  BetCountAsc = 'BET_COUNT_ASC',
  BetCountDesc = 'BET_COUNT_DESC',
  MaxPayoutAsc = 'MAX_PAYOUT_ASC',
  MaxPayoutDesc = 'MAX_PAYOUT_DESC',
  Natural = 'NATURAL',
  PayoutAmountAsc = 'PAYOUT_AMOUNT_ASC',
  PayoutAmountDesc = 'PAYOUT_AMOUNT_DESC',
  PayoutCountAsc = 'PAYOUT_COUNT_ASC',
  PayoutCountDesc = 'PAYOUT_COUNT_DESC',
  PlayerAsc = 'PLAYER_ASC',
  PlayerDesc = 'PLAYER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  WinCountAsc = 'WIN_COUNT_ASC',
  WinCountDesc = 'WIN_COUNT_DESC'
}

export type UserTokenSale = {
  __typename?: 'UserTokenSale';
  created: Scalars['Datetime']['output'];
  partner?: Maybe<Scalars['String']['output']>;
  partnerReferral: Scalars['BigInt']['output'];
  partnerRewardInj: Scalars['BigFloat']['output'];
  partnerRewardUsdc: Scalars['BigFloat']['output'];
  partnerTransactionCount: Scalars['BigInt']['output'];
  payInj?: Maybe<Scalars['BigFloat']['output']>;
  payUsdc?: Maybe<Scalars['BigFloat']['output']>;
  player: Scalars['String']['output'];
  tokenAmount: Scalars['BigInt']['output'];
  transactionCount: Scalars['BigInt']['output'];
};

/**
 * A condition to be used against `UserTokenSale` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserTokenSaleCondition = {
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `partner` field. */
  partner?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `partnerReferral` field. */
  partnerReferral?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `partnerRewardInj` field. */
  partnerRewardInj?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `partnerRewardUsdc` field. */
  partnerRewardUsdc?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `partnerTransactionCount` field. */
  partnerTransactionCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `payInj` field. */
  payInj?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `payUsdc` field. */
  payUsdc?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `player` field. */
  player?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `tokenAmount` field. */
  tokenAmount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `transactionCount` field. */
  transactionCount?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `UserTokenSale` object types. All fields are combined with a logical ‘and.’ */
export type UserTokenSaleFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserTokenSaleFilter>>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserTokenSaleFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserTokenSaleFilter>>;
  /** Filter by the object’s `partner` field. */
  partner?: InputMaybe<StringFilter>;
  /** Filter by the object’s `partnerReferral` field. */
  partnerReferral?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `partnerRewardInj` field. */
  partnerRewardInj?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `partnerRewardUsdc` field. */
  partnerRewardUsdc?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `partnerTransactionCount` field. */
  partnerTransactionCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `payInj` field. */
  payInj?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `payUsdc` field. */
  payUsdc?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `player` field. */
  player?: InputMaybe<StringFilter>;
  /** Filter by the object’s `tokenAmount` field. */
  tokenAmount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `transactionCount` field. */
  transactionCount?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `UserTokenSale` */
export type UserTokenSaleInput = {
  created: Scalars['Datetime']['input'];
  partner?: InputMaybe<Scalars['String']['input']>;
  partnerReferral: Scalars['BigInt']['input'];
  partnerRewardInj: Scalars['BigFloat']['input'];
  partnerRewardUsdc: Scalars['BigFloat']['input'];
  partnerTransactionCount: Scalars['BigInt']['input'];
  payInj?: InputMaybe<Scalars['BigFloat']['input']>;
  payUsdc?: InputMaybe<Scalars['BigFloat']['input']>;
  player: Scalars['String']['input'];
  tokenAmount: Scalars['BigInt']['input'];
  transactionCount: Scalars['BigInt']['input'];
};

/** Represents an update to a `UserTokenSale`. Fields that are set will be updated. */
export type UserTokenSalePatch = {
  created?: InputMaybe<Scalars['Datetime']['input']>;
  partner?: InputMaybe<Scalars['String']['input']>;
  partnerReferral?: InputMaybe<Scalars['BigInt']['input']>;
  partnerRewardInj?: InputMaybe<Scalars['BigFloat']['input']>;
  partnerRewardUsdc?: InputMaybe<Scalars['BigFloat']['input']>;
  partnerTransactionCount?: InputMaybe<Scalars['BigInt']['input']>;
  payInj?: InputMaybe<Scalars['BigFloat']['input']>;
  payUsdc?: InputMaybe<Scalars['BigFloat']['input']>;
  player?: InputMaybe<Scalars['String']['input']>;
  tokenAmount?: InputMaybe<Scalars['BigInt']['input']>;
  transactionCount?: InputMaybe<Scalars['BigInt']['input']>;
};

export type UserTokenSaleTransaction = {
  __typename?: 'UserTokenSaleTransaction';
  amount: Scalars['BigInt']['output'];
  created: Scalars['Datetime']['output'];
  id: Scalars['BigInt']['output'];
  partner: Scalars['String']['output'];
  partnerFee: Scalars['JSON']['output'];
  pay: Scalars['JSON']['output'];
  player: Scalars['String']['output'];
  priceId: Scalars['BigInt']['output'];
};

/**
 * A condition to be used against `UserTokenSaleTransaction` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type UserTokenSaleTransactionCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `partner` field. */
  partner?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `partnerFee` field. */
  partnerFee?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `pay` field. */
  pay?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `player` field. */
  player?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `priceId` field. */
  priceId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `UserTokenSaleTransaction` object types. All fields are combined with a logical ‘and.’ */
export type UserTokenSaleTransactionFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigIntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserTokenSaleTransactionFilter>>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserTokenSaleTransactionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserTokenSaleTransactionFilter>>;
  /** Filter by the object’s `partner` field. */
  partner?: InputMaybe<StringFilter>;
  /** Filter by the object’s `partnerFee` field. */
  partnerFee?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `pay` field. */
  pay?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `player` field. */
  player?: InputMaybe<StringFilter>;
  /** Filter by the object’s `priceId` field. */
  priceId?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `UserTokenSaleTransaction` */
export type UserTokenSaleTransactionInput = {
  amount: Scalars['BigInt']['input'];
  created: Scalars['Datetime']['input'];
  id: Scalars['BigInt']['input'];
  partner: Scalars['String']['input'];
  partnerFee: Scalars['JSON']['input'];
  pay: Scalars['JSON']['input'];
  player: Scalars['String']['input'];
  priceId: Scalars['BigInt']['input'];
};

/** Represents an update to a `UserTokenSaleTransaction`. Fields that are set will be updated. */
export type UserTokenSaleTransactionPatch = {
  amount?: InputMaybe<Scalars['BigInt']['input']>;
  created?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  partner?: InputMaybe<Scalars['String']['input']>;
  partnerFee?: InputMaybe<Scalars['JSON']['input']>;
  pay?: InputMaybe<Scalars['JSON']['input']>;
  player?: InputMaybe<Scalars['String']['input']>;
  priceId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A connection to a list of `UserTokenSaleTransaction` values. */
export type UserTokenSaleTransactionsConnection = {
  __typename?: 'UserTokenSaleTransactionsConnection';
  /** A list of edges which contains the `UserTokenSaleTransaction` and cursor to aid in pagination. */
  edges: Array<UserTokenSaleTransactionsEdge>;
  /** A list of `UserTokenSaleTransaction` objects. */
  nodes: Array<Maybe<UserTokenSaleTransaction>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserTokenSaleTransaction` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UserTokenSaleTransaction` edge in the connection. */
export type UserTokenSaleTransactionsEdge = {
  __typename?: 'UserTokenSaleTransactionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserTokenSaleTransaction` at the end of the edge. */
  node?: Maybe<UserTokenSaleTransaction>;
};

/** Methods to use when ordering `UserTokenSaleTransaction`. */
export enum UserTokenSaleTransactionsOrderBy {
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PartnerAsc = 'PARTNER_ASC',
  PartnerDesc = 'PARTNER_DESC',
  PartnerFeeAsc = 'PARTNER_FEE_ASC',
  PartnerFeeDesc = 'PARTNER_FEE_DESC',
  PayAsc = 'PAY_ASC',
  PayDesc = 'PAY_DESC',
  PlayerAsc = 'PLAYER_ASC',
  PlayerDesc = 'PLAYER_DESC',
  PriceIdAsc = 'PRICE_ID_ASC',
  PriceIdDesc = 'PRICE_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `UserTokenSale` values. */
export type UserTokenSalesConnection = {
  __typename?: 'UserTokenSalesConnection';
  /** A list of edges which contains the `UserTokenSale` and cursor to aid in pagination. */
  edges: Array<UserTokenSalesEdge>;
  /** A list of `UserTokenSale` objects. */
  nodes: Array<Maybe<UserTokenSale>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserTokenSale` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UserTokenSale` edge in the connection. */
export type UserTokenSalesEdge = {
  __typename?: 'UserTokenSalesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserTokenSale` at the end of the edge. */
  node?: Maybe<UserTokenSale>;
};

/** Methods to use when ordering `UserTokenSale`. */
export enum UserTokenSalesOrderBy {
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  Natural = 'NATURAL',
  PartnerAsc = 'PARTNER_ASC',
  PartnerDesc = 'PARTNER_DESC',
  PartnerReferralAsc = 'PARTNER_REFERRAL_ASC',
  PartnerReferralDesc = 'PARTNER_REFERRAL_DESC',
  PartnerRewardInjAsc = 'PARTNER_REWARD_INJ_ASC',
  PartnerRewardInjDesc = 'PARTNER_REWARD_INJ_DESC',
  PartnerRewardUsdcAsc = 'PARTNER_REWARD_USDC_ASC',
  PartnerRewardUsdcDesc = 'PARTNER_REWARD_USDC_DESC',
  PartnerTransactionCountAsc = 'PARTNER_TRANSACTION_COUNT_ASC',
  PartnerTransactionCountDesc = 'PARTNER_TRANSACTION_COUNT_DESC',
  PayInjAsc = 'PAY_INJ_ASC',
  PayInjDesc = 'PAY_INJ_DESC',
  PayUsdcAsc = 'PAY_USDC_ASC',
  PayUsdcDesc = 'PAY_USDC_DESC',
  PlayerAsc = 'PLAYER_ASC',
  PlayerDesc = 'PLAYER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TokenAmountAsc = 'TOKEN_AMOUNT_ASC',
  TokenAmountDesc = 'TOKEN_AMOUNT_DESC',
  TransactionCountAsc = 'TRANSACTION_COUNT_ASC',
  TransactionCountDesc = 'TRANSACTION_COUNT_DESC'
}

/** A connection to a list of `User` values. */
export type UsersConnection = {
  __typename?: 'UsersConnection';
  /** A list of edges which contains the `User` and cursor to aid in pagination. */
  edges: Array<UsersEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<User>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `User` edge in the connection. */
export type UsersEdge = {
  __typename?: 'UsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `User` at the end of the edge. */
  node?: Maybe<User>;
};

/** Methods to use when ordering `User`. */
export enum UsersOrderBy {
  BalanceAsc = 'BALANCE_ASC',
  BalanceDesc = 'BALANCE_DESC',
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LastBlockProcessAsc = 'LAST_BLOCK_PROCESS_ASC',
  LastBlockProcessDesc = 'LAST_BLOCK_PROCESS_DESC',
  ModifiedAsc = 'MODIFIED_ASC',
  ModifiedDesc = 'MODIFIED_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProfileAvatarAsc = 'PROFILE_AVATAR_ASC',
  ProfileAvatarDesc = 'PROFILE_AVATAR_DESC',
  ProfileUserNameAsc = 'PROFILE_USER_NAME_ASC',
  ProfileUserNameDesc = 'PROFILE_USER_NAME_DESC',
  ReferrerAsc = 'REFERRER_ASC',
  ReferrerDesc = 'REFERRER_DESC'
}

export type VersionInfo = {
  __typename?: 'VersionInfo';
  appliedOn?: Maybe<Scalars['Datetime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  version: Scalars['BigInt']['output'];
};

/**
 * A condition to be used against `VersionInfo` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type VersionInfoCondition = {
  /** Checks for equality with the object’s `appliedOn` field. */
  appliedOn?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `version` field. */
  version?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `VersionInfo` object types. All fields are combined with a logical ‘and.’ */
export type VersionInfoFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VersionInfoFilter>>;
  /** Filter by the object’s `appliedOn` field. */
  appliedOn?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VersionInfoFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VersionInfoFilter>>;
  /** Filter by the object’s `version` field. */
  version?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `VersionInfo` */
export type VersionInfoInput = {
  appliedOn?: InputMaybe<Scalars['Datetime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['BigInt']['input'];
};

/** A connection to a list of `VersionInfo` values. */
export type VersionInfosConnection = {
  __typename?: 'VersionInfosConnection';
  /** A list of edges which contains the `VersionInfo` and cursor to aid in pagination. */
  edges: Array<VersionInfosEdge>;
  /** A list of `VersionInfo` objects. */
  nodes: Array<Maybe<VersionInfo>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VersionInfo` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VersionInfo` edge in the connection. */
export type VersionInfosEdge = {
  __typename?: 'VersionInfosEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VersionInfo` at the end of the edge. */
  node?: Maybe<VersionInfo>;
};

/** Methods to use when ordering `VersionInfo`. */
export enum VersionInfosOrderBy {
  AppliedOnAsc = 'APPLIED_ON_ASC',
  AppliedOnDesc = 'APPLIED_ON_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  Natural = 'NATURAL',
  VersionAsc = 'VERSION_ASC',
  VersionDesc = 'VERSION_DESC'
}

export type GetUserProfileQueryVariables = Exact<{
  address: Scalars['String']['input'];
}>;


export type GetUserProfileQuery = { __typename?: 'Query', nfts?: { __typename?: 'NftsConnection', totalCount: number } | null, user?: { __typename?: 'User', profileUserName?: string | null, profileAvatar?: string | null } | null };

export type GetJackpotGamesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetJackpotGamesQuery = { __typename?: 'Query', jackpotGames?: { __typename?: 'JackpotGamesConnection', nodes: Array<{ __typename?: 'JackpotGame', id: any, playerWinner?: string | null, winAmount?: any | null, randomness?: string | null, startBlock?: any | null, created?: any | null, drawTimestamp?: any | null, jackpotBetsByGameId: { __typename?: 'JackpotBetsConnection', nodes: Array<{ __typename?: 'JackpotBet', id: any, address: string, amount: any } | null> } } | null> } | null };

export type GetJackpotUserGamesQueryVariables = Exact<{
  address: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type GetJackpotUserGamesQuery = { __typename?: 'Query', jackpotUserGames?: { __typename?: 'JackpotGamesConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: any | null }, edges: Array<{ __typename?: 'JackpotGamesEdge', node?: { __typename?: 'JackpotGame', id: any, playerWinner?: string | null, pool: any, winAmount?: any | null, jackpotBetsByGameId: { __typename?: 'JackpotBetsConnection', nodes: Array<{ __typename?: 'JackpotBet', id: any, address: string, amount: any } | null> } } | null }> } | null };

export type GetJackpotGameDetailsQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type GetJackpotGameDetailsQuery = { __typename?: 'Query', jackpotGame?: { __typename?: 'JackpotGame', id: any, playerWinner?: string | null, drawTxHash?: string | null, winAmount?: any | null, randomness?: string | null, startBlock?: any | null, created?: any | null, drawTimestamp?: any | null, drawRound?: any | null, state?: string | null, pool: any, jackpotBetsByGameId: { __typename?: 'JackpotBetsConnection', nodes: Array<{ __typename?: 'JackpotBet', id: any, address: string, amount: any, txHash: string } | null> } } | null };

export type GetUserLootboxOrdersQueryVariables = Exact<{
  address: Scalars['String']['input'];
  orderBy?: InputMaybe<Array<LootboxMarketOrdersOrderBy> | LootboxMarketOrdersOrderBy>;
}>;


export type GetUserLootboxOrdersQuery = { __typename?: 'Query', lootboxMarketOrders?: { __typename?: 'LootboxMarketOrdersConnection', totalCount: number, nodes: Array<{ __typename?: 'LootboxMarketOrder', orderId: any, lootbox: string, price: any, status: LootboxMarketOrderStatus, type: LootboxMarketOrderType } | null> } | null };

export type GetUserNumberLootboxOrdersQueryVariables = Exact<{
  address: Scalars['String']['input'];
}>;


export type GetUserNumberLootboxOrdersQuery = { __typename?: 'Query', lootboxMarketOrders?: { __typename?: 'LootboxMarketOrdersConnection', totalCount: number } | null };

export type GetUserLastWinsQueryVariables = Exact<{
  address: Scalars['String']['input'];
}>;


export type GetUserLastWinsQuery = { __typename?: 'Query', jackpotGames?: { __typename?: 'JackpotGamesConnection', nodes: Array<{ __typename?: 'JackpotGame', id: any, drawTimestamp?: any | null, pool: any, winAmount?: any | null, jackpotBetsByGameId: { __typename?: 'JackpotBetsConnection', nodes: Array<{ __typename?: 'JackpotBet', id: any, address: string, amount: any } | null> } } | null> } | null, doubleUserGames?: { __typename?: 'DoubleUserGamesConnection', nodes: Array<{ __typename?: 'DoubleUserGame', timestamp?: any | null, denom?: string | null, gameId?: any | null, totalpayout?: any | null, totalresult?: any | null, wincolor?: DoubleColor | null, totalamount?: any | null } | null> } | null, minesGames?: { __typename?: 'MinesGamesConnection', nodes: Array<{ __typename?: 'MinesGame', id: any, payable: any, bet: any, denom?: string | null, updated: any, txHash: string } | null> } | null };

export type GetUserStatsDataQueryVariables = Exact<{
  address: Scalars['String']['input'];
}>;


export type GetUserStatsDataQuery = { __typename?: 'Query', nfts?: { __typename?: 'NftsConnection', totalCount: number, nodes: Array<{ __typename?: 'Nft', type: string } | null> } | null, userStatisticsV2?: { __typename?: 'UserStatisticsV2', betCount: any, betAmount: any, payoutCount: any, payoutAmount: any, maxPayout: any, activeReferralsCount: any } | null, user?: { __typename?: 'User', profileUserName?: string | null, profileAvatar?: string | null, created: any, referrer: string } | null };

export type GetUserReferralDetailsQueryVariables = Exact<{
  referrerAddress: Scalars['String']['input'];
}>;


export type GetUserReferralDetailsQuery = { __typename?: 'Query', users?: { __typename?: 'UsersConnection', totalCount: number, nodes: Array<{ __typename?: 'User', id: string, profileUserName?: string | null, profileAvatar?: string | null, created: any, modified: any, userStatistic?: { __typename?: 'UserStatistic', totalBetAmount: any, totalGameCount: any } | null } | null> } | null };

export type GetPartnerUsersStatsQueryVariables = Exact<{
  partnerAddress: Scalars['String']['input'];
  startDate: Scalars['Datetime']['input'];
  endDate: Scalars['Datetime']['input'];
}>;


export type GetPartnerUsersStatsQuery = { __typename?: 'Query', getPartnerUsersStats?: { __typename?: 'GetPartnerUsersStatsConnection', totalCount: number, nodes: Array<{ __typename?: 'GetPartnerUsersStatsRecord', userId?: string | null, profileUserName?: string | null, profileAvatar?: string | null, registeredAt?: any | null, lastBetAt?: any | null, betCount?: any | null, byDenom?: any | null } | null> } | null };

export type GetUserLootboxGamesQueryVariables = Exact<{
  address: Scalars['String']['input'];
}>;


export type GetUserLootboxGamesQuery = { __typename?: 'Query', lootboxGames?: { __typename?: 'LootboxGamesConnection', nodes: Array<{ __typename?: 'LootboxGame', lootbox: string, id: any, txHash: string, height: any, created: any, updated: any, status: LootboxGameStatus, drawnTxHash?: string | null, player: string, randomness?: string | null, roundRandomness?: string | null, rewardId?: string | null } | null> } | null };

export type GetUserUnclaimedRewardsQueryVariables = Exact<{
  lootbox: Scalars['String']['input'];
  address: Scalars['String']['input'];
}>;


export type GetUserUnclaimedRewardsQuery = { __typename?: 'Query', lootboxGames?: { __typename?: 'LootboxGamesConnection', nodes: Array<{ __typename?: 'LootboxGame', id: any, rewardId?: string | null } | null> } | null };

export type GetAllUserUnclaimedRewardsQueryVariables = Exact<{
  address: Scalars['String']['input'];
}>;


export type GetAllUserUnclaimedRewardsQuery = { __typename?: 'Query', lootboxGames?: { __typename?: 'LootboxGamesConnection', nodes: Array<{ __typename?: 'LootboxGame', id: any, rewardId?: string | null, lootbox: string } | null> } | null };

export type GetLootboxV2GamesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLootboxV2GamesQuery = { __typename?: 'Query', lootboxUnlimitedGames?: { __typename?: 'LootboxUnlimitedGamesConnection', edges: Array<{ __typename?: 'LootboxUnlimitedGamesEdge', node?: { __typename?: 'LootboxUnlimitedGame', id: any, player: string, lootbox: string, rewards: Array<string | null>, denom: string, bet: any, betUsd: any } | null }> } | null, statistic?: { __typename?: 'Statistic', lootboxBetCount?: any | null } | null };

export type GetLootboxGamesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetLootboxGamesQuery = { __typename?: 'Query', lootboxGames?: { __typename?: 'LootboxGamesConnection', nodes: Array<{ __typename?: 'LootboxGame', lootbox: string, id: any, txHash: string, height: any, created: any, updated: any, status: LootboxGameStatus, drawnTxHash?: string | null, player: string, randomness?: string | null, roundRandomness?: string | null, rewardId?: string | null } | null> } | null, statistic?: { __typename?: 'Statistic', lootboxBetCount?: any | null } | null };

export type GetLootboxesSalesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLootboxesSalesQuery = { __typename?: 'Query', lootboxSales?: { __typename?: 'LootboxSalesConnection', nodes: Array<{ __typename?: 'LootboxSale', id: string, salesCount: any } | null> } | null };

export type GetLootboxSalesQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetLootboxSalesQuery = { __typename?: 'Query', lootboxSale?: { __typename?: 'LootboxSale', id: string, salesCount: any } | null };

export type GetLootboxesGamesCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLootboxesGamesCountQuery = { __typename?: 'Query', lootboxes?: { __typename?: 'LootboxesConnection', edges: Array<{ __typename?: 'LootboxesEdge', node?: { __typename?: 'Lootbox', id: string, gameCount: any } | null }> } | null };

export type GetLootboxTradesQueryVariables = Exact<{
  denom: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetLootboxTradesQuery = { __typename?: 'Query', lootboxMarketTrades?: { __typename?: 'LootboxMarketTradesConnection', nodes: Array<{ __typename?: 'LootboxMarketTrade', buyer: string, price: any, tx: string, created: any } | null> } | null };

export type GetLootboxGameCountQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetLootboxGameCountQuery = { __typename?: 'Query', lootbox?: { __typename?: 'Lootbox', gameCount: any } | null };

export type GetLootboxOrderbookQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetLootboxOrderbookQuery = { __typename?: 'Query', buy?: { __typename?: 'LootboxOrderBookConnection', nodes: Array<{ __typename?: 'LootboxOrderBookRecord', price?: any | null, quantity?: any | null } | null> } | null, sell?: { __typename?: 'LootboxOrderBookConnection', nodes: Array<{ __typename?: 'LootboxOrderBookRecord', price?: any | null, quantity?: any | null } | null> } | null };

export type GetUserGamesQueryVariables = Exact<{
  address: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['Cursor']['input']>;
  game: Scalars['String']['input'];
}>;


export type GetUserGamesQuery = { __typename?: 'Query', betsHistories?: { __typename?: 'BetsHistoriesConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: any | null }, edges: Array<{ __typename?: 'BetsHistoriesEdge', node?: { __typename?: 'BetsHistory', game: string, player: string, denom: string, betId: any, createdAt: any, payout: any, bet: any, payoutUsd: any, betUsd: any, gameId: any, extra?: any | null } | null }> } | null };

export type GetDoubleGamesQueryVariables = Exact<{
  address: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type GetDoubleGamesQuery = { __typename?: 'Query', doubleUserGames?: { __typename?: 'DoubleUserGamesConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: any | null }, edges: Array<{ __typename?: 'DoubleUserGamesEdge', node?: { __typename?: 'DoubleUserGame', gameId?: any | null, totalpayout?: any | null, totalamount?: any | null, denom?: string | null, red?: any | null, black?: any | null, green?: any | null, wincolor?: DoubleColor | null, totaljackpot?: any | null } | null }> } | null };

export type GetDoubleGameDetailsQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
  address: Scalars['String']['input'];
}>;


export type GetDoubleGameDetailsQuery = { __typename?: 'Query', doubleGame?: { __typename?: 'DoubleGame', id: any, state?: string | null, drawTimestamp?: any | null, randomness?: string | null, drawRound?: any | null, drawTxHash?: string | null, winColor?: DoubleColor | null, startBlock?: any | null, created?: any | null, jackpot?: any | null, doubleBetsByGameId: { __typename?: 'DoubleBetsConnection', nodes: Array<{ __typename?: 'DoubleBet', amount: any, address: string, denom?: string | null, bet?: any | null, jackpotPayout?: any | null, color: DoubleColor } | null> } } | null, doubleUserGames?: { __typename?: 'DoubleUserGamesConnection', nodes: Array<{ __typename?: 'DoubleUserGame', red?: any | null, black?: any | null, green?: any | null, totaljackpot?: any | null, totalamount?: any | null, totalpayout?: any | null } | null> } | null };

export type GetDoubleGameByDenomDetailsQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
  address: Scalars['String']['input'];
  denom: Scalars['String']['input'];
}>;


export type GetDoubleGameByDenomDetailsQuery = { __typename?: 'Query', doubleGame?: { __typename?: 'DoubleGame', id: any, state?: string | null, drawTimestamp?: any | null, randomness?: string | null, drawRound?: any | null, drawTxHash?: string | null, winColor?: DoubleColor | null, startBlock?: any | null, created?: any | null, jackpot?: any | null, doubleBetsByGameId: { __typename?: 'DoubleBetsConnection', nodes: Array<{ __typename?: 'DoubleBet', amount: any, address: string, denom?: string | null, jackpotPayout?: any | null, color: DoubleColor } | null> } } | null, doubleUserGames?: { __typename?: 'DoubleUserGamesConnection', nodes: Array<{ __typename?: 'DoubleUserGame', red?: any | null, black?: any | null, green?: any | null, totaljackpot?: any | null, totalamount?: any | null, totalpayout?: any | null } | null> } | null };

export type GetUserMinesHistoryGameQueryVariables = Exact<{
  address: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type GetUserMinesHistoryGameQuery = { __typename?: 'Query', minesGames?: { __typename?: 'MinesGamesConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: any | null }, edges: Array<{ __typename?: 'MinesGamesEdge', node?: { __typename?: 'MinesGame', id: any, player: string, bet: any, denom?: string | null, payable: any, status: MiniGameStatus, mines: number, maxCells: number, tryGemsOpened: number, gemsOpened?: number | null, theoreticalGemsOpened: number } | null }> } | null };

export type GetMineGamesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMineGamesQuery = { __typename?: 'Query', minesGames?: { __typename?: 'MinesGamesConnection', nodes: Array<{ __typename?: 'MinesGame', id: any, player: string, bet: any, denom?: string | null, payable: any, status: MiniGameStatus, betUsd?: any | null, payoutUsd?: any | null } | null> } | null };

export type GetMineGamesByPlayerQueryVariables = Exact<{
  player: Scalars['String']['input'];
}>;


export type GetMineGamesByPlayerQuery = { __typename?: 'Query', minesGames?: { __typename?: 'MinesGamesConnection', nodes: Array<{ __typename?: 'MinesGame', id: any, player: string, bet: any, denom?: string | null, payable: any, status: MiniGameStatus, betUsd?: any | null, payoutUsd?: any | null } | null> } | null };

export type GetUserLootboxCompetitionScoreQueryVariables = Exact<{
  player: Scalars['String']['input'];
}>;


export type GetUserLootboxCompetitionScoreQuery = { __typename?: 'Query', openCompetitionLeaderBoards?: { __typename?: 'OpenCompetitionLeaderBoardsConnection', nodes: Array<{ __typename?: 'OpenCompetitionLeaderBoard', boxOpen?: any | null, score?: any | null, refererScore?: any | null, hasNft?: number | null } | null> } | null };

export type GetUserLootboxCompetitionJackpotScoreQueryVariables = Exact<{
  player: Scalars['String']['input'];
}>;


export type GetUserLootboxCompetitionJackpotScoreQuery = { __typename?: 'Query', openCompetitionEntity?: { __typename?: 'OpenCompetitionEntity', jackpotScore?: any | null, score: any, refererScore: any, doubleScore: any } | null };

export type GetUserLootboxCompetitionLeaderboardQueryVariables = Exact<{
  player: Scalars['String']['input'];
}>;


export type GetUserLootboxCompetitionLeaderboardQuery = { __typename?: 'Query', userProfile?: { __typename?: 'User', created: any } | null, leaderboard?: { __typename?: 'OpenCompetitionLeaderBoardsConnection', nodes: Array<{ __typename?: 'OpenCompetitionLeaderBoard', player?: string | null, boxOpen?: any | null, score?: any | null, refererScore?: any | null, hasNft?: number | null, fullScore?: any | null, totalScore?: any | null, rank?: any | null, nfts?: any | null } | null> } | null, user?: { __typename?: 'OpenCompetitionLeaderBoardsConnection', nodes: Array<{ __typename?: 'OpenCompetitionLeaderBoard', score?: any | null, totalScore?: any | null, fullScore?: any | null, hasNft?: number | null, rank?: any | null, nfts?: any | null } | null> } | null, userEntity?: { __typename?: 'OpenCompetitionEntity', score: any, refererScore: any, jackpotScore?: any | null, doubleScore: any } | null };

export type GetMinesGameDetailsQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type GetMinesGameDetailsQuery = { __typename?: 'Query', minesGame?: { __typename?: 'MinesGame', id: any, player: string, bet: any, payable: any, status: MiniGameStatus, mines: number, denom?: string | null, maxCells: number, tryGemsOpened: number, minesLast?: any | null, rtp: any, gemsOpened?: number | null, created: any, txHash: string, theoreticalGemsOpened: number, minesGameRoundsByGameId: { __typename?: 'MinesGameRoundsConnection', nodes: Array<{ __typename?: 'MinesGameRound', userChoice: any, mines?: any | null, result: MiniGameStatus } | null> } } | null };

export type GetUserMineGameQueryVariables = Exact<{
  player: Scalars['String']['input'];
}>;


export type GetUserMineGameQuery = { __typename?: 'Query', minesGames?: { __typename?: 'MinesGamesConnection', nodes: Array<{ __typename?: 'MinesGame', id: any, bet: any, denom?: string | null, mines: number, rtp: any, maxCells: number, maxWin: any } | null> } | null };

export type GetMineGameQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type GetMineGameQuery = { __typename?: 'Query', minesGame?: { __typename?: 'MinesGame', id: any, bet: any, denom?: string | null, mines: number, minesGameRoundsByGameId: { __typename?: 'MinesGameRoundsConnection', nodes: Array<{ __typename?: 'MinesGameRound', id: any, result: MiniGameStatus } | null> } } | null };

export type Get_Auction_BasketsQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_Auction_BasketsQuery = { __typename?: 'Query', auctionBaskets?: { __typename?: 'AuctionBasketsConnection', nodes: Array<{ __typename?: 'AuctionBasket', id: any, basket: any, status: AuctionBasketStatus, bet: any, leader?: string | null, created: any, end: any, auctionBasketBets: { __typename?: 'AuctionBasketBetsConnection', totalCount: number, nodes: Array<{ __typename?: 'AuctionBasketBet', id: any, bet: any, player: string, created?: any | null, txHash?: string | null } | null> } } | null> } | null, statistic?: { __typename?: 'Statistic', auctionBurnToken?: any | null } | null, tokenPrices?: { __typename?: 'TokenPricesConnection', nodes: Array<{ __typename?: 'TokenPrice', symbol: string, value: any, updated: any } | null> } | null };

export type Get_Auction_Basket_By_IdQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type Get_Auction_Basket_By_IdQuery = { __typename?: 'Query', auctionBasket?: { __typename?: 'AuctionBasket', id: any, basket: any, status: AuctionBasketStatus, bet: any, leader?: string | null, created: any, end: any, auctionBasketBets: { __typename?: 'AuctionBasketBetsConnection', totalCount: number, nodes: Array<{ __typename?: 'AuctionBasketBet', id: any, bet: any, player: string, created?: any | null, txHash?: string | null } | null> } } | null, auctionBaskets?: { __typename?: 'AuctionBasketsConnection', nodes: Array<{ __typename?: 'AuctionBasket', id: any, basket: any, status: AuctionBasketStatus, bet: any, leader?: string | null, created: any, end: any, auctionBasketBets: { __typename?: 'AuctionBasketBetsConnection', totalCount: number, nodes: Array<{ __typename?: 'AuctionBasketBet', id: any, bet: any, player: string, created?: any | null, txHash?: string | null } | null> } } | null> } | null, statistic?: { __typename?: 'Statistic', auctionBurnToken?: any | null } | null, tokenPrices?: { __typename?: 'TokenPricesConnection', nodes: Array<{ __typename?: 'TokenPrice', symbol: string, value: any, updated: any } | null> } | null };

export type Get_Coinflip_GameQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type Get_Coinflip_GameQuery = { __typename?: 'Query', coinflipGame?: { __typename?: 'CoinflipGame', id: any, gameRound: number, processedGameRound: number, player: string, status: MiniGameStatus, txHash: string, bet: any, payable: any, rtp: any, maxWin: any, maxGameRound: number, denom?: string | null, mode?: CoinflipGameMode | null, updated: any, coinflipGameRoundsByGameId: { __typename?: 'CoinflipGameRoundsConnection', nodes: Array<{ __typename?: 'CoinflipGameRound', userChoice: CoinflipChoice, result: MiniGameStatus } | null> } } | null };

export type Get_Last_Coinflip_GamesQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_Last_Coinflip_GamesQuery = { __typename?: 'Query', coinflipGames?: { __typename?: 'CoinflipGamesConnection', nodes: Array<{ __typename?: 'CoinflipGame', id: any, player: string, bet: any, payable: any, status: MiniGameStatus, denom?: string | null, betUsd?: any | null, payoutUsd?: any | null } | null> } | null, appCoinflipLeaderboardLuckyBets?: { __typename?: 'AppCoinflipLeaderboardLuckyBetsConnection', nodes: Array<{ __typename?: 'AppCoinflipLeaderboardLuckyBet', id?: any | null, player?: string | null, bet?: any | null, payable?: any | null, status?: MiniGameStatus | null, denom?: string | null, betUsd?: any | null, payoutUsd?: any | null } | null> } | null };

export type Get_Last_Coinflip_Games_By_PlayerQueryVariables = Exact<{
  player: Scalars['String']['input'];
}>;


export type Get_Last_Coinflip_Games_By_PlayerQuery = { __typename?: 'Query', coinflipGames?: { __typename?: 'CoinflipGamesConnection', nodes: Array<{ __typename?: 'CoinflipGame', id: any, player: string, bet: any, payable: any, status: MiniGameStatus, denom?: string | null, betUsd?: any | null, payoutUsd?: any | null } | null> } | null };

export type Get_Coinflip_User_ScoreQueryVariables = Exact<{
  address: Scalars['String']['input'];
}>;


export type Get_Coinflip_User_ScoreQuery = { __typename?: 'Query', userCompetition?: { __typename?: 'UserCompetition', score: any } | null };

export type Get_Last_Coinflip_Game_By_PlayerQueryVariables = Exact<{
  player: Scalars['String']['input'];
}>;


export type Get_Last_Coinflip_Game_By_PlayerQuery = { __typename?: 'Query', coinflipGames?: { __typename?: 'CoinflipGamesConnection', nodes: Array<{ __typename?: 'CoinflipGame', id: any, gameRound: number, processedGameRound: number, maxGameRound: number, denom?: string | null, bet: any, rtp: any, maxWin: any, coinflipGameRoundsByGameId: { __typename?: 'CoinflipGameRoundsConnection', nodes: Array<{ __typename?: 'CoinflipGameRound', userChoice: CoinflipChoice, result: MiniGameStatus } | null> } } | null> } | null };

export type Get_Last_Runes_GamesQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_Last_Runes_GamesQuery = { __typename?: 'Query', runesGames?: { __typename?: 'RunesGamesConnection', nodes: Array<{ __typename?: 'RunesGame', id: any, risk: GameRisk, player: string, bet: any, payout: any, denom: string, betUsd: any, payoutUsd: any } | null> } | null };

export type Get_Last_Runes_Games_By_PlayerQueryVariables = Exact<{
  player: Scalars['String']['input'];
}>;


export type Get_Last_Runes_Games_By_PlayerQuery = { __typename?: 'Query', runesGames?: { __typename?: 'RunesGamesConnection', nodes: Array<{ __typename?: 'RunesGame', id: any, risk: GameRisk, player: string, bet: any, payout: any, denom: string, betUsd: any, payoutUsd: any } | null> } | null };

export type Get_Runes_GameQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type Get_Runes_GameQuery = { __typename?: 'Query', runesGame?: { __typename?: 'RunesGame', id: any, player: string, txHash: string, bet: any, payout: any, denom: string, created: any, risk: GameRisk, result?: Array<number | null> | null } | null };

export type Get_Plinko_Tickets_LeaderboardQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_Plinko_Tickets_LeaderboardQuery = { __typename?: 'Query', userCompetitions?: { __typename?: 'UserCompetitionsConnection', nodes: Array<{ __typename?: 'UserCompetition', player: string, score: any } | null> } | null };

export type Get_Plinko_Tickets_By_UserQueryVariables = Exact<{
  address: Scalars['String']['input'];
}>;


export type Get_Plinko_Tickets_By_UserQuery = { __typename?: 'Query', userCompetition?: { __typename?: 'UserCompetition', player: string, score: any } | null };

export type Get_Last_WinsQueryVariables = Exact<{
  start: Scalars['Datetime']['input'];
}>;


export type Get_Last_WinsQuery = { __typename?: 'Query', infoLast100WinBets?: { __typename?: 'InfoLast100WinBetsConnection', nodes: Array<{ __typename?: 'InfoLast100WinBet', id?: string | null, player?: string | null, denom?: string | null, payout?: any | null, payoutUsd?: any | null, createdAt?: any | null, game?: string | null, extraGameId?: string | null } | null> } | null };

export type Get_Users_By_NameQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type Get_Users_By_NameQuery = { __typename?: 'Query', users?: { __typename?: 'UsersConnection', nodes: Array<{ __typename?: 'User', id: string, profileUserName?: string | null, profileAvatar?: string | null } | null> } | null };

export type Get_Plinko_GameQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type Get_Plinko_GameQuery = { __typename?: 'Query', plinkoGame?: { __typename?: 'PlinkoGame', id: any, player: string, denom: string, bet: any, balls: number, payout: any, risk: GameRisk, result: Array<number | null>, status: GameStatus, txHash: string, created: any, updated: any } | null };

export type Get_Last_Plinko_GamesQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_Last_Plinko_GamesQuery = { __typename?: 'Query', plinkoGames?: { __typename?: 'PlinkoGamesConnection', nodes: Array<{ __typename?: 'PlinkoGame', id: any, player: string, denom: string, bet: any, balls: number, payout: any, risk: GameRisk, betUsd: any, payoutUsd: any } | null> } | null };

export type Get_Last_Plinko_Games_By_PlayerQueryVariables = Exact<{
  player: Scalars['String']['input'];
}>;


export type Get_Last_Plinko_Games_By_PlayerQuery = { __typename?: 'Query', plinkoGames?: { __typename?: 'PlinkoGamesConnection', nodes: Array<{ __typename?: 'PlinkoGame', id: any, player: string, denom: string, bet: any, balls: number, payout: any, risk: GameRisk, betUsd: any, payoutUsd: any } | null> } | null };

export type GameZoneSessionTokenPricesQueryVariables = Exact<{ [key: string]: never; }>;


export type GameZoneSessionTokenPricesQuery = { __typename?: 'Query', tokenPrices?: { __typename?: 'TokenPricesConnection', nodes: Array<{ __typename?: 'TokenPrice', symbol: string, value: any } | null> } | null };

export type GameZoneWithdrawTokenPricesQueryVariables = Exact<{ [key: string]: never; }>;


export type GameZoneWithdrawTokenPricesQuery = { __typename?: 'Query', tokenPrices?: { __typename?: 'TokenPricesConnection', nodes: Array<{ __typename?: 'TokenPrice', symbol: string, value: any } | null> } | null };

export type GetDoubleJackpotsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDoubleJackpotsQuery = { __typename?: 'Query', doubleJackpots?: { __typename?: 'DoubleJackpotsConnection', nodes: Array<{ __typename?: 'DoubleJackpot', id?: any | null, startBlock?: any | null, drawTimeStamp?: any | null, jackpot?: any | null } | null> } | null };

export type ReadMetadataQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadMetadataQuery = { __typename?: 'Query', metadata?: any | null };


export const GetUserProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nfts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileUserName"}},{"kind":"Field","name":{"kind":"Name","value":"profileAvatar"}}]}}]}}]} as unknown as DocumentNode<GetUserProfileQuery, GetUserProfileQueryVariables>;
export const GetJackpotGamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetJackpotGames"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jackpotGames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"7"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"StringValue","value":"finished","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"playerWinner"}},{"kind":"Field","name":{"kind":"Name","value":"jackpotBetsByGameId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"winAmount"}},{"kind":"Field","name":{"kind":"Name","value":"randomness"}},{"kind":"Field","name":{"kind":"Name","value":"startBlock"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"drawTimestamp"}}]}}]}}]}}]} as unknown as DocumentNode<GetJackpotGamesQuery, GetJackpotGamesQueryVariables>;
export const GetJackpotUserGamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetJackpotUserGames"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jackpotUserGames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"player"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"finished","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"playerWinner"}},{"kind":"Field","name":{"kind":"Name","value":"pool"}},{"kind":"Field","name":{"kind":"Name","value":"winAmount"}},{"kind":"Field","name":{"kind":"Name","value":"jackpotBetsByGameId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetJackpotUserGamesQuery, GetJackpotUserGamesQueryVariables>;
export const GetJackpotGameDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetJackpotGameDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jackpotGame"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"playerWinner"}},{"kind":"Field","name":{"kind":"Name","value":"jackpotBetsByGameId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"txHash"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"drawTxHash"}},{"kind":"Field","name":{"kind":"Name","value":"winAmount"}},{"kind":"Field","name":{"kind":"Name","value":"randomness"}},{"kind":"Field","name":{"kind":"Name","value":"startBlock"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"drawTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"drawRound"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"pool"}}]}}]}}]} as unknown as DocumentNode<GetJackpotGameDetailsQuery, GetJackpotGameDetailsQueryVariables>;
export const GetUserLootboxOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserLootboxOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LootboxMarketOrdersOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lootboxMarketOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"player"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"ACTIVE"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"lootbox"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetUserLootboxOrdersQuery, GetUserLootboxOrdersQueryVariables>;
export const GetUserNumberLootboxOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserNumberLootboxOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lootboxMarketOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"player"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"ACTIVE"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetUserNumberLootboxOrdersQuery, GetUserNumberLootboxOrdersQueryVariables>;
export const GetUserLastWinsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserLastWins"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jackpotGames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"DRAW_TIMESTAMP_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"playerWinner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"drawTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"pool"}},{"kind":"Field","name":{"kind":"Name","value":"winAmount"}},{"kind":"Field","name":{"kind":"Name","value":"jackpotBetsByGameId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"doubleUserGames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"GAME_ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"totalresult"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"StringValue","value":"0","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"denom"}},{"kind":"Field","name":{"kind":"Name","value":"gameId"}},{"kind":"Field","name":{"kind":"Name","value":"totalpayout"}},{"kind":"Field","name":{"kind":"Name","value":"totalresult"}},{"kind":"Field","name":{"kind":"Name","value":"wincolor"}},{"kind":"Field","name":{"kind":"Name","value":"totalamount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"minesGames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"player"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"WIN"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"UPDATED_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"payable"}},{"kind":"Field","name":{"kind":"Name","value":"bet"}},{"kind":"Field","name":{"kind":"Name","value":"denom"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"txHash"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserLastWinsQuery, GetUserLastWinsQueryVariables>;
export const GetUserStatsDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserStatsData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nfts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userStatisticsV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"player"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"betCount"}},{"kind":"Field","name":{"kind":"Name","value":"betAmount"}},{"kind":"Field","name":{"kind":"Name","value":"payoutCount"}},{"kind":"Field","name":{"kind":"Name","value":"payoutAmount"}},{"kind":"Field","name":{"kind":"Name","value":"maxPayout"}},{"kind":"Field","name":{"kind":"Name","value":"activeReferralsCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileUserName"}},{"kind":"Field","name":{"kind":"Name","value":"profileAvatar"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}}]}}]}}]} as unknown as DocumentNode<GetUserStatsDataQuery, GetUserStatsDataQueryVariables>;
export const GetUserReferralDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserReferralDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referrerAddress"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"referrer"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referrerAddress"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profileUserName"}},{"kind":"Field","name":{"kind":"Name","value":"profileAvatar"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"userStatistic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalBetAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totalGameCount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetUserReferralDetailsQuery, GetUserReferralDetailsQueryVariables>;
export const GetPartnerUsersStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPartnerUsersStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerAddress"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPartnerUsersStats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pPartnerAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerAddress"}}},{"kind":"Argument","name":{"kind":"Name","value":"pFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"pTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"profileUserName"}},{"kind":"Field","name":{"kind":"Name","value":"profileAvatar"}},{"kind":"Field","name":{"kind":"Name","value":"registeredAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastBetAt"}},{"kind":"Field","name":{"kind":"Name","value":"betCount"}},{"kind":"Field","name":{"kind":"Name","value":"byDenom"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetPartnerUsersStatsQuery, GetPartnerUsersStatsQueryVariables>;
export const GetUserLootboxGamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserLootboxGames"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lootboxGames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEqualTo"},"value":{"kind":"EnumValue","value":"FINISHED"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"player"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lootbox"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"txHash"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"drawnTxHash"}},{"kind":"Field","name":{"kind":"Name","value":"player"}},{"kind":"Field","name":{"kind":"Name","value":"randomness"}},{"kind":"Field","name":{"kind":"Name","value":"roundRandomness"}},{"kind":"Field","name":{"kind":"Name","value":"rewardId"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserLootboxGamesQuery, GetUserLootboxGamesQueryVariables>;
export const GetUserUnclaimedRewardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserUnclaimedRewards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lootbox"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lootboxGames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"DRAWN"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"player"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lootbox"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lootbox"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rewardId"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserUnclaimedRewardsQuery, GetUserUnclaimedRewardsQueryVariables>;
export const GetAllUserUnclaimedRewardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllUserUnclaimedRewards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lootboxGames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"DRAWN"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"player"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rewardId"}},{"kind":"Field","name":{"kind":"Name","value":"lootbox"}}]}}]}}]}}]} as unknown as DocumentNode<GetAllUserUnclaimedRewardsQuery, GetAllUserUnclaimedRewardsQueryVariables>;
export const GetLootboxV2GamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLootboxV2Games"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lootboxUnlimitedGames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"FINISHED"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"9"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"player"}},{"kind":"Field","name":{"kind":"Name","value":"lootbox"}},{"kind":"Field","name":{"kind":"Name","value":"rewards"}},{"kind":"Field","name":{"kind":"Name","value":"denom"}},{"kind":"Field","name":{"kind":"Name","value":"bet"}},{"kind":"Field","name":{"kind":"Name","value":"betUsd"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statistic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lootboxBetCount"}}]}}]}}]} as unknown as DocumentNode<GetLootboxV2GamesQuery, GetLootboxV2GamesQueryVariables>;
export const GetLootboxGamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLootboxGames"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lootboxGames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"HEIGHT_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"FINISHED"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lootbox"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"txHash"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"drawnTxHash"}},{"kind":"Field","name":{"kind":"Name","value":"player"}},{"kind":"Field","name":{"kind":"Name","value":"randomness"}},{"kind":"Field","name":{"kind":"Name","value":"roundRandomness"}},{"kind":"Field","name":{"kind":"Name","value":"rewardId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statistic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lootboxBetCount"}}]}}]}}]} as unknown as DocumentNode<GetLootboxGamesQuery, GetLootboxGamesQueryVariables>;
export const GetLootboxesSalesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLootboxesSales"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lootboxSales"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"salesCount"}}]}}]}}]}}]} as unknown as DocumentNode<GetLootboxesSalesQuery, GetLootboxesSalesQueryVariables>;
export const GetLootboxSalesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLootboxSales"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lootboxSale"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"salesCount"}}]}}]}}]} as unknown as DocumentNode<GetLootboxSalesQuery, GetLootboxSalesQueryVariables>;
export const GetLootboxesGamesCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLootboxesGamesCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lootboxes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gameCount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLootboxesGamesCountQuery, GetLootboxesGamesCountQueryVariables>;
export const GetLootboxTradesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLootboxTrades"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"denom"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lootboxMarketTrades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"TRADE_ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lootbox"},"value":{"kind":"Variable","name":{"kind":"Name","value":"denom"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"tx"}},{"kind":"Field","name":{"kind":"Name","value":"created"}}]}}]}}]}}]} as unknown as DocumentNode<GetLootboxTradesQuery, GetLootboxTradesQueryVariables>;
export const GetLootboxGameCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLootboxGameCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lootbox"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gameCount"}}]}}]}}]} as unknown as DocumentNode<GetLootboxGameCountQuery, GetLootboxGameCountQueryVariables>;
export const GetLootboxOrderbookDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLootboxOrderbook"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"buy"},"name":{"kind":"Name","value":"lootboxOrderBook"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lootbox"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"quote"},"value":{"kind":"StringValue","value":"inj","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"BUY"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"sell"},"name":{"kind":"Name","value":"lootboxOrderBook"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lootbox"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"quote"},"value":{"kind":"StringValue","value":"inj","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"SELL"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}}]}}]}}]} as unknown as DocumentNode<GetLootboxOrderbookQuery, GetLootboxOrderbookQueryVariables>;
export const GetUserGamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserGames"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"game"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"betsHistories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"player"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"game"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"game"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"_ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"game"}},{"kind":"Field","name":{"kind":"Name","value":"player"}},{"kind":"Field","name":{"kind":"Name","value":"denom"}},{"kind":"Field","name":{"kind":"Name","value":"betId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"payout"}},{"kind":"Field","name":{"kind":"Name","value":"bet"}},{"kind":"Field","name":{"kind":"Name","value":"payoutUsd"}},{"kind":"Field","name":{"kind":"Name","value":"betUsd"}},{"kind":"Field","name":{"kind":"Name","value":"gameId"}},{"kind":"Field","name":{"kind":"Name","value":"extra"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserGamesQuery, GetUserGamesQueryVariables>;
export const GetDoubleGamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDoubleGames"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doubleUserGames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gameId"}},{"kind":"Field","name":{"kind":"Name","value":"totalpayout"}},{"kind":"Field","name":{"kind":"Name","value":"totalamount"}},{"kind":"Field","name":{"kind":"Name","value":"denom"}},{"kind":"Field","name":{"kind":"Name","value":"red"}},{"kind":"Field","name":{"kind":"Name","value":"black"}},{"kind":"Field","name":{"kind":"Name","value":"green"}},{"kind":"Field","name":{"kind":"Name","value":"wincolor"}},{"kind":"Field","name":{"kind":"Name","value":"totaljackpot"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDoubleGamesQuery, GetDoubleGamesQueryVariables>;
export const GetDoubleGameDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDoubleGameDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doubleGame"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"drawTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"randomness"}},{"kind":"Field","name":{"kind":"Name","value":"drawRound"}},{"kind":"Field","name":{"kind":"Name","value":"drawTxHash"}},{"kind":"Field","name":{"kind":"Name","value":"winColor"}},{"kind":"Field","name":{"kind":"Name","value":"startBlock"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"jackpot"}},{"kind":"Field","name":{"kind":"Name","value":"doubleBetsByGameId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"denom"}},{"kind":"Field","name":{"kind":"Name","value":"bet"}},{"kind":"Field","name":{"kind":"Name","value":"jackpotPayout"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"doubleUserGames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"gameId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"red"}},{"kind":"Field","name":{"kind":"Name","value":"black"}},{"kind":"Field","name":{"kind":"Name","value":"green"}},{"kind":"Field","name":{"kind":"Name","value":"totaljackpot"}},{"kind":"Field","name":{"kind":"Name","value":"totalamount"}},{"kind":"Field","name":{"kind":"Name","value":"totalpayout"}}]}}]}}]}}]} as unknown as DocumentNode<GetDoubleGameDetailsQuery, GetDoubleGameDetailsQueryVariables>;
export const GetDoubleGameByDenomDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDoubleGameByDenomDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"denom"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doubleGame"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"drawTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"randomness"}},{"kind":"Field","name":{"kind":"Name","value":"drawRound"}},{"kind":"Field","name":{"kind":"Name","value":"drawTxHash"}},{"kind":"Field","name":{"kind":"Name","value":"winColor"}},{"kind":"Field","name":{"kind":"Name","value":"startBlock"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"jackpot"}},{"kind":"Field","name":{"kind":"Name","value":"doubleBetsByGameId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"denom"}},{"kind":"Field","name":{"kind":"Name","value":"jackpotPayout"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"doubleUserGames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"gameId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"denom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"denom"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"red"}},{"kind":"Field","name":{"kind":"Name","value":"black"}},{"kind":"Field","name":{"kind":"Name","value":"green"}},{"kind":"Field","name":{"kind":"Name","value":"totaljackpot"}},{"kind":"Field","name":{"kind":"Name","value":"totalamount"}},{"kind":"Field","name":{"kind":"Name","value":"totalpayout"}}]}}]}}]}}]} as unknown as DocumentNode<GetDoubleGameByDenomDetailsQuery, GetDoubleGameByDenomDetailsQueryVariables>;
export const GetUserMinesHistoryGameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserMinesHistoryGame"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minesGames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"player"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEqualTo"},"value":{"kind":"EnumValue","value":"PENDING"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"player"}},{"kind":"Field","name":{"kind":"Name","value":"bet"}},{"kind":"Field","name":{"kind":"Name","value":"denom"}},{"kind":"Field","name":{"kind":"Name","value":"payable"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"mines"}},{"kind":"Field","name":{"kind":"Name","value":"maxCells"}},{"kind":"Field","name":{"kind":"Name","value":"tryGemsOpened"}},{"kind":"Field","name":{"kind":"Name","value":"gemsOpened"}},{"kind":"Field","name":{"kind":"Name","value":"theoreticalGemsOpened"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserMinesHistoryGameQuery, GetUserMinesHistoryGameQueryVariables>;
export const GetMineGamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMineGames"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minesGames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEqualTo"},"value":{"kind":"EnumValue","value":"PENDING"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"11"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"UPDATED_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"player"}},{"kind":"Field","name":{"kind":"Name","value":"bet"}},{"kind":"Field","name":{"kind":"Name","value":"denom"}},{"kind":"Field","name":{"kind":"Name","value":"payable"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"betUsd"}},{"kind":"Field","name":{"kind":"Name","value":"payoutUsd"}}]}}]}}]}}]} as unknown as DocumentNode<GetMineGamesQuery, GetMineGamesQueryVariables>;
export const GetMineGamesByPlayerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMineGamesByPlayer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"player"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minesGames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEqualTo"},"value":{"kind":"EnumValue","value":"PENDING"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"player"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"player"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"11"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"UPDATED_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"player"}},{"kind":"Field","name":{"kind":"Name","value":"bet"}},{"kind":"Field","name":{"kind":"Name","value":"denom"}},{"kind":"Field","name":{"kind":"Name","value":"payable"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"betUsd"}},{"kind":"Field","name":{"kind":"Name","value":"payoutUsd"}}]}}]}}]}}]} as unknown as DocumentNode<GetMineGamesByPlayerQuery, GetMineGamesByPlayerQueryVariables>;
export const GetUserLootboxCompetitionScoreDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserLootboxCompetitionScore"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"player"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openCompetitionLeaderBoards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"player"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"player"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boxOpen"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"refererScore"}},{"kind":"Field","name":{"kind":"Name","value":"hasNft"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserLootboxCompetitionScoreQuery, GetUserLootboxCompetitionScoreQueryVariables>;
export const GetUserLootboxCompetitionJackpotScoreDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserLootboxCompetitionJackpotScore"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"player"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openCompetitionEntity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"player"},"value":{"kind":"Variable","name":{"kind":"Name","value":"player"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jackpotScore"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"refererScore"}},{"kind":"Field","name":{"kind":"Name","value":"doubleScore"}}]}}]}}]} as unknown as DocumentNode<GetUserLootboxCompetitionJackpotScoreQuery, GetUserLootboxCompetitionJackpotScoreQueryVariables>;
export const GetUserLootboxCompetitionLeaderboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserLootboxCompetitionLeaderboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"player"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"userProfile"},"name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"player"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"leaderboard"},"name":{"kind":"Name","value":"openCompetitionLeaderBoards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"player"}},{"kind":"Field","name":{"kind":"Name","value":"boxOpen"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"refererScore"}},{"kind":"Field","name":{"kind":"Name","value":"hasNft"}},{"kind":"Field","name":{"kind":"Name","value":"fullScore"}},{"kind":"Field","name":{"kind":"Name","value":"totalScore"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"nfts"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"user"},"name":{"kind":"Name","value":"openCompetitionLeaderBoards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"player"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"player"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"totalScore"}},{"kind":"Field","name":{"kind":"Name","value":"fullScore"}},{"kind":"Field","name":{"kind":"Name","value":"hasNft"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"nfts"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"userEntity"},"name":{"kind":"Name","value":"openCompetitionEntity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"player"},"value":{"kind":"Variable","name":{"kind":"Name","value":"player"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"refererScore"}},{"kind":"Field","name":{"kind":"Name","value":"jackpotScore"}},{"kind":"Field","name":{"kind":"Name","value":"doubleScore"}}]}}]}}]} as unknown as DocumentNode<GetUserLootboxCompetitionLeaderboardQuery, GetUserLootboxCompetitionLeaderboardQueryVariables>;
export const GetMinesGameDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMinesGameDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minesGame"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"player"}},{"kind":"Field","name":{"kind":"Name","value":"bet"}},{"kind":"Field","name":{"kind":"Name","value":"payable"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"mines"}},{"kind":"Field","name":{"kind":"Name","value":"denom"}},{"kind":"Field","name":{"kind":"Name","value":"maxCells"}},{"kind":"Field","name":{"kind":"Name","value":"tryGemsOpened"}},{"kind":"Field","name":{"kind":"Name","value":"minesLast"}},{"kind":"Field","name":{"kind":"Name","value":"rtp"}},{"kind":"Field","name":{"kind":"Name","value":"gemsOpened"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"txHash"}},{"kind":"Field","name":{"kind":"Name","value":"theoreticalGemsOpened"}},{"kind":"Field","name":{"kind":"Name","value":"minesGameRoundsByGameId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userChoice"}},{"kind":"Field","name":{"kind":"Name","value":"mines"}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMinesGameDetailsQuery, GetMinesGameDetailsQueryVariables>;
export const GetUserMineGameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserMineGame"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"player"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minesGames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"player"},"value":{"kind":"Variable","name":{"kind":"Name","value":"player"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"PENDING"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ID_DESC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bet"}},{"kind":"Field","name":{"kind":"Name","value":"denom"}},{"kind":"Field","name":{"kind":"Name","value":"mines"}},{"kind":"Field","name":{"kind":"Name","value":"rtp"}},{"kind":"Field","name":{"kind":"Name","value":"maxCells"}},{"kind":"Field","name":{"kind":"Name","value":"maxWin"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserMineGameQuery, GetUserMineGameQueryVariables>;
export const GetMineGameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMineGame"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minesGame"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bet"}},{"kind":"Field","name":{"kind":"Name","value":"denom"}},{"kind":"Field","name":{"kind":"Name","value":"mines"}},{"kind":"Field","name":{"kind":"Name","value":"minesGameRoundsByGameId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMineGameQuery, GetMineGameQueryVariables>;
export const Get_Auction_BasketsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_AUCTION_BASKETS"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auctionBaskets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"5"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"basket"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"bet"}},{"kind":"Field","name":{"kind":"Name","value":"leader"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"auctionBasketBets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bet"}},{"kind":"Field","name":{"kind":"Name","value":"player"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"txHash"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statistic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auctionBurnToken"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tokenPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}}]}}]}}]}}]} as unknown as DocumentNode<Get_Auction_BasketsQuery, Get_Auction_BasketsQueryVariables>;
export const Get_Auction_Basket_By_IdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_AUCTION_BASKET_BY_ID"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auctionBasket"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"basket"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"bet"}},{"kind":"Field","name":{"kind":"Name","value":"leader"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"auctionBasketBets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bet"}},{"kind":"Field","name":{"kind":"Name","value":"player"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"txHash"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"auctionBaskets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"5"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"basket"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"bet"}},{"kind":"Field","name":{"kind":"Name","value":"leader"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"auctionBasketBets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bet"}},{"kind":"Field","name":{"kind":"Name","value":"player"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"txHash"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statistic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auctionBurnToken"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tokenPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}}]}}]}}]}}]} as unknown as DocumentNode<Get_Auction_Basket_By_IdQuery, Get_Auction_Basket_By_IdQueryVariables>;
export const Get_Coinflip_GameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_COINFLIP_GAME"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coinflipGame"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gameRound"}},{"kind":"Field","name":{"kind":"Name","value":"processedGameRound"}},{"kind":"Field","name":{"kind":"Name","value":"player"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"txHash"}},{"kind":"Field","name":{"kind":"Name","value":"bet"}},{"kind":"Field","name":{"kind":"Name","value":"payable"}},{"kind":"Field","name":{"kind":"Name","value":"rtp"}},{"kind":"Field","name":{"kind":"Name","value":"maxWin"}},{"kind":"Field","name":{"kind":"Name","value":"maxGameRound"}},{"kind":"Field","name":{"kind":"Name","value":"denom"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"coinflipGameRoundsByGameId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userChoice"}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Get_Coinflip_GameQuery, Get_Coinflip_GameQueryVariables>;
export const Get_Last_Coinflip_GamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_LAST_COINFLIP_GAMES"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coinflipGames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"WIN"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"LOSE"}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"11"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"player"}},{"kind":"Field","name":{"kind":"Name","value":"bet"}},{"kind":"Field","name":{"kind":"Name","value":"payable"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"denom"}},{"kind":"Field","name":{"kind":"Name","value":"betUsd"}},{"kind":"Field","name":{"kind":"Name","value":"payoutUsd"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"appCoinflipLeaderboardLuckyBets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"player"}},{"kind":"Field","name":{"kind":"Name","value":"bet"}},{"kind":"Field","name":{"kind":"Name","value":"payable"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"denom"}},{"kind":"Field","name":{"kind":"Name","value":"betUsd"}},{"kind":"Field","name":{"kind":"Name","value":"payoutUsd"}}]}}]}}]}}]} as unknown as DocumentNode<Get_Last_Coinflip_GamesQuery, Get_Last_Coinflip_GamesQueryVariables>;
export const Get_Last_Coinflip_Games_By_PlayerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_LAST_COINFLIP_GAMES_BY_PLAYER"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"player"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coinflipGames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"player"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"player"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"WIN"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"LOSE"}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"11"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"player"}},{"kind":"Field","name":{"kind":"Name","value":"bet"}},{"kind":"Field","name":{"kind":"Name","value":"payable"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"denom"}},{"kind":"Field","name":{"kind":"Name","value":"betUsd"}},{"kind":"Field","name":{"kind":"Name","value":"payoutUsd"}}]}}]}}]}}]} as unknown as DocumentNode<Get_Last_Coinflip_Games_By_PlayerQuery, Get_Last_Coinflip_Games_By_PlayerQueryVariables>;
export const Get_Coinflip_User_ScoreDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_COINFLIP_USER_SCORE"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCompetition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"player"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}},{"kind":"Argument","name":{"kind":"Name","value":"competition"},"value":{"kind":"StringValue","value":"coinflip-100000","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}}]}}]}}]} as unknown as DocumentNode<Get_Coinflip_User_ScoreQuery, Get_Coinflip_User_ScoreQueryVariables>;
export const Get_Last_Coinflip_Game_By_PlayerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_LAST_COINFLIP_GAME_BY_PLAYER"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"player"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coinflipGames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"player"},"value":{"kind":"Variable","name":{"kind":"Name","value":"player"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"PENDING"}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"MULTIPLE"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gameRound"}},{"kind":"Field","name":{"kind":"Name","value":"processedGameRound"}},{"kind":"Field","name":{"kind":"Name","value":"maxGameRound"}},{"kind":"Field","name":{"kind":"Name","value":"denom"}},{"kind":"Field","name":{"kind":"Name","value":"bet"}},{"kind":"Field","name":{"kind":"Name","value":"rtp"}},{"kind":"Field","name":{"kind":"Name","value":"maxWin"}},{"kind":"Field","name":{"kind":"Name","value":"coinflipGameRoundsByGameId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userChoice"}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Get_Last_Coinflip_Game_By_PlayerQuery, Get_Last_Coinflip_Game_By_PlayerQueryVariables>;
export const Get_Last_Runes_GamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_LAST_RUNES_GAMES"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"runesGames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"FINISHED"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"11"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"risk"}},{"kind":"Field","name":{"kind":"Name","value":"player"}},{"kind":"Field","name":{"kind":"Name","value":"bet"}},{"kind":"Field","name":{"kind":"Name","value":"payout"}},{"kind":"Field","name":{"kind":"Name","value":"denom"}},{"kind":"Field","name":{"kind":"Name","value":"betUsd"}},{"kind":"Field","name":{"kind":"Name","value":"payoutUsd"}}]}}]}}]}}]} as unknown as DocumentNode<Get_Last_Runes_GamesQuery, Get_Last_Runes_GamesQueryVariables>;
export const Get_Last_Runes_Games_By_PlayerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_LAST_RUNES_GAMES_BY_PLAYER"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"player"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"runesGames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"FINISHED"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"player"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"player"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"11"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"risk"}},{"kind":"Field","name":{"kind":"Name","value":"player"}},{"kind":"Field","name":{"kind":"Name","value":"bet"}},{"kind":"Field","name":{"kind":"Name","value":"payout"}},{"kind":"Field","name":{"kind":"Name","value":"denom"}},{"kind":"Field","name":{"kind":"Name","value":"betUsd"}},{"kind":"Field","name":{"kind":"Name","value":"payoutUsd"}}]}}]}}]}}]} as unknown as DocumentNode<Get_Last_Runes_Games_By_PlayerQuery, Get_Last_Runes_Games_By_PlayerQueryVariables>;
export const Get_Runes_GameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_RUNES_GAME"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"runesGame"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"player"}},{"kind":"Field","name":{"kind":"Name","value":"txHash"}},{"kind":"Field","name":{"kind":"Name","value":"bet"}},{"kind":"Field","name":{"kind":"Name","value":"payout"}},{"kind":"Field","name":{"kind":"Name","value":"denom"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"risk"}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<Get_Runes_GameQuery, Get_Runes_GameQueryVariables>;
export const Get_Plinko_Tickets_LeaderboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_PLINKO_TICKETS_LEADERBOARD"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCompetitions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"competition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"plinko","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"SCORE_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"player"}},{"kind":"Field","name":{"kind":"Name","value":"score"}}]}}]}}]}}]} as unknown as DocumentNode<Get_Plinko_Tickets_LeaderboardQuery, Get_Plinko_Tickets_LeaderboardQueryVariables>;
export const Get_Plinko_Tickets_By_UserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_PLINKO_TICKETS_BY_USER"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCompetition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"player"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}},{"kind":"Argument","name":{"kind":"Name","value":"competition"},"value":{"kind":"StringValue","value":"plinko","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"player"}},{"kind":"Field","name":{"kind":"Name","value":"score"}}]}}]}}]} as unknown as DocumentNode<Get_Plinko_Tickets_By_UserQuery, Get_Plinko_Tickets_By_UserQueryVariables>;
export const Get_Last_WinsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_LAST_WINS"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"infoLast100WinBets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"player"}},{"kind":"Field","name":{"kind":"Name","value":"denom"}},{"kind":"Field","name":{"kind":"Name","value":"payout"}},{"kind":"Field","name":{"kind":"Name","value":"payoutUsd"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"game"}},{"kind":"Field","name":{"kind":"Name","value":"extraGameId"}}]}}]}}]}}]} as unknown as DocumentNode<Get_Last_WinsQuery, Get_Last_WinsQueryVariables>;
export const Get_Users_By_NameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_USERS_BY_NAME"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"profileUserName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profileUserName"}},{"kind":"Field","name":{"kind":"Name","value":"profileAvatar"}}]}}]}}]}}]} as unknown as DocumentNode<Get_Users_By_NameQuery, Get_Users_By_NameQueryVariables>;
export const Get_Plinko_GameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_PLINKO_GAME"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plinkoGame"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"player"}},{"kind":"Field","name":{"kind":"Name","value":"denom"}},{"kind":"Field","name":{"kind":"Name","value":"bet"}},{"kind":"Field","name":{"kind":"Name","value":"balls"}},{"kind":"Field","name":{"kind":"Name","value":"payout"}},{"kind":"Field","name":{"kind":"Name","value":"risk"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"txHash"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}}]}}]}}]} as unknown as DocumentNode<Get_Plinko_GameQuery, Get_Plinko_GameQueryVariables>;
export const Get_Last_Plinko_GamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_LAST_PLINKO_GAMES"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plinkoGames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"FINISHED"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"player"}},{"kind":"Field","name":{"kind":"Name","value":"denom"}},{"kind":"Field","name":{"kind":"Name","value":"bet"}},{"kind":"Field","name":{"kind":"Name","value":"balls"}},{"kind":"Field","name":{"kind":"Name","value":"payout"}},{"kind":"Field","name":{"kind":"Name","value":"risk"}},{"kind":"Field","name":{"kind":"Name","value":"betUsd"}},{"kind":"Field","name":{"kind":"Name","value":"payoutUsd"}}]}}]}}]}}]} as unknown as DocumentNode<Get_Last_Plinko_GamesQuery, Get_Last_Plinko_GamesQueryVariables>;
export const Get_Last_Plinko_Games_By_PlayerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_LAST_PLINKO_GAMES_BY_PLAYER"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"player"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plinkoGames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"FINISHED"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"player"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"player"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"player"}},{"kind":"Field","name":{"kind":"Name","value":"denom"}},{"kind":"Field","name":{"kind":"Name","value":"bet"}},{"kind":"Field","name":{"kind":"Name","value":"balls"}},{"kind":"Field","name":{"kind":"Name","value":"payout"}},{"kind":"Field","name":{"kind":"Name","value":"risk"}},{"kind":"Field","name":{"kind":"Name","value":"betUsd"}},{"kind":"Field","name":{"kind":"Name","value":"payoutUsd"}}]}}]}}]}}]} as unknown as DocumentNode<Get_Last_Plinko_Games_By_PlayerQuery, Get_Last_Plinko_Games_By_PlayerQueryVariables>;
export const GameZoneSessionTokenPricesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GameZoneSessionTokenPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tokenPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<GameZoneSessionTokenPricesQuery, GameZoneSessionTokenPricesQueryVariables>;
export const GameZoneWithdrawTokenPricesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GameZoneWithdrawTokenPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tokenPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<GameZoneWithdrawTokenPricesQuery, GameZoneWithdrawTokenPricesQueryVariables>;
export const GetDoubleJackpotsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDoubleJackpots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doubleJackpots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startBlock"}},{"kind":"Field","name":{"kind":"Name","value":"drawTimeStamp"}},{"kind":"Field","name":{"kind":"Name","value":"jackpot"}}]}}]}}]}}]} as unknown as DocumentNode<GetDoubleJackpotsQuery, GetDoubleJackpotsQueryVariables>;
export const ReadMetadataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReadMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]} as unknown as DocumentNode<ReadMetadataQuery, ReadMetadataQueryVariables>;